export default {
  cvHealth: {
    title: "صحة السيرة",
    heart: {
      a11y: "صحة السيرة، النتيجة {{score}} من 100. افتح المراجعة.",
      a11yUnavailable: "صحة السيرة غير متاحة. افتح المراجعة.",
    },
    areas: {
      human: {
        label: "مسؤولو التوظيف",
        purpose: "هل يستطيع القارئ فهم خبرتك بسرعة؟",
        allClear: "يستطيع مسؤولو التوظيف معرفة دورك ومهاراتك الأساسية بسرعة.",
        tab: "التوظيف",
      },
      system: {
        label: "أنظمة التوظيف",
        purpose: "هل تستطيع البرامج قراءة النص والروابط في ملفك؟",
        allClear: "تساعد العناوين الواضحة وروابط التواصل أنظمة التوظيف على العثور على بياناتك.",
        tab: "الأنظمة",
      },
      ai_bot: {
        label: "أدوات الذكاء الاصطناعي",
        purpose: "هل خبرتك واضحة بما يكفي لتفهمها أدوات الذكاء الاصطناعي؟",
        allClear: "تساعد أسماء المهارات الكاملة والأمثلة أدوات الذكاء الاصطناعي على فهم خبرتك.",
        tab: "الذكاء",
      },
    },
    stages: {
      reading: "جارٍ قراءة سيرتك الذاتية…",
      sections_links: "جارٍ فحص الأقسام والروابط…",
      skills_experience: "جارٍ فحص المهارات والوضوح…",
      preparing: "جارٍ تجهيز النتائج…",
      ready: "تقرير صحة سيرتك جاهز",
      failed: "تعذّرت مراجعة هذه السيرة الذاتية.",
      writing: "جارٍ كتابة سيرتك الذاتية…",
      fixing: "جارٍ إصلاح سيرتك الذاتية…",
    },
    heading: {
      suggestions_zero: "لا توجد أمور لتحسينها",
      suggestions_one: "أمر واحد يمكن تحسينه",
      suggestions_two: "أمران يمكن تحسينهما",
      suggestions_few: "{{count}} أمور يمكن تحسينها",
      suggestions_many: "{{count}} أمرًا يمكن تحسينه",
      suggestions_other: "{{count}} أمر يمكن تحسينه",
      looksGood: "تبدو سيرتك الذاتية جيدة",
      partial: "تعذّر إكمال بعض الفحوصات.",
      unreadable: "تعذّرت قراءة ما يكفي من هذه السيرة الذاتية.",
      unreadableBody: "جرّب ملفًا آخر، أو تابع وأكمل بناءها مما لدينا.",
      areaUnavailable: "تعذّر إكمال هذه الفحوصات هذه المرة.",
      fixed_zero: "لم يُصلَح أي أمر",
      fixed_one: "تم إصلاح أمر واحد",
      fixed_two: "تم إصلاح أمرين",
      fixed_few: "تم إصلاح {{count}} أمور",
      fixed_many: "تم إصلاح {{count}} أمرًا",
      fixed_other: "تم إصلاح {{count}} أمر",
      scoreUpFrom: "ارتفعت من {{score}}",
      scoreDownFrom: "انخفضت من {{score}}",
      skippedFixes_zero: "طُبّقت كل الاقتراحات.",
      skippedFixes_one: "تعذّر تطبيق اقتراح واحد لأن سيرتك الذاتية تغيّرت.",
      skippedFixes_two: "تعذّر تطبيق اقتراحين لأن سيرتك الذاتية تغيّرت.",
      skippedFixes_few: "تعذّر تطبيق {{count}} اقتراحات لأن سيرتك الذاتية تغيّرت.",
      skippedFixes_many: "تعذّر تطبيق {{count}} اقتراحًا لأن سيرتك الذاتية تغيّرت.",
      skippedFixes_other: "تعذّر تطبيق {{count}} اقتراح لأن سيرتك الذاتية تغيّرت.",
      fixFailed: "تعذّر تطبيق هذه التغييرات. حاول مرة ثانية.",
      undoFailed: "تعذّر التراجع عن هذه التغييرات. حاول مرة ثانية.",
    },
    badges: {
      suggestions_zero: "لا اقتراحات",
      suggestions_one: "اقتراح واحد",
      suggestions_two: "اقتراحان",
      suggestions_few: "{{count}} اقتراحات",
      suggestions_many: "{{count}} اقتراحًا",
      suggestions_other: "{{count}} اقتراح",
      looksGood: "تبدو جيدة",
      checkDetail: "تحقّق من تفصيل",
      unavailable: "تعذّر الفحص",
      checking: "جارٍ الفحص…",
      cvChanged: "تغيّرت السيرة الذاتية",
      optional: "اختياري",
    },
    rings: {
      score:
        "درجة صحة السيرة {{score}} من 100. مسؤولو التوظيف {{humanPassed}} من {{humanEligible}}، أنظمة التوظيف {{systemPassed}} من {{systemEligible}}، أدوات الذكاء الاصطناعي {{aiPassed}} من {{aiEligible}}.",
      progress: "جارٍ فحص سيرتك الذاتية، اكتمل {{percent}} بالمئة.",
      unavailable: "درجة صحة السيرة غير متاحة.",
    },
    checks: {
      human_headline_present: {
        name: "المسمى الوظيفي في الأعلى",
        title: "أضف مسماك الوظيفي في الأعلى",
        why: "يوضح المسمى الوظيفي تحت اسمك لمسؤول التوظيف طبيعة عملك قبل أن يتابع القراءة.",
        change: "سنسألك عن المسمى الذي تريد أن تُعرف به ونضعه تحت اسمك.",
        agent: "لنضع مسماك الوظيفي تحت اسمك مباشرة.",
        plain: "لا تذكر سيرتك الذاتية في أعلاها ما هي وظيفتك.",
        plainFix: "سنضيف مسماك الوظيفي تحت اسمك.",
      },
      human_summary_present: {
        name: "ملخص قصير",
        title: "أضف ملخصًا قصيرًا",
        why: "تساعد بضعة أسطر في الأعلى مسؤول التوظيف على رؤية تركيزك ونقاط قوتك بسرعة.",
        change: "سنقترح ملخصًا قصيرًا مبنيًا فقط على الخبرات الموجودة في سيرتك الذاتية.",
        agent: "لنضف ملخصًا قصيرًا يوضح تركيزك.",
        plain: "لا تحتوي سيرتك الذاتية على نبذة قصيرة عنك.",
        plainFix: "سنكتب نبذة قصيرة من خبرتك.",
      },
      human_summary_specific: {
        name: "ملخص محدد",
        title: "اجعل ملخصك أكثر تحديدًا",
        why: "الملخص الذي يذكر دورك ومهاراتك الفعلية أسهل في التذكر من عبارات المديح العامة.",
        change: "يحافظ الملخص الجديد على معلوماتك ويذكر دورك ومهاراتك الأساسية.",
        agent: "لنجعل ملخصك يعبّر عمّا تقوم به فعلًا.",
        plain: "نبذتك عامة، ولا توضّح ما تقوم به فعلًا.",
        plainFix: "سنعيد كتابتها لتركّز على دورك ومهاراتك الفعلية.",
      },
      human_recent_role_detail: {
        name: "وصف أحدث وظيفة",
        title: "صف أحدث وظيفة لك",
        why: "غالبًا ما تُقرأ أحدث وظيفة أولًا، لذا تُحدث بضعة أسطر عنها فرقًا كبيرًا.",
        change: "سنسألك عمّا قمت به في هذه الوظيفة ونضيفه كوصف قصير.",
        agent: "لنضف بضعة أسطر عن أحدث وظيفة لك.",
        plain: "لا يوجد وصف لأحدث وظيفة لك.",
        plainFix: "أضف سطرين أو ثلاثة عمّا قمت به فيها.",
      },
      human_action_openers: {
        name: "نقاط تبدأ بفعل",
        title: "ابدأ هذه النقطة بما قمت به",
        why: "النقاط التي تبدأ بفعل أسرع في التصفح وأسهل في المتابعة.",
        change: "تحافظ النقطة الجديدة على المعلومات نفسها وتبدأ بما قمت به.",
        agent: "لنبدأ هذه النقطة بما قمت به.",
        plain: "تبدأ إحدى النقاط بعبارة «مسؤول عن» بدلًا من ذكر ما قمت به.",
        plainFix: "سنعيد كتابتها لتبدأ بما قمت به.",
      },
      human_bullets_concise: {
        name: "نقاط سهلة التصفح",
        title: "اجعل هذه النقطة أسهل في التصفح",
        why: "تتيح النقاط الأقصر للقارئ تمييز عملك دون إعادة القراءة.",
        change: "تقول النقطة الجديدة الشيء نفسه بكلمات أقل.",
        agent: "لنختصر هذه النقطة لتُقرأ بنظرة واحدة.",
        plain: "إحدى النقاط أطول من أن تُقرأ بسرعة.",
        plainFix: "سنختصرها مع الحفاظ على المعلومات نفسها.",
      },
      human_chronology_consistent: {
        name: "أحدث وظيفة أولًا",
        title: "ضع أحدث وظيفة لك أولًا",
        why: "يتوقع القراء أن يجدوا أحدث أعمالك في أعلى قسم الخبرة.",
        change: "سنطلب منك تأكيد أحدث وظيفة قبل تغيير أي ترتيب.",
        agent: "لنتأكد من أن أحدث وظيفة لك تأتي أولًا.",
        plain: "وظائفك ليست مرتبة من الأحدث إلى الأقدم.",
        plainFix: "انقل أحدث وظيفة لك إلى الأعلى.",
      },
      human_personal_details: {
        name: "البيانات الشخصية",
        title: "اجعل سيرتك الذاتية مركّزة على عملك",
        why: "لا حاجة إلى تفاصيل مثل تاريخ الميلاد أو الحالة الاجتماعية لفهم خبرتك.",
        change: "أنت من يقرر ما إذا كنت ستستبعد هذه التفاصيل من سيرتك الجديدة. لن يُحذف شيء تلقائيًا.",
        agent: "لنراجع البيانات الشخصية التي تريد مشاركتها.",
        plain: "تعرض سيرتك الذاتية بيانات شخصية لا يحتاجها أصحاب العمل، مثل تاريخ الميلاد.",
        plainFix: "أنت من يقرر ما إذا كنت ستستبعدها.",
      },
      human_impact_clarity: {
        name: "نتائج عملك",
        title: "أظهر نتيجة عملك",
        why: "توضح النتيجة ما تغيّر بفضل عملك، ما يسهّل تقدير قيمته.",
        change: "أضف ما تغيّر بفضل هذا العمل: رقمًا، أو توفيرًا، أو موعدًا تم الالتزام به، أو قرارًا نتج عنه. أنت وحدك تعرف النتيجة، لذلك لا تُعاد كتابتها عنك.",
        agent: "لنجعل نتيجة هذا العمل أوضح.",
        plain: "تذكر إحدى النقاط ما قمت به، لكنها لا تذكر النتيجة.",
        plainFix: "أضف النتيجة التي تعرفها وحدك.",
      },
      system_email_valid: {
        name: "البريد الإلكتروني",
        title: "أضف بريدًا إلكترونيًا",
        why: "تبحث أنظمة التوظيف عن بريد إلكتروني في بيانات التواصل ليتمكن أصحاب العمل من الرد عليك.",
        change: "سنسألك عن البريد الإلكتروني الذي تريد أن يستخدمه أصحاب العمل.",
        agent: "لنضف بريدًا إلكترونيًا يمكن لأصحاب العمل التواصل معك عبره.",
        plain: "لا تحتوي سيرتك الذاتية على بريد إلكتروني صالح.",
        plainFix: "أضف بريدًا إلكترونيًا ليتمكن أصحاب العمل من الرد عليك.",
      },
      system_phone_valid: {
        name: "صيغة رقم الهاتف",
        title: "استخدم صيغة دولية لرقم الهاتف",
        why: "يساعد رمز الدولة البرامج على حفظ رقمك بشكل صحيح ويتيح لأصحاب العمل في الخارج الاتصال بك.",
        change: "يحافظ الرقم الجديد على أرقامك ويضيف رمز الدولة.",
        agent: "لنكتب رقم هاتفك مع رمز الدولة.",
        plain: "رقم هاتفك ليس بالصيغة الدولية.",
        plainFix: "اكتبه بهذا الشكل: \u2066+971 50 123 4567\u2069.",
      },
      system_role_fields_complete: {
        name: "المسمى والشركة",
        title: "أضف المسمى أو الشركة الناقصة",
        why: "تصنّف أنظمة التوظيف كل وظيفة حسب مسماها وشركتها، لذا يترك النقص فجوة.",
        change: "سنسألك عن المسمى أو الشركة الناقصة لهذه الوظيفة.",
        agent: "لنكمل المسمى أو الشركة الناقصة.",
        plain: "ينقص إحدى وظائفك المسمى الوظيفي أو اسم الشركة.",
        plainFix: "أكمل الجزء الناقص.",
      },
      system_role_dates_complete: {
        name: "تواريخ الوظائف",
        title: "أضف تواريخ لهذه الوظيفة",
        why: "تتيح التواريخ للبرامج معرفة المدة التي قضيتها في كل وظيفة.",
        change: "سنسألك متى بدأت، ومتى غادرت إن كانت الوظيفة قد انتهت.",
        agent: "لنضف تواريخ لهذه الوظيفة.",
        plain: "إحدى وظائفك بلا تواريخ.",
        plainFix: "أضف متى بدأت ومتى انتهيت.",
      },
      system_dates_consistent: {
        name: "تواريخ متسقة",
        title: "تحقّق من تاريخ واحد",
        why: "قد يجعل تاريخ انتهاء يسبق تاريخ البدء البرامجَ تسيء قراءة مسيرتك.",
        change: "سنعرض التاريخ كما هو مكتوب ونطلب منك تأكيده أو تصحيحه.",
        agent: "لنتحقّق من تاريخ واحد.",
        plain: "أحد التواريخ غير منطقي.",
        plainFix: "راجع تاريخ البدء وتاريخ الانتهاء.",
      },
      system_skills_discrete: {
        name: "مهارات منفصلة",
        title: "قسّم مهارة طويلة",
        why: "تطابق البرامج المهارات واحدة تلو الأخرى، لذا قد تفوتها مهارة مدمجة طويلة.",
        change: "تصبح المهارة الطويلة مهارات منفصلة تحافظ على صياغتك.",
        agent: "لنقسّم هذه المهارة إلى مهارات منفصلة.",
        plain: "إحدى المهارات مكتوبة كجملة كاملة، فلا تستطيع البرامج مطابقتها.",
        plainFix: "سنقسّمها إلى مهارات منفصلة.",
      },
      system_links_valid: {
        name: "روابط صالحة",
        title: "أصلح رابطًا واحدًا",
        why: "لا يمكن للبرامج ولا لقارئ سيرتك فتح رابط فيه خطأ مطبعي.",
        change: "يحافظ الرابط المصحح على العنوان نفسه بعد تصحيح الخطأ المطبعي.",
        agent: "لنصلح هذا الرابط ليعمل.",
        plain: "أحد روابطك لا يعمل.",
        plainFix: "سنصلح الرابط.",
      },
      system_source_parse_complete: {
        name: "قراءة الملف كاملًا",
        title: "ربما لم تُقرأ أجزاء من ملفك",
        why: "تعذّرت قراءة بعض محتوى ملفك كنص، لذا قد تفوته أنظمة التوظيف أيضًا.",
        change: "لن يتغير شيء تلقائيًا. يمكنك مراجعة الجزء الناقص وإضافته في المحرر.",
        agent: "لنتحقّق مما إذا كان شيء من ملفك مفقودًا.",
        plain: "تعذّرت قراءة جزء من ملفك.",
        plainFix: "تأكّد من اكتمال كل قسم أدناه.",
      },
      ai_bot_skills_present: {
        name: "المهارات الأساسية",
        title: "أدرج مهاراتك الأساسية",
        why: "تساعد قائمة المهارات الواضحة أدوات الذكاء الاصطناعي على فهم ما يمكنك فعله.",
        change: "سنقترح مهارات مذكورة بالفعل في خبرتك لتؤكدها.",
        agent: "لنضف مهاراتك الأساسية.",
        plain: "تذكر سيرتك الذاتية أقل من ثلاث مهارات.",
        plainFix: "سنضيف مهارات من خبرتك.",
      },
      ai_bot_skills_evidenced: {
        name: "المهارات في عملك",
        title: "أظهر أين استخدمت مهاراتك",
        why: "تمنح أدوات الذكاء الاصطناعي وزنًا أكبر للمهارات التي تظهر في خبرتك أيضًا.",
        change: "تذكر النقطة الجديدة مهارة من قائمتك في الموضع الذي استخدمتها فيه فعلًا.",
        agent: "لنُظهر أين استخدمت مهاراتك.",
        plain: "بعض المهارات التي تذكرها لا تظهر في خبرتك أبدًا.",
        plainFix: "أضف مثالًا يوضح أين استخدمتها.",
      },
      ai_bot_role_identity_consistent: {
        name: "توافق العنوان مع أحدث وظيفة",
        title: "اجعل عنوانك المهني متوافقًا مع أحدث وظيفة",
        why: "عندما يتوافق عنوانك المهني مع أحدث وظيفة، تقرأ أدوات الذكاء الاصطناعي ملفك كقصة واحدة واضحة.",
        change: "سنسألك عن المسمى الذي تريد أن تبدأ به ونستخدمه في عنوانك المهني.",
        agent: "لنجعل عنوانك المهني وأحدث وظيفة متوافقين.",
        plain: "عنوانك المهني لا يطابق مسمى أحدث وظيفة لك.",
        plainFix: "سنستخدم مسمى أحدث وظيفة لك.",
      },
      ai_bot_experience_span_consistent: {
        name: "سنوات الخبرة",
        title: "تحقّق من سنوات الخبرة في ملخصك",
        why: "إذا أشار ملخصك وتواريخ وظائفك إلى مجموعين مختلفين، فقد تختار أدوات الذكاء الاصطناعي الرقم الخطأ.",
        change: "سنعرض الرقمين ونسألك أيهما الصحيح.",
        agent: "لنتحقّق من سنوات الخبرة في ملخصك.",
        plain: "تذكر نبذتك عددًا من سنوات الخبرة يختلف عن مجموع سنوات وظائفك.",
        plainFix: "سنصحّح الرقم.",
      },
      ai_bot_claims_supported: {
        name: "عبارات تدعمها الخبرة",
        title: "ادعم عبارة واحدة في ملخصك",
        why: "العبارة التي تدعمها خبرتك أسهل في الثقة بها لدى أدوات الذكاء الاصطناعي والأشخاص.",
        change: "يحافظ الملخص الجديد على العبارة ويربطها بعمل موجود في سيرتك الذاتية.",
        agent: "لندعم هذه العبارة بخبرتك.",
        plain: "إحدى العبارات في نبذتك لا تدعمها خبرتك.",
        plainFix: "راجعها أو احذفها.",
      },
      ai_bot_professional_proof: {
        name: "رابط مهني",
        title: "أضف رابطًا مهنيًا",
        why: "يمنح ملف LinkedIn أو معرض الأعمال أو صفحة GitHub القراء مزيدًا من عملك للاطلاع عليه.",
        change: "سنضيف الرابط الذي تختاره إلى بيانات التواصل.",
        agent: "لنضف رابطًا مهنيًا إن كان لديك واحد.",
        plain: "لا يوجد رابط LinkedIn أو معرض أعمال أو GitHub بعد.",
        plainFix: "أضف واحدًا إن كان لديك. اختياري.",
      },
      status: {
        passed: "اجتاز الفحص",
        failed: "يحتاج إلى انتباه",
        needs_review: "تحقّق من تفصيل",
        not_applicable: "لا ينطبق",
        unavailable: "تعذّر الفحص",
      },
    },
    simple: {
      scoreHeading: "حصلت سيرتك الذاتية على {{score}} من 100",
      yourCall: "القرار لك. راجعه متى شئت في سيرتك الذاتية.",
      fixesSub_zero: "لا توجد إصلاحات مطلوبة.",
      fixesSub_one: "إصلاح سريع واحد سيجعل سيرتك أقوى.",
      fixesSub_two: "إصلاحان سريعان سيجعلان سيرتك أقوى.",
      fixesSub_few: "{{count}} إصلاحات سريعة ستجعل سيرتك أقوى.",
      fixesSub_many: "{{count}} إصلاحًا سريعًا سيجعل سيرتك أقوى.",
      fixesSub_other: "{{count}} إصلاح سريع سيجعل سيرتك أقوى.",
      noFixes: "لا شيء يحتاج إلى إصلاح. أحسنت.",
      fixButton: "أصلح سيرتي بالذكاء الاصطناعي",
      continueWithoutFixing: "متابعة بدون إصلاح",
      fixingLine: "نصلح سيرتك الذاتية…",
      doneHeading: "تم. انتقلت سيرتك من {{before}} إلى {{after}}.",
      doneSub_zero: "لم نصلح شيئًا.",
      doneSub_one: "أصلحنا أمرًا واحدًا. يمكنك التراجع.",
      doneSub_two: "أصلحنا أمرين. يمكنك التراجع.",
      doneSub_few: "أصلحنا {{count}} أمور. يمكنك التراجع.",
      doneSub_many: "أصلحنا {{count}} أمرًا. يمكنك التراجع.",
      doneSub_other: "أصلحنا {{count}} أمر. يمكنك التراجع.",
      fixFailed: "تعذّر إصلاح سيرتك الذاتية هذه المرة.",
      nowLabel: "الآن",
      afterLabel: "بعد الإصلاح",
      weAskLabel: "ما سنسألك عنه",
      undo: "تراجع",
      checkingHeading: "جارٍ فحص سيرتك الذاتية",
      editorHeading: "حصلت سيرتك الذاتية على {{score}} من 100",
      editorFixesSub_zero: "لا توجد إصلاحات مطلوبة.",
      editorFixesSub_one: "إصلاح سريع واحد سيجعل سيرتك أقوى.",
      editorFixesSub_two: "إصلاحان سريعان سيجعلان سيرتك أقوى.",
      editorFixesSub_few: "{{count}} إصلاحات سريعة ستجعل سيرتك أقوى.",
      editorFixesSub_many: "{{count}} إصلاحًا سريعًا سيجعل سيرتك أقوى.",
      editorFixesSub_other: "{{count}} إصلاح سريع سيجعل سيرتك أقوى.",
      editorNoFixes: "لا شيء يحتاج إلى إصلاح الآن.",
    },
    report: {
      gaugeLabel: "نتيجة صحة السيرة الذاتية",
      gaugeValue: "{{score}} من 100",
      allPassed: "اجتازت سيرتك كل الفحوصات",
      reviewSuggestions_zero: "لا توجد اقتراحات للمراجعة",
      reviewSuggestions_one: "راجع اقتراحًا واحدًا",
      reviewSuggestions_two: "راجع اقتراحين",
      reviewSuggestions_few: "راجع {{count}} اقتراحات",
      reviewSuggestions_many: "راجع {{count}} اقتراحًا",
      reviewSuggestions_other: "راجع {{count}} اقتراح",
      resumeReview: "تابع المراجعة",
      viewSuggestions: "عرض الاقتراحات واحدًا واحدًا",
      whatWeChecked: "ما الذي فحصناه",
      looksGood: "تبدو جيدة",
      improvements_zero: "لا تحسينات",
      improvements_one: "تحسين واحد",
      improvements_two: "تحسينان",
      improvements_few: "{{count}} تحسينات",
      improvements_many: "{{count}} تحسينًا",
      improvements_other: "{{count}} تحسين",
      couldntCheck: "تعذّر الفحص",
      basedOn_zero: "لم نُجرِ أي فحص على نص سيرتك وروابطها. هذه النتيجة لا تتنبأ بفرص التوظيف.",
      basedOn_one: "بناءً على فحص واحد لنص سيرتك وروابطها. هذه النتيجة لا تتنبأ بفرص التوظيف.",
      basedOn_two: "بناءً على فحصين لنص سيرتك وروابطها. هذه النتيجة لا تتنبأ بفرص التوظيف.",
      basedOn_few: "بناءً على {{count}} فحوصات لنص سيرتك وروابطها. هذه النتيجة لا تتنبأ بفرص التوظيف.",
      basedOn_many: "بناءً على {{count}} فحصًا لنص سيرتك وروابطها. هذه النتيجة لا تتنبأ بفرص التوظيف.",
      basedOn_other: "بناءً على {{count}} فحص لنص سيرتك وروابطها. هذه النتيجة لا تتنبأ بفرص التوظيف.",
      overview: "نظرة عامة",
      areasLabel: "جوانب صحة السيرة الذاتية",
      checksInArea: "الفحوصات في هذا الجانب",
      coverage: "بناءً على نص سيرتك وروابطها. لا يشمل الفحص تنسيق الملف ولا الصفحات الممسوحة ضوئيًا ولا المطابقة مع وظيفة محددة. هذه النتيجة لا تتنبأ بفرص التوظيف.",
      previewChanges_zero: "لا توجد تعديلات",
      previewChanges_one: "معاينة التعديل",
      previewChanges_two: "معاينة التعديلين",
      previewChanges_few: "معاينة {{count}} تعديلات",
      previewChanges_many: "معاينة {{count}} تعديلًا",
      previewChanges_other: "معاينة {{count}} تعديل",
      optional: "اختياري",
      proofTitle: "اعرض أمثلة من عملك",
      proofBody: "قد يفيدك رابط GitHub أو LinkedIn أو ملف أعمال. يكفي رابط واحد مناسب.",
      proofAction: "أضف رابط أعمالك",
      proofNote: "لن تتغير نتيجتك إذا تخطيت هذه الخطوة.",
      changesSaved_zero: "لم يُحفظ أي تعديل",
      changesSaved_one: "حُفظ تعديل واحد",
      changesSaved_two: "حُفظ تعديلان",
      changesSaved_few: "حُفظت {{count}} تعديلات",
      changesSaved_many: "حُفظ {{count}} تعديلًا",
      changesSaved_other: "حُفظ {{count}} تعديل",
      undone: "تم التراجع عن التعديلات",
      checkingChanges: "نفحص تعديلاتك…",
      recheckFailed_zero: "لم يُحفظ أي تعديل، وتعذّر فحص سيرتك الذاتية من جديد.",
      recheckFailed_one: "حُفظ تعديل واحد، لكن تعذّر فحص سيرتك الذاتية من جديد.",
      recheckFailed_two: "حُفظ تعديلان، لكن تعذّر فحص سيرتك الذاتية من جديد.",
      recheckFailed_few: "حُفظت {{count}} تعديلات، لكن تعذّر فحص سيرتك الذاتية من جديد.",
      recheckFailed_many: "حُفظ {{count}} تعديلًا، لكن تعذّر فحص سيرتك الذاتية من جديد.",
      recheckFailed_other: "حُفظ {{count}} تعديل، لكن تعذّر فحص سيرتك الذاتية من جديد.",
      undoSkipped_zero: "تم التراجع عن كل التعديلات.",
      undoSkipped_one: "تعذّر التراجع عن تعديل واحد لأن سيرتك الذاتية تغيّرت بعده.",
      undoSkipped_two: "تعذّر التراجع عن تعديلين لأن سيرتك الذاتية تغيّرت بعدهما.",
      undoSkipped_few: "تعذّر التراجع عن {{count}} تعديلات لأن سيرتك الذاتية تغيّرت بعدها.",
      undoSkipped_many: "تعذّر التراجع عن {{count}} تعديلًا لأن سيرتك الذاتية تغيّرت بعدها.",
      undoSkipped_other: "تعذّر التراجع عن {{count}} تعديل لأن سيرتك الذاتية تغيّرت بعدها.",
    },
    review: {
      heading: "تعديلاتك جاهزة",
      cvUpdated: "أعدنا كتابة سيرتك الذاتية، لذا هذه هي التعديلات المناسبة للنسخة الجديدة. احتفظ بما يعجبك منها.",
      lead: "احتفظ بالتعديلات التي تعجبك، وعدّل ما تريد.",
      compare: "قارن وعدّل",
      original: "الأصل",
      suggested: "المقترح",
      selected_zero: "لم تحدد أي تعديل · الأصل محفوظ",
      selected_one: "حددت تعديلًا واحدًا · الأصل محفوظ",
      selected_two: "حددت تعديلين · الأصل محفوظ",
      selected_few: "حددت {{count}} تعديلات · الأصل محفوظ",
      selected_many: "حددت {{count}} تعديلًا · الأصل محفوظ",
      selected_other: "حددت {{count}} تعديل · الأصل محفوظ",
      save_zero: "احفظ التعديلات",
      save_one: "احفظ التعديل",
      save_two: "احفظ التعديلين",
      save_few: "احفظ {{count}} تعديلات",
      save_many: "احفظ {{count}} تعديلًا",
      save_other: "احفظ {{count}} تعديل",
      useInCv: "استخدمها في سيرتي الجديدة",
      keepOriginal: "احتفظ بالأصل",
      saving: "نحفظ تعديلاتك…",
      saveFailed: "تعذّر حفظ هذه التعديلات. حاول مجددًا.",
      invalidLink: "أحد الروابط لا يبدو صحيحًا. تحقق منه وحاول مجددًا.",
      empty: "اكتب شيئًا، أو ألغِ تحديد هذا التعديل.",
      others_zero: "لا توجد اقتراحات أخرى.",
      others_one: "اقتراح آخر يحتاج تفاصيل لا يعرفها غيرك.",
      others_two: "اقتراحان آخران يحتاجان تفاصيل لا يعرفها غيرك.",
      others_few: "{{count}} اقتراحات أخرى تحتاج تفاصيل لا يعرفها غيرك.",
      others_many: "{{count}} اقتراحًا آخر يحتاج تفاصيل لا يعرفها غيرك.",
      others_other: "{{count}} اقتراح آخر يحتاج تفاصيل لا يعرفها غيرك.",
      seeOthers: "اعرضها في القائمة",
    },
    checkSteps: {
      reading: "الصياغة والخبرة",
      sections_links: "الأقسام وبيانات التواصل",
      skills_experience: "المهارات والوضوح",
      preparing: "نتيجتك",
      progressLabel: "الفحوصات المكتملة",
      unchanged: "تبقى سيرتك الأصلية كما هي.",
      cancel: "إلغاء الفحص",
      slowHint: "قد تستغرق الفحوصات الأخيرة بعض الوقت.",
      failedLead: "سيرتك الذاتية لم تتغيّر. جرّب الفحص مرة أخرى.",
      cancelledTitle: "أُلغي الفحص",
      cancelledLead: "سيرتك الذاتية لم تتغيّر. ابدأ من جديد متى شئت.",
      checkMyCv: "افحص سيرتي الذاتية",
    },
    about: {
      title: "حول هذه الفحوصات",
    },
    notChecked: {
      title: "لم تُفحص في هذا الإصدار",
      layout: "تخطيط الصفحة والأعمدة",
      fonts: "الخطوط والأحجام",
      contrast: "تباين الألوان",
      ocr: "الصفحات الممسوحة ضوئيًا أو المصوّرة فقط",
      spelling: "الإملاء",
      job_match: "المطابقة مع وظيفة محددة",
    },
    actions: {
      fixWithAi_zero: "لا شيء لإصلاحه بالذكاء الاصطناعي",
      fixWithAi_one: "أصلح أمرًا واحدًا بالذكاء الاصطناعي",
      fixWithAi_two: "أصلح أمرين بالذكاء الاصطناعي",
      fixWithAi_few: "أصلح {{count}} أمور بالذكاء الاصطناعي",
      fixWithAi_many: "أصلح {{count}} أمرًا بالذكاء الاصطناعي",
      fixWithAi_other: "أصلح {{count}} أمر بالذكاء الاصطناعي",
      continueWithoutFixing: "المتابعة دون إصلاح",
      undo: "تراجع",
      previewChange: "معاينة التغيير",
      seeChange: "عرض التغيير",
      leaveUnchanged: "الإبقاء دون تغيير",
      skipForNow: "التخطي الآن",
      looksRight: "يبدو صحيحًا",
      useSuggestion: "استخدام الاقتراح",
      leaveOut: "استبعاد من السيرة الجديدة",
      keepIt: "الإبقاء عليه",
      addProfessionalLink: "إضافة رابط مهني",
      noProfessionalLink: "ليس لدي رابط",
      useFixedLink: "استخدام الرابط المصحح",
      saveChange: "حفظ التغيير",
      keepOriginal: "الإبقاء على الأصل",
      original: "الأصل",
      suggested: "المقترح",
      nothingYet: "لا شيء بعد",
      editHint: "يمكنك تعديل هذا قبل الحفظ.",
      inYourCv: "في سيرتك الذاتية",
      sectionLabels: {
        header: "الترويسة",
        contact: "بيانات التواصل",
        summary: "الملخص",
        experience: "الخبرة",
        skills: "المهارات",
        education: "التعليم",
        projects: "المشاريع",
        certifications: "الشهادات",
        languages: "اللغات",
        careerHighlights: "أبرز الإنجازات",
      },
    },
  },
  photoCrop: {
    accountTitle: "ضبط صورة الحساب",
    cvTitle: "ضبط صورة السيرة الذاتية",
    instructions: "اسحب لتحديد الموضع. باعد بين إصبعين أو استخدم شريط التكبير.",
    webInstructions: "اسحب لتحديد الموضع واضبط التكبير. يمكنك أيضاً استخدام مفاتيح الأسهم.",
    preview: "معاينة اقتصاص الصورة",
    accessibilityHint: "استخدم الإجراءات لتحريك الصورة وشريط التكبير لتغيير حجمها.",
    zoom: "التكبير",
    reset: "إعادة الضبط",
    cancel: "إلغاء",
    usePhoto: "استخدام الصورة",
    failed: "تعذر تجهيز هذه الصورة. حاول مجدداً أو اختر صورة أخرى.",
    left: "تحريك الصورة لليسار",
    right: "تحريك الصورة لليمين",
    up: "تحريك الصورة للأعلى",
    down: "تحريك الصورة للأسفل",
  },
  accountPhoto: {
    "title": "صورة الحساب",
    "edit": "تغيير صورة الحساب",
    "choose": "اختيار صورة",
    "remove": "إزالة صورة الحساب",
    "saveFailed": "تعذّر حفظ الصورة. يرجى المحاولة مرة أخرى.",
    "removeCv": "إزالة صورة السيرة الذاتية"
  },
  supportDesk: {
  "resumeDraft": "متابعة المسودة",
  "eyebrow": "المساعدة متاحة عندما تحتاج إليها",
  "title": "المساعدة والدعم",
  "intro": "اعثر على إجابة أو تواصل مع فريق تابيو. تابع المحادثة كاملة هنا.",
  "back": "رجوع",
  "quickAnswers": "إجابات سريعة",
  "allAnswers": "تصفح مركز المساعدة",
  "contactTitle": "كيف يمكننا مساعدتك؟",
  "contactDescription": "أخبرنا بما كنت تحاول فعله وما حدث. يمكنك متابعة الرد هنا.",
  "newRequest": "تواصل مع الدعم",
  "history": "طلباتك",
  "empty": "ليس لديك طلبات بعد. نحن هنا لمساعدتك عند الحاجة.",
  "loading": "جارٍ تحميل طلباتك…",
  "loadError": "تعذر تحميل المحادثة. يرجى المحاولة مرة أخرى.",
  "retry": "حاول مرة أخرى",
  "more": "المزيد من الطلبات",
  "older": "الرسائل السابقة",
  "conversation": "محادثة الدعم",
  "you": "أنت",
  "team": "دعم تابيو",
  "topic": "ما موضوع طلبك؟",
  "message": "أخبرنا بما حدث",
  "reply": "ردك",
  "placeholder": "ما الذي كنت تحاول فعله؟ وما الذي حدث بدلًا من ذلك؟",
  "draftSaved": "تم حفظ المسودة على هذا الجهاز",
  "draftFailed": "تعذر حفظ المسودة على هذا الجهاز. أبقِ هذه الصفحة مفتوحة.",
  "sendError": "تعذر تأكيد التسليم. حاول مرة أخرى لإعادة إرسال الرسالة نفسها بأمان. ما زالت مسودتك محفوظة هنا.",
  "sent": "تم حفظ رسالتك. يمكنك متابعة المحادثة هنا.",
  "sending": "جارٍ الإرسال…",
  "send": "إرسال الطلب",
  "sendReply": "إرسال الرد",
  "discard": "مسح المسودة",
  "privacy": "تتم مشاركة رسالتك وتفاصيل التطبيق الأساسية مع فريق الدعم. يرجى عدم تضمين كلمات المرور أو بيانات بطاقات الدفع.",
  "readOnly": "تتيح هذه الجلسة عرض الطلبات فقط، ولا يمكن إرسال رسائل منها.",
  "status": {
    "open": "مفتوح",
    "closed": "تم الحل"
  },
  "categories": {
    "account": "الحساب",
    "cv": "السيرة الذاتية والتنزيلات",
    "billing": "الخطة والفوترة",
    "jobs": "الوظائف والطلبات",
    "other": "موضوع آخر"
  },
  "answers": {
    "cv": {
      "title": "المساعدة في تنزيل السيرة الذاتية",
      "body": "افتح السيرة الذاتية التي تريد تنزيلها وراجع محتواها في المحرر. إذا اختلف الملف بعد التنزيل، أخبرنا بالتنسيق الذي استخدمته وما الذي تغير."
    },
    "billing": {
      "title": "مراجعة خطتك أو رصيدك",
      "body": "افتح الإعدادات واختر الخطة والفوترة للاطلاع على خطتك الحالية ورصيدك. لمشكلة في الدفع، اذكر تاريخ الشراء والمتجر الذي استخدمته."
    },
    "account": {
      "title": "تحديث بيانات حسابك",
      "body": "افتح الإعدادات واختر الحساب لإدارة اسمك وبريدك الإلكتروني وبيانات تسجيل الدخول. إذا تعذر إجراء تغيير، أرسل لنا رسالة الخطأ التي تظهر لك."
    }
  }
},
  errorBoundary: {
    title: "حدث خطأ ما",
    message: "واجه التطبيق خطأً غير متوقع. يمكنك المحاولة مرة أخرى.",
    retry: "إعادة المحاولة",
    goHome: "العودة إلى الرئيسية",
  },
  appName: "Tabbio",
  appTagline: "سيرتك الذاتية الرقمية.",
  ai: "ذكاء اصطناعي",
  status: {
    loading: "جارٍ التحميل",
  },
  attachTitle: "إضافة مرفق",
  attachCamera: "الكاميرا",
  attachLibrary: "مكتبة الصور",
  attachDocument: "مستند",
  attachFailedTitle: "تعذّر إرفاق الملف",
  attachFailedMessage: "حاول مرة أخرى أو اختر ملفاً مختلفاً.",
  attachUnsupportedMessage:
    "نوع الملف هذا غير مدعوم. حمّل ملف PDF أو DOCX أو TXT أو صورة.",
  localeSwitch: {
    switching: "جارٍ التبديل إلى {{language}}",
  },
  dirtyGuard: {
    title: "تغييرات غير محفوظة",
    message: "لديك تغييرات غير محفوظة. ماذا تريد أن تفعل؟",
    stay: "البقاء",
    discard: "تجاهل",
    save: "حفظ",
  },
  supportSession: {
    title: "جلسة الدعم",
    checkingTitle: "جارٍ التحقق من رابط الدعم",
    checkingDescription:
      "يتحقق Tabbio من هذه الجلسة المؤقتة المخصصة للعرض فقط.",
    viewOnly: "وصول دعم للعرض فقط",
    readyTitle: "عرض حساب {{name}}",
    readyDescription: "ستدخل إلى {{email}} بصفتك {{actor}} لغرض الدعم.",
    restriction:
      "تُحظر التغييرات والإرسال والرسائل والمشتريات وأي إجراءات كتابة أخرى في هذه الجلسة.",
    expires: "تنتهي هذه الجلسة الساعة {{time}} ولا يمكن تجديدها.",
    continue: "المتابعة بوضع العرض فقط",
    exit: "إنهاء الجلسة",
    failedTitle: "رابط الدعم غير متاح",
    failedDescription:
      "انتهت صلاحية الرابط أو استُخدم سابقاً أو لم يعد صالحاً. أنشئ رابطاً جديداً من لوحة الإدارة.",
    goHome: "الانتقال إلى Tabbio",
    bannerTitle: "عرض حساب {{name}} كدعم",
    bannerDescription: "جلسة للعرض فقط: جميع التغييرات محظورة",
  },
  meta: {
    titles: {
      appEntry:
        "Tabbio: وكيلك المهني بالذكاء الاصطناعي للسيرة الذاتية والوظائف",
      onboarding: "الإعداد",
      services: "الخدمات",
      library: "المكتبة",
      shortlists: "القوائم المختصرة",
      upgrade: "الترقية",
      createCompany: "إنشاء شركة",
      autoApply: "الأتمتة",
      subscription: "الاشتراك",
      share: "صفحة مشتركة",
    },
    descriptions: {
      appEntry:
        "أنشئ سيرة ذاتية تقرأها أنظمة التوظيف بسهولة، واعثر على وظائف مناسبة في الإمارات ودول الخليج، وخصص كل طلب واستخدم التقديم التلقائي مع وكيل Tabbio المهني الذكي.",
      default:
        "محادثات مهنية مدعومة بالذكاء الاصطناعي وسير ذاتية ووظائف وأدوات توظيف في Tabbio.",
      auth: "سجّل الدخول إلى Tabbio للوصول إلى مساحة عملك المهنية على الويب.",
      onboarding: "أكمل إعداد ملفك الشخصي ومساحة عملك في Tabbio على الويب.",
      chat: "واصل محادثتك المهنية المدعومة بالذكاء الاصطناعي في Tabbio.",
      jobs: "استعرض الفرص وسير عمل التوظيف داخل مساحة عملك في Tabbio.",
      messages: "راجع محادثات مسؤولي التوظيف وأصحاب العمل في Tabbio.",
      cv: "أدر سيرتك الذاتية وملفاتك العامة وعناصر ملفك في Tabbio.",
      profile: "راجع وحدّث ملفك الشخصي في Tabbio على الويب.",
      candidates: "تصفح المرشحين وأنشطة التوظيف في مساحة عملك في Tabbio.",
      company: "أدر ملف شركتك وفريقك وصفحة التوظيف في Tabbio.",
      analytics: "تابع المشاهدات والأداء عبر مساحة عملك في Tabbio.",
      services: "اربط Tabbio بالتطبيقات الخارجية وأدوات الأتمتة.",
      library: "تصفح ونظّم مكتبة المواهب الخاصة بك في Tabbio.",
      shortlists: "راجع القوائم المختصرة وتدفقات مشاركة المرشحين في Tabbio.",
      notifications: "ابقَ على اطلاع بالنشاط داخل مساحة عملك في Tabbio.",
      settings: "أدر الحساب والفوترة وتفضيلات مساحة العمل في Tabbio.",
      upgrade: "راجع الخطط وقم بترقية مساحة عملك في Tabbio.",
      uaePass: "اعرض حالة UAE PASS والتحقق الخاص بك في Tabbio.",
      share: "اعرض المحتوى المشترك والصفحات العامة في Tabbio.",
      autoApply:
        "راجع الأتمتة المجدولة وإشارات المطابقة التي يستخدمها Tabbio لبحثك الوظيفي.",
    },
  },

  nav: {
    home: "الرئيسية",
    chat: "المحادثة",
    cv: "السيرة الذاتية",
    jobs: "الوظائف",
    messages: "الرسائل",
    profile: "الملف الشخصي",
    candidates: "المرشحون",
    company: "صفحة الشركة",
    tabbio: "Tabbio",
    publicProfile: "الملف العام",
    webCv: "السيرة الذاتية",
    sharedCvs: "السير المشتركة",
    sites: "المواقع",
    skills: "المهارات",
    connectors: "الموصلات",
    analytics: "المشاهدات",
    findJobs: "البحث عن وظائف",
    myCv: "سيرتي الذاتية",
    autoMatch: "الأتمتة",
    tasks: "المهام",
    postJob: "نشر وظيفة",
    apps: "التطبيقات",
    memory: "الذاكرة",
    search: "بحث",
    careerPage: "صفحة التوظيف",
    findTalent: "البحث عن المواهب",
    applications: "طلبات التوظيف",
    notifications: "الإشعارات",
    workspaceSoon: "مساحة العمل",
    soon: "قريبًا",
  },
  // قائمة المواقع وصفحة إعداداتها والإنشاء (الخطة 7.10).
  sites: {
    title: "المواقع",
    create: "إنشاء",
    refresh: "تحديث",
    search: "البحث في المواقع",
    tabs: {
      owned: "مواقعي",
      shared: "مشارَكة معي",
    },
    columns: {
      site: "الموقع",
      sharedWith: "مشترك مع",
    },
    audience: {
      everyone: "الجميع",
      onlyYou: "أنت فقط",
    },
    share: "مشاركة",
    shareLabel: "مشاركة {{title}}",
    more: "إجراءات أخرى لـ {{title}}",
    menu: {
      share: "مشاركة",
      edit: "تعديل",
      analytics: "الإحصاءات",
      settings: "الإعدادات",
    },
    empty: "لا توجد مواقع بعد",
    emptyShared: "لم تتم مشاركة أي مواقع معك",
    noMatches: "لا توجد مواقع تطابق {{query}}",
    loadFailed: "تعذّر تحميل مواقعك.",
    rowMeta: "{{age}} · {{host}}",
    draft: "مسودة",
    noAddress: "لم يُنشر بعد",
    age: {
      now: "الآن",
      minutes: "{{count}} د",
      hours: "{{count}} س",
      days: "{{count}} ي",
      weeks: "{{count}} أ",
    },
    composer: {
      chip: "المواقع",
      removeChip: "إزالة المواقع",
      placeholder: "أنشئ موقعًا يقوم بـ …",
    },
    settings: {
      breadcrumb: "المواقع",
      breadcrumbLabel: "مسار التنقل",
      edit: "تعديل",
      tabs: {
        settings: "الإعدادات",
        analytics: "الإحصاءات",
      },
      general: {
        title: "عام",
        subtitle: "اسم موقعك وعنوانه ومن يمكنه رؤيته",
      },
      name: {
        label: "الاسم",
        hint: "اسم موقعك",
        saved: "تم حفظ الاسم",
        failed: "تعذّر حفظ الاسم. حاول مرة أخرى.",
      },
      url: {
        label: "الرابط",
        hint: "عنوان الويب",
        change: "تغيير",
        none: "انشر الموقع ليحصل على عنوان",
      },
      domain: {
        label: "النطاق",
        hint: "رابط موقعك",
      },
      sharing: {
        label: "المشاركة",
        hint: "من يمكنه عرض موقعك",
        everyone: "مرئي للجميع",
        onlyYou: "أنت فقط",
        manage: "إدارة",
      },
      danger: {
        title: "منطقة الخطر",
        label: "حذف الموقع",
        hint: "حذف هذا الموقع نهائيًا",
        cta: "حذف الموقع",
      },
      delete: {
        title: "حذف هذا الموقع؟",
        body: "سيتوقف العنوان عن العمل فورًا. يمكنك الاحتفاظ بالصفحة في ملفاتك.",
        keep: "الاحتفاظ بالصفحة في ملفاتي",
        confirm: "حذف الموقع",
        keepAndDelete: "حذف الموقع مع الاحتفاظ بالصفحة",
        deleteAll: "حذف الموقع والصفحة",
        deleting: "جارٍ الحذف…",
        deleted: "تم حذف الموقع",
        failed: "تعذّر حذف الموقع. حاول مرة أخرى.",
      },
      notFound: "هذا الموقع لم يعد متاحًا.",
      loadFailed: "تعذّر تحميل هذا الموقع.",
    },
    analytics: {
      views7: "المشاهدات في آخر 7 أيام",
      views30: "المشاهدات في آخر 30 يومًا",
      visitors7: "الزوار في آخر 7 أيام",
      visitors30: "الزوار في آخر 30 يومًا",
      daily: "المشاهدات اليومية (بتوقيت UTC)",
      empty: "لا مشاهدات بعد. شارك الرابط لتصلك أولى الزيارات.",
      notLive: "انشر الموقع لبدء عدّ المشاهدات.",
      dayViews_zero: "{{day}}: لا مشاهدات",
      dayViews_one: "{{day}}: مشاهدة واحدة",
      dayViews_two: "{{day}}: مشاهدتان",
      dayViews_few: "{{day}}: {{count}} مشاهدات",
      dayViews_many: "{{day}}: {{count}} مشاهدة",
      dayViews_other: "{{day}}: {{count}} مشاهدة",
      loadFailed: "تعذّر تحميل الأرقام.",
    },
  },

  // مركز المهارات
  skills: {
    title: "المهارات",
    subtitle: "مهارات وكيل تعمل بنقرة واحدة لقراءة سيرتك الذاتية وتحسينها.",
    nativeComingSoon:
      "مركز المهارات متاح في تطبيق الويب. ستتوفر تجربة أصلية قريباً.",
    searchPlaceholder: "ابحث في المهارات",
    shelves: {
      default: "الافتراضية",
      community: "المجتمع",
      own: "مهاراتي",
    },
    tiers: {
      free: "مجاني",
      plus: "بلس",
      pro: "برو",
    },
    filters: {
      title: "عوامل التصفية",
      clear: "مسح عوامل التصفية",
      sort: "الترتيب",
      country: "الدولة",
      level: "المستوى",
      language: "اللغة",
    },
    tabs: {
      explore: "استكشاف",
      mine: "مهاراتي",
    },
    sections: {
      cv: "مهارات السيرة الذاتية",
      other: "مهارات أخرى",
    },
    directoryGroups: {
      uae: "الإمارات العربية المتحدة",
      generalCv: "مهارات عامة للسيرة الذاتية",
      apply: "التقديم للوظائف",
      interview: "التحضير للمقابلات",
      message: "الكتابة وبناء العلاقات المهنية",
      general: "الدعم المهني",
    },
    // كتالوج tabbio/v2: فئات المهارات الأخرى (شريط الفئات + التسميات)
    categories: {
      all: "الكل",
      apply: "التقديم",
      interview: "المقابلات",
      message: "الرسائل",
      general: "عام",
    },
    // كتالوج tabbio/v2: دول مهارات السيرة الذاتية (التصفية + صف التفاصيل)
    countries: {
      uae: "الإمارات",
      ksa: "السعودية",
      kwt: "الكويت",
      qat: "قطر",
      omn: "عُمان",
      bhr: "البحرين",
      gulf: "دول الخليج",
    },
    // كتالوج tabbio/v2: المستويات المهنية
    levels: {
      intern: "متدرب",
      fresh: "خريج جديد",
      mid: "منتصف المسيرة",
      exec: "تنفيذي",
      all: "كل المستويات",
    },
    // شارة ثنائية اللغة على صفوف المركز (رموز اللغات، تبقى كما هي)
    langBadgeBi: "EN·AR",
    // tabbio/v2: ما تقرأه المهارة قبل التشغيل (صف «تقرأ هذه المهارة»)
    contextSources: {
      primary_cv: "السيرة الذاتية الأساسية",
      profile: "الملف الشخصي",
      memory: "الذاكرة المهنية",
    },
    // tabbio/v2: قوالب تنسيق مهارات السيرة الذاتية (صف «التصميم»)
    layoutTemplates: {
      modern: "عصري",
      classic: "كلاسيكي",
      executive: "تنفيذي",
      creative: "إبداعي",
    },
    filterBar: {
      allPlans: "كل الخطط",
      allLevels: "كل المستويات",
      allCountries: "كل الدول",
      anyLanguage: "أي لغة",
      trending: "الرائجة",
      langEn: "الإنجليزية",
      langAr: "العربية",
      langBi: "ثنائية اللغة",
    },
    newSkill: "مهارة جديدة",
    addSkill: "إضافة مهارة",
    open: "فتح",
    use: "استخدام",
    useSkill: "استخدام المهارة",
    add: "إضافة",
    added: "مُضافة",
    install: "تثبيت",
    installed: "مثبّتة",
    uninstall: "إلغاء التثبيت",
    installUpgrade: "رقّ للتثبيت",
    installCount: "{{value}} عملية تثبيت",
    installCount_zero: "{{value}} عملية تثبيت",
    installCount_one: "عملية تثبيت واحدة",
    installCount_two: "عمليتا تثبيت",
    installCount_few: "{{value}} عمليات تثبيت",
    installCount_many: "{{value}} عملية تثبيت",
    installCount_other: "{{value}} عملية تثبيت",
    usageCount: "{{value}} مرة استخدام",
    usageCount_zero: "{{value}} مرة استخدام",
    usageCount_one: "مرة استخدام واحدة",
    usageCount_two: "مرتا استخدام",
    usageCount_few: "{{value}} مرات استخدام",
    usageCount_many: "{{value}} مرة استخدام",
    usageCount_other: "{{value}} مرة استخدام",
    installFailed: "تعذّر تحديث هذه المهارة",
    verified: "من اختيار Tabbio",
    useInChat: "استخدامها في محادثة الوكيل",
    slashMenuTitle: "جميع المهارات",
    slashMenuEmpty: "لم يتم العثور على مهارات مطابقة.",
    chatStarters: {
      title: "ابدأ بهذه المهارات",
      browse: "عرض الكل",
      browseHint: "اكتشف مهارات وكيل إضافية وأدرها",
      viewAll: "عرض الكل",
      run: "تشغيل في المحادثة",
      view: "عرض وتثبيت",
      runLabel: "تشغيل {{name}} في محادثة الوكيل",
      openLabel: "عرض {{name}} وتثبيتها",
    },
    handoff: {
      opening: "جارٍ فتح مهارتك…",
      signInRequired: "سجّل الدخول لتطبيق هذه المهارة على سيرتك الذاتية.",
      signInToUse: "سجّل الدخول لاستخدام هذه الأداة المهنية.",
    },
    toast: {
      addedToMySkills: "أُضيفت إلى مهاراتي",
      removedFromMySkills: "أُزيلت من مهاراتي",
      installed: "تم تثبيتها في مهاراتي",
      uninstalled: "أُزيلت من مهاراتي",
    },
    count_zero: "لا توجد مهارات",
    count_one: "مهارة واحدة",
    count_two: "مهارتان",
    count_few: "{{count}} مهارات",
    count_many: "{{count}} مهارة",
    count_other: "{{count}} مهارة",
    newFlow: {
      chooser: {
        cvTitle: "إنشاء مهارة سيرة ذاتية",
        anyTitle: "إنشاء مهارة",
      },
      describe: {
        label: "الوصف",
        placeholder:
          "مثال: سيرة ذاتية تسويقية من صفحة واحدة لخريج جديد في الإمارات. إنجليزية، تنسيق بسيط، بدون صورة.",
        writeWith: "اكتبها باستخدام",
        buildManually: "الإنشاء يدوياً",
        generate: "إنشاء المهارة",
      },
      any: {
        title: "إنشاء مهارة",
        tabs: { write: "الكتابة بالذكاء", paste: "لصق", import: "استيراد" },
        writePlaceholder:
          "مثال: حوّل إعلان وظيفة إلى 5 أسئلة مقابلة مخصصة مع إجابات نموذجية.",
        pastePlaceholder: "الصق محتوى SKILL.md أو تعليمات نصية.",
        save: "حفظ المهارة",
        dropTitle: "أفلت ملف SKILL.md",
        dropBody: "أو اختر ملفاً من جهازك",
        choose: "اختيار ملف",
      },
      // الكتابة بالذكاء على خطوتين: وصف الفكرة ثم مراجعة المسودة.
      write: {
        describeLabel: "صف ما يجب أن تفعله هذه المهارة",
        describePlaceholder:
          "مثال: أعد صياغة قسم \"نبذة عني\" في لينكدإن لمسؤولي التوظيف في الخليج بأقل من 200 كلمة.",
        reviewNotice:
          "صاغها الذكاء الاصطناعي من وصفك. عدّل ما تشاء قبل الإنشاء.",
        regenerate: "إعادة الصياغة",
        tagsLabel: "الوسوم",
        modelSuggested: "المقترح: {{model}}",
        tryAgain: "إعادة المحاولة",
        writeManually: "الكتابة يدوياً",
      },
      basics: {
        nameCvPlaceholder: "سمِّ مهارة سيرتك الذاتية",
        iconLabel: "اختر أيقونة",
        upload: "رفع صورة",
        recommendedModel: "النموذج الموصى به",
        recommendedModelHint: "لمن يشغّل هذه المهارة",
        subtitle: "سمِّها، واختر أيقونة، وأخبرنا لمن هي.",
      },
      regions: {
        UAE: "الإمارات",
        KSA: "السعودية",
        Kuwait: "الكويت",
        Qatar: "قطر",
        Bahrain: "البحرين",
        Oman: "عُمان",
        GCC: "دول الخليج",
      },
      levels: {
        intern: "متدرب",
        "fresh-grad": "خريج جديد",
        "mid-career": "منتصف المسيرة",
        executive: "تنفيذي",
      },
      langs: { en: "الإنجليزية", ar: "العربية", bi: "ثنائية اللغة" },
      models: {
        "gemini-flash-lite": { name: "Gemini 3.5 Flash-Lite", note: "الأسرع" },
        "gemini-flash": { name: "Gemini 3.6 Flash", note: "سريع" },
        "gpt-4o-mini": { name: "GPT-4o mini", note: "مجاني" },
        "claude-sonnet": { name: "Claude Sonnet 5", note: "كتابة أدق" },
        "gemini-pro": { name: "Gemini 3.7 Flash", note: "استدلال قوي" },
        "claude-opus": { name: "Claude Opus 5", note: "أفضل كتابة" },
      },
      upgrade: {
        title: "{{model}} نموذج احترافي",
        body: "افتح كل النماذج بالإضافة إلى مسودّات ذكاء اصطناعي غير محدودة.",
        notNow: "ليس الآن",
        upgrade: "ترقية",
      },
      sectionDefaults: {
        summary:
          "ثلاثة أسطر مركّزة. ابدأ بالدور وسنوات الخبرة، واذكر نقطة قوة مميزة، واختم بإنجاز قابل للقياس. بلا مبالغات أو أرقام مُختلقة.",
        careerHighlights:
          "ثلاثة إلى أربعة إنجازات، كل منها سطر واحد بنتيجة قابلة للقياس (٪ أو درهم أو وقت موفَّر). ابدأ بالأكبر.",
        skills:
          "اجمعها حسب الموضوع (تصميم، أدوات، لغات). داخل كل مجموعة، ابدأ بالأكثر صلة بالوظيفة. احذف كل ما هو عام.",
        experience:
          "بترتيب زمني عكسي. سطر سياق واحد لكل دور، ثم نقاط تبدأ بفعل وتنتهي بنتيجة.",
        education:
          "ابدأ بالدرجة والمؤسسة والسنة. أضف المقررات أو التكريمات فقط عندما تعزز الدور المستهدف.",
        certifications:
          "اذكر الشهادة والجهة المانحة والسنة. أبقِ فقط على الشهادات الحالية وذات الصلة.",
        languages: "اذكر كل لغة بمستوى إتقان صادق.",
      },
    },
    run: "تشغيل",
    by: "بواسطة {{author}}",
    byTabbio: "بواسطة Tabbio",
    byTabbioName: "Tabbio",
    sort: {
      top: "الأعلى",
      new: "الأحدث",
      az: "أ–ي",
      popular: "الأكثر تثبيتًا",
    },
    board: { skill: "المهارة", activity: "النشاط", runs: "مرات التشغيل" },
    detail: {
      run: "تشغيل المهارة",
      runTune: "التشغيل والضبط",
      result: "النتيجة",
      summary: "الملخّص",
      howItWorks: "كيف تعمل",
      showContent: "عرض المحتوى",
      hideContent: "إخفاء المحتوى",
      contentCopied: "تم نسخ محتوى المهارة",
      copyFailed: "تعذر نسخ محتوى المهارة",
      linkCopied: "تم نسخ رابط المهارة",
      shareFailed: "تعذرت مشاركة هذه المهارة",
      needsLabel: "ما تحتاجه",
      givesLabel: "ما تحصل عليه",
      author: "المؤلف",
      usage: "الاستخدام",
      runs: "تشغيل",
      rating: "التقييم",
      category: "الفئة",
      tier: "الخطة",
      languages: "اللغات",
      version: "الإصدار",
      added: "أُضيفت",
      // صفوف بيانات كتالوج tabbio/v2
      recommendedModel: "النموذج الموصى به",
      reads: "تقرأ هذه المهارة",
      country: "الدولة",
      level: "المستوى",
      style: "التصميم",
      photoOn: "مع صورة",
      photoOff: "بدون صورة",
      actions: {
        export: "تصدير ‎.md",
        copyMd: "نسخ SKILL.md",
        edit: "تعديل",
        delete: "حذف",
      },
      exportCopied: "تم نسخ SKILL.md إلى الحافظة",
      exportDownloaded: "تم تنزيل SKILL.md",
      exportFailed: "تعذّر تصدير هذه المهارة",
      deleteTitle: "حذف المهارة",
      deleteMessage:
        "سيؤدي هذا إلى إزالة «{{name}}» من مهاراتك. لا يمكن التراجع عن ذلك.",
      deleteConfirm: "حذف",
      deleteCancel: "إلغاء",
      deleted: "تم حذف المهارة",
      deleteFailed: "تعذّر حذف المهارة",
      // المشاركة لمهارة خاصة تخصّك تنشرها أولاً.
      publish: {
        confirmTitle: "هل تريد جعل هذه المهارة عامة؟",
        confirmBody:
          "يمكن لأي شخص لديه الرابط عرضها وتشغيلها على {{link}}. يمكنك إعادتها إلى الوضع الخاص لاحقاً.",
        confirmAction: "النشر والمشاركة",
        published: "أصبحت مهارتك عامة",
        publishFailed: "تعذّر نشر هذه المهارة",
        unpublishTitle: "هل تريد جعل هذه المهارة خاصة؟",
        unpublishBody:
          "سيتوقف الرابط العام عن العمل فوراً. يمكنك نشرها مرة أخرى في أي وقت.",
        unpublishAction: "جعلها خاصة",
        unpublished: "أصبحت مهارتك خاصة",
        unpublishFailed: "تعذّر جعل هذه المهارة خاصة",
        publicBadge: "عامة",
        privateBadge: "خاصة",
        makePrivate: "جعلها خاصة",
      },
      needs: {
        cv: "سيرتك الذاتية",
        cv_jd: "سيرتك الذاتية + إعلان وظيفة",
        job: "وصف وظيفة",
        topic: "موضوع",
        text: "وصف مختصر",
        profile: "لا شيء: تعمل على ملفك الشخصي",
        none: "لا شيء",
      },
      gives: {
        cvEdit: "سيرة ذاتية مُحدَّثة",
        letter: "خطاب تغطية",
        post: "منشور جاهز للنشر",
        message: "رسالة تواصل",
        search: "نتائج وروابط بحث",
        plan: "خطة خطوة بخطوة",
        prep: "مواد تحضير للمقابلة",
        doc: "مستند جاهز للاستخدام",
      },
    },
    createSkill: "إنشاء مهارة",
    loadMore: "تحميل المزيد",
    loadFailed: "تعذّر تحميل المهارات",
    empty: {
      defaultTitle: "لا توجد مهارات بعد",
      defaultBody: "ستظهر هنا مهارات Tabbio المدمجة.",
      communityTitle: "مهارات المجتمع قادمة",
      communityBody: "ستظهر هنا المهارات التي يشاركها المجتمع بمجرد إطلاقها.",
      ownTitle: "لا توجد مهارات مثبّتة بعد",
      ownBody: "ثبّت مهارة من الاستكشاف أو أنشئ مهارتك الخاصة.",
      retryBody: "حدث خطأ ما. حاول مرة أخرى.",
      createdTitle: "لم تنشئ أي مهارة بعد",
      createdBody: "تظهر هنا المهارات التي تنشئها.",
    },
    menu: {
      publish: "نشر",
      publishConfirmTitle: "نشر المهارة",
      publishConfirmMessage: "إتاحة هذه المهارة للتشغيل. هل تريد المتابعة؟",
      published: "تم نشر المهارة",
      publishFailed: "تعذّر نشر المهارة",
    },
    runDialog: {
      previewSubtitle: "راجع ما ستغيّره {{name}} قبل التطبيق.",
      loading: "جارٍ تجهيز التغييرات…",
      noChanges: "لم تقترح هذه المهارة أي تغييرات.",
      changes: "التغييرات",
      nextActions: "الخطوات التالية",
      titleField: "العنوان",
      headlineField: "العنوان الرئيسي",
      summaryField: "النبذة",
      skillsField: "المهارات",
      apply: "تطبيق التغييرات",
      applying: "جارٍ التطبيق…",
      cancel: "إلغاء",
      done: "تم تطبيق المهارة",
      failed: "تعذّر تشغيل المهارة",
      blocked: "هذه المهارة محظورة. حدّث إعدادات وصول الوكيل لتشغيلها.",
      configureSubtitle: "اطّلع على ما تفعله، ثم طبّقها على سيرة ذاتية.",
      configureTextSubtitle: "أضف ما تحتاجه المهارة، ثم شغّلها.",
      resultSubtitle: "هذه هي التغييرات: احتفظ بها أو تراجع عنها.",
      resultTextSubtitle: "نتيجتك جاهزة للاستخدام.",
      whatItDoes: "ماذا تفعل",
      applyTo: "تطبيق على",
      allowanceTitle: "مرات تشغيل المهارات",
      allowanceChecking: "جارٍ التحقق من رصيد تشغيل المهارات…",
      allowanceUnavailable:
        "معلومات الاستخدام غير متاحة مؤقتًا. سيجري التحقق من أهليتك قبل بدء التشغيل.",
      allowanceSummary:
        "{{included}} مشمولة · {{used}} مستخدمة · {{remaining}} متبقية",
      allowanceResets: "يتجدد في {{date}}",
      allowanceIncluded: "مشمولة في خطتك الحالية",
      allowanceUpgrade: "عرض Plus",
      run: "تشغيل المهارة",
      running: "جارٍ تطبيق {{name}}…",
      runningText: "جارٍ تشغيل {{name}}…",
      runningHint: "يستغرق ذلك عادةً بضع ثوانٍ.",
      appliedTo: "طُبّقت على {{cv}}",
      yourCv: "سيرتك الذاتية",
      viewCv: "عرض السيرة المُحدّثة",
      undo: "تراجع",
      undoing: "جارٍ التراجع…",
      undone: "تم التراجع: سيرتك الذاتية كما كانت.",
      undoFailed: "تعذّر التراجع. حاول مرة أخرى.",
      noChangesTitle: "لا حاجة لأي تغييرات",
      safeNote: "يعمل على نسخة: تبقى سيرتك الأصلية دون تغيير.",
      // B09: the CV changed (or the write would differ) after the review.
      reviewAgain:
        "تغيّرت سيرتك الذاتية أو طريقة حفظ هذا التشغيل بعد مراجعته، لذلك لم يتغيّر شيء ولم يُستخدم أي رصيد. شغّل المهارة مرة أخرى لمراجعة أحدث نسخة.",
      loadingCvs: "جارٍ تحميل سيرك الذاتية…",
      untitledCv: "سيرة ذاتية بدون عنوان",
      noCvBody: "ليس لديك سيرة ذاتية بعد. أنشئ واحدة ثم شغّل المهارات عليها.",
      createCv: "إنشاء سيرة ذاتية",
      importCv: "استيراد سيرة ذاتية",
      importCvFromDevice: "استيراد سيرة ذاتية من جهازك",
      importing: "جارٍ استيراد سيرتك الذاتية…",
      importFailed: "تعذّر استيراد هذه السيرة الذاتية. جرّب ملفًا آخر.",
      tryAgain: "حاول مرة أخرى",
      doneButton: "تم",
      regenerate: "إعادة توليد",
      copy: "نسخ",
      copied: "تم النسخ إلى الحافظة",
      copyFailed: "تعذّر النسخ",
      applyMode: "طريقة الحفظ",
      modeUpdate: "تحديث هذه السيرة",
      modeNewVersion: "حفظ كنسخة جديدة",
      versionNamePlaceholder: "سمِّ هذه النسخة (مثال: مخصّصة: مدير منتج)",
      updateNote: "تُطبَّق التغييرات على هذه السيرة. يمكنك التراجع لاحقًا.",
      updatedCv: "تم تحديث {{cv}}",
      jobLabel: "إعلان الوظيفة أو وصفها",
      jobPlaceholder: "الصق إعلان الوظيفة أو وصفها أو رابطًا…",
      topicLabel: "عمّ سيكون؟",
      topicPlaceholder: "مثال: دروس من إطلاق أول ميزة لي",
      freeTextLabel: "أخبر Tabbio بالمزيد",
      freeTextPlaceholder: "صِف وضعك أو دورك أو ما تحتاجه…",
      profileNote: "يعمل هذا على ملفك الشخصي: لا حاجة لأي إدخال.",
      textReady: "جاهزة للاستخدام",
      noOutput: "لم يُنتَج أي مخرَج.",
      selectPlaceholder: "اختر…",
    },
    // CV spine B05: an undo that would replace edits made after the run.
    undoConflict: {
      title: "عدّلت هذه السيرة الذاتية بعد تشغيل المهارة",
      message:
        "التراجع الآن سيستبدل تعديلاتك الأحدث على: {{fields}}. هل تريد استعادة ما غيّرته المهارة على أي حال، أم الاحتفاظ بتعديلاتك؟",
      unknownMessage:
        "هذا التشغيل أقدم من قدرة التراجع على التمييز بين تعديلاتك وتعديلات المهارة. الاستعادة تُرجع السيرة الذاتية كما كانت قبل التشغيل وتستبدل: {{fields}}.",
      restoreAnyway: "استعادة على أي حال",
      keepEdits: "الاحتفاظ بتعديلاتي",
      copyTitle: "تم الاحتفاظ بالنسخة",
      copyMessage:
        "عدّلت النسخة التي أنشأتها هذه المهارة، لذلك لم تُحذف. يمكنك حذفها من سيرك الذاتية إذا لم تعد تحتاج إليها.",
      unavailableTitle: "لا يمكن التراجع عن هذا التشغيل",
      unavailableMessage:
        "لم يحتفظ هذا التشغيل بسيرتك الذاتية كما كانت قبله، لذلك لا يمكن التراجع عنه. لم يتغيّر شيء.",
      ok: "حسنًا",
      separator: "، ",
      fields: {
        title: "اسم السيرة الذاتية",
        summary: "النبذة",
        headline: "العنوان المهني",
        contact: "بيانات التواصل",
        skills: "المهارات",
        experience: "الخبرات",
        education: "التعليم",
        certifications: "الشهادات",
        highlights: "أبرز الإنجازات",
        projects: "المشاريع",
        languages: "اللغات",
        design: "التصميم",
        layout: "ترتيب الأقسام",
        content: "محتوى السيرة الذاتية",
        other: "تفاصيل أخرى",
      },
    },
    create: {
      title: "إنشاء مهارة",
      nameLabel: "الاسم",
      namePlaceholder: "مثال: تحسين نبذتي",
      descriptionLabel: "ماذا تفعل",
      descriptionPlaceholder: "استخدمها عندما… (يظهر على البطاقة)",
      instructionsLabel: "التعليمات",
      instructionsPlaceholder: "صف الطريقة التي يجب أن تتبعها المهارة.",
      submit: "إنشاء مهارة",
      creating: "جارٍ الإنشاء…",
      created: "تم إنشاء المهارة",
      failed: "تعذّر إنشاء المهارة",
      nameRequired: "أضف اسماً.",
      descriptionRequired: "أضف وصفاً من سطر واحد.",
    },
    // المهارات ثنائية الاتجاه: معالج الإنشاء من ٥ خطوات (الويب يملك هذه المفاتيح؛ الأصلي يعيد استخدامها)
    builder: {
      title: "إنشاء مهارة",
      editTitle: "تعديل المهارة",
      drafting: "جارٍ الصياغة\u2026",
      generateFailed: "تعذّرت صياغة هذه المهارة. ما زال بإمكانك بناؤها بنفسك.",
      generateRetry: "البناء يدويًا",
      stepLabel: "الخطوة {{current}} من {{total}}",
      steps: {
        basics: "الأساسيات",
        type: "النوع",
        style: "التنسيق",
        sections: "الأقسام",
        review: "المراجعة",
      },
      back: "رجوع",
      next: "التالي",
      create: "إنشاء المهارة",
      save: "حفظ التغييرات",
      saving: "جارٍ الحفظ…",
      created: "تم إنشاء المهارة",
      saved: "تم تحديث المهارة",
      failed: "تعذّر حفظ المهارة",
      basics: {
        nameLabel: "الاسم",
        namePlaceholder: "مثال: سيرة خريج جديد في الكويت",
        descriptionLabel: "ماذا تفعل",
        descriptionPlaceholder:
          "سطر أو سطران يظهران على البطاقة: متى تُستخدم هذه المهارة.",
        nameRequired: "أضف اسماً.",
        descriptionRequired: "أضف وصفاً قصيراً.",
      },
      type: {
        label: "ما نوع هذه المهارة؟",
        portableTitle: "تعليمات قابلة للنقل",
        portableBody:
          "ملف SKILL.md قياسي: تعليمات يتبعها الوكيل. صدّرها وشاركها في أي مكان.",
        customTitle: "مهارة سيرة ذاتية مخصّصة",
        customBody:
          "اختر تنسيق السيرة ولون التمييز والأقسام، ثم وجّه كل قسم بتوجيهات. تُطبَّق بنقرة واحدة.",
        instructionsLabel: "التعليمات",
        instructionsPlaceholder:
          "صف الطريقة التي يجب أن تتبعها المهارة خطوة بخطوة…",
        instructionsHint:
          "هذه هي طريقة عمل المهارة: ما يقرؤه الوكيل عند تشغيلها.",
        charCount: "{{used}} / {{max}}",
      },
      style: {
        layoutLabel: "التخطيط",
        colorLabel: "لون التمييز",
        layouts: {
          MODERN: "عصري",
          CLASSIC: "كلاسيكي",
          EXECUTIVE: "تنفيذي",
          CREATIVE: "إبداعي",
        },
        colors: {
          BLACK: "أسود",
          BLUE: "أزرق",
          PURPLE: "بنفسجي",
          EMERALD: "زمردي",
          RED: "أحمر",
          ORANGE: "برتقالي",
        },
      },
      sectionsStep: {
        hint: "اختر الأقسام التي تتضمنها هذه السيرة الذاتية وترتيبها. أضف توجيهاً لتحديد طريقة كتابة كل قسم.",
        needOne: "ضمّن قسماً واحداً على الأقل.",
        moveUp: "نقل لأعلى",
        moveDown: "نقل لأسفل",
        dragHint: "اسحب لإعادة الترتيب",
        addSection: "إضافة {{name}}",
        suggest: "اقتراح بالذكاء الاصطناعي",
        suggestFailed: "تعذّر اقتراح تعليمات. سنعرض الافتراضي بدلًا من ذلك.",
        suggesting: "جارٍ الاقتراح…",
        regenerate: "إعادة التوليد",
        promptCount: "{{used}} / {{max}}",
        names: {
          summary: "النبذة",
          careerHighlights: "أبرز الإنجازات",
          skills: "المهارات",
          experience: "الخبرة",
          education: "التعليم",
          projects: "المشاريع",
          certifications: "الشهادات",
          languages: "اللغات",
        },
        prompts: {
          summary:
            "مثال: ٣ أسطر كحد أقصى، بأسلوب حيوي، دون عبارات مبتذلة أو أرقام مختلقة.",
          careerHighlights: "مثال: ٣–٤ إنجازات، لكل منها نتيجة قابلة للقياس.",
          skills:
            "مثال: جمّعها حسب الموضوع؛ ابدأ بالمهارات الأكثر صلة بالوظيفة.",
          experience:
            "مثال: اعرض فترات التدريب كأثر ملموس. العمل التطوعي يُحتسب.",
          education: "مثال: ابدأ بالشهادة. اذكر المقررات فقط إذا كانت ذات صلة.",
          projects: "صف العمل باستخدام حقائق المشروع الواردة في المصدر فقط.",
          certifications: "مثال: الأحدث أولاً؛ احذف منتهية الصلاحية.",
          languages: "مثال: فقط اللغات التي يمكنك العمل بها؛ اذكر المستوى.",
        },
      },
      review: {
        name: "الاسم",
        description: "الوصف",
        type: "النوع",
        typePortable: "تعليمات قابلة للنقل",
        typeCustom: "مهارة سيرة ذاتية مخصّصة",
        style: "التنسيق",
        color: "لون التمييز",
        sections: "الأقسام",
        withPrompt: "مع توجيه",
        instructions: "التعليمات",
        noInstructions: "لم تُضف تعليمات.",
        privateNote: "تبقى مهارتك خاصة بك. يمكنك تصديرها أو نشرها لاحقاً.",
      },
    },
    // استيراد SKILL.md (لصق أو رفع): مدخل في المركز بجانب الإنشاء
    import: {
      entry: "استيراد مهارة",
      title: "استيراد مهارة",
      subtitle:
        "الصق محتوى SKILL.md أو ارفع الملف: تعمل مهارات Tabbio والمهارات القياسية القابلة للنقل على حد سواء.",
      pasteLabel: "محتوى SKILL.md",
      pastePlaceholder: "---\nname: …\ndescription: …\n---\n…",
      uploadLabel: "رفع ملف ‎.md",
      fileTooLarge: "هذا الملف كبير جداً. الحد الأقصى 200 كيلوبايت.",
      readFailed: "تعذّرت قراءة هذا الملف.",
      required: "الصق محتوى SKILL.md أو ارفع ملفاً.",
      errorLabel: "مشكلة في ملف SKILL.md هذا",
      submit: "استيراد المهارة",
      importing: "جارٍ الاستيراد…",
      imported: "تم استيراد المهارة",
      failed: "تعذّر استيراد هذه المهارة",
    },
    // Shared discard-draft confirmation (builder wizard + import dialog)
    discard: {
      title: "تجاهل التغييرات؟",
      message:
        "لديك تغييرات غير محفوظة على هذه المهارة. هل تريد الإغلاق وتجاهلها؟",
      confirm: "تجاهل",
    },
    picker: {
      title: "تطبيق مهارة",
      subtitle: "اختر مهارة لتشغيلها على هذه السيرة الذاتية.",
      empty: "لا توجد مهارات متاحة للتشغيل.",
    },
    // ورقة التأكيد الأصلية (إعادة كتابة السيرة الذاتية بالكامل)
    confirm: {
      title: "تأكيد تحديث السيرة الذاتية بالكامل",
      message:
        "ستعيد هذه المهارة كتابة سيرتك الذاتية بالكامل. راجع المعاينة ثم أكّد للتطبيق.",
      confirmCta: "تأكيد وتطبيق",
    },
    // بطاقات أدوات المحادثة الأصلية
    card: {
      label: "مهارة",
      runTitle: "تشغيل مهارة",
      publishTitle: "نشر مهارة",
      created: "تم إنشاء مهارة",
      published: "تم نشر مهارة",
      previewBadge: "معاينة",
      listLabel: "المهارات",
      listEmpty: "لا توجد مهارات مطابقة.",
      openHint: "افتح هذه المهارة لتشغيلها",
      selectHint: "اختر هذه المهارة في محادثة الوكيل",
      appliedBadge: "تم التطبيق",
      // الفئات الست مطلوبة: بدون _zero/_two/_few/_many كان i18next يعود إلى
      // الإنجليزية عند 0 و2 و3–99 فيظهر "3 skills" داخل واجهة عربية.
      count_zero: "لا توجد مهارات",
      count_one: "مهارة واحدة",
      count_two: "مهارتان",
      count_few: "{{count}} مهارات",
      count_many: "{{count}} مهارة",
      count_other: "{{count}} مهارة",
      showAll_zero: "عرض المهارات",
      showAll_one: "عرض المهارة",
      showAll_two: "عرض المهارتين",
      showAll_few: "عرض كل المهارات الـ{{count}}",
      showAll_many: "عرض كل المهارات الـ{{count}}",
      showAll_other: "عرض كل المهارات الـ{{count}}",
      forYou: "مهارات مقترحة لك",
    },
  },

  // الموصلات (M3.3): سطحا الأدوات والذكاء الاصطناعي
  connectors: {
    simple: {
      setupFailed: "تعذر تحميل تفاصيل الاتصال. يرجى المحاولة مجددًا.",
      aiDescription: "استخدم تابيو مع {{name}}.",
      available: "التطبيقات المتاحة",
      back: "العودة إلى الموصلات",
      disconnectName: "قطع الاتصال بـ {{name}}",
      actionFailed: "تعذر تحديث هذا الاتصال. يرجى المحاولة مجددًا.",
    },
    title: "الموصلات",
    subtitle: "اربط Tabbio بالتطبيقات وأدوات الذكاء الاصطناعي التي تستخدمها.",
    nativeSubtitle: "تطبيقات يمكنها قراءة سيرتك الذاتية.",
    searchPlaceholder: "ابحث في الموصلات",
    sections: {
      connected: "متصل",
      tools: "الأدوات",
      ai: "مساعدو الذكاء الاصطناعي",
    },
    endpoint: {
      title: "نقطة اتصال Tabbio الخاصة بك",
      hint: "وجّه أدوات الذكاء الاصطناعي إلى هذا العنوان.",
      copy: "نسخ",
      copied: "تم النسخ",
      copyFailed: "تعذّر النسخ إلى الحافظة",
      loading: "جارٍ تحميل نقطة الاتصال…",
    },
    soon: "قريباً",
    connect: "ربط",
    connectName: "ربط {{name}}",
    toast: {
      connected: "تم الربط",
      disconnected: "تم قطع الربط",
    },
    consent: {
      willBeAbleTo: "سيتمكن من",
      willNot: "لن يتمكن من",
      canEditCv: "تعديل سيرتك الذاتية",
      canReadCv: "عرض سيرتك الذاتية ومهاراتك",
      runYourSkills: "تشغيل مهاراتك",
      canTailorCv: "تخصيص سيرتك الذاتية",
      canFindJobs: "البحث عن وظائف",
      canDownloadResume: "تنزيل سيرتك الذاتية بأي صيغة",
      cannotAccessAccount: "الوصول إلى إعدادات حسابك أو حذف حسابك",
      disconnectAnytime: "يمكنك فصل الاتصال في أي وقت.",
      finishTitle: "أكمل في {{name}}",
      finishHint: "انسخ العنوان والرمز إلى {{name}} لإتمام الربط.",
    },
    connecting: "جارٍ الربط…",
    manage: "إدارة",
    manageSubtitle: "راجع الصلاحيات وافصل الاتصال",
    revoke: "فصل الاتصال",
    revoking: "جارٍ فصل الاتصال…",
    revokeTitle: "فصل الاتصال بـ {{name}}؟",
    revokeMessage:
      "سيفقد Tabbio الوصول إلى هذا الموصل. يمكنك إعادة الربط في أي وقت.",
    grantedAccess: "الصلاحيات الممنوحة",
    noScopes: "لم تتم مشاركة أي صلاحيات محددة.",
    loadingScopes: "جارٍ تحميل الصلاحيات…",
    loading: "جارٍ تحميل الموصلات…",
    loadFailed: "تعذّر تحميل الموصلات",
    loadFailedBody: "حدث خطأ ما. حاول مرة أخرى.",
    empty: {
      title: "لا توجد موصلات",
      body: "جرّب كلمة بحث مختلفة.",
    },
    status: {
      connected: "متصل",
      notConnected: "غير متصل",
      comingSoon: "قريباً",
    },
    aiHint:
      "اربط Tabbio بمساعد الذكاء الاصطناعي عبر MCP لاستخدام بيانات مسارك المهني في أي مكان.",
    aiSetupNote: "الإعداد بالأسفل",
    setup: {
      subtitle: "اربط {{name}} بـ Tabbio في خطوات قليلة.",
      comingSoonSubtitle: "قريبًا",
      comingSoonBody:
        "نضع اللمسات الأخيرة على هذا. ستتمكّن من ربط {{name}} قريبًا.",
      introFallback:
        "اربط {{name}} بـ Tabbio عبر MCP ليستفيد من سيرتك الذاتية ومهاراتك وبياناتك المهنية.",
      stepsLabel: "طريقة الربط",
      configLabel: "الإعدادات",
      commandLabel: "الأمر",
      serverUrl: "رابط الخادم",
      token: "رمز الوصول",
      generateToken: "إنشاء رمز",
      generating: "جارٍ الإنشاء…",
      regenerate: "إنشاء رمز جديد",
      revoke: "إلغاء",
      revokeTitle: "إلغاء الرمز؟",
      revokeBody:
        "سيفقد أي مساعد ذكاء اصطناعي يستخدم هذا الرمز إمكانية الوصول حتى تعيد الإعداد.",
      revoked: "تم إلغاء الرمز",
      tokenActive: "الرمز نشط",
      oneTimeWarning: "انسخ هذا الرمز الآن: لن نعرضه مرة أخرى.",
      needTokenForCode: "أنشئ رمزًا بالأعلى ليُملأ هنا تلقائيًا.",
      personalAccess: "يمنح الوصول إلى ملفك الشخصي وسيرتك الذاتية وطلباتك فقط.",
      copy: "نسخ",
      copied: "تم النسخ",
      copyFailed: "تعذّر النسخ إلى الحافظة",
      tokenFailed: "تعذّر تحديث الرمز",
      openDocs: "دليل الإعداد",
      done: "تم",
      chatgpt: {
        intro:
          "استخدم Tabbio داخل ChatGPT: يمكنه قراءة سيرتك الذاتية وبياناتك المهنية لمساعدتك في التقديم.",
        steps: [
          "في ChatGPT، افتح الإعدادات ← Connectors (يجب تفعيل Developer Mode: لخطط Plus أو Pro أو Business أو Enterprise أو Edu).",
          "اضغط “Create” وسمِّه “Tabbio” والصق رابط الخادم بالأسفل.",
          "عند طلب المصادقة، الصق الرمز بالأسفل كـ Bearer token.",
          "احفظ. في المحادثة، افتح + ← Developer mode واختر Tabbio.",
        ],
      },
      claude: {
        intro:
          "أضِف Tabbio كموصّل مخصّص في Claude Desktop أو claude.ai أو Claude for Work.",
        steps: [
          "في Claude، اضغط + في مربّع الرسالة ← Connectors ← Manage connectors.",
          "اختر “Add custom connector”.",
          "الصق رابط الخادم بالأسفل. من Advanced settings، أضِف الرمز كترويسة Bearer.",
          "فعّل موصّل Tabbio وابدأ المحادثة.",
        ],
      },
      gemini: {
        intro: "أضِف Tabbio إلى Gemini CLI كخادم MCP.",
        steps: [
          "افتح ملف settings.json الخاص بـ Gemini CLI.",
          "أضِف الإعدادات بالأسفل داخل mcpServers.",
          "احفظ وأعد تشغيل Gemini CLI ثم شغّل /mcp للتأكد من اتصال Tabbio.",
        ],
      },
      grok: {
        intro: "أضِف Tabbio إلى Grok كموصّل MCP مخصّص.",
        steps: [
          "افتح grok.com/connectors.",
          "اضغط New Connector ثم اختر Custom.",
          "الصق رابط الخادم بالأسفل وأكمل المصادقة المطلوبة.",
          "سيكتشف Grok أدوات Tabbio ويجعلها متاحة داخل المحادثات.",
        ],
      },
      perplexity: {
        intro:
          "يدعم Perplexity حاليًا MCP المحلي على Mac. سيظهر Tabbio هنا عند إتاحة Remote MCP في Perplexity.",
        steps: [
          "افتح Perplexity على Mac وانتقل إلى Account settings ← Connectors.",
          "ثبّت مساعد PerplexityXPC إذا طُلب منك ذلك.",
          "Remote MCP غير متاح للجميع بعد. راجع دليل الإعداد لمعرفة حالة الطرح.",
        ],
      },
    },
    // بطاقات أدوات المحادثة لموصلات M3.2
    card: {
      connectedLabel: "الخدمات المتصلة",
      emailsLabel: "أحدث الرسائل البريدية",
      messagesLabel: "أحدث الرسائل",
      listEmpty: "لا يوجد ما يُعرض بعد.",
      more: "+{{count}} المزيد",
      actionLabel: "إجراء موصل",
      sendEmailTitle: "إرسال بريد إلكتروني",
      postSlackTitle: "إرسال رسالة Slack",
      zapierTitle: "تشغيل سير عمل Zapier",
      makeTitle: "تشغيل سيناريو Make",
      sentEmail: "تم إرسال البريد الإلكتروني",
      postedSlack: "تم إرسال الرسالة",
      triggered: "تم تشغيل الأتمتة",
      confirm: "هل تريد تنفيذ إجراء الموصل هذا؟",
      fieldTo: "إلى",
      fieldSubject: "الموضوع",
      fieldChannel: "القناة",
      fieldMessage: "الرسالة",
      fieldWorkflow: "سير العمل",
      fieldScenario: "السيناريو",
    },
  },
  nova: {
    title: "الأتمتة",
    subtitle:
      "جدولة مهام تعمل نيابةً عنك، وأنت توافق على كل مسودة قبل إرسال أي شيء.",
    proBadge: "برو",
    lockedTitle: "تعرّف على وكيلك المهني",
    lockedSubtitle:
      "مساعدك الآلي في البحث عن عمل. يفحص وكيلك المهني الوظائف ويجد المطابقات ويُعدّ المسودات وفق جدول، وأنت توافق قبل إرسال أي شيء.",
    locked: {
      benefits: {
        scan: {
          title: "تعمل أثناء غيابك",
          body: "يفحص وكيلك المهني الوظائف الجديدة حسب جدولك حتى عندما يكون التطبيق مغلقًا.",
        },
        drafts: {
          title: "مسودات، لا إرسال تلقائي",
          body: "تُجهَّز الطلبات والردود كمسودات تراجعها وتوافق عليها أولًا.",
        },
        results: {
          title: "النتائج أينما كنت",
          body: "تصلك المطابقات كإشعارات وملخصات بريدية، مع ظهور كل تشغيل على لوحتك.",
        },
      },
    },
    board: {
      newAutomation: "أتمتة جديدة",
      loading: "جارٍ تحميل الأتمتة الخاصة بك…",
      loadFailed: "تعذّر تحميل الأتمتة الخاصة بك",
      loadFailedBody: "حدث خطأ ما. يرجى المحاولة مرة أخرى.",
      empty: {
        title: "لا توجد أتمتة بعد",
        body: "ابدأ من قالب، أو صِف المهمة بكلماتك.",
        cta: "أتمتة جديدة",
      },
      nextRun: "التشغيل التالي {{when}}",
      noSchedule: "بلا جدول ثابت",
      viewHistory: "عرض سجل التشغيل",
      yourAutomations: "أتمتتك",
      activeMeter: "{{active}} من {{max}} نشطة",
      lastRan: "شُغِّلت {{when}}",
      getStarted: "ابدأ",
      finishSetup: "أكمل الإعداد",
      draftNeedsSetup: "مسودة · أكمل الإعداد",
      draftProRequired: "مسودة · يلزم برو للتفعيل",
      filter: {
        label: "تصفية",
        all: "الكل",
        active: "نشِطة",
        paused: "موقوفة مؤقتًا",
      },
      filteredEmpty: {
        active: "لا توجد أتمتة نشطة",
        paused: "لا توجد أتمتة موقوفة مؤقتًا",
      },
    },
    composer: {
      placeholder: "إنشاء مهمة",
      send: "إرسال",
      add: "خيارات إضافية",
      discard: "تجاهل",
      controls: "عناصر التحكم في البحث والنتيجة",
      controlsTitle: "البحث والنتائج",
      controlsClose: "إغلاق",
    },
    cadence: {
      daily: "يوميًا",
      weekdays: "أيام العمل",
      weekly: "أسبوعيًا",
      monthly: "شهريًا",
      custom: "مخصصة",
    },
    timeOfDay: {
      morning: "صباحًا",
      afternoon: "ظهرًا",
      evening: "مساءً",
      night: "ليلًا",
    },
    approvals: {
      title: "بحاجة إلى موافقتك",
      review: "مراجعة",
      draftReady: "مسودة جاهزة للمراجعة",
      jobMatches_one: "وظيفة مطابقة واحدة",
      jobMatches_other: "{{count}} وظيفة مطابقة",
    },
    limit: {
      title: "بلغت حد الأتمتة",
      body: "يمكنك إبقاء {{max}} أتمتة نشطة كحد أقصى. أوقف واحدة مؤقتًا أو قم بالترقية للمزيد.",
    },
    rateLimit: {
      automation: {
        title: "تم التشغيل اليوم بالفعل",
        body: "تعمل هذه الأتمتة مرة واحدة يوميًا، وستعمل مجددًا غدًا.",
      },
      user: {
        title: "بلغت حد الأتمتة اليومي",
        body: "لقد بلغت حد اليوم عبر جميع أتمتتك. تتم إعادة التعيين غدًا.",
      },
      concurrency: {
        title: "هناك تشغيل قيد التنفيذ بالفعل",
        body: "امنح التشغيل الحالي لحظة لينتهي ثم حاول مرة أخرى.",
      },
    },
    status: {
      draft: "مسودة",
      active: "نشِطة",
      paused: "موقوفة مؤقتًا",
      archived: "مؤرشفة",
    },
    actions: {
      pause: "إيقاف مؤقت",
      resume: "استئناف",
      edit: "تعديل",
      delete: "حذف",
      runNow: "تشغيل الآن",
    },
    delete: {
      confirmTitle: "حذف هذه الأتمتة؟",
      confirmMessage:
        "سيتوقف وكيلك المهني عن تشغيلها. لا يمكن التراجع عن هذا الإجراء.",
      failed: "تعذّر حذف هذه الأتمتة",
    },
    lifecycle: {
      paused: "تم إيقاف الأتمتة مؤقتًا",
      resumed: "تم استئناف الأتمتة",
      failed: "تعذّر تحديث هذه الأتمتة",
      runStarted: "بدأ التشغيل",
      runFailed: "تعذّر بدء التشغيل",
      rateLimited: "لقد بلغت حد الأتمتة لليوم. حاول لاحقًا.",
    },
    templates: {
      label: "القوالب",
      use: "استخدام القالب",
      add: "إضافة",
      enabled: "تمت إضافته إلى لوحتك",
      draftCreated: "تمت إضافة المسودة. أكمل الإعداد للتفعيل",
      enableFailed: "تعذّرت إضافة هذا القالب",
    },
    builder: {
      title: "أتمتة جديدة",
      editTitle: "تحسين الأتمتة",
      taskLabel: "ماذا يجب أن يفعل وكيلك المهني؟",
      taskPlaceholder:
        "مثال: كل يوم اثنين الساعة 9 صباحًا، ابحث عن وظائف جديدة تناسب سيرتي الذاتية وجهّز طلبات لمراجعتها.",
      scheduleLabel: "الجدول (اختياري)",
      schedulePlaceholder: "مثال: كل يوم عمل الساعة 8 صباحًا",
      scheduleHelp: "اتركه فارغًا وسيستنتج وكيلك المهني الجدول من وصفك.",
      compile: "بناء الخطة",
      compiling: "جارٍ بناء خطتك…",
      compilingHint:
        "يحوّل وكيلك المهني كلماتك إلى خطة خطوة بخطوة. يستغرق الأمر عادةً بضع ثوانٍ.",
      recompile: "إعادة بناء الخطة",
      compileFailed: "تعذّر على وكيلك المهني بناء خطة",
      compileFailedBody: "حاول وصف المهمة بطريقة مختلفة قليلًا.",
      emptyTask: "صِف أولًا ما يجب أن يفعله وكيلك المهني.",
      planTitle: "خطة الوكيل المهني",
      summaryLabel: "الملخّص",
      whenLabel: "وقت التشغيل",
      sentenceLabel: "بلغة عادية",
      cronLabel: "تعبير الجدولة",
      triggerEventLabel: "المُشغِّل",
      stepsLabel: "الخطوات",
      outputsLabel: "النتائج",
      showDetails: "عرض التفاصيل",
      hideDetails: "إخفاء التفاصيل",
      stepDryRun: "مسودة فقط",
      stepApproval: "يتطلّب موافقتك",
      stepLive: "يعمل تلقائيًا",
      trustLabel: "أنا أثق بهذا، طبّقه تلقائيًا",
      trustHelp:
        "قريبًا. في الوقت الحالي يجهّز وكيلك المهني مسودة دائمًا وينتظر موافقتك قبل إرسال أي شيء.",
      safetyNote:
        "يُجهّز وكيلك المهني المسودات فقط. لا يُرسَل أو يُقدَّم أي شيء حتى تراجعه وتوافق عليه.",
      approve: "الموافقة والتفعيل",
      activating: "جارٍ التفعيل…",
      activated: "تم تفعيل الأتمتة",
      activatedWithRun: "تم التفعيل. أول تشغيل {{when}}",
      activatedHint: "سنُعلمك عندما تكون هناك نتيجة للمراجعة.",
      activateFailed: "تعذّر تفعيل هذه الأتمتة",
      validationFailed: "أصلح المشكلات المميّزة قبل التفعيل.",
      connectTitle: "اربط تطبيقًا أولًا",
      connectBody:
        "يحتاج وكيلك المهني إلى الوصول إلى {{apps}} لتشغيل هذه الأتمتة.",
      connectCta: "ربط التطبيقات",
      rateLimited:
        "لقد بلغت حد الأتمتة لهذا اليوم. حاول مرة أخرى خلال {{seconds}} ثانية.",
      controlsLabel: "البحث والنتائج",
      controlsHint:
        "اختر ما إذا كانت هذه المهمة تبحث في الويب وتضيف صورة، وما الذي ترسله إليك.",
    },
    runs: {
      title: "سجل التشغيل",
      subtitle: "كل ما فعله وكيلك المهني، مع المسودات التي أنتجها.",
      empty: {
        title: "لا عمليات تشغيل بعد",
        body: "عند تشغيل هذه الأتمتة، سترى ما فعلته هنا.",
      },
      loadFailed: "تعذّر تحميل سجل التشغيل",
      filterStatus: "الحالة",
      filterAll: "الكل",
      allAutomations: "كل الأتمتة",
      startedAt: "بدأ {{when}}",
      scheduledFor: "مجدول لـ {{when}}",
      stepsLabel: "الخطوات",
      outputsLabel: "المُنتَج",
      draftLabel: "مسودة",
      approve: "موافقة",
      reject: "رفض",
      approved: "تمت الموافقة",
      rejected: "مرفوض",
      approveFailed: "تعذّر تحديث هذا التشغيل",
      viewRun: "عرض التشغيل",
      runStatus: {
        queued: "في قائمة الانتظار",
        running: "قيد التشغيل",
        succeeded: "تم",
        failed: "فشل",
        skipped: "تم التخطّي",
        killed: "متوقف",
        awaiting_approval: "بانتظار الموافقة",
      },
      skipReason: {
        entitlement: "تم التخطّي: يلزم اشتراك برو",
        inactive: "تم التخطّي: هذه المهمة لم تكن نشطة",
        no_version: "تم التخطّي: لا توجد خطة محفوظة لهذه المهمة",
        rate_automation: "تم التخطّي: بلغت هذه المهمة حدّ التشغيل اليومي",
        rate_user: "تم التخطّي: بلغت الحدّ اليومي لجميع مهامك",
        rate_concurrency: "تم التخطّي: كان تشغيل سابق لا يزال قيد التنفيذ",
        kill_switch: "تم التخطّي: المهام متوقفة مؤقتًا",
      },
      failReason: {
        research_no_sources:
          "لم نعثر على مصادر حديثة هذه المرة. سيحاول التشغيل التالي مجددًا.",
        research_failed:
          "لم تستجب خدمة البحث. سيحاول التشغيل التالي مجددًا.",
        research_limit: "بلغت هذه المهمة حدّ البحث المسموح به في التشغيل الواحد.",
        sources_unreadable:
          "تعذّرت قراءة جميع المصادر. تحقّق من الرابط أو الملف.",
        capability_unavailable:
          "البحث أو المستندات غير متاحة لحسابك حاليًا.",
        credits_exhausted:
          "نفدت أرصدتك لهذا اليوم. سيحاول التشغيل التالي مجددًا.",
        report_failed: "تعذّرت كتابة التقرير هذه المرة.",
        render_failed: "تعذّر إنشاء المستند هذه المرة.",
        invalid_plan: "تحتاج هذه المهمة إلى إعادة بناء. عدّل خطتها.",
      },
    },
    runPanel: {
      title: "تشغيل الأتمتة",
      liveTitle: "وكيلك المهني يعمل الآن…",
      liveHint: "تظهر النتائج فور اكتمال كل خطوة.",
      awaitingTitle: "بانتظار موافقتك",
      awaitingHint: "أعدّ وكيلك المهني مسودات. لن يُرسَل أي شيء حتى توافق.",
      failedTitle: "لم يكتمل هذا التشغيل",
      failedHint: "لم يُرسَل أي شيء. حاول التشغيل مرة أخرى بعد قليل.",
      doneWithMatches_one: "تم. عُثر على وظيفة مطابقة واحدة",
      doneWithMatches_other: "تم. عُثر على {{count}} وظيفة مطابقة",
      doneHint: "اضغط على أي نتيجة لعرض الوظيفة.",
      doneGeneric: "تم. نتيجتك جاهزة",
      doneGenericHint: "راجع النتيجة الكاملة أدناه.",
      noResults: "لا نتائج جديدة هذه المرة",
      noResultsHint:
        "سيواصل وكيلك المهني البحث حسب الجدول وسيُعلمك عند وجود جديد.",
      resultsLabel: "ما وجده وكيلك المهني",
      detailsLabel: "تفاصيل النتيجة",
      loadFailed: "تعذّر تحميل هذا التشغيل",
      notFoundTitle: "هذه النتيجة لم تعد متاحة",
      notFoundHint: "ربما حُذفت، أو أنها تخص حسابًا آخر.",
      backToTasks: "العودة إلى المهام",
      retry: "إعادة المحاولة",
      nothingNewHint:
        "راجع وكيلك المهني مصادره مجددًا ولم يجد جديدًا، لذلك لم يُرسل شيء.",
    },
    results: {
      matchesFound_one: "عُثر على وظيفة مطابقة واحدة",
      matchesFound_other: "عُثر على {{count}} وظيفة مطابقة",
      digestReady_one: "الملخص جاهز مع وظيفة واحدة",
      digestReady_other: "الملخص جاهز مع {{count}} وظيفة",
      draftAwaiting: "المسودة جاهزة بانتظار موافقتك",
      scoreLabel: "تطابق {{score}}٪",
      sourcesFound_zero: "لم يُعثر على مصادر",
      sourcesFound_one: "عُثر على مصدر واحد",
      sourcesFound_two: "عُثر على مصدرين",
      sourcesFound_few: "عُثر على {{count}} مصادر",
      sourcesFound_many: "عُثر على {{count}} مصدرًا",
      sourcesFound_other: "عُثر على {{count}} مصدر",
      sourcesRead_zero: "لم يُقرأ أي مصدر",
      sourcesRead_one: "قُرئ مصدر واحد",
      sourcesRead_two: "قُرئ مصدران",
      sourcesRead_few: "قُرئت {{count}} مصادر",
      sourcesRead_many: "قُرئ {{count}} مصدرًا",
      sourcesRead_other: "قُرئ {{count}} مصدر",
      reportReady: "اكتملت كتابة التقرير",
      nothingNew: "لا جديد منذ آخر تشغيل",
      documentReady: "المستند جاهز",
      documentRendering: "جارٍ إنشاء المستند",
      delivered: "تم التسليم",
    },
    steps: {
      search_jobs: "البحث عن وظائف مطابقة",
      evaluate_matches: "اختيار أفضل النتائج",
      compose_digest: "إعداد الملخص",
      summarize: "تلخيص النتائج",
      draft_applications: "إعداد مسودات التقديم",
      draft_engagement: "إعداد مسودات تواصل",
      draft_follow_up: "إعداد مسودات المتابعة",
      draft_prep: "تحضير ملاحظات المقابلة",
      draft_reply: "إعداد مسودات الرد",
      fetch_cv: "قراءة سيرتك الذاتية",
      fetch_profile: "قراءة ملفك الشخصي",
      fetch_applications: "قراءة طلباتك",
      get_analytics: "مراجعة التحليلات",
      get_views: "مراجعة مشاهدات الملف",
      connectorAction: "الإرسال عبر تطبيق مرتبط",
      draft: "مسودة",
      research_web: "البحث في الويب",
      read_sources: "قراءة مصادرك",
      compose_report: "كتابة التقرير",
      render_document: "إنشاء الملفات",
      deliver: "تسليم النتيجة",
    },
    report: {
      title: "ما تقرؤه المهمة وما ترسله",
      sourcesLabel: "المصادر",
      resultLabel: "النتيجة",
      imageLabel: "الصورة",
      deliveryLabel: "التسليم",
      creditsLabel: "الأرصدة التقديرية لكل تشغيل",
      separator: "، ",
      sources: {
        web: "بحث في الويب: {{topic}}",
        webRegion: "بحث في الويب: {{topic}} في {{region}}",
        links: "الروابط: {{list}}",
        pdf: "ملفات PDF الخاصة بك: {{number}}",
        github: "مستودع GitHub: {{repo}}",
        skill: "إحدى مهاراتك",
      },
      window: {
        day: "آخر 24 ساعة",
        week: "آخر 7 أيام",
        month: "آخر 30 يومًا",
      },
      format: {
        summary: "ملخص قصير",
        document: "مستند ({{files}})",
        slides: "شرائح ({{files}})",
      },
      image: {
        included: "مضمّنة",
        notIncluded: "غير مضمّنة",
      },
      channels: {
        in_app: "داخل التطبيق",
        email: "البريد الإلكتروني",
      },
    },
    templateInputs: {
      title: "إعداد {{name}}",
      subtitle: "أخبر وكيلك المهني بما يقرؤه. يمكنك مراجعة الخطة قبل تشغيلها.",
      topicLabel: "الموضوع",
      topicPlaceholder: "مثال: تصميم المنتجات",
      topicHint: "اتركه فارغًا لاستخدام تفضيلاتك الوظيفية.",
      regionLabel: "المنطقة (اختياري)",
      regionPlaceholder: "مثال: الإمارات",
      urlLabel: "الرابط المراد متابعته",
      urlPlaceholder: "https://",
      urlHint: "صفحة عامة يقرؤها وكيلك المهني في كل تشغيل.",
      urlInvalid: "استخدم رابطًا يبدأ بـ http أو https.",
      pdfLabel: "ملف PDF الخاص بك",
      pdfEmpty: "لا توجد ملفات PDF بعد. أرفق ملف PDF في محادثة أولًا ثم عُد إلى هنا.",
      pdfLoading: "جارٍ تحميل ملفات PDF…",
      pdfLoadFailed: "تعذّر تحميل ملفات PDF.",
      pdfRequired: "اختر أحد ملفات PDF الخاصة بك.",
      required: "هذا الحقل مطلوب.",
      submit: "إضافة المهمة",
      submitting: "جارٍ الإضافة…",
      cancel: "إلغاء",
    },
    card: {
      planLabel: "خطة الوكيل المهني",
      listLabel: "الأتمتة",
      listEmpty: "لا توجد أتمتة بعد.",
      count_one: "أتمتة واحدة",
      count_other: "{{count}} أتمتة",
      runsLabel: "سجل التشغيل",
      runsEmpty: "لا عمليات تشغيل بعد.",
      runsCount_one: "تشغيل واحد",
      runsCount_other: "{{count}} عملية تشغيل",
      activateTitle: "تفعيل الأتمتة",
      runNowTitle: "تشغيل الأتمتة الآن",
      activated: "تم تفعيل الأتمتة",
      ranNow: "بدأ التشغيل",
      confirmActivate: "الموافقة على هذه الأتمتة وتفعيلها؟",
      confirmRunNow: "تشغيل هذه الأتمتة الآن؟",
      whenLabel: "الوقت",
      stepsLabel: "الخطوات",
      draftBadge: "مسودة فقط",
    },
  },

  // عناصر القوائم المنسدلة المشتركة (DropdownField للجوال والويب)
  dropdown: {
    title: "اختر خيارًا",
    searchPlaceholder: "بحث",
    empty: "لا توجد خيارات",
    noResults: "لا توجد نتائج",
  },

  actions: {
    save: "حفظ",
    add: "إضافة",
    remove: "إزالة",
    enable: "تفعيل",
    disable: "تعطيل",
    copy: "نسخ",
    share: "مشاركة",
    cancel: "إلغاء",
    delete: "حذف",
    edit: "تعديل",
    done: "تم",
    selectDate: "اختر التاريخ",
    close: "إغلاق",
    back: "رجوع",
    moveUp: "حرك للأعلى",
    moveDown: "حرك للأسفل",
    next: "التالي",
    submit: "إرسال",
    retry: "إعادة المحاولة",
    download: "تنزيل",
    dismiss: "إخفاء",
    open: "فتح",
    signOut: "تسجيل الخروج",
    goHome: "الرئيسية",
    getStarted: "ابدأ الآن",
    newChat: "+ جديد",
    clear: "مسح",
    more: "المزيد",
    openMenu: "فتح القائمة",
    continueOnboarding: "متابعة الإعداد",
  },

  labels: {
    yourChats: "المحادثات",
    today: "اليوم",
    yesterday: "أمس",
    previous7Days: "آخر ٧ أيام",
    previous30Days: "آخر ٣٠ يوم",
    loading: "جاري التحميل...",
    noResults: "لا توجد نتائج",
    noConversations: "ستظهر محادثاتك هنا",
    personal: "شخصي",
    employer: "جهة توظيف",
    switchWorkspace: "تبديل مساحة العمل",
    addWorkspace: "إضافة مساحة عمل",
    countryCode: "رمز الدولة",
    searchCountry: "ابحث عن دولة...",
  },

  location: {
    title: "الموقع",
    search: "ابحث عن مدينة أو دولة...",
    searching: "جارٍ البحث…",
    noMatches: "لا توجد نتائج. جرّب مدينة أخرى.",
    selectLocation: "اختر الموقع",
    select: "اختر",
    regions: {
      remote: "عن بُعد",
      gcc: "دول الخليج",
      middleEast: "الشرق الأوسط",
      southAsia: "جنوب آسيا",
      southeastAsia: "جنوب شرق آسيا",
      eastAsia: "شرق آسيا",
      europe: "أوروبا",
      americas: "الأمريكتان",
      africa: "أفريقيا",
      oceania: "أوقيانوسيا",
    },
  },

  startup: {
    openingWorkspace: "جارٍ فتح مساحة العمل",
    loadingSettings: "جارٍ فتح الإعدادات",
    loadingUpgrade: "جارٍ فتح الباقات",
    openingConversation: "جارٍ فتح المحادثة",
  },

  resumeImport: {
    checking: "جارٍ تجهيز استيراد السيرة الذاتية",
    claiming: "جارٍ قراءة سيرتك الذاتية",
    saving: "جارٍ تحديث سيرتك الذاتية",
    missingError:
      "رابط استيراد السيرة الذاتية مفقود أو منتهي. يرجى رفع سيرتك الذاتية مرة أخرى.",
    genericClaimError: "تعذر معالجة سيرتك الذاتية. يرجى رفعها مرة أخرى.",
    emptyError: "لم نجد تفاصيل كافية لتحديث ملفك.",
    saveFailed: "تعذر تحديث سيرتك الذاتية. يرجى المحاولة مرة أخرى.",
    toastTitle: "تم تحديث السيرة الذاتية",
    toastMessage: "تفاصيل سيرتك الذاتية جاهزة للمراجعة.",
    kicker: "استيراد السيرة الذاتية",
    importTitle: "لنبنِ سيرتك الذاتية",
    creating: "جارٍ إنشاء سيرتك الجديدة",
    errorTitle: "استيراد السيرة يحتاج إلى رفع جديد",
    retryTitle: "توقف استيراد السيرة مؤقتًا",
    errorBody:
      "انتهت صلاحية هذا الرابط. ارجع إلى صفحة Tabbio وارفع سيرتك الذاتية مرة أخرى.",
    importedResume: "سيرة ذاتية مستوردة",
    summaryMeta: "{{roles}} أدوار · {{education}} تعليم · {{skills}} مهارات",
    backToTabbio: "العودة إلى Tabbio",
    retryAction: "المحاولة مرة أخرى",
    chooseTitle: "إلى أين تريد إضافة هذه السيرة؟",
    chooseBody:
      "قرأنا سيرتك الذاتية ولم يتغير شيء بعد، فاختر ما سيحدث لها.",
    chooseUpdate: "تحديث سيرتي الرئيسية",
    chooseUpdateHint:
      "سيستبدل سيرتك الرئيسية بهذه السيرة، ويمكنك تعديلها بعد ذلك.",
    chooseCopy: "حفظها كسيرة ذاتية جديدة",
    chooseCopyHint:
      "ستُضاف إلى سيرك الأخرى، وتبقى سيرتك الرئيسية كما هي تمامًا.",
    copyToastTitle: "تم إنشاء سيرة ذاتية جديدة",
    copyToastMessage: "تم حفظ سيرتك الذاتية كسيرة جديدة.",
    copyFailed: "تعذر حفظ هذه السيرة كسيرة جديدة. يرجى المحاولة مرة أخرى.",
    confirmTitle: "استبدال سيرتك الذاتية الحالية؟",
    confirmBody:
      "سيؤدي هذا إلى استبدال الأقسام المطابقة في سيرتك الحالية بمحتوى السيرة المستوردة. لن نتابع إلا بعد تأكيدك.",
    confirmAction: "استبدال السيرة الحالية",
  },

  errors: {
    generic: "حدث خطأ. يرجى المحاولة مرة أخرى.",
    network: "خطأ في الشبكة. تحقق من اتصالك.",
    notFound: "الصفحة غير موجودة",
  },

  feedback: {
    floatingLabel: "ملاحظات",
    title: "شاركنا الملاحظات",
    categoryLabel: "عن ماذا تدور الملاحظة؟",
    ratingLabel: "كيف كانت التجربة؟",
    messageLabel: "ما الذي يجب أن نعرفه؟",
    messagePlaceholder: "اكتب ما حدث أو ما الذي يمكن تحسينه.",
    messageHelper: "10 أحرف على الأقل. تصل الملاحظات إلى فريق إدارة Tabbio.",
    placeholders: {
      bug: "خطوات إعادة الإنتاج، النتيجة المتوقعة، وما حدث فعلاً.",
      idea: "اشرح فكرتك والمشكلة التي ستحلها.",
      confusing: "ماذا كنت تحاول أن تفعل، وما الذي اعترض طريقك؟",
      performance: "أين شعرت بالبطء؟ ما الشاشة والإجراء؟",
      other: "اكتب ما حدث أو ما الذي يمكن تحسينه.",
    },
    helpers: {
      bug: "10 أحرف على الأقل. اذكر الخطوات والنتيجة المتوقعة والنتيجة الفعلية.",
      idea: "10 أحرف على الأقل. أخبرنا بالحالة التي ستحلها فكرتك.",
      confusing: "10 أحرف على الأقل. صف ما لم يكن واضحاً وأين.",
      performance: "10 أحرف على الأقل. اذكر الشاشة والإجراء ومدى البطء.",
      other: "10 أحرف على الأقل. تصل الملاحظات إلى فريق إدارة Tabbio.",
    },
    submit: "إرسال الملاحظة",
    submitting: "جارٍ الإرسال...",
    successTitle: "تم إرسال الملاحظة",
    successMessage: "شكراً لك. سنراجعها في لوحة الإدارة.",
    errorTitle: "تعذر إرسال الملاحظة",
    errorMessage: "يرجى المحاولة مرة أخرى بعد قليل.",
    screenshotLabel: "لقطة شاشة (اختياري)",
    addScreenshot: "إضافة لقطة شاشة",
    removeScreenshot: "إزالة لقطة الشاشة",
    screenshotUploading: "جارٍ الرفع...",
    screenshotError: "تعذر إرفاق لقطة الشاشة. يرجى المحاولة مرة أخرى.",
    screenshotErrors: {
      unsupportedType: "نوع الصورة غير مدعوم. استخدم JPG أو PNG أو WebP.",
      tooLarge: "حجم الصورة كبير جداً. الحد الأقصى {{size}} ميغابايت.",
    },
    charCount: "{{count}} / {{max}}",
    ratingOption: "{{value}} من 5",
    validation: {
      messageMin: "يرجى كتابة 10 أحرف على الأقل.",
      messageMax: "لقد وصلت إلى الحد الأقصى وهو {{max}} حرف.",
    },
    categories: {
      bug: "خلل",
      idea: "فكرة",
      confusing: "غير واضح",
      performance: "الأداء",
      other: "أخرى",
    },
  },

  // Settings
  // منصة مطوّري Tabbio: شاشة الموافقة "تسجيل الدخول عبر Tabbio" وكتالوج الصلاحيات.
  oauth: {
    consent: {
      loading: "جارٍ التحميل",
      redirecting: "جارٍ إعادتك",
      unavailableTitle:
        "تسجيل الدخول عبر تابيو غير متاح",
      unavailableBody:
        "تسجيل الدخول عبر تابيو غير متاح في هذا الإصدار. عد إلى التطبيق الذي أرسلك إلى هنا وحاول مرة أخرى لاحقًا.",
      errorTitle: "لا يمكن إكمال طلب تسجيل الدخول هذا",
      errorBody:
        "التطبيق الذي أرسلك إلى هنا غير مُعدّ بشكل صحيح. عد إليه وحاول مرة أخرى، أو تواصل مع فريق الدعم لديه.",
      goToTabbio: "الذهاب إلى Tabbio",
      title: "تسجيل الدخول إلى {{app}} عبر Tabbio",
      titleExisting: "{{app}} متصل بالفعل",
      subtitle:
        "سيتمكن {{app}} من قراءة المعلومات التي تسمح بها أدناه، وستبقى محدّثة حتى تقطع الاتصال.",
      signedInAs: "مسجّل الدخول باسم",
      permissions: "ما الذي سيحصل عليه {{app}}",
      required: "مطلوب",
      includePhoto: "تضمين صورة الملف الشخصي",
      cvRow: "السيرة الذاتية المشاركة",
      cvNone: "لم يتم اختيار سيرة ذاتية",
      change: "تغيير",
      continue: "متابعة",
      cancel: "إلغاء",
      legal:
        "بالمتابعة، أنت تسمح لـ Tabbio بمشاركة العناصر أعلاه مع {{app}}.",
      privacyPolicy: "سياسة الخصوصية",
      terms: "الشروط",
      disconnectNote:
        "يمكنك قطع الاتصال في أي وقت من الإعدادات، ضمن التطبيقات المتصلة.",
      presets: {
        label: "حجم المشاركة",
        signin: "تسجيل الدخول فقط",
        cv: "مشاركة سيرتي الذاتية",
        full: "مشاركة كل شيء",
      },
    },
    scopes: {
      profile: {
        title: "الاسم واسم المستخدم وصورة الملف الشخصي",
        description:
          "اسمك واسم المستخدم والعنوان المهني واللغة ورابط ملفك الشخصي العام.",
      },
      email: {
        title: "البريد الإلكتروني",
        description: "البريد الإلكتروني المُوثَّق في حسابك على Tabbio.",
      },
      cvRead: {
        title: "سيرتك الذاتية",
        description:
          "السيرة الذاتية التي تختارها، محدَّثة تلقائياً، كبيانات منظّمة وكملف PDF.",
      },
      cvContact: {
        title: "بيانات الاتصال الخاصة",
        description:
          "رقم الهاتف والعنوان الكامل وتاريخ الميلاد والجنسية وبيانات شخصية مشابهة من سيرتك الذاتية.",
      },
    },
  },
  settings: {
    groups: { account: "الحساب", activity: "النشاط", access: "الوصول والاتصالات", help: "المساعدة والمعلومات" },
    mobileAbout: "Tabbio لنظام {{platform}} · {{version}}",
    feedbackDescription: "شارك فكرة أو أخبرنا عن مشكلة.",
    title: "الإعدادات",
    editProfile: "تعديل الملف الشخصي",
    name: "الاسم",
    categories: {
      account: "الحساب",
      billing: "الفوترة",
      preferences: "التفضيلات",
      notifications: "الإشعارات",
      agentAccess: "وصول الوكيل",
      usage: "الاستخدام والأرصدة",
    },
    usageScreen: {
      limitSection: "حد الاستخدام",
      limitInfoLabel: "حول حدود الاستخدام",
      limitInfo:
        "الرصيد مشترك بين محادثة الوكيل وكتابة السيرة الذاتية والمهارات وأتمتة Nova. كل إجراء يُخصم من الرصيد نفسه.",
      monthlyLimit: "الحد الشهري",
      dailyLimit: "الحد اليومي",
      percentRemaining: "المتبقي {{percent}}",
      unlimited: "غير محدود",
      resetsToday: "يُعاد التعيين اليوم الساعة {{time}}",
      resetsTomorrow: "يُعاد التعيين غدًا الساعة {{time}}",
      resetsOnWeekday: "يُعاد التعيين يوم {{date}} الساعة {{time}}",
      resetsOn: "يُعاد التعيين في {{date}} الساعة {{time}}",
      creditsSection: "الرصيد",
      creditsRemaining: "الرصيد المتبقي",
      creditCount_zero: "{{value}} رصيد",
      creditCount_one: "رصيد واحد",
      creditCount_two: "رصيدان",
      creditCount_few: "{{value}} أرصدة",
      creditCount_many: "{{value}} رصيدًا",
      creditCount_other: "{{value}} رصيد",
      footnoteFree: "يتجدد الرصيد المجاني كل يوم.",
      footnotePaid:
        "يتجدد الرصيد مع خطتك كل شهر. ويحدد الحد اليومي مقدار ما يمكنك استخدامه في اليوم الواحد.",
      upgradeFree: "رقِّ خطتك للحصول على رصيد شهري",
      upgradePlus: "رقِّ إلى Pro للحصول على رصيد أكبر",
    },
    agentAccess: {
      permissions: "الأذونات",
      activityAndBlocks: "النشاط والوصول المحظور",
      runsLoadFailed: "تعذّر تحميل عمليات التشغيل الأخيرة",
      undoTitle: "التراجع عن تشغيل هذه المهارة؟",
      undoMessage: "التراجع عن تغييرات السيرة الذاتية التي أجرتها {{skill}}. سيؤدي ذلك إلى استعادة السيرة الذاتية المعدّلة أو حذف النسخة الجديدة التي أنشأها هذا التشغيل.",
      subtitle:
        "تحكّم في من يمكنه تشغيل المهارات على سيرتك الذاتية وراجع عمليات التشغيل الأخيرة.",
      whoCanRun: "من يمكنه تشغيل المهارات",
      who: {
        any: "أي مهارة",
        verified: "مهارات Tabbio المختارة فقط",
        default_only: "مهارات Tabbio الافتراضية فقط",
        nobody: "لا توجد مهارات",
      },
      communityToggle: "مهارات المجتمع",
      communityToggleDescription:
        "السماح بتشغيل المهارات التي يشاركها المجتمع.",
      confirmFullCv: "التأكيد قبل إعادة كتابة السيرة كاملة",
      confirmFullCvDescription:
        "اطلب التأكيد قبل أن تعيد مهارة كتابة سيرتك الذاتية بالكامل.",
      runLog: "عمليات التشغيل الأخيرة",
      runLogEmpty: "لا توجد عمليات تشغيل للمهارات بعد.",
      dryRunBadge: "معاينة",
      undo: "تراجع",
      undone: "تم التراجع عن التشغيل",
      undoFailed: "تعذّر التراجع عن التشغيل",
      blockedSkills: "المهارات المحظورة",
      blockedCreators: "المنشئون المحظورون",
      noBlocked: "لا شيء محظور.",
      unblock: "إلغاء الحظر",
      loadFailed: "تعذّر تحميل إعدادات وصول الوكيل",
      saveFailed: "تعذّر حفظ الإعدادات",
      runStatus: {
        reverted: "تم التراجع",
        pending: "قيد الانتظار",
        running: "قيد التشغيل",
        completed: "مكتمل",
        failed: "فشل",
        blocked: "محظور",
      },
    },
    accountEdit: {
      title: "تعديل الحساب",
      subtitle: "حدّث اسم المستخدم والبريد الإلكتروني وكلمة المرور.",
      usernameTitle: "اسم المستخدم",
      usernameDescription: "هذا هو المعرف العام الخاص بك على Tabbio.",
      usernamePlaceholder: "username",
      usernameHint: "اختر اسم مستخدم يسهل العثور عليه.",
      usernameRequired: "اسم المستخدم مطلوب",
      usernameMin: "يجب أن يكون اسم المستخدم 3 أحرف على الأقل",
      usernameChecking: "جارٍ التحقق من التوفر...",
      usernameAvailable: "اسم المستخدم متاح",
      usernameCurrent: "هذا هو اسم المستخدم الحالي",
      usernameConfirmTitle: "تغيير اسم المستخدم؟",
      usernameConfirmMessage:
        "سيتغير رابطك من {{oldLink}} إلى {{newLink}}. سيتوقف رابطك القديم وأي روابط سيرة ذاتية شاركتها عن العمل.",
      usernameConfirmAction: "تغيير اسم المستخدم",
      usernameConfirmCancel: "إلغاء",
      usernameInvalid: "صيغة اسم المستخدم غير صحيحة",
      usernameReserved: "اسم المستخدم هذا محجوز",
      usernameReservedWithSuggestion:
        "اسم المستخدم هذا محجوز. جرّب {{suggestion}}",
      usernameTaken: "اسم المستخدم هذا مستخدم بالفعل",
      usernameTakenWithSuggestion: "اسم المستخدم مستخدم. جرّب {{suggestion}}",
      usernameCannotSave: "اختر اسم مستخدم متاحاً قبل الحفظ",
      usernameUpdated: "تم تحديث اسم المستخدم بنجاح",
      saveUsername: "حفظ اسم المستخدم",
      emailTitle: "البريد الإلكتروني",
      emailDescription: "سنرسل رمز تحقق لمرة واحدة إلى بريدك الجديد.",
      currentEmail: "البريد الحالي",
      newEmailLabel: "البريد الجديد",
      newEmailPlaceholder: "you@example.com",
      sendOtp: "إرسال رمز التحقق",
      otpLabel: "رمز التحقق",
      otpPlaceholder: "أدخل الرمز",
      verifyEmail: "تحقق وحدّث البريد",
      emailOtpSent: "تم إرسال رمز التحقق",
      emailUpdated: "تم تحديث البريد الإلكتروني بنجاح",
      emailInvalid: "أدخل بريداً إلكترونياً صالحاً",
      emailSameAsCurrent: "يجب أن يكون البريد الجديد مختلفاً عن الحالي",
      otpRequired: "رمز التحقق مطلوب",
      passwordTitle: "كلمة المرور",
      passwordModeChecking: "جارٍ التحقق من إعدادات كلمة المرور...",
      passwordDescriptionChange: "قم بتغيير كلمة المرور الحالية.",
      passwordDescriptionSet: "قم بتعيين كلمة مرور لحسابك.",
      currentPasswordLabel: "كلمة المرور الحالية",
      currentPasswordPlaceholder: "كلمة المرور الحالية",
      newPasswordLabel: "كلمة المرور الجديدة",
      newPasswordPlaceholder: "كلمة المرور الجديدة",
      confirmPasswordLabel: "تأكيد كلمة المرور",
      confirmPasswordPlaceholder: "تأكيد كلمة المرور الجديدة",
      currentPasswordRequired: "كلمة المرور الحالية مطلوبة",
      currentPasswordIncorrect: "كلمة المرور الحالية غير صحيحة",
      passwordMismatch: "كلمتا المرور غير متطابقتين",
      passwordChanged: "تم تغيير كلمة المرور بنجاح",
      passwordSet: "تم تعيين كلمة المرور بنجاح",
      changePasswordAction: "تغيير كلمة المرور",
      setPasswordAction: "تعيين كلمة المرور",
      nameTitle: "الاسم",
      nameDescription: "هذا هو الاسم المعروض على ملفك الشخصي.",
      namePlaceholder: "اسمك",
      nameRequired: "الاسم مطلوب",
      nameUpdated: "تم تحديث الاسم بنجاح",
      saveName: "حفظ الاسم",
      uaePassLocked: "هذا الحقل مقفل لأن الحساب مرتبط بـ UAE PASS.",
      errorGeneric: "حدث خطأ. يرجى المحاولة مرة أخرى.",
    },
    signInMethods: {
      title: "طرق تسجيل الدخول",
      connected: "متصل",
      notConnected: "غير متصل",
      connect: "ربط",
      disconnect: "إلغاء الربط",
      working: "جارٍ…",
      passwordSet: "مُعيَّنة",
      passwordNotSet:
        "غير مُعيَّنة. تسجّل الدخول عبر حساب مرتبط",
      setPassword: "تعيين كلمة المرور",
      connectedToast: "تم ربط {{provider}}.",
      disconnectedToast: "تم إلغاء ربط {{provider}}.",
      disconnectTitle: "إلغاء ربط {{provider}}؟",
      disconnectMessage:
        "لن تتمكّن بعد الآن من تسجيل الدخول عبر {{provider}}. ستظلّ طرق الدخول الأخرى تعمل.",
      providers: {
        password: "كلمة المرور",
        google: "Google",
        apple: "Apple",
      },
      errors: {
        generic:
          "تعذّر ربط هذا الحساب. يرجى المحاولة مجددًا.",
        emailMismatch:
          "يستخدم هذا الحساب بريدًا إلكترونيًا مختلفًا عن بريد حسابك في Tabbio، لذا لا يمكننا ربطهما.",
        emailMissing:
          "لم يشاركنا هذا الحساب بريدًا إلكترونيًا، لذا لا يمكننا مطابقته مع حسابك.",
        alreadyLinkedElsewhere:
          "هذا الحساب مرتبط بالفعل بحساب Tabbio آخر.",
        disconnect:
          "تعذّر إلغاء ربط هذا الحساب. يرجى المحاولة مجددًا.",
      },
    },
    manageCredentials: {
      title: "إدارة الحساب",
      description:
        "تغيير الاسم أو البريد الإلكتروني أو كلمة المرور أو اسم المستخدم أو حذف الحساب.",
      changeName: "تغيير الاسم",
      changeNameDescription: "تحديث الاسم المعروض على ملفك الشخصي.",
      changeUsername: "تغيير اسم المستخدم",
      changeUsernameDescription: "تحديث معرفك العام على Tabbio.",
      changeEmail: "تغيير البريد الإلكتروني",
      changeEmailDescription: "تحديث عنوان البريد الإلكتروني لحسابك.",
      changePassword: "تغيير كلمة المرور",
      changePasswordDescription: "تحديث كلمة المرور أو تعيينها لحسابك.",
      deleteAccount: "حذف الحساب",
      deleteAccountDescription: "إزالة حسابك وجميع بياناتك نهائياً.",
    },
    uaePass: {
      title: "UAE PASS",
      statusLinked: "موثق",
      statusUnlinked: "غير مرتبط",
      linkedDescription:
        "حسابك مرتبط بـ UAE PASS. حقول الهوية الموثقة للقراءة فقط.",
      unlinkedDescription: "UAE PASS غير مرتبط بهذا الحساب.",
      unavailable: "تعذر تحميل حالة UAE PASS حالياً.",
      linkAction: "الربط مع UAE PASS",
    },
    mcpAccess: {
      title: "وصول MCP",
      enabled: "الرمز نشط",
      notCreated: "لا يوجد رمز لهذا النطاق",
      scope: "النطاق",
      scopeHelp: "اختر ما يمكن لهذا الرمز الواحد الوصول إليه.",
      personalScope: "الملف الشخصي",
      personalScopeDescription:
        "الملف الشخصي والسيرة والتقديمات والمعرفة الشخصية.",
      companyScopes: "مساحات عمل الشركات",
      companyScopeDescription:
        "ملف الشركة والوظائف والمرشحين والتواصل والموافقات.",
      noCompanies: "لا توجد مساحات عمل شركات متاحة لهذا الحساب.",
      selectScopeRequired: "اختر الوصول الشخصي أو شركة واحدة على الأقل.",
      serverUrl: "رابط الخادم",
      token: "الرمز",
      lastUsed: "آخر استخدام {{date}}",
      neverUsed: "لم يُستخدم بعد",
      oneTimeToken: "رمز لمرة واحدة",
      oneTimeWarning:
        "انسخ هذا الرمز الآن. لن يعرضه Tabbio مرة أخرى بعد مغادرة الإعدادات.",
      copied: "تم النسخ",
      copyFailed: "تعذر النسخ",
      urlCopied: "تم نسخ رابط MCP",
      secretCopied: "تم نسخ رمز MCP",
      create: "إنشاء رمز",
      created: "تم إنشاء رمز MCP",
      createFailed: "تعذر إنشاء رمز MCP",
      rotate: "إعادة إنشاء",
      rotateTitle: "إعادة إنشاء رمز MCP",
      rotateMessage: "سيتوقف الرمز الحالي عن العمل فوراً. هل تريد المتابعة؟",
      rotated: "تمت إعادة إنشاء رمز MCP",
      rotateFailed: "تعذرت إعادة إنشاء رمز MCP",
      revoke: "إلغاء",
      revokeTitle: "إلغاء رمز MCP",
      revokeMessage: "سيتوقف هذا الرمز عن العمل فوراً. هل تريد المتابعة؟",
      revoked: "تم إلغاء رمز MCP",
      revokeFailed: "تعذر إلغاء رمز MCP",
      pendingApprovals: "الموافقات المعلقة",
      approve: "موافقة",
      reject: "رفض",
      approved: "تمت الموافقة على إجراء MCP",
      rejected: "تم رفض إجراء MCP",
      approvalFailed: "تعذر تحديث موافقة MCP",
      loadFailed: "تعذر تحميل وصول MCP",
    },
    connectedApps: {
      title: "التطبيقات المتصلة",
      detailTitle: "تطبيق متصل",
      subtitle:
        "التطبيقات التي سجّلت الدخول إليها عبر Tabbio. غيّر ما يمكن لكل تطبيق قراءته، أو اقطع الاتصال.",
      loading: "جارٍ التحميل",
      loadFailed: "تعذّر تحميل التطبيقات المتصلة",
      emptyTitle: "لا توجد تطبيقات متصلة بعد",
      emptyBody:
        "عند استخدام المتابعة عبر Tabbio في موقع آخر، سيظهر هنا وتبقى أنت المتحكّم فيما يقرأه.",
      connectedOn: "تم الاتصال في {{date}}",
      lastUsed: "آخر استخدام {{date}}",
      neverUsed: "لم يُستخدم بعد",
      notFound: "هذا الاتصال لم يعد متاحاً.",
      accessTitle: "الوصول",
      photoDescription: "مشاركة صورة ملفك الشخصي مع هذا التطبيق.",
      cvRow: "السيرة الذاتية المشاركة",
      cvNone: "لم يتم اختيار سيرة ذاتية",
      cvUnavailable:
        "تم حذف السيرة الذاتية التي شاركتها. اختر سيرة ذاتية ليتمكّن هذا التطبيق من قراءتها مجدداً.",
      cvUnavailableShort: "تم حذف السيرة الذاتية التي شاركتها. اختر سيرة ذاتية",
      chooseCv: "اختر سيرة ذاتية",
      updated: "تم تحديث الوصول",
      updateFailed: "تعذّر تحديث الوصول",
      disconnect: "قطع الاتصال",
      disconnectApp: "قطع الاتصال بـ {{app}}",
      disconnectTitle: "قطع الاتصال بـ {{app}}؟",
      disconnectMessage:
        "سيفقد {{app}} الوصول إلى حسابك على Tabbio فوراً. يمكنك إعادة الاتصال لاحقاً.",
      disconnected: "تم قطع الاتصال بالتطبيق",
      disconnectFailed: "تعذّر قطع الاتصال بهذا التطبيق",
    },
    account: "الحساب",
    email: "البريد الإلكتروني",
    phone: "رقم الهاتف",
    subscription: "الاشتراك",
    manageSubscription: "إدارة الاشتراك",
    manageBilling: "إدارة الفوترة",
    freePlan: "الخطة المجانية",
    upgradePro: "ترقية إلى Tabbio Pro",
    restorePurchases: "استعادة المشتريات",
    syncSubscription: "مزامنة الاشتراك",
    refreshSubscription: "تحديث الاشتراك",
    checkingSubscription: "جارٍ التحقق من الاشتراك",
    billingUnavailable: "الفوترة غير متاحة الآن",
    restoreFailed: "تعذرت استعادة المشتريات",
    restoreFailedMessage:
      "يرجى المحاولة مجدداً بعد لحظات. إذا استمرت المشكلة، تواصل مع الدعم.",
    syncFailed: "تعذرت مزامنة الاشتراك",
    syncFailedMessage:
      "يرجى المحاولة مجدداً بعد لحظات. إذا استمرت المشكلة، تواصل مع الدعم.",
    onboardingCheckoutWrongUser:
      "رابط الرجوع من الدفع يخص مستخدماً آخر مسجلاً الدخول. يرجى بدء الدفع مرة أخرى من التهيئة.",
    onboardingCheckoutNotPaid:
      "لم نتمكن من تأكيد دفع التهيئة بعد. أعد محاولة المزامنة أو تابع بالخطة المجانية.",
    subscriptionScopeInvalid:
      "تعذر تحديد نطاق الاشتراك لرابط الرجوع هذا. يرجى فتح تأكيد الشراء مرة أخرى أو المزامنة من الإعدادات.",
    subscriptionSynced: "تمت مزامنة الاشتراك",
    subscriptionSyncedFromStore: "تمت مزامنة الاشتراك من {{store}}.",
    subscriptionSyncing: "جاري مزامنة الاشتراك",
    subscriptionSyncingDescription: "جارٍ التحقق من حالة الفوترة الآن.",
    storeAppStore: "App Store",
    storeGooglePlay: "Google Play",
    storeBillingPortal: "بوابة الفوترة",
    storeUnknown: "المتجر الأصلي",
    managedInAppStore:
      "تتم الفوترة عبر App Store. يمكنك الإدارة أو الإلغاء من اشتراكات Apple، بما في ذلك account.apple.com.",
    managedInGooglePlay:
      "تتم الفوترة عبر Google Play. يمكنك الإدارة أو الإلغاء من اشتراكات Google Play.",
    managedInBillingPortal: "تتم الفوترة عبر بوابة فوترة Tabbio.",
    managedInUnknownStore: "تتم إدارة الفوترة من المتجر الأصلي لهذا الاشتراك.",
    subscriptionActive: "نشط",
    subscriptionTrial: "فترة تجريبية",
    subscriptionEnding: "تم إيقاف التجديد",
    subscriptionExpired: "منتهي",
    subscriptionBillingIssue: "مشكلة في الفوترة",
    subscriptionRenewsOn: "يتجدد في {{date}}.",
    subscriptionTrialEndsOn: "تنتهي الفترة التجريبية في {{date}}.",
    subscriptionAccessUntil: "سيستمر الوصول حتى {{date}}.",
    subscriptionExpiredOn: "انتهى الوصول في {{date}}.",
    subscriptionBillingIssueDescription:
      "توجد مشكلة في فوترة هذا الاشتراك. قم بالمزامنة مرة أخرى بعد تحديث طريقة الدفع.",
    plansCreditUsage: "الخطة والرصيد",
    plansCreditUsageDescription: "اطّلع على خطتك ورصيدك وأدوات إدارة الاشتراك.",
    creditUsageUnavailable: "تظهر حدود الإجراءات للخطط الفردية.",
    subscriptionPlans: {
      planSets: {
        individual: "فردي",
        employer: "جهة توظيف",
      },
      tiers: {
        free: "الخطة المجانية",
        plus: "Plus",
        pro: "Pro",
      },
      descriptions: {
        individual: {
          free: "أنشئ ملفك وسيرتك، وتحدث مع الوكيل المهني برصيد يومي مجاني، واستكشف ما تفتحه Plus وPro.",
          plus: "10,000 رصيد شهرياً لذكاء اصطناعي أذكى والمهارات والتصدير والتحليلات والتطبيقات المتصلة.",
          pro: "كل ما في Plus، مع 100,000 رصيد شهرياً وأتمتة الوكيل المهني وذكاء مهني متقدم.",
        },
        employer: {
          free: "أعضاء مجانيون غير محدودين، صفحة توظيف واحدة، إعلان وظيفة واحد، واستخدام أساسي مشترك للذكاء الاصطناعي.",
          plus: "50 إجراء ذكاء اصطناعي يومياً لكل مقعد",
          pro: "200 إجراء ذكاء اصطناعي يومياً لكل مقعد",
        },
      },
      upgradeCtas: {
        individual: {
          plus: "الترقية إلى Plus",
          pro: "الترقية إلى Pro",
        },
        employer: {
          plus: "إضافة مقاعد Plus",
          pro: "إضافة مقاعد Pro",
        },
      },
    },
    monthlyCredits: "الرصيد الشهري",
    dailyCredits: "الرصيد اليومي",
    dailyCreditsTopUp: "الإضافة اليومية",
    creditsLeft: "متبقي {{value}}",
    creditCount: "تم استخدام {{value}}",
    creditsUsed: "الاستخدام المشمول",
    creditsResetOn: "يعاد التعيين في {{date}}",
    resetsDaily: "يعاد التعيين يومياً",
    resetsMonthly: "يعاد التعيين شهرياً",
    needMoreCredits: "هل تريد إنجاز المزيد؟",
    upgradeForMoreCredits:
      "رقّ خطتك لمزيد من استخدام الذكاء الاصطناعي وأدوات مهنية إضافية.",
    needMoreAccess: "هل تريد إنجاز المزيد؟",
    upgradeForMoreAccess:
      "رقّ إلى Plus لطلبات أقوى، أو إلى Pro لأتمتة الوكيل المهني.",
    allowances: {
      careerChat: "ردود المحادثة المهنية",
      skillRuns: "مرات تشغيل المهارات",
      novaPreviews: "معاينات خطط الوكيل المهني",
      cvPreviews: "معاينات أقسام السيرة",
      cvFitReports: "تقارير ملاءمة السيرة",
      aiActions: "إجراءات الذكاء الاصطناعي",
      remaining: "متبقي {{remaining}} من {{limit}}",
      fairUse:
        "تشمل خطتك استخدامًا سخيًا تحميه ضوابط الاستخدام العادل، ويظهر الاستخدام كإجراءات واضحة داخل المنتج.",
      resets: {
        day: "يتجدد يوميًا",
        week: "يتجدد أسبوعيًا",
        month: "يتجدد شهريًا",
      },
    },
    upgradePlan: "ترقية الخطة",
    usage: "الاستخدام",
    thisMonth: "هذا الشهر",
    unlimitedCredits: "غير محدود",
    notAvailable: "غير متاح",
    preferences: "التفضيلات",
    theme: "المظهر",
    themeSystem: "النظام",
    themeLight: "فاتح",
    themeDark: "داكن",
    language: "اللغة",
    controls: {
      publicPageOn: "الصفحة العامة مفعّلة",
      publicPageOff: "الصفحة العامة متوقفة",
      "audience": "من يمكنه رؤية سيرتي الذاتية الرئيسية؟",
      "audienceHint": "اختر إتاحة ملفك للجميع أو لأصحاب العمل أو جعله خاصاً.",
      "contact": "الصورة وبيانات التواصل",
      "contactHint": "حدد من يمكنه رؤية صورتك وبريدك الإلكتروني ورقم هاتفك.",
      "sharing": "الروابط والأشخاص",
      "sharingHint": "راجع الروابط الخاصة والدعوات المتعلقة بسيرتك الرئيسية.",
      "audienceOptions": {
        "public": "يمكن لأي شخص رؤية سيرتك الرئيسية، وقد تظهر في محركات البحث.",
        "employers": "يمكن لمسؤولي التوظيف اكتشافك، وتبقى صفحاتك العامة مخفية.",
        "private": "تبقى صفحاتك العامة مخفية ولا يظهر ملفك في بحث التوظيف."
      },
      "cvSharingHint": "للصفحات العامة والروابط الخاصة والدعوات إعدادات مستقلة.",
      "cvData": "سيرك الذاتية",
      "mainDataHint": "عدّل أو احذف تفاصيلك الشخصية وخبراتك ومهاراتك.",
      "savedCvHint": "احذف هذه النسخة مع الاحتفاظ بسيرك الأخرى.",
      "identityConnections": "الهوية والاتصالات",
      "uaePassHint": "راجع هويتك الموثّقة أو افصل الهوية الرقمية UAE PASS.",
      "unavailable": "غير متاح",
      "connectionsHint": "أدر الخدمات والتطبيقات التي يمكنها الوصول إلى حسابك.",
      "memoryAccount": "الذاكرة والحساب",
      "memoryHint": "راجع المعلومات التي يتذكرها المساعد أو امسحها.",
      "accountHint": "احذف حسابك والبيانات التي يملكها نهائياً.",
      "reviewMemory": "راجع المعلومات المحفوظة وإعدادات الذاكرة.",
      "chooseSection": "اختر قسماً",
      "appPrivacy": "خصوصية التطبيق",
      "appConnections": "التطبيق والاتصالات",
      "settingsHint": "أدر حسابك وخصوصيتك والخدمات التي تستخدمها.",
      "allSettings": "كل الإعدادات"
    },
    cvPrivacy: {
      description:
        "راجع من يمكنه الاطلاع على سيرك الذاتية وبيانات التواصل والروابط المشتركة.",
      guide: "كيفية إدارة خصوصية سيرتك الذاتية",
      mainCv: "السيرة الذاتية الرئيسية والملف الشخصي",
      mainDescription:
        "يتيح الخيار «عام» عرض سيرتك الذاتية الرئيسية وملفك الشخصي على الويب وإمكانية فهرستهما في محركات البحث. يبقيك خيار «أصحاب العمل فقط» متاحاً لاكتشاف مسؤولي التوظيف. يخفي الخيار «خاص» الصفحات العامة ويمنع اكتشافك في بحث التوظيف.",
      audience: "من يمكنه رؤية سيرتي الذاتية الرئيسية؟",
      photo: "صورة الملف الشخصي",
      phone: "رقم الهاتف",
      visibility: {
        public: "عام",
        employers: "أصحاب العمل فقط",
        private: "خاص",
        hidden: "مخفي",
      },
      publishTitle: "هل تريد إتاحة سيرتك الذاتية الرئيسية للجميع؟",
      publishBody:
        "سيتمكن الآخرون من فتح سيرتك الذاتية الرئيسية وملفك الشخصي دون تسجيل الدخول. وقد تفهرسهما محركات البحث. راجع بياناتك الظاهرة قبل المتابعة.",
      publishAction: "إتاحة للجميع",
      independentAccess:
        "للروابط الخاصة والأشخاص المدعوين والصفحات العامة للسير الأخرى صلاحيات مستقلة. تغيير خصوصية سيرتك الرئيسية لا يلغيها. لا تشمل هذه الإعدادات النسخ التي سبق تنزيلها أو إرسالها لأصحاب العمل.",
      otherCvs: "سيرك الذاتية الأخرى",
      noCvs: "ليس لديك سير ذاتية أخرى محفوظة.",
      publicPageOn: "الصفحة العامة مفعّلة. يمكن لأي شخص لديه عنوانها فتحها.",
      publicPageOff:
        "الصفحة العامة متوقفة. راجع الروابط والأشخاص المدعوين أدناه لمعرفة أي صلاحيات وصول متبقية.",
      unpublish: "إيقاف الصفحة العامة",
      unpublishTitle: "هل تريد إيقاف هذه الصفحة العامة؟",
      unpublishBody:
        "لن يعود بالإمكان فتح الصفحة العامة للسيرة «{{title}}». تبقى صلاحيات الروابط الخاصة والأشخاص المدعوين سارية حتى تلغيها أدناه.",
      reviewAccess: "مراجعة الروابط والأشخاص",
      hideAccess: "إخفاء تفاصيل الوصول",
      shareLinks: "روابط المشاركة الخاصة",
      noLinks: "لا توجد روابط مشاركة خاصة.",
      shareLink: "رابط مشاركة",
      anyoneWithLink: "أي شخص لديه هذا الرابط",
      expired: "منتهي الصلاحية",
      downloadsOn: "التنزيل مسموح",
      downloadsOff: "التنزيل غير مسموح",
      people: "الأشخاص المدعوون",
      noPeople: "لا توجد دعوات نشطة أو قيد الانتظار.",
      sharedAccess: "وصول مشترك",
      pending: "الدعوة قيد الانتظار",
      active: "الوصول مفعّل",
      revoke: "إلغاء الوصول",
      revokeTitle: "هل تريد إلغاء هذا الوصول؟",
      revokeBody:
        "لن يمنح هذا الرابط أو هذه الدعوة صلاحية الوصول بعد الآن. لا يحذف ذلك النسخ التي سبق لشخص تنزيلها أو استلامها.",
    },
    employerAccess: {
      title: "وصول الشركات إلى تغييرات ملفك المستقبلية",
      description:
        "تشارك الطلبات نسخة السيرة التي أرسلتها. يسمح إذن منفصل لشركة محددة بقراءة ملفك المهني الحالي المعروض أدناه، بما في ذلك التغييرات المستقبلية. يمنع إلغاء الإذن القراءات المستقبلية، ولا يؤثر على النسخ التي حفظتها الشركة سابقاً.",
      loading: "جارٍ تحميل معاينة المشاركة…",
      unavailable: "معاينة المشاركة غير متاحة. حاول مجدداً قبل التقديم.",
      showPreview: "راجع ما ستتلقاه الشركة",
      hidePreview: "إخفاء معاينة المشاركة",
      empty: "لا توجد شركات مستلمة مؤهلة بعد.",
      active: "الوصول المستمر مفعّل",
      inactive: "الطلبات المحفوظة فقط",
      revoke: "إلغاء الوصول المستمر",
      review: "مراجعة إذن الملف الحالي",
      consent:
        "السماح لشركة {{company}} بقراءة حقول الملف هذه وتحديثاتها المستقبلية. لا يغيّر ذلك أي سيرة محفوظة في طلب سابق.",
      grant: "السماح بالوصول المستمر إلى الملف",
      cancel: "إلغاء",
      retryReview:
        "قد يكون ملفك أو سيرتك قد تغيّر. راجع معاينة المشاركة المحدّثة وحاول مجدداً.",
      fields: {
        additional: "حقل إضافي",
        name: "الاسم",
        title: "العنوان",
        subtitle: "التفاصيل",
        summary: "الملخص",
        bio: "نبذة",
        about: "حول",
        location: "الموقع",
        email: "البريد الإلكتروني",
        contactEmail: "بريد التواصل",
        phone: "الهاتف",
        image: "الصورة",
        avatarUrl: "الصورة",
        photo: "الصورة مشمولة",
        company: "الشركة",
        school: "المؤسسة التعليمية",
        degree: "الدرجة",
        fieldOfStudy: "التخصص",
        grade: "التقدير",
        description: "الوصف",
        startDate: "تاريخ البدء",
        endDate: "تاريخ الانتهاء",
        current: "مستمر حالياً",
        isCurrent: "مستمر حالياً",
        skills: "المهارات",
        interests: "الاهتمامات",
        achievements: "الإنجازات",
        issuer: "الجهة المانحة",
        issueDate: "تاريخ الإصدار",
        expirationDate: "تاريخ انتهاء الصلاحية",
        credentialId: "رقم الاعتماد",
        credentialUrl: "رابط الاعتماد",
        mediaUrl: "رابط الوسائط",
        mediaType: "نوع الوسائط",
        link: "الرابط",
        date: "التاريخ",
        technologies: "التقنيات",
        tags: "الوسوم",
        locationType: "نوع موقع العمل",
        employmentType: "نوع التوظيف",
        url: "الرابط",
        level: "المستوى",
        language: "اللغة",
        proficiency: "الإتقان",
      },
    },
    subjectReview: {
      title: "مراجعة محتوى الحساب المحجوب",
      description:
        "تفتقر بعض السجلات القديمة إلى سياق موثوق للشخص المعني. اطلب مراجعة مستقلة للسجلات التي تخصك. إفادتك وحدها لا تثبت الملكية.",
      unavailable:
        "المراجعة غير متاحة حالياً. يظل المحتوى غير الموثّق محجوباً من ملفات التصدير.",
      kind: "نوع السجل",
      empty: "لا توجد سجلات مؤهلة في هذه الصفحة.",
      record: "{{kind}} · {{id}}",
      more: "تحميل المزيد",
      statement: "اشرح لماذا يخصك هذا السجل (من 10 إلى 1000 حرف)",
      request: "طلب مراجعة مستقلة",
      failed:
        "تعذّر تحميل المراجعة أو إرسالها. تم الاحتفاظ بمسودتك. حاول مجدداً.",
      refresh: "تحديث حالة المراجعة",
      downloadAgain:
        "تسري الموافقة على المحتوى الذي تمت مراجعته بدقة. نزّل ملف بيانات حسابك مجدداً لتضمين المحتوى المؤهل. تتطلب السجلات المتغيرة مراجعة جديدة.",
      rerunExport: "تنزيل بيانات الحساب مجدداً",
      states: {
        pending: "بانتظار المراجعة",
        needs_evidence: "يلزم دليل مستقل",
        approved_personal: "تمت الموافقة على محتواك المحدد",
        denied: "لم تتم الموافقة",
        stale: "تغيّر المحتوى أو نطاقه؛ اطلب المراجعة مجدداً",
      },
      classes: {
        NovaAutomation: "الأتمتة",
        NovaAutomationVersion: "إصدار الأتمتة",
        NovaTrigger: "مشغّل الأتمتة",
        NovaStep: "خطوة الأتمتة",
        NovaRun: "تشغيل الأتمتة",
        NovaAuditLog: "ملخص تغيير الأتمتة",
        NovaWebhookSubscription: "ربط أحداث الأتمتة",
        Episode: "ذاكرة المسار المهني",
        SemanticFact: "معلومة مهنية",
        GraphNode: "عنصر معرفة مهنية",
        GraphEdge: "علاقة معرفة مهنية",
        KnowledgeAsset: "مستند معرفة",
        AgentArtifact: "مستند الوكيل",
        ArtifactVersion: "إصدار المستند",
        PublishedSite: "وصف الموقع المنشور",
        JobApplication: "نسخة السيرة في طلب الوظيفة",
        TalentNetworkSubmission: "نسخة السيرة في تقديم المواهب",
        SubmissionReceipt: "نسخة السيرة في إيصال التقديم",
        ApplicationStudioProject: "مشروع الأدوات المهنية",
        ApplicationStudioArtifact: "مستند الأدوات المهنية",
        MastraThreads: "عنوان محادثة قديمة",
        MastraMessages: "نص محادثة قديمة",
        MastraWorkingMemory: "الذاكرة المهنية المشتركة",
        CV: "محتوى السيرة الذاتية القديمة",
        CVLanguageVariant: "نسخة السيرة الذاتية بلغة أخرى",
        CvRevisionContent: "مستند إصدار السيرة الذاتية المحفوظ",
        CvImportEvidence: "مصدر استيراد السيرة الذاتية وأدلة التحليل",
      },
    },
    dataManagement: {
      privacyAndData: "الخصوصية والبيانات",
      title: "إدارة البيانات",
      description:
        "اختر السير الذاتية والمعلومات المحفوظة والاتصالات التي تريد الاحتفاظ بها أو حذفها.",
      guide: "كيفية إدارة بياناتك وحذفها",
      loadFailed: "تعذّر تحميل هذه المعلومات. حاول مجدداً قبل إجراء تغييرات.",
      retry: "إعادة المحاولة",
      mainCvDescription:
        "تستخدم سيرتك الذاتية الرئيسية معلومات ملفك الشخصي. اختر قسماً لتعديل تفاصيل محددة أو حذفها. قد تستخدم سير أخرى هذه التفاصيل، وقد تحتفظ النسخ المحفوظة بمعلوماتها الخاصة.",
      manageMainCv: "اختر بيانات السيرة الرئيسية لإدارتها",
      sections: {
        header: "الاسم والصورة وبيانات التواصل",
        summary: "الملخص",
        experience: "الخبرة العملية",
        education: "التعليم",
        certifications: "الشهادات",
        highlights: "أبرز الإنجازات المهنية",
        skills: "المهارات",
        languages: "اللغات",
      },
      savedCvs: "حذف سيرة ذاتية محفوظة",
      savedCvsDescription:
        "احذف سيراً ذاتية محددة مع الاحتفاظ بحسابك وسيرك الأخرى.",
      deleteCv: "حذف هذه السيرة الذاتية",
      deleteCvTitle: "هل تريد حذف «{{title}}»؟",
      deleteCvBody:
        "سيؤدي هذا إلى حذف «{{title}}» وروابط مشاركتها ودعواتها نهائياً. لا يمكن التراجع عن ذلك. يبقى ملفك الرئيسي وسيرك الأخرى. لن تُسترجع النسخ التي سبق إرسالها أو تنزيلها.",
      autoApplyWarning:
        "هذه السيرة محددة للمطابقة التلقائية. يؤدي حذفها إلى إلغاء هذا الاختيار؛ اختر سيرة أخرى قبل استخدام الميزة مجدداً.",
      removed: "تم حذف البيانات",
      actionFailed: "تعذّر إتمام هذا التغيير. يرجى المحاولة مجدداً.",
      disconnect: "فصل الهوية الرقمية UAE PASS",
      disconnectTitle: "هل تريد فصل الهوية الرقمية UAE PASS عن تبّيو؟",
      disconnectBody:
        "سيُحذف الاتصال بالهوية الرقمية وشارة التحقق وسجل الهوية الرقمية المخزّن من تبّيو. يبقى حسابك في تبّيو واسمك وبريدك الإلكتروني وبيانات سيرتك الذاتية. لا يحذف هذا حسابك في الهوية الرقمية. يمكنك متابعة تسجيل الدخول ببريدك الإلكتروني في تبّيو.",
      disconnected: "تم فصل الهوية الرقمية",
      memoryTitle: "ذاكرة الذكاء الاصطناعي",
      clearMemory: "مسح ذاكرة الذكاء الاصطناعي",
      clearMemoryTitle: "هل تريد مسح الذاكرة المحفوظة؟",
      clearMemoryBody:
        "احذف المعلومات المحفوظة في ذاكرة عمل الذكاء الاصطناعي. تبقى محادثاتك وسيرك الذاتية وحسابك. يمكن للمحادثات اللاحقة حفظ معلومات جديدة.",
      connectionsTitle: "الخدمات المتصلة",
      connectionsDescription:
        "راجع الخدمات المتصلة وصلاحيات التطبيقات. افصل الخدمة أو ألغِ رمز الوصول عندما لا تعود بحاجة إلى منحها الوصول.",
      accountTitle: "حذف الحساب وبياناته",
      accountDescription:
        "احذف حسابك في تبّيو والبيانات التي يملكها نهائياً. اقرأ خطوات الحذف وأكّد عندما تكون مستعداً. لا يمكن التراجع عن هذا الإجراء.",
    },
    privacy: {
      title: "الخصوصية",
      viewCvsPrivately: "تصفّح السير الذاتية بشكل خاص",
      viewCvsPrivatelyDescription:
        "عند فتح السيرة الذاتية لشخص آخر وأنت مسجّل الدخول، يظهر له زائر مجهول بدلاً من اسمك وصورتك.",
      description: "اختر ما إذا كان بإمكان Tabbio جمع تحليلات اختيارية للمنتج.",
      consentTitle: "خيارات الخصوصية",
      consentBody:
        "تساعدنا التحليلات الاختيارية على تحسين Tabbio، ويتيح التسويق الاختياري لمنصات الإعلان التي نستخدمها قياس حملاتنا. يعمل التطبيق بشكل طبيعي بدونهما، ويمكنك تغيير اختيارك من الإعدادات في أي وقت.",
      marketing: "التسويق",
      marketingDescription:
        "يتيح لمنصات الإعلان التي نستخدمها (مثل Google وMeta) قياس ما إذا كانت حملاتنا قد أوصلتك إلينا وعرض إعلانات أكثر صلة. متوقف إلى أن تسمح به. لا نشارك معها سيرتك الذاتية أو محتوى محادثاتك أو بيانات التواصل.",
      productAnalytics: "تحليلات المنتج",
      productAnalyticsDescription:
        "شارك بيانات محدودة عن استخدام المنتج ونشاط الشاشات لمساعدتنا على فهم Tabbio وتحسينه. هذه تحليلات للمنتج فقط، وليست بيانات سيرتك الذاتية أو محادثاتك الشخصية. لا يشمل ذلك محتوى السيرة الذاتية أو رسائل المحادثة أو الأوامر.",
      allowAnalytics: "سماح",
      continueWithoutAnalytics: "رفض",
      analyticsOn: "التحليلات مفعّلة",
      analyticsOff: "التحليلات متوقفة",
      manage: "إدارة خيارات الخصوصية",
      save: "حفظ الخيارات",
      saved: "تم حفظ خيارات الخصوصية",
      updateFailed: "تعذر تحديث خيارات الخصوصية",
      yourData: "بياناتك",
      downloadData: "تنزيل بياناتي",
      downloadDataDescription:
        "نسخة من حسابك وملفك الشخصي وسيرك الذاتية وطلباتك وروابط المشاركة والرسائل التي أرسلتها، في ملف JSON.",
      downloadDataPreparing: "جارٍ تجهيز ملفك…",
      downloadDataReady: "ملف بياناتك جاهز.",
      downloadDataFailed: "تعذر تجهيز بياناتك. يرجى المحاولة مرة أخرى بعد قليل.",
    },
    notifications: "الإشعارات",
    dataControls: "التحكم بالبيانات",
    notificationPreferences: {
      marketingEmails: "رسائل التسويق",
      marketingEmailsDescription: "تحديثات المنتج والعروض والنصائح من Tabbio.",
      systemEmails: "رسائل المنتج ودورة الاستخدام",
      systemEmailsDescription:
        "إرشادات المنتج الاختيارية ورسائل مسؤولي التوظيف وتحديثات الطلبات.",
      pushNotifications: "الإشعارات الفورية",
      pushNotificationsDescription:
        "تنبيهات الجوال للرسائل ومطابقات الوظائف ونشاط الحساب.",
      loadFailed: "تعذر تحميل تفضيلات الإشعارات",
      updateFailed: "تعذر تحديث تفضيل الإشعارات",
      saving: "جارٍ حفظ تفضيلات الإشعارات",
    },
    about: "حول",
    helpCenter: "مركز المساعدة",
    termsOfUse: "شروط الاستخدام",
    privacyPolicy: "سياسة الخصوصية",
    accountDeletion: "حذف الحساب",
    accountDeletionDescription: "إدارة الخصوصية والإشعارات وخيارات حذف الحساب.",
    accountDeletionFlow: {
      manageAccount: "إدارة الحساب",
      accountControls: "إدارة الحساب",
      accountControlsDescription: "الخصوصية والإشعارات وخيارات حذف الحساب.",
      dangerZone: "حذف الحساب",
      deleteAccountTitle: "حذف الحساب",
      deleteAccountDescription:
        "احذف حسابك والبيانات المرتبطة به نهائياً. لا يمكن التراجع عن ذلك.",
      beforeYouGo: "قبل الحذف",
      beforeYouGoBody: "يمكن غالباً حل سبب رغبتك في المغادرة بدون حذف الحساب.",
      reasonStepTitle: "لماذا تريد حذف حسابك؟",
      reasonStepBody:
        "اختر السبب الأقرب. يُستخدم فقط أثناء معالجة هذا الحذف ولا يتم الاحتفاظ به بعد ذلك.",
      reasons: {
        too_many_notifications: {
          label: "إشعارات كثيرة",
          description: "رسائل البريد أو التنبيهات أو مطابقات الوظائف مزعجة.",
        },
        privacy_concern: {
          label: "قلق بشأن الخصوصية",
          description: "لديك قلق حول ظهور الملف أو السيرة أو الحساب.",
        },
        not_useful: {
          label: "لا يفيدني حالياً",
          description: "Tabbio لا يساعدك في سير عملك الحالي.",
        },
        found_job: {
          label: "وجدت وظيفة",
          description: "لم تعد بحاجة إلى أدوات البحث عن وظائف أو الملف.",
        },
        cost: {
          label: "الخطة أو الفوترة",
          description: "السعر أو التجديد أو الفوترة هو السبب الرئيسي.",
        },
        other: {
          label: "سبب آخر",
          description: "السبب غير موجود في القائمة.",
        },
      },
      protectionTitle: "حسابك محمي",
      protectionBody:
        "يبقى ملفك وسيرتك وطلباتك وبيانات مساحة العمل خلف عناصر تحكم الحساب الموثق.",
      notificationsTitle: "إشعارات كثيرة؟",
      notificationsBody:
        "استخدم الإعدادات > الإشعارات لإيقاف رسائل التسويق أو رسائل النظام أو التنبيهات الفورية.",
      jobsTitle: "تنبيهات مطابقة الوظائف",
      jobsBody:
        "تنبيهات مطابقة الوظائف تأتي من تفضيلات الوظائف والأتمتة. يمكنك تعديلها بدلاً من حذف الحساب.",
      billingTitle: "التحكم بالفوترة والخطة",
      billingBody:
        "يمكن إدارة الخطط واشتراكات المتاجر من الإعدادات > الفوترة قبل إغلاق الحساب.",
      retention: {
        too_many_notifications: {
          title: "يمكنك تقليل الإشعارات بدون حذف الحساب",
          body: "رسائل البريد والتنبيهات العادية موجودة في الإعدادات > الإشعارات. أما تنبيهات مطابقة الوظائف والأتمتة فيمكن تعديلها من تفضيلات الوظائف.",
        },
        privacy_concern: {
          title: "ظهور حسابك تحت سيطرتك",
          body: "يبقى ملفك وسيرتك وبيانات مساحة العمل محمية خلف حسابك الموثق. ويمكن إبقاء النشر العام معطلاً.",
        },
        not_useful: {
          title: "يمكنك إبقاء الحساب متوقفاً",
          body: "يمكنك تسجيل الخروج وتقليل التنبيهات مع إبقاء سيرتك الذاتية والسجل متاحين إذا احتجتهما لاحقاً.",
        },
        found_job: {
          title: "يمكنك إبقاء Tabbio للتحديثات المهنية لاحقاً",
          body: "يمكن أن تبقى سيرتك الذاتية والمحادثات والملف متاحة للأدوار القادمة بدون تنبيهات وظائف نشطة.",
        },
        cost: {
          title: "يمكن إدارة الفوترة قبل الحذف",
          body: "الخطط واشتراكات المتاجر تُدار من الإعدادات > الفوترة. يمكنك إلغاء الفوترة بدون حذف الحساب.",
        },
        other: {
          title: "يمكن أن يبقى حسابك محمياً حتى تقرر",
          body: "يمكنك تعديل الإشعارات والفوترة والظهور أولاً. تابع فقط إذا كنت ما زلت تريد حذف الحساب.",
        },
      },
      finalWarningTitle: "سيتم حذف حسابك",
      finalWarningBody:
        "ستؤدي المتابعة إلى حذف حسابك نهائياً وإلغاء الجلسات والاتصالات النشطة وإزالة البيانات المرتبطة به. لا يمكن التراجع عن ذلك.",
      keepAccount: "إبقاء حسابي",
      continueDeletion: "متابعة الحذف",
      finalStepTitle: "التأكيد النهائي",
      finalStepBody:
        "سيتم حذف حسابك الآن. إذا سجلت لاحقاً بالبريد الإلكتروني نفسه، سينشئ Tabbio حساباً جديداً ولن يستعيد هذه البيانات.",
      searchResultsTitle: "حول نتائج البحث في Google",
      searchResultsBody:
        "يزيل Tabbio صفحة المصدر أو يحجبها ضمن عملية الحذف. وقد يحتفظ Google مؤقتاً بنتيجة قديمة حتى يتم تحديث فهرسه.",
      searchResultsHelper:
        "فقط إذا استمرت نتيجة Tabbio في الظهور بعد إزالة صفحة المصدر، يمكنك أن تطلب من Google تحديثها. يتولى Google معالجة الطلب وقد يستغرق ذلك بضعة أيام.",
      searchResultsAction: "فتح أداة التحديث من Google",
      reasonTitle: "السبب",
      reasonHelp: "أخبرنا لماذا تريد المغادرة.",
      reasonPlaceholder: "ما الذي جعلك تقرر حذف حسابك؟",
      detailsLabel: "أي تفاصيل أخرى؟ (اختياري)",
      detailsPlaceholder:
        "أضف تفاصيل اختيارية لاستخدامها فقط أثناء معالجة هذا الحذف.",
      otherReasonLabel: "اكتب السبب",
      otherReasonPlaceholder: "يرجى وصف سبب رغبتك في حذف حسابك.",
      otherReasonRequired: "يرجى إضافة سبب قصير.",
      reasonCounter: "{{count}}/{{max}}",
      acknowledge: "أفهم أن هذا سيحذف حسابي.",
      acknowledgeDescription:
        "سيؤدي ذلك إلى حذف الحساب والبيانات المرتبطة به نهائياً وإلغاء الجلسات والاتصالات النشطة وتسجيل خروجك.",
      requestAction: "حذف الحساب نهائياً",
      requesting: "جارٍ حذف الحساب...",
      deleteAction: "حذف الحساب",
      deleting: "جارٍ حذف الحساب...",
      successTitle: "تم حذف الحساب",
      successMessage:
        "تم حذف حسابك والبيانات المرتبطة به. التسجيل لاحقاً بالبريد نفسه سينشئ حساباً جديداً.",
      deletedTitle: "تم حذف الحساب",
      deletedMessage:
        "تم حذف حسابك والبيانات المرتبطة به. يمكنك الآن استخدام البريد نفسه لتسجيل جديد.",
      deletedMessageWithReceipt:
        "تم حذف حسابك والبيانات المرتبطة به. رقم إيصال الحذف: {{receiptId}}",
      errorTitle: "تعذر حذف الحساب",
      errorMessage: "يرجى المحاولة مرة أخرى بعد قليل.",
    },
    subscriptionValue: {
      title: "خطتك",
      subtitle: "مزايا خطتك واستخدامك في مكان واحد.",
      activity: "نشاطك الأخير",
      benefits: "ضمن خطة {{plan}}",
      allowances: "استخدامك المتاح",
      remaining: "متبقي {{remaining}} من {{limit}}",
      resets: "يتجدد في {{date}}",
      usageUnavailable: "تفاصيل خطتك غير متاحة. حاول مزامنة اشتراكك.",
      period: {
        day: "اليوم (UTC)",
        week: "هذا الأسبوع (UTC)",
        month: "هذا الشهر (UTC)",
      },
      actions: {
        chat: "ردود المحادثة المهنية",
        skills: "مرات تشغيل المهارات",
        cvPreviews: "معاينات أقسام السيرة الذاتية",
        fitReports: "تقارير توافق السيرة الذاتية",
        taskPreviews: "معاينات المهام",
      },
      benefit: {
        cv: {
          title: "سيرة ذاتية تناسب الوظيفة",
          body: "خصص سيرتك الذاتية لوظيفة قبل التقديم.",
        },
        automation: {
          title: "تابع مهامك باستمرار",
          body: "أعدّ مهام متكررة مع نوفا.",
        },
        interview: {
          title: "استعد للمقابلة",
          body: "تدرب على أسئلة المقابلة للوظيفة التي تستهدفها.",
        },
        letters: {
          title: "تقديم يعبّر عنك",
          body: "اكتب مسودة خطاب تقديم للوظيفة التي تريدها.",
        },
        analytics: {
          title: "تعرّف على جمهورك",
          body: "اعرف مصادر الزيارات إلى سيرتك الذاتية العامة.",
        },
        ranking: {
          title: "اعثر على المرشحين المناسبين",
          body: "رتّب المرشحين حسب متطلبات الوظيفة.",
        },
        screening: {
          title: "راجع مجموعة من المرشحين",
          body: "قيّم مجموعة مرشحين وفق متطلبات الوظيفة.",
        },
        outreach: {
          title: "ابدأ التواصل",
          body: "تواصل مع المرشحين من مساحة عملك.",
        },
        team: {
          title: "اطّلع على نشاط فريقك",
          body: "راجع نشاط التوظيف باستخدام تحليلات الفريق.",
        },
      },
    },
    cancelFlow: {
      cancelPlan: "إلغاء الاشتراك",
      sheetTitle: "اشتراكك",
      title: "قبل أن تغادر خطة {{plan}}",
      body: "إليك ما يمكنك الاستفادة منه ضمن خطتك.",
      keepPlan: "الاحتفاظ بخطة {{plan}}",
      reasonTitle: "ما الذي يمكن تحسينه؟",
      reasonOptional: "اختياري",
      noReason: "أفضل عدم الإجابة",
      reasons: {
        not_needed_now: "لا أحتاجها الآن",
        too_expensive: "التكلفة مرتفعة",
        hard_to_use: "لست متأكدًا من طريقة الاستخدام",
        missing_feature: "هناك ميزة أحتاجها غير متاحة",
        quality_issue: "النتائج تحتاج إلى تحسين",
        switching: "أستخدم أداة أخرى",
        other: "سبب آخر",
      },
      response: {
        not_needed_now:
          "تنتظر فرصة جديدة؟ يمكنك تحديث سيرتك الذاتية والاستعداد لخطوتك القادمة.",
        too_expensive:
          "يمكنك مراجعة الخطط المتاحة لدى مزود الفوترة. ستظهر الأسعار وشروط الفوترة هناك قبل أي تغيير.",
        hard_to_use:
          "جرّب مهمة محددة في المهارات، أو اطلب من المساعد المساعدة في سيرة ذاتية أو وظيفة أو مقابلة.",
        missing_feature:
          "يمكنك مشاركة الميزة التي تحتاجها في الإعدادات ← الملاحظات. يمكنك متابعة الإلغاء دون إرسال ملاحظات.",
        quality_issue:
          "يمكنك الإبلاغ عن نتيجة محددة في الإعدادات ← الملاحظات. يمكنك متابعة الإلغاء دون إرسال ملاحظات.",
        switching: "شكرًا لتجربة تابيو. يمكنك العودة متى احتجت إليها.",
        other: "شكرًا لتجربة تابيو. يمكنك العودة متى احتجت إليها.",
      },
      employerResponse:
        "استخدم مساحة عملك لمراجعة المرشحين أو إعداد وظيفة أو التواصل مع مرشحك القادم.",
      accessUntil: "إذا ألغيت الاشتراك، ينتهي وصولك الحالي في {{date}}.",
      accessUnknown: "سيؤكد مزود الفوترة موعد انتهاء وصولك.",
      trialAccess:
        "سيؤكد مزود الفوترة موعد انتهاء الفترة التجريبية. قد ينتهي الوصول فور الإلغاء.",
      freeAfter:
        "بعد ذلك، تُطبق حدود الخطة المجانية. إلغاء الاشتراك لا يحذف حسابك أو سيرك الذاتية.",
      employerAfter:
        "بعد ذلك، تُطبق حدود مساحة العمل المجانية. إلغاء الاشتراك لا يحذف حسابك.",
      providerNote: {
        app_store: "يكتمل الإلغاء في إعدادات اشتراكات Apple.",
        play_store: "يكتمل الإلغاء في Google Play.",
        portal: "يكتمل الإلغاء في بوابة الفوترة.",
      },
      continueCta: {
        app_store: "المتابعة إلى اشتراكات Apple",
        play_store: "المتابعة إلى Google Play",
        portal: "المتابعة إلى بوابة الفوترة",
      },
      opening: "جارٍ الفتح…",
      handoffError: "تعذر فتح إعدادات الاشتراك. يرجى المحاولة مجددًا.",
    },
    signOutTitle: "تسجيل الخروج",
    signOutMessage: "هل أنت متأكد أنك تريد تسجيل الخروج؟",
    aiMemory: "الذكاء الاصطناعي والذاكرة",
    viewMemory: "عرض ذاكرة الذكاء الاصطناعي",
    editMemory: "تعديل ذاكرة الذكاء الاصطناعي",
    clearMemory: "مسح ذاكرة الذكاء الاصطناعي",
    clearMemoryConfirm:
      "سيؤدي هذا إلى مسح كل ما تعلمه الذكاء الاصطناعي عنك. هل تريد المتابعة؟",
    memoryCleared: "تم مسح ذاكرة الذكاء الاصطناعي",
    memorySaved: "تم تحديث ذاكرة الذكاء الاصطناعي",
    noMemory: "لم يتعلم الذكاء الاصطناعي أي شيء عنك بعد. ابدأ محادثة أولاً.",
    memoryGraph: {
      title: "خريطة الذاكرة",
      subtitle:
        "{{count}} حقول ذاكرة محفوظة مرتبطة بالسيرة الذاتية ووصول MCP واتصالات التطبيقات.",
      user: "الذاكرة",
      cv: "السيرة",
      mcp: "MCP",
      apps: "التطبيقات",
      webSubtitle:
        "كل ما تتذكره تابيو عنك: سيرتك ومهاراتك ووظائفك وموصّلاتك ووكلاؤك: كخريطة مترابطة.",
      listTitle: "الذاكرة",
      listSubtitle:
        "ما تتذكره تابيو عنك: سيرتك الذاتية ومهاراتك ووظائفك واتصالاتك وتفضيلاتك. افتح أي عنصر لمراجعته أو نسيانه.",
      nativeSubtitle: "{{count}} عنصرًا تتذكرها تابيو، مجمّعة حسب النوع.",
      loading: "جارٍ تحميل خريطة الذاكرة…",
      loadError: "تعذّر تحميل خريطة الذاكرة.",
      empty: "لا يوجد شيء في خريطة الذاكرة بعد. تحدّث مع تابيو لبنائها.",
      rebuild: "تحديث خريطة الذاكرة",
      rebuildSuccess: "تم تحديث خريطة الذاكرة",
      rebuildError: "تعذّر تحديث خريطة الذاكرة.",
      searchPlaceholder: "بحث في الذاكرة…",
      viewGraph: "عرض الخريطة",
      viewList: "عرض القائمة",
      clearFilters: "مسح عوامل التصفية",
      window: {
        all: "كل الوقت",
        d7: "٧ أيام",
        d30: "٣٠ يومًا",
        d365: "سنة",
      },
      connections: "{{count}} اتصالات",
      noConnections: "لا توجد اتصالات",
      showAll: "عرض الكل ({{count}})",
      showLess: "عرض أقل",
      deleteNode: "نسيان هذا",
      deleteTitle: "نسيان من الذاكرة؟",
      deleteMessage: 'ستنسى تابيو "{{name}}". يمكنك التراجع خلال ٣٠ يومًا.',
      deleteError: "تعذّر نسيان هذا العنصر.",
      deletedToast: 'تم نسيان "{{name}}"',
      restoreError: "تعذّر استعادة هذا العنصر.",
      revokeTitle: "إلغاء الوصول؟",
      revokeMessage: "سيفقد {{name}} الوصول إلى ذاكرتك.",
      revokeConfirm: "إلغاء",
      revokeError: "تعذّر إلغاء الوصول.",
      zoomIn: "تكبير",
      zoomOut: "تصغير",
      zoomReset: "إعادة ضبط العرض",
      capTitle: "عرض {{shown}} من {{total}} ذكرى",
      capSubtitle:
        "قم بالترقية إلى Pro للاحتفاظ بذاكرة سنة كاملة وحتى ١٠٠٬٠٠٠ عقدة.",
      capCta: "الترقية إلى Pro",
      advancedTitle: "متقدم",
      advancedRowSubtitle:
        "ذاكرة العمل الخام التي يحتفظ بها الوكيل بين المحادثات",
      advancedDescription:
        "بيانات JSON الخام لذاكرة العمل التي يحتفظ بها الوكيل بين المحادثات. JSON منظم فقط.",
      advancedInvalidJsonError:
        "تنسيق JSON غير صالح. تحقق من الفواصل وعلامات الاقتباس والأقواس، ثم حاول مرة أخرى.",
      advancedInvalidStructureError:
        "يجب أن تكون ذاكرة العمل كائن JSON. ضع الحقول داخل { } ثم حاول مرة أخرى.",
      advancedValidationError:
        "تحتوي بعض حقول الذاكرة على قيم غير مدعومة. تحقق من أسماء الحقول وأنواع القيم، ثم حاول مرة أخرى.",
      advancedNetworkError:
        "تعذّر الاتصال بتابيو. تحقق من اتصالك بالإنترنت ثم حاول الحفظ مرة أخرى.",
      advancedSaveError:
        "تعذّر حفظ تغييرات الذاكرة. حاول مرة أخرى. إذا استمرت المشكلة، حدّث الصفحة.",
      advancedClearError: "فشل المسح",
      nodeTypes: {
        cv: "السيرة",
        section: "قسم",
        skill: "مهارة",
        experience: "خبرة",
        education: "تعليم",
        certification: "شهادة",
        job: "وظيفة",
        application: "طلب",
        company: "شركة",
        recruiter: "مسؤول توظيف",
        connector: "موصّل",
        agent: "وكيل",
        automation: "أتمتة",
        episode: "ذاكرة",
        fact: "حقيقة",
        preference: "تفضيل",
        knowledge_asset: "أصل",
      },
      edgeTypes: {
        CV_HAS_SECTION: "يحتوي قسمًا",
        CV_HAS_SKILL: "يحتوي مهارة",
        SECTION_USES_SKILL: "يستخدم مهارة",
        USER_HAS_EXPERIENCE: "خبرة",
        USER_HAS_EDUCATION: "تعليم",
        USER_HAS_CERTIFICATION: "شهادة",
        USER_APPLIED_JOB: "تقدّم",
        USER_SAVED_JOB: "محفوظة",
        JOB_MATCHED_USER: "مطابقة",
        JOB_REQUIRES_SKILL: "يتطلب مهارة",
        JOB_AT_COMPANY: "في شركة",
        RECRUITER_WORKS_AT_COMPANY: "يعمل في",
        AGENT_HAS_ACCESS: "لديه وصول",
        AGENT_GENERATED_EPISODE: "أنشأ",
        AUTOMATION_READS_NODE: "يقرأ",
        AUTOMATION_WRITES_NODE: "يكتب",
        CONNECTOR_FEEDS_NODE: "يغذّي",
        FACT_DERIVED_FROM_EPISODE: "مشتق من",
        PREFERENCE_OF_USER: "تفضيل",
        EPISODE_ABOUT_NODE: "حول",
      },
      card: {
        remembered: "تم التذكر",
        recalled: "مُستدعى من الذاكرة",
        recallEmpty: "لم يُعثر على شيء ذي صلة في الذاكرة.",
        more: "+{{count}} المزيد",
        actionLabel: "الذاكرة",
        confirm: "تطبيق هذا التغيير على ذاكرتك؟",
        forgetNodeTitle: "نسيان من الذاكرة",
        revokeAccessTitle: "إلغاء وصول الوكيل",
        forgetTitle: "نسيان الذاكرة",
        forgotNode: "تم النسيان",
        revokedAccess: "تم إلغاء الوصول",
        forgot: "تم النسيان",
      },
    },
  },

  // Public Profile Builder
  publicProfile: {
    title: "الملف الشخصي",
    defaultName: "اسمك",
    defaultHeadline: "أضف نبذتك وروابطك الاجتماعية لإكمال ملفك العام",
    joinOnTabbio: "انضم إليّ على Tabbio",
    comingSoon: "قريباً",
    addCollection: "إضافة مجموعة",
    addBlock: "إضافة قسم",
    archive: "الأرشيف >",
    activeBlocks: "أقسام نشطة",
    setup: "الإعداد",
    add: "إضافة",
    preview: "معاينة",
    previewNotPublishedTitle: "غير ظاهر للعامة بعد",
    previewNotPublishedHint: "فعّل الإظهار من الإعدادات للنشر",
    previewSurface: {
      upgrade: "ترقية",
      website: "الموقع",
      message: "رسالة",
      joinOwner: "انضم إلى {{name}} على Tabbio",
      cookiePreferences: "تفضيلات ملفات الارتباط",
      report: "إبلاغ",
      privacy: "الخصوصية",
      webCv: "السيرة الذاتية",
      servicesCount: "{{count}} خدمة نشطة",
      servicesCount_plural: "{{count}} خدمات نشطة",
      projectsCount: "{{count}} مشروع مميز",
      projectsCount_plural: "{{count}} مشاريع مميزة",
      teamCount: "{{count}} عضو عام",
      teamCount_plural: "{{count}} أعضاء عامون",
      getDirections: "احصل على الاتجاهات",
      openMap: "فتح الخريطة",
      contactForm: "نموذج التواصل",
      openForm: "فتح النموذج",
      searchRoles: "ابحث في الوظائف...",
      location: "الموقع",
      type: "النوع",
      apply: "تقديم",
      applyNow: "قدّم الآن",
      noRoleMatches: "لا توجد وظائف تطابق المرشحات.",
      noOpenRoles: "لا توجد وظائف عامة مفتوحة حالياً.",
      talentPoolCta: "لم تجد الدور المناسب؟ انضم إلى قاعدة المواهب.",
      moreRoleOptions: "خيارات إضافية لـ {{title}}",
      remote: "عن بُعد",
      hybrid: "هجين",
      onSite: "من المكتب",
      discord: "ديسكورد",
      spotify: "سبوتيفاي",
    },
    style: "النمط",
    editSheetTitle: "تعديل الملف الشخصي",
    tapPhotoToChange: "اضغط على الصورة للتغيير",
    locationHint: "قابل للنقر في المعاينة",
    websiteHint: "يستخدمه قسم الموقع",
    saved: "تم حفظ الملف الشخصي",
    saveFailed: "تعذّر حفظ الملف الشخصي",
    fields: {
      name: "الاسم الظاهر في السيرة الذاتية",
      bio: "النبذة",
      website: "الموقع",
      location: "الموقع",
    },
    validation: {
      nameRequired: "الاسم الظاهر في السيرة الذاتية مطلوب",
      bioTooLong: "النبذة طويلة جداً (الحد الأقصى {{max}} حرف)",
      websiteInvalid: "أدخل رابط موقع صالح",
    },
    checklist: {
      title: "قائمة الإعداد",
      items: {
        name_bio: "أضف اسمك ونبذتك",
        profile_image: "أضف صورتك الشخصية",
        socials: "أضف حساباتك الاجتماعية",
        important_links: "أضف روابطك المهمة",
        customize_design: "خصص تصميمك",
        share_tabbio: "شارك ملفك في Tabbio",
      },
    },
    addSheet: {
      title: "إضافة قسم",
      subtitle: "ابنِ صفحتك العامة بأقسام قابلة لإعادة الاستخدام",
      mode: {
        individual: "فردي",
        company: "شركة",
      },
      searchPlaceholder: "ابحث عن قسم",
      smartAdd: {
        placeholder: "الصق رابط موقع إلكتروني أو خرائط Google",
        invalid:
          "الصق رابطًا كاملاً يبدأ بـ https‏://‏. روابط الفيديو ستتوفر في تحديث لاحق.",
        update: "تحديث",
      },
      company: {
        title: "إضافة قسم",
        subtitle: "أضف جزءًا مفيدًا واحدًا إلى صفحة شركتك.",
        combinedPlaceholder: "الصق رابطًا أو ابحث عن الأقسام",
        basicsGroup: "الأساسيات",
        linkLabel: "رابط",
        noMatches: "لا توجد أقسام مطابقة لبحثك.",
      },
      suggested: "مقترح لك",
      explore: "استكشاف حسب الهدف",
      backExplore: "العودة للفئات",
      groups: {
        profile: "الملف",
        video: "فيديو",
        document: "مستند",
        audio: "صوت",
        contact: "تواصل",
        commerce: "تجاري",
        text: "نص",
        hiring: "توظيف",
        other: "أخرى",
      },
    },
    design: {
      title: "النمط",
      subtitle: "المظهر واللون وأزرار الصفحة",
      previewTitle: "معاينة مباشرة",
      tabs: {
        themes: "الأنماط",
        accents: "الألوان",
        buttons: "الأزرار",
      },
      buttonStyle: "نمط الزر",
      buttonShape: "شكل الزر",
      buttonStyles: {
        fill: "ممتلئ",
        outline: "حدود",
        soft: "هادئ",
        glass: "زجاجي",
      },
      buttonShapes: {
        square: "مربع",
        rounded: "مستدير",
        pill: "حبّة",
      },
      themes: {
        tabbio: "تابيو",
        air: "هوائي",
        midnight: "منتصف الليل",
        galaxy: "مجرة",
        glass: "زجاج",
        aurora: "شفق",
        mono: "أحادي",
        sunset: "غروب",
        ocean: "محيط",
      },
    },
    contactSheet: {
      title: "إضافة وسيلة تواصل",
      subtitle: "اختر القنوات التي تريد أن يصلك الناس من خلالها",
    },
    socialSheet: {
      // ليست "رابط اجتماعي": الورقة تضم أيضًا موقع الشركة، فتُضاف كل الروابط
      // الخارجية للصفحة من مكان واحد.
      title: "إضافة رابط",
      subtitle: "أدخل اسم المستخدم فقط وسننشئ الرابط تلقائيًا",
    },
    previewFailed:
      "تعذّر تحميل المعاينة. تأكد من تشغيل الموقع العام وواجهة البرمجة.",
    linkPlaceholders: {
      handle: "اسم المستخدم",
    },
    linkErrors: {
      handle: "أدخل اسم مستخدم صالحًا",
      phone: "أدخل رقم هاتف صالحًا",
      email: "أدخل بريدًا إلكترونيًا صالحًا",
      url: "أدخل رابطًا كاملاً يبدأ بـ https‏://‏",
      slack: "أدخل رابط Slack‏ (slack.com/…)",
    },
    settingsSheet: {
      title: "الإعدادات",
      subtitle: "الخصوصية وإعدادات الملف",
      betaSubtitle:
        "نشر الملف العام يبقى متوقفًا خلال النسخة التجريبية حتى تجهز نسخة الويب.",
      privacyTitle: "الخصوصية",
      profileVisibility: "الملف",
      photoVisibility: "الصورة",
      photoVisibilityHint:
        "يزيل خيار الإخفاء رابط الصورة الحقيقي ويستخدم صورة بديلة محايدة.",
      emailVisibility: "البريد الإلكتروني",
      phoneVisibility: "الهاتف",
      visibilityPublic: "عام",
      visibilityEmployers: "جهات العمل",
      visibilityPrivate: "خاص",
      visibilityHidden: "مخفي",
      profileVisibilityHint:
        "ينشئ الخيار العام صفحة ويب قابلة للبحث وقد تفهرسها محركات البحث. يخفي خيار جهات العمل فقط الروابط العامة مع إبقائك قابلاً للاكتشاف لدى مسؤولي التوظيف.",
      visibility: {
        public: "عام",
        employers: "جهات العمل فقط",
        private: "خاص",
      },
      profileUrl: "رابط الملف",
      showContactChannels: "إظهار قنوات التواصل للعامة",
      showContactChannelsHint:
        "اسمح للزوار برؤية وسائل التواصل المباشرة التي فعلتها.",
      hideBranding: "إخفاء علامة Tabbio",
      hideBrandingHint:
        "يزيل عبارة الانضمام إلى Tabbio من صفحتك العامة المنشورة.",
      sensitiveContent: "تحذير محتوى حساس",
      sensitiveContentHint: "عرض تنبيه قبل فتح الروابط الحساسة.",
    },
    teamSheet: {
      title: "الفريق",
      subtitle: "اختر الأشخاص الذين يظهرون علنًا في صفحة الشركة",
      members: "أعضاء الفريق",
      addMember: "إضافة عضو فريق",
      emptyTitle: "لا يوجد أعضاء فريق بعد",
      emptySubtitle: "أضف عضوًا عامًا لإظهار الأشخاص خلف الشركة.",
      memberFallback: "عضو فريق",
      roleFallback: "الدور",
      namePlaceholder: "الاسم",
      rolePlaceholder: "الدور",
      bioPlaceholder: "نبذة قصيرة",
      linkedinPlaceholder: "رابط لينكدإن",
      websitePlaceholder: "رابط الموقع",
      validation: {
        nameRequired: "الاسم مطلوب",
        roleRequired: "الدور مطلوب",
      },
      memberCount: "العضو {{count}}",
    },
    company: {
      pageTitle: "صفحة الشركة",
      defaultHeadline: "نحن نوظف! انضم إلى {{name}}.",
      footerTitle: "تذييل Tabbio",
      fields: {
        tagline: "الوصف المختصر",
        taglinePlaceholder: "سطر واحد يصف ما تقدمه شركتك",
        industry: "المجال",
        industryPlaceholder: "اختر المجال",
        slug: "عنوان الصفحة العامة",
        slugPlaceholder: "acme",
      },
      removeLogo: "إزالة الشعار",
      removeLogoTitle: "إزالة الشعار؟",
      removeLogoBody: "ستعرض صفحتك صورة بديلة حتى ترفع شعارًا جديدًا.",
      settings: {
        title: "إعدادات صفحة الشركة",
        subtitle: "الهوية والموقع الإلكتروني والنشر والظهور في البحث.",
        menu: {
          pageGroup: "الصفحة",
          publishingGroup: "النشر",
          companyProfile: "ملف الشركة",
          companyProfileHint: "الشعار والاسم والنبذة المختصرة والمجال والموقع",
          website: "الموقع الإلكتروني الرسمي",
          websiteHint: "أضف الموقع الإلكتروني الرسمي لشركتك",
          pageAddress: "عنوان الصفحة",
          pageAddressHint: "اختر عنوان صفحتك العامة",
          searchAppearance: "الظهور في نتائج البحث",
          searchAppearanceHint: "عنوان البحث ووصفه وخيارات الظهور",
          domainEmbedding: "النطاق والتضمين",
          advancedSeo: "إعدادات SEO المتقدمة",
        },
        saved: "تم الحفظ",
        searchSection: "الظهور في نتائج البحث",
        searchTitle: "عنوان نتيجة البحث",
        searchTitlePlaceholder: "Acme | الوظائف",
        searchDescription: "وصف نتيجة البحث",
        searchDescriptionPlaceholder: "ما يراه المرشحون في نتائج البحث",
        indexing: "الفهرسة في محركات البحث",
        indexingHint: "السماح لمحركات البحث بفهرسة صفحتك العامة.",
        socialSection: "المشاركة على المنصات",
        useSearchText: "استخدام نص البحث",
        useSearchTextHint: "تعيد معاينات المشاركة استخدام عنوان البحث ووصفه.",
        socialTitle: "عنوان المشاركة",
        socialTitlePlaceholder: "العنوان الظاهر عند مشاركة صفحتك",
        socialDescription: "وصف المشاركة",
        socialDescriptionPlaceholder: "الوصف الظاهر عند مشاركة صفحتك",
        languageSection: "لغة الصفحة",
        languages: {
          "en-AE": "الإنجليزية (الإمارات)",
          "ar-AE": "العربية (الإمارات)",
          en: "الإنجليزية",
          ar: "العربية",
        },
      },
      checklist: {
        company_identity: "أكمل هوية شركتك",
        logo: "ارفع شعار الشركة",
        social_or_website: "أضف رابطًا اجتماعيًا أو موقعًا إلكترونيًا",
        careers_ready: "جهّز قسم الوظائف",
        design_reviewed: "راجع تصميم صفحتك",
        shared: "شارك صفحتك",
      },
      dock: {
        add: "إضافة",
        preview: "معاينة",
        design: "التصميم",
        analytics: "التحليلات",
        settings: "الإعدادات",
        enhance: "تحسين",
        setupLabel: "مكتمل",
        setupProgress: "{{percent}}% مكتمل",
        setupOpenHint: "يفتح قائمة إعداد صفحة الشركة",
        enhanceSend: "إرسال طلب تعديل الصفحة",
        enhanceDefaultPrompt:
          "حسّن صفحة الشركة المفتوحة حاليًا في Tabbio مباشرة. حافظ على جميع الحقائق المتعلقة بالشركة. اختصر النبذة وأوصاف الأقسام، واستخدم صياغة واضحة وجذابة تعكس هوية جهة التوظيف، وأزل التكرار، وأبقِ التفاصيل الأهم للمرشحين. لا تخترع أي تفاصيل ما لم أطلب ذلك.",
      },
      backToEditor: "تعديل الصفحة",
    },
    openRoles: {
      title: "الوظائف المفتوحة",
      subtitle: "إدارة الوظائف والتخطيط والصورة المصغرة والتحليلات",
      stats: "{{roles}} وظائف · {{applicants}} متقدمون",
      statsRoles_zero: "{{count}} وظائف",
      statsRoles_one: "وظيفة واحدة",
      statsRoles_two: "وظيفتان",
      statsRoles_few: "{{count}} وظائف",
      statsRoles_many: "{{count}} وظيفةً",
      statsRoles_other: "{{count}} وظيفة",
      statsApplicants_zero: "{{count}} متقدمين",
      statsApplicants_one: "متقدم واحد",
      statsApplicants_two: "متقدمان",
      statsApplicants_few: "{{count}} متقدمين",
      statsApplicants_many: "{{count}} متقدمًا",
      statsApplicants_other: "{{count}} متقدم",
      statsOpen_zero: "{{count}} وظائف مفتوحة",
      statsOpen_one: "وظيفة واحدة مفتوحة",
      statsOpen_two: "وظيفتان مفتوحتان",
      statsOpen_few: "{{count}} وظائف مفتوحة",
      statsOpen_many: "{{count}} وظيفةً مفتوحةً",
      statsOpen_other: "{{count}} وظيفة مفتوحة",
      statsTotal_zero: "{{count}} وظائف إجمالًا",
      statsTotal_one: "وظيفة واحدة إجمالًا",
      statsTotal_two: "وظيفتان إجمالًا",
      statsTotal_few: "{{count}} وظائف إجمالًا",
      statsTotal_many: "{{count}} وظيفةً إجمالًا",
      statsTotal_other: "{{count}} وظيفة إجمالًا",
      deleted: "تمت إزالة قسم الوظائف المفتوحة",
      emptyTitle: "أضف الوظائف المفتوحة",
      emptySubtitle: "أنشئ قسم الوظائف المفتوحة لبدء التوظيف من ملفك العام.",
      noJobs: "لا توجد وظائف بعد",
      noJobsHint: "انشر أول وظيفة لبدء استقبال الطلبات.",
      postJob: "نشر وظيفة",
      addJob: "إضافة وظيفة",
      futureRoles: {
        title: "جمع السير الذاتية للوظائف المستقبلية",
        helper: "يضيف «انضم إلى شبكة مواهبنا» بعد قائمة الوظائف.",
      },
      talentLibrary: "مكتبة المواهب",
      talentLibraryDesc:
        "تظهر في نهاية قائمة الوظائف. يرسل المرشحون سيرتهم للنظر في الفرص القادمة.",
      gotIdeas: "عندك أفكار؟",
      shareFeedback: "شاركنا الملاحظات",
      deleteBlock: "حذف القسم",
      layoutHeading: "كيف تظهر الوظائف على ملفك",
      tabs: {
        jobs: "الوظائف",
        layout: "التخطيط",
        thumbnail: "الصورة المصغرة",
        insights: "التحليلات",
      },
      layout: {
        byDepartment: "حسب القسم",
        byDepartmentDesc: "تجميع الوظائف داخل تبويبات الأقسام.",
        cards: "بطاقات",
        cardsDesc: "كل وظيفة تظهر كبطاقة كاملة بالتفاصيل.",
        compact: "مضغوط",
        compactDesc: "قائمة كثيفة بمساحة أقل.",
      },
      thumbnailTitle: "أضف صورة مصغرة لهذا الرابط",
      thumbnailDesc: "صورة أو أيقونة",
      thumbnailSetTitle: "تمت إضافة الصورة المصغرة",
      thumbnailSetDesc: "تظهر بجانب الوظائف المتاحة في ملفك.",
      thumbnailUploading: "جارٍ الرفع…",
      thumbnailReplace: "استبدال",
      thumbnailRemove: "إزالة",
      thumbnailUploaded: "تم تحديث الصورة المصغرة",
      thumbnailRemoved: "تمت إزالة الصورة المصغرة",
      thumbnailUploadFailed: "تعذّر رفع الصورة. حاول مرة أخرى.",
      insights: {
        all: "الكل",
        updating: "جارٍ التحديث…",
        error: "تعذّر تحميل التحليلات لهذه الفترة.",
        totalViews: "إجمالي المشاهدات",
        uniqueVisitors: "الزوار الفريدون",
        applyClicks: "نقرات التقديم",
        peakDay: "أفضل يوم",
        openRolesClicks: "نقرات الوظائف المتاحة",
        viewToApply: "معدل المشاهدة إلى التقديم",
        viewToApplyHint:
          "تُحتسب المشاهدات عبر بكسل الصفحة، لذا قد تقلّ عن العدد الحقيقي بسبب حاجبات الإعلانات.",
        sourceBreakdown: "توزيع المصادر",
        sourceEmpty: "لا توجد زيارات مسجّلة في هذه الفترة بعد.",
        scopePageWide: "يشمل صفحة ملفك بالكامل، وليس قسم الوظائف المتاحة فقط.",
        scopeBlock: "قسم الوظائف المتاحة فقط.",
        noData: "–",
        upgrade: "ترقية ->",
        locked: "PLUS",
        lockedA11y: "مقفل. قم بالترقية لعرض هذا المؤشر.",
        lockedTitle: "التحليلات التفصيلية تتطلب Plus",
        lockedSubtitle:
          "خطتك الحالية تقيس إجمالي المشاهدات فقط. الزوار ونقرات التقديم وأفضل يوم ومصادر الزيارات تبقى مخفية حتى تقوم بالترقية، وهي ليست أصفارًا.",
        lockedCta: "ترقية لعرضها",
        sourceLocked:
          "مصادر الزيارات تتطلب Plus. قم بالترقية لمعرفة من أين يأتي الزوار.",
        sources: {
          direct: "مباشر",
          open_roles: "الوظائف المتاحة",
          open_roles_more: "الوظائف المتاحة (عرض الكل)",
          social: "التواصل الاجتماعي",
          contact: "التواصل",
          form: "نموذج التواصل",
          form_submit: "نموذج التواصل",
          website: "الموقع الإلكتروني",
          owner_website: "الموقع الإلكتروني",
          portfolio: "معرض الأعمال",
          visit: "زيارة",
          map: "الخريطة",
          image: "صورة",
          team_member: "الفريق",
          links: "الروابط",
        },
      },
    },
    shareSheet: {
      title: "شارك Tabbio الخاص بك",
      subtitle: "شارك ملفك في أي مكان",
      copied: "تم نسخ الرابط",
      // تظهر عندما يمنع المتصفح الوصول إلى الحافظة تمامًا: سياق غير آمن أو
      // صلاحية مرفوضة. لا نُبلّغ أبدًا عن نسخ لم يحدث.
      copyFailed: "تعذّر نسخ الرابط",
      copyFailedHint: "منع المتصفح الوصول إلى الحافظة. حدّد الرابط وانسخه يدويًا.",
      unavailable: "خيار المشاركة هذا غير متاح على هذا الجهاز",
      tweet: "اطّلع على {{name}} على Tabbio",
      copyLink: "نسخ الرابط",
      shareVia: "المشاركة عبر…",
      qrTitle: "رمز QR",
      qrSubtitle: "يمكن لأي شخص مسح الرمز لفتح ملفك مباشرة.",
      pageLinkLabel: "رابط صفحتك",
      company: {
        title: "شارك صفحة شركتك",
        subtitle: "اختر طريقة مشاركة صفحة شركتك العامة.",
        qrSubtitle: "يمكن لأي شخص مسح الرمز لفتح صفحة شركتك مباشرة.",
        copyLink: "نسخ رابط الصفحة",
        downloadQr: "تنزيل رمز QR",
        openPage: "فتح الصفحة العامة",
        openPageHint: "شاهد الصفحة المنشورة تمامًا كما يراها المرشحون",
        emailSignature: "أضِف إلى توقيع البريد الإلكتروني",
        emailSignatureHint: "انسخ توقيعًا من سطر واحد مع رابط صفحتك",
        signatureCopied: "تم نسخ التوقيع",
        pageLinkLabel: "رابط صفحة الشركة",
      },
      menu: {
        addToBio: "أضفه إلى البايو",
        qrCode: "رمز QR",
        shareTo: "مشاركة إلى",
        customize: "تخصيص",
        open: "فتح",
      },
      qr: {
        save: "حفظ QR",
        download: "تنزيل",
        saved: "تم حفظ رمز QR في الصور",
        downloaded: "رمز QR جاهز للمشاركة",
      },
      targets: {
        copy: "نسخ",
        copied: "تم النسخ",
        whatsapp: "واتساب",
        x: "X",
        linkedin: "لينكدإن",
        email: "البريد",
        more: "المزيد",
      },
      addToBio: {
        title: "طريقة إضافة الرابط إلى البايو",
        subtitle: "اختر المنصة للحصول على الخطوات.",
        shareTo: "شارك على {{platform}}",
        steps: {
          1: "انسخ رابط Tabbio الخاص بك.",
          2: "افتح إعدادات حسابك الاجتماعي.",
          3: "الصق الرابط في البايو ثم احفظ.",
        },
      },
      shareOn: "شارك على {{platform}}",
      moreOptions: "خيارات أخرى",
      goToPlatform: "اذهب إلى {{platform}}",
      platforms: {
        snapchat: "سناب شات",
        facebook: "فيسبوك",
        facebook_page: "صفحة فيسبوك",
        linkedin: "لينكدإن",
        x: "X",
        whatsapp: "واتساب",
        telegram: "تيليجرام",
        tiktok: "تيك توك",
        twitch: "تويتش",
        youtube: "يوتيوب",
        instagram: "إنستغرام",
        pinterest: "بنترست",
        soundcloud: "ساوند كلاود",
      },
      customize: {
        title: "تخصيص المشاركة",
        subtitle: "تحكم في العلامة التجارية والرؤية والتنبيهات قبل المشاركة.",
        cta: "فتح الإعدادات",
        backgrounds: {
          gradient: "متدرج",
          light: "فاتح",
          dark: "داكن",
        },
      },
    },
    previewShareSheet: {
      title: "مشاركة الملف",
      subtitle: "شارك مباشرة من وضع المعاينة",
    },
    previewCtas: {
      getDirections: "الاتجاهات",
      openMap: "فتح الخريطة",
    },
    searchRoles: "البحث عن وظائف...",
    filterLocation: "الموقع",
    filterType: "النوع",
    talentPoolCta: "لا ترى وظيفتك؟ انضم إلى مجموعة المواهب.",
    talentPoolApply: "تقدم الآن",
    applyButton: "تقدم",
    footerCookies: "تفضيلات ملفات تعريف الارتباط",
    footerReport: "إبلاغ",
    footerPrivacy: "الخصوصية",
    joinOwnerOnTabbio: "انضم إلى {{name}} على Tabbio",
    upsell: {
      heading1: "مسيرتك المهنية.",
      heading2: "رابط واحد.",
      subtitle:
        "انضم إلى {{name}} وأكثر من 23,000 محترف في الإمارات على Tabbio",
      inputPrefix: "tabbio.com/",
      inputPlaceholder: "اسم المستخدم",
      cta: "احصل على Tabbio الخاص بك",
      exploreProfiles: "استكشف الملفات",
      aboutTabbio: "عن Tabbio",
    },
    blockCounts: {
      projects: "{{count}} مشروع",
      projects_other: "{{count}} مشاريع",
      services: "{{count}} خدمة",
      services_other: "{{count}} خدمات",
      teamMembers: "{{count}} عضو فريق",
      teamMembers_other: "{{count}} أعضاء فريق",
    },
    status: {
      loadingTitle: "جارٍ تحميل ملفك العام",
      loadingBody: "نقوم بجلب أحدث إعدادات الباني والمحتوى المحفوظ.",
      errorTitle: "تعذر تحميل الملف العام",
      errorBody:
        "حاول مرة أخرى بعد قليل. لم يتم فقدان الأقسام أو الإعدادات المحفوظة.",
      savingTitle: "جارٍ حفظ التغييرات",
      savingBody: "يتم الحفظ التلقائي لملفك العام في الخلفية.",
      saveErrorTitle: "تعذر حفظ التغييرات",
      saveErrorBody: "لم تتم مزامنة آخر تعديل. راجع التغيير وحاول مرة أخرى.",
    },
    blockEditor: {
      linksLabel: "الروابط",
      linkTitle: "التسمية",
      linkTitlePlaceholder: "صفحة الوظائف",
      linkUrl: "الرابط",
      linkUrlPlaceholder: "https://example.com/careers",
      linksEmpty: "لا توجد روابط بعد: أضف أول رابط أدناه.",
      addLink: "إضافة رابط",
      faqsLabel: "الأسئلة",
      faqsEmpty: "لا توجد أسئلة بعد: أضف أول سؤال أدناه.",
      faqQuestion: "السؤال",
      faqQuestionPlaceholder: "ما المنطقة الزمنية التي تعمل بها؟",
      faqAnswer: "الإجابة",
      faqAnswerPlaceholder:
        "أعمل أساساً بتوقيت غرينتش +4، مع ساعات عمل مشتركة مع عملاء أوروبا وشرق الولايات المتحدة.",
      addQuestion: "إضافة سؤال",
      testimonialsLabel: "آراء العملاء",
      testimonialsEmpty: "لا توجد آراء بعد: الصق أول اقتباس أدناه.",
      testimonialAuthor: "اسم صاحب الرأي",
      testimonialAuthorPlaceholder: "مايا بارك",
      testimonialQuote: "الاقتباس",
      testimonialQuotePlaceholder: "كان العمل معهم أفضل قرار اتخذناه هذا العام.",
      testimonialMeta: "المنصب / الشركة",
      testimonialMetaPlaceholder: "شريك مؤسس، أكمي",
      addTestimonial: "إضافة رأي",
      title: "تعديل القسم",
      subtitle: "عدّل إعدادات القسم والمحتوى المرتبط به.",
      settings: "إعدادات القسم",
      sourceData: "البيانات المصدرية",
      visible: "إظهاره في الملف العام",
      visibleHint: "أوقفه لإخفاء القسم دون حذف محتواه.",
      titlePlaceholder: "عنوان مخصص",
      subtitlePlaceholder: "عنوان فرعي مخصص",
      urlPlaceholder: "https://example.com",
      bodyPlaceholder: "أضف نصاً داعماً أو تعليمات",
      buttonLabelPlaceholder: "نص الزر",
      submitEmailPlaceholder: "submissions@example.com",
      deleteBlock: "حذف القسم",
      deleteConfirm: "هل تريد حذف هذا القسم؟ لا يمكن التراجع عن هذا.",
      deleteSuccess: "تمت إزالة القسم من ملفك العام",
      authoredTitle: "هذا القسم تتم إدارته من هنا",
      authoredBody: "أي تغييرات هنا ستظهر مباشرة في ملفك العام.",
      notFoundTitle: "القسم غير موجود",
      notFoundBody: "قد يكون هذا القسم قد حُذف أو لم يعد متاحاً.",
      sourceLinkTitle: "الحقل المصدر",
      sourceLinkCta: "تعديل بيانات الملف",
      websiteSourceTitle: "مصدر قسم الموقع",
      websiteSourceBody:
        "يقرأ هذا القسم الموقع المحفوظ في ملفك أو في تفاصيل الشركة.",
      websiteSourceEmpty:
        "أضف موقعاً في بيانات الملف ليشير هذا القسم إلى وجهة حقيقية.",
      locationSourceTitle: "مصدر أقسام الموقع",
      locationSourceBody:
        "يعتمد قسما الزيارة والخريطة على الموقع المحفوظ في ملفك أو في تفاصيل الشركة.",
      locationSourceEmpty:
        "أضف موقعاً في بيانات الملف ليحصل هذا القسم على وجهة حقيقية.",
      webcv: {
        title: "محتوى السيرة الذاتية",
        body: "تعرض السيرة الذاتية لـ {{name}} أحدث بيانات الملف الشخصي والسيرة المهنية المحفوظة في Tabbio.",
        cta: "تعديل بيانات الملف",
      },
      project: {
        emptyTitle: "لا توجد مشاريع مميزة بعد",
        emptyBody: "أضف مشروعاً مميزاً ليعرض قسم الأعمال نماذج حقيقية من عملك.",
        noDescription: "لم تتم إضافة وصف للمشروع بعد.",
        add: "إضافة مشروع مميز",
        addAnother: "إضافة مشروع آخر",
        addTitle: "مشروع مميز جديد",
        editTitle: "تعديل المشروع المميز",
        titlePlaceholder: "عنوان المشروع",
        descriptionPlaceholder: "ماذا بنيت ولماذا هو مهم؟",
        linkPlaceholder: "رابط المشروع",
        technologiesPlaceholder: "التقنيات، مفصولة بفواصل",
        imagePlaceholder: "رابط صورة المشروع",
        uploadImage: "رفع صورة",
        imageUploaded: "تم رفع صورة المشروع",
        imageUploadFailed: "تعذر رفع صورة المشروع",
        titleRequired: "أضف عنواناً للمشروع قبل الحفظ.",
        saveCta: "حفظ المشروع",
        saved: "تم حفظ المشروع",
        saveFailed: "تعذر حفظ المشروع",
        deleted: "تمت إزالة المشروع",
        deleteFailed: "تعذر إزالة المشروع",
      },
      service: {
        emptyTitle: "لا توجد خدمات مضافة بعد",
        emptyBody: "أضف عرض خدمة ليظهر للزوار ما الذي تقدمه.",
        noDescription: "لم تتم إضافة وصف للخدمة بعد.",
        add: "إضافة خدمة",
        addAnother: "إضافة خدمة أخرى",
        addTitle: "عرض خدمة جديد",
        editTitle: "تعديل عرض الخدمة",
        titlePlaceholder: "عنوان الخدمة",
        descriptionPlaceholder: "صف الخدمة والنطاق والنتيجة",
        basePricePlaceholder: "السعر الأساسي",
        deliveryDaysPlaceholder: "مدة التسليم بالأيام",
        deliverablesPlaceholder: "المخرجات، مفصولة بفواصل",
        titleRequired: "أضف عنواناً للخدمة قبل الحفظ.",
        numberError: "استخدم أرقاماً للسعر ومدة التسليم.",
        saveCta: "حفظ الخدمة",
        saved: "تم حفظ الخدمة",
        saveFailed: "تعذر حفظ الخدمة",
        deleted: "تمت إزالة الخدمة",
        deleteFailed: "تعذر إزالة الخدمة",
        priceAndTime: "يبدأ من {{price}} · {{days}} أيام",
        timeOnly: "{{days}} أيام",
      },
    },
    contacts: {
      tabbioMessage: {
        label: "رسائل Tabbio",
        desc: "مراسلة داخل التطبيق عبر Tabbio",
        placeholder: "",
      },
      whatsapp: {
        label: "واتساب",
        desc: "محادثة مباشرة عبر واتساب",
        placeholder: "+971 50 000 0000",
      },
      telegram: {
        label: "تيليجرام",
        desc: "قناة عامة أو محادثة مباشرة",
        placeholder: "@username",
      },
      slack: {
        label: "سلاك",
        desc: "رابط مساحة Slack",
        placeholder: "https://slack.com/...",
      },
      email: {
        label: "البريد الإلكتروني",
        desc: "عنوان بريد مباشر",
        placeholder: "you@email.com",
      },
      phone: {
        label: "الجوال",
        desc: "رقم الجوال",
        placeholder: "+971 50 000 0000",
      },
      landline: {
        label: "الهاتف الأرضي",
        desc: "رقم المكتب أو المنزل",
        placeholder: "+971 2 000 0000",
      },
    },
    socials: {
      website: {
        label: "رابط صفحة الشركة / الموقع",
        desc: "موقعك الخاص أو صفحة الوظائف",
        placeholder: "https://www.example.com",
      },
      linkedin: {
        label: "لينكدإن",
        desc: "الملف المهني",
        placeholder: "https://linkedin.com/in/username",
      },
      instagram: {
        label: "إنستغرام",
        desc: "الصور والقصص",
        placeholder: "https://instagram.com/username",
      },
      x: {
        label: "X",
        desc: "المنشورات والتحديثات",
        placeholder: "https://x.com/username",
      },
      tiktok: {
        label: "تيك توك",
        desc: "مقاطع الفيديو القصيرة",
        placeholder: "https://tiktok.com/@username",
      },
      youtube: {
        label: "يوتيوب",
        desc: "قناة الفيديو",
        placeholder: "https://youtube.com/@username",
      },
      snapchat: {
        label: "سناب شات",
        desc: "رابط حساب سناب",
        placeholder: "https://snapchat.com/add/username",
      },
      facebook: {
        label: "فيسبوك",
        desc: "صفحة أو حساب عام",
        placeholder: "https://facebook.com/username",
      },
      discord: {
        label: "ديسكورد",
        desc: "رابط دعوة المجتمع",
        placeholder: "https://discord.gg/...",
      },
      pinterest: {
        label: "بنترست",
        desc: "لوحات وإلهام محفوظ",
        placeholder: "https://pinterest.com/username",
      },
      spotify: {
        label: "سبوتيفاي",
        desc: "حساب فنان أو قائمة تشغيل",
        placeholder: "https://open.spotify.com/...",
      },
      tabbio: {
        label: "Tabbio",
        desc: "ملفك على Tabbio",
        placeholder: "https://tabbio.com/username",
      },
      whatsapp: {
        label: "واتساب",
        desc: "رابط مراسلة مباشر",
        placeholder: "https://wa.me/971500000000",
      },
      email: {
        label: "البريد",
        desc: "بريد التواصل",
        placeholder: "you@email.com",
      },
    },
    explore: {
      hiring: "التوظيف",
      makeMoney: "تحقيق الدخل",
      professional: "مهني",
      media: "وسائط",
      contact: "تواصل",
      text: "نص",
      all: "كل الأقسام",
    },
    blocks: {
      webcv: {
        title: "السيرة الذاتية على الويب",
        subtitle: "ahmed.tabbio.com",
        desc: "اعرض سيرتك الذاتية كاملة بصيغة ويب عامة.",
      },
      career: {
        title: "صفحة الوظائف",
        subtitle: "company.tabbio.com",
        desc: "اعرض الوظائف وتفاصيل التوظيف الخاصة بالشركة.",
      },
      services: {
        title: "الخدمات",
        subtitle: "عروض الخدمات",
        desc: "اعرض ما تقدمه مع السعر ومدة التسليم والنطاق.",
      },
      website: {
        title: "الموقع",
        subtitle: "موقع خارجي",
        desc: "اربط الموقع الأساسي الشخصي أو موقع الشركة المحفوظ في الملف.",
      },
      insights: {
        title: "رؤى الموارد البشرية الأسبوعية",
        subtitle: "احصل على أحدث اتجاهات الموارد البشرية",
        desc: "شارك نشراتك وتحديثاتك الدورية.",
      },
      links: {
        title: "روابط",
        subtitle: "قائمة بالوجهات المهمة",
        desc: "اجمع عدة روابط في قسم واحد: صفحة الوظائف، الملف الصحفي، دليل المزايا.",
      },
      faqs: {
        title: "الأسئلة الشائعة",
        subtitle: "الإجابة على الأسئلة المتكررة",
        desc: "أجب عن الأسئلة المتكررة في قسم واضح.",
      },
      visit: {
        title: "زرنا",
        subtitle: "موقع فعلي",
        desc: "اعرض العنوان المحفوظ مع إجراء للحصول على الاتجاهات.",
      },
      openroles: {
        title: "الوظائف المفتوحة",
        subtitle: "نحن نوظف",
        desc: "انشر الوظائف المفتوحة واجمع الطلبات.",
      },
      team: {
        title: "الفريق",
        subtitle: "تعرّف على الفريق",
        desc: "اعرض أعضاء الفريق وأدوارهم.",
      },
      talentpool: {
        title: "بنك المواهب",
        subtitle: "ابنِ قاعدة مرشحين",
        desc: "اجمع مرشحين محتملين للتوظيف القادم.",
      },
      portfolio: {
        title: "معرض الأعمال",
        subtitle: "أعمال مميزة",
        desc: "اعرض المشاريع المميزة مع الصور والملخصات والروابط.",
      },
      testimonial: {
        title: "آراء العملاء",
        subtitle: "ماذا يقول العملاء",
        desc: "أضف شهادات العملاء والشركاء.",
      },
      booking: {
        title: "احجز جلسة",
        subtitle: "احجز وقتك فوراً",
        desc: "اسمح للناس بحجز موعد مباشرة.",
      },
      map: {
        title: "الخريطة",
        subtitle: "اتجاهات ومعاينة الخريطة",
        desc: "حوّل موقعك المحفوظ إلى قسم خريطة مخصص للاتجاهات.",
      },
      pdf: {
        title: "ملف PDF",
        subtitle: "ملف قابل للتنزيل",
        desc: "شارك ملفات تعريفية أو دلائل بصيغة PDF.",
      },
      image: {
        title: "صورة",
        subtitle: "صورة مميزة",
        desc: "اعرض صورة رئيسية أو أصل بصري.",
      },
      video: {
        title: "فيديو",
        subtitle: "فيديو مميز",
        desc: "أضف فيديو تعريفي أو محتوى رئيسي.",
      },
      digitalproduct: {
        title: "منتج رقمي",
        subtitle: "بيع الملفات",
        desc: "بع ملفات رقمية أو موارد مدفوعة.",
      },
      text: {
        title: "نص",
        subtitle: "قسم نص حر",
        desc: "أضف فقرات أو ملاحظات مخصصة.",
      },
      header: {
        title: "عنوان",
        subtitle: "عنوان قسم",
        desc: "أضف عنواناً بصرياً بين الأقسام.",
      },
      form: {
        title: "نموذج",
        subtitle: "استقبال الطلبات",
        desc: "أنشئ نموذجاً للتواصل أو الطلبات.",
      },
      music: {
        title: "موسيقى",
        subtitle: "محتوى صوتي مميز",
        desc: "شارك مقطعاً صوتياً أو قائمة تشغيل.",
      },
    },
    collections: {
      web_cv: {
        title: "السيرة الذاتية",
        subtitle: "ahmed.tabbio.com",
      },
      career_page: {
        title: "صفحة الوظائف",
        subtitle: "company.tabbio.com",
      },
      services: {
        title: "الخدمات",
        subtitle: "٣ خدمات نشطة",
      },
      website: {
        title: "موقعي",
        subtitle: "ahmedaldhraif.com",
      },
      insights: {
        title: "رؤى الموارد البشرية الأسبوعية",
        subtitle: "احصل على أحدث اتجاهات الموارد البشرية",
      },
      faqs: {
        title: "الأسئلة الشائعة",
        subtitle: "الإجابة على الأسئلة المتكررة",
      },
      visit_us: {
        title: "زرنا",
        subtitle: "احجز اجتماعاً",
      },
      booking: {
        title: "احجز جلسة",
        subtitle: "احجز موعدك فوراً",
      },
    },
  },

  // "ضع رابطك في نبذتك": خطوات لكل منصة، تُعرض من نوافذ المشاركة.
  linkInBio: {
    sectionTitle: "المشاركة إلى",
    sectionSubtitle: "أضف رابطك إلى نبذتك، أو انشر عنه. اختر منصة.",
    sectionSubtitleCompany:
      "المرشحون يتابعونك بالفعل في مكان ما. أضف رابطك إلى نبذتك هناك، أو انشر عنه.",
    guideSubtitle: "دقيقتان، مرة واحدة فقط.",
    stepsLabel: "الخطوات",
    yourLink: "رابطك",
    copy: "نسخ الرابط",
    copied: "تم النسخ",
    goTo: "فتح {{platform}}",
    postAbout: "انشر عنه على {{platform}}",
    appOnlyHint: "هذه الخطوة تتم عبر التطبيق فقط.",
    prereq: {
      phone: "ستحتاج إلى هاتفك لهذه الخطوة.",
      app: "ستحتاج إلى التطبيق على هاتفك.",
    },
    notices: {
      linkedin_page:
        "يجب أن تكون مشرفًا رئيسيًا (Super admin) على الصفحة. لا يستطيع مشرفو المحتوى تعديل معلومات الصفحة.",
      tiktok:
        "إذا لم يظهر لك حقل \"الموقع الإلكتروني\"، فحسابك غير مؤهل بعد. التحويل إلى حساب أعمال هو الطريقة الأضمن لإتاحته.",
      youtube:
        "يتطلب قسم \"الروابط\" تفعيل الميزات المتقدمة، أي التحقق من رقم هاتفك أو هويتك.",
      whatsapp:
        "الحساب الشخصي لا يحتوي على حقل موقع، والرابط في \"نبذة عني\" غير قابل للضغط. أما واتساب للأعمال فلديه حقل موقع حقيقي، فاستخدمه إن كان متاحًا لديك.",
      google_business:
        "يجب أن يكون ملفك مُطالَبًا به ومُوثَّقًا أولًا. والأمر يستحق: يظهر الرابط بعدها مباشرة في بحث Google وخرائطه.",
      snapchat:
        "لا يوفّر سناب شات حقل موقع إلا لملفات Snap Star وملفات الأعمال. إن لم يكن لديك أحدها، أرفق الرابط بسناب بدلًا من ذلك.",
    },
    footnotes: {
      instagram:
        "يمكنك إضافة حتى خمسة روابط، لكن الأول فقط هو الذي يظهر في نبذتك، لذا ضع هذا الرابط في المقدمة.",
      linkedin:
        "أزال لينكد إن الرابط الذي كان يظهر أسفل مسماك الوظيفي، لذا أصبحت \"معلومات التواصل\" هي المكان المناسب له.",
      facebook:
        "لحقل الموقع إعداد جمهور خاص به ولا يكون \"عام\" افتراضيًا. اضبطه على \"عام\" وإلا لن يراه أحد.",
      facebook_page:
        "بعض الصفحات ما زالت تستخدم التصميم القديم: \"نبذة\" ثم \"تعديل معلومات الصفحة\" ثم \"التواصل\".",
      youtube:
        "يمكنك إضافة حتى أربعة عشر رابطًا، لكن الأول فقط هو الذي يظهر بجوار زر الاشتراك.",
    },
    platforms: {
      linkedin: "لينكد إن",
      linkedin_page: "صفحة لينكد إن",
      instagram: "إنستغرام",
      x: "إكس",
      facebook: "فيسبوك",
      facebook_page: "صفحة فيسبوك",
      youtube: "يوتيوب",
      tiktok: "تيك توك",
      whatsapp: "واتساب",
      telegram: "تيليجرام",
      snapchat: "سناب شات",
      google_business: "ملف Google للنشاط التجاري",
    },
    steps: {
      linkedin_page: [
        "افتح صفحتك وانتقل إلى عرض المشرف الرئيسي",
        "اضغط على \"تعديل الصفحة\" ثم \"معلومات الصفحة\"",
        "الصق رابطك في حقل \"عنوان الموقع الإلكتروني\"، وليس \"رابط لينكد إن العام\" أسفله",
        "احفظ التغييرات، ثم افتح صفحتك واضغط على الرابط للتأكد",
      ],
      linkedin: [
        "افتح ملفك الشخصي واضغط على \"معلومات التواصل\"",
        "اضغط على القلم ثم \"إضافة موقع إلكتروني\"",
        "الصق رابطك واختر نوع الموقع",
        "احفظ التغييرات، ثم تحقق منه من ملفك العام",
      ],
      // صيغة تناسب التطبيق والويب معًا: حقل \"الروابط\" متاح في التطبيق وفي
      // instagram.com/accounts/edit، وهو ما يشير إليه `webUrl`.
      instagram: [
        "افتح إنستغرام وانتقل إلى \"تعديل الملف الشخصي\"",
        "افتح \"الروابط\" ثم \"إضافة رابط خارجي\"",
        "الصق رابطك واحفظ التغييرات",
        "افتح ملفك الشخصي واضغط على الرابط في نبذتك للتأكد",
      ],
      x: [
        "افتح ملفك الشخصي واضغط على \"تعديل الملف الشخصي\"",
        "الصق رابطك في حقل \"الموقع الإلكتروني\"",
        "احفظ التغييرات، ثم اضغط على الرابط في ملفك للتأكد",
      ],
      facebook_page: [
        "افتح صفحتك واضغط على \"تعديل\" أسفل اسم الصفحة",
        "اضغط على القلم بجوار \"الروابط\"",
        "الصق رابطك كاملًا مع https:// في بدايته",
        "احفظ التغييرات، ثم افتح صفحتك واضغط على الرابط للتأكد",
      ],
      facebook: [
        "انتقل إلى تبويب \"نبذة\" في ملفك الشخصي",
        "افتح \"معلومات التواصل والمعلومات الأساسية\" ثم \"المواقع والروابط الاجتماعية\"",
        "الصق رابطك واضبط الجمهور على \"عام\"",
        "احفظ التغييرات، ثم تحقق من الرابط من ملفك الشخصي",
      ],
      youtube: [
        "افتح استوديو يوتيوب، ثم \"التخصيص\"، ثم \"الملف التعريفي\"",
        "انزل إلى \"الروابط\" واضغط على \"إضافة رابط\"",
        "أضف عنوانًا والصق رابطك",
        "اضغط على \"نشر\"، ثم تحقق منه في صفحة قناتك",
      ],
      tiktok: [
        "افتح تطبيق تيك توك واضغط على \"الملف الشخصي\"",
        "اضغط على \"تعديل الملف الشخصي\"",
        "انزل إلى \"الموقع الإلكتروني\" والصق رابطك",
        "احفظ التغييرات، ثم اضغط على الرابط في نبذتك للتأكد",
      ],
      whatsapp: [
        "افتح واتساب للأعمال وانتقل إلى \"الإعدادات\"",
        "اضغط على \"أدوات الأعمال\" ثم \"الملف التعريفي للنشاط\"",
        "الصق رابطك في حقل \"الموقع الإلكتروني\" كاملًا مع https://",
        "احفظ التغييرات، ثم افتح ملفك التعريفي للتأكد",
      ],
      google_business: [
        "ابحث عن اسم نشاطك في Google وأنت مسجّل الدخول، أو افتح business.google.com",
        "اضغط على \"تعديل الملف التعريفي\" ثم \"التواصل\"",
        "الصق رابطك في حقل \"الموقع الإلكتروني\" كاملًا مع https://",
        "احفظ التغييرات. يظهر التحديث عادةً خلال دقائق",
      ],
      snapchat: [
        "افتح سناب شات واضغط على أيقونة ملفك ثم \"الملف العام\"",
        "اضغط على القلم للتعديل",
        "الصق رابطك في حقل \"الموقع الإلكتروني\"",
        "يحفظ سناب شات تلقائيًا. افتح ملفك العام للتأكد",
      ],
    },
  },

  // Chat
  chat: {
    historyLoadError: "تعذّر تحميل هذه المحادثة. يرجى المحاولة مرة أخرى.",
    retryHistory: "حاول مرة أخرى",
    noConversations: "لا توجد محادثات بعد",
    recents: "الأخيرة",
    newChat: "محادثة جديدة",
    searchChats: "بحث في المحادثات",
    searchPlaceholder: "بحث في المحادثات…",
    emptyState: "جاهز عندما تكون جاهزاً.",
    askAnything: "اسأل أي شيء",
    // مسار عمل الوكيل. ترتيب الاختيار في tool-activity-copy.ts:
    // نص خاص بالأداة ← قالب فعل × كيان ← نص عام احتياطي.
    turnError: "حدث خطأ ما في هذا الرد.",
    // رد توقف عند حد الإخراج (finishReason "length"): رسالة كاملة إذا لم
    // يُكتب شيء، وسطر ختامي بعد جزء من الرد. لا يحفظها الخادم.
    errors: {
      truncated: "انقطع الرد لأنه طويل جدًا. اطلب نسخة أقصر.",
      truncatedPartial: "انقطع الرد هنا. اطلب المتابعة أو نسخة أقصر.",
    },
    approval: {
      confirm: "هل تريد تأكيد هذا الإجراء؟",
      approve: "موافقة",
      decline: "رفض",
      declining: "جارٍ الرفض…",
      approved: "تمت الموافقة",
      declined: "تم الرفض",
      reasonOptional: "السبب (اختياري)",
      approveFailed: "تعذّرت الموافقة على هذا الإجراء.",
      declineFailed: "تعذّر رفض هذا الإجراء.",
      // Agent CV publish (B10): what the person approves.
      publishCvTitle: "هل تريد نشر هذه السيرة الذاتية؟",
      publishCvBody:
        "سيتمكن أي شخص لديه الرابط من رؤية هذه السيرة الذاتية. أنت توافق عليها كما هي الآن: إذا تغيّرت أو مرّت 10 دقائق، سيطلب Tabbio موافقتك مرة أخرى.",
      // A refused approval (B10).
      stale:
        "تغيّر هذا المحتوى بعد تقديم الطلب، لذلك لم يتم التنفيذ. اطلب من Tabbio مرة أخرى لمراجعة أحدث نسخة.",
      expired:
        "انتهت صلاحية هذه الموافقة، لذلك لم يتم أي شيء. اطلب من Tabbio مرة أخرى إذا كنت لا تزال تريد ذلك.",
    },
    // What a user attached to a sent message (images and PDFs), shown with
    // the message after a refresh.
    messageAttachments: {
      image: "صورة",
      pdf: "PDF",
      download: "تنزيل {{name}}",
      open: "فتح {{name}}",
    },
    toolResult: {
      rawPayload: "النتيجة الخام",
      details: "التفاصيل",
      code: "الرمز",
      status: "الحالة",
      failed: "تعذّر إكمال هذه الخطوة.",
      inputInvalid: "لم تُنفَّذ هذه الخطوة لأن مدخلاتها غير صالحة.",
    },
    cvCard: {
      title: "سيرك الذاتية",
      count_zero: "لا توجد سير ذاتية",
      count_one: "سيرة ذاتية واحدة",
      count_two: "سيرتان ذاتيتان",
      count_few: "{{count}} سير ذاتية",
      count_many: "{{count}} سيرة ذاتية",
      count_other: "{{count}} سيرة ذاتية",
      main: "الرئيسية",
      profileBacked: "سيرة الملف الشخصي",
      public: "عامة",
      private: "خاصة",
      untitled: "سيرة ذاتية بلا عنوان",
      empty: "لم يتم العثور على سير ذاتية.",
      openHint: "افتح هذه السيرة الذاتية",
      showAll: "عرض جميع السير الذاتية",
    },
    threadGroups: {
      pinned: "المثبتة",
      today: "اليوم",
      yesterday: "أمس",
      previous7Days: "آخر 7 أيام",
      previous30Days: "آخر 30 يوماً",
      older: "أقدم",
    },
    threadActions: {
      rename: "إعادة تسمية",
      renameTitle: "إعادة تسمية المحادثة",
      renamePlaceholder: "اسم المحادثة",
      pin: "تثبيت",
      unpin: "إلغاء التثبيت",
      delete: "حذف",
      more: "خيارات المحادثة",
      renameFailed: "تعذّرت إعادة تسمية المحادثة",
      pinFailed: "تعذّر تحديث المحادثة",
    },
    threadSearch: {
      noResults: 'لا توجد محادثات تطابق "{{query}}"',
      clear: "مسح البحث",
    },
    sources: {
      count_zero: "بدون مصادر",
      count_one: "مصدر واحد",
      count_two: "مصدران",
      count_few: "{{count}} مصادر",
      count_many: "{{count}} مصدرًا",
      count_other: "{{count}} مصدر",
    },
    followUps: {
      title: "متابعات",
    },
    tasks: {
      completed: "مكتمل",
      failed: "فشل",
      running: "قيد التنفيذ",
      pending: "في الانتظار",
      statusUpdate: "تحديث الحالة",
      submitted: "تم الإرسال",
      untitledJob: "وظيفة بلا عنوان",
      started: "بدأ",
      finished: "انتهى",
      more_zero: "لا مزيد",
      more_one: "وواحد آخر",
      more_two: "واثنان آخران",
      more_few: "و{{count}} أخرى",
      more_many: "و{{count}} أخرى",
      more_other: "و{{count}} أخرى",
    },
    activity: {
      phase: {
        thinking: "جارٍ التفكير…",
        writing: "جارٍ الكتابة…",
        rewriting: "جارٍ إعادة الكتابة…",
      },
      header: {
        working: "جارٍ العمل…",
        done_zero: "لم تُنفَّذ خطوات",
        done_one: "نُفِّذت خطوة واحدة",
        done_two: "نُفِّذت خطوتان",
        done_few: "نُفِّذت {{count}} خطوات",
        done_many: "نُفِّذت {{count}} خطوة",
        done_other: "نُفِّذت {{count}} خطوة",
        doneTimed_zero: "لم تُنفَّذ خطوات خلال {{duration}}",
        doneTimed_one: "نُفِّذت خطوة واحدة خلال {{duration}}",
        doneTimed_two: "نُفِّذت خطوتان خلال {{duration}}",
        doneTimed_few: "نُفِّذت {{count}} خطوات خلال {{duration}}",
        doneTimed_many: "نُفِّذت {{count}} خطوة خلال {{duration}}",
        doneTimed_other: "نُفِّذت {{count}} خطوة خلال {{duration}}",
      },
      elapsed: {
        seconds: "{{value}} ث",
        minutes: "{{minutes}} د {{seconds}} ث",
      },
      // العربية تحتاج فئات الجمع الست كاملة. الاكتفاء بـ _one/_other يجعل
      // i18next يعود إلى الإنجليزية عند 0 و2 و3–99، فيظهر نص إنجليزي داخل
      // واجهة عربية. أي مفتاح جديد يحمل {{count}} يجب أن يعرّف الست جميعاً.
      summary_zero: "بدون خطوات",
      summary_one: "خطوة واحدة",
      summary_two: "خطوتان",
      summary_few: "{{count}} خطوات",
      summary_many: "{{count}} خطوة",
      summary_other: "{{count}} خطوة",
      showWork: "عرض الخطوات",
      hideWork: "إخفاء الخطوات",
      generic: {
        running: "جارٍ العمل…",
        done: "تم",
        waiting: "بانتظار تأكيدك",
        failed: "لم تكتمل هذه الخطوة",
      },
      entity: {
        profile: "ملفك الشخصي",
        experience: "خبرتك",
        education: "تعليمك",
        certification: "شهادتك",
        project: "مشروعك",
        serviceOffer: "خدمتك",
        cv: "سيرتك الذاتية",
        job: "الوظيفة",
        catalogJob: "الوظيفة",
        catalogApply: "طلبك",
        application: "طلبك",
        company: "الشركة",
        candidate: "المرشح",
        message: "رسالتك",
        conversation: "محادثاتك",
        asset: "ملفاتك",
        skill: "المهارة",
        skills: "مهاراتك",
        nova: "أتمتتك",
        memory: "ذاكرتك",
        mcp: "الاتصال",
        user: "الأشخاص",
        notification: "إشعاراتك",
        personal: "تحليلات سيرتك الذاتية",
        studio: "أدواتك المهنية",
        catalog: "وظائفك",
        messaging: "إعدادات رسائلك",
        careerHighlight: "إنجازك المهني",
        public: "ملفك العام",
      },
      verb: {
        search: {
          running: "جارٍ البحث في {{entity}}…",
          done: "تم البحث في {{entity}}",
          waiting: "بانتظار البحث في {{entity}}",
          failed: "تعذّر البحث في {{entity}}",
        },
        read: {
          running: "جارٍ قراءة {{entity}}…",
          done: "تمت قراءة {{entity}}",
          waiting: "بانتظار فتح {{entity}}",
          failed: "تعذّر فتح {{entity}}",
        },
        check: {
          running: "جارٍ التحقق من {{entity}}…",
          done: "تم التحقق من {{entity}}",
          waiting: "بانتظار التحقق من {{entity}}",
          failed: "تعذّر التحقق من {{entity}}",
        },
        create: {
          running: "جارٍ إنشاء {{entity}}…",
          done: "تم إنشاء {{entity}}",
          waiting: "بانتظار إنشاء {{entity}}",
          failed: "تعذّر إنشاء {{entity}}",
        },
        update: {
          running: "جارٍ تحديث {{entity}}…",
          done: "تم تحديث {{entity}}",
          waiting: "بانتظار تحديث {{entity}}",
          failed: "تعذّر تحديث {{entity}}",
        },
        publish: {
          running: "جارٍ نشر {{entity}}…",
          done: "تم نشر {{entity}}",
          waiting: "بانتظار نشر {{entity}}",
          failed: "تعذّر نشر {{entity}}",
        },
        send: {
          running: "جارٍ إرسال {{entity}}…",
          done: "تم إرسال {{entity}}",
          waiting: "بانتظار إرسال {{entity}}",
          failed: "تعذّر إرسال {{entity}}",
        },
        run: {
          running: "جارٍ تشغيل {{entity}}…",
          done: "تم تشغيل {{entity}}",
          waiting: "بانتظار تشغيل {{entity}}",
          failed: "تعذّر تشغيل {{entity}}",
        },
        remove: {
          running: "جارٍ حذف {{entity}}…",
          done: "تم حذف {{entity}}",
          waiting: "بانتظار حذف {{entity}}",
          failed: "تعذّر حذف {{entity}}",
        },
        attach: {
          running: "جارٍ إرفاق {{entity}}…",
          done: "تم إرفاق {{entity}}",
          waiting: "بانتظار إرفاق {{entity}}",
          failed: "تعذّر إرفاق {{entity}}",
        },
        memory: {
          running: "جارٍ الحفظ في {{entity}}…",
          done: "تم الحفظ في {{entity}}",
          waiting: "بانتظار الحفظ في {{entity}}",
          failed: "تعذّر الحفظ في {{entity}}",
        },
      },
      tool: {
        skillsList: {
          running: "جارٍ تصفح مهاراتك…",
          done_zero: "لم يتم العثور على مهارات",
          done_one: "تم العثور على مهارة واحدة",
          done_two: "تم العثور على مهارتين",
          done_few: "تم العثور على {{count}} مهارات",
          done_many: "تم العثور على {{count}} مهارة",
          done_other: "تم العثور على {{count}} مهارة",
          waiting: "بانتظار فتح مهاراتك",
          failed: "تعذّر تحميل مهاراتك",
        },
        jobSearch: {
          running: "جارٍ البحث عن وظائف…",
          done_zero: "لم يتم العثور على وظائف",
          done_one: "تم العثور على وظيفة واحدة",
          done_two: "تم العثور على وظيفتين",
          done_few: "تم العثور على {{count}} وظائف",
          done_many: "تم العثور على {{count}} وظيفة",
          done_other: "تم العثور على {{count}} وظيفة",
          waiting: "بانتظار البحث عن وظائف",
          failed: "تعذّر البحث عن وظائف",
        },
        catalogJobSearch: {
          running: "جارٍ البحث في الإعلانات المباشرة…",
          done_zero: "لم يتم العثور على إعلانات",
          done_one: "تم العثور على إعلان واحد",
          done_two: "تم العثور على إعلانين",
          done_few: "تم العثور على {{count}} إعلانات",
          done_many: "تم العثور على {{count}} إعلان",
          done_other: "تم العثور على {{count}} إعلان",
          waiting: "بانتظار البحث في الإعلانات",
          failed: "تعذّر البحث في الإعلانات",
        },
        jobRecommend: {
          running: "جارٍ مطابقتك بالوظائف…",
          done_zero: "لم يتم العثور على مطابقات",
          done_one: "تم العثور على مطابقة واحدة",
          done_two: "تم العثور على مطابقتين",
          done_few: "تم العثور على {{count}} مطابقات",
          done_many: "تم العثور على {{count}} مطابقة",
          done_other: "تم العثور على {{count}} مطابقة",
          waiting: "بانتظار مطابقة الوظائف",
          failed: "تعذّرت مطابقة الوظائف",
        },
        candidateSearch: {
          running: "جارٍ البحث عن مرشحين…",
          done_zero: "لم يتم العثور على مرشحين",
          done_one: "تم العثور على مرشح واحد",
          done_two: "تم العثور على مرشحين اثنين",
          done_few: "تم العثور على {{count}} مرشحين",
          done_many: "تم العثور على {{count}} مرشحاً",
          done_other: "تم العثور على {{count}} مرشح",
          waiting: "بانتظار البحث عن مرشحين",
          failed: "تعذّر البحث عن مرشحين",
        },
        assetRecall: {
          running: "جارٍ تصفح ملفاتك…",
          done_zero: "لم يتم العثور على ملفات",
          done_one: "تم العثور على ملف واحد",
          done_two: "تم العثور على ملفين",
          done_few: "تم العثور على {{count}} ملفات",
          done_many: "تم العثور على {{count}} ملفاً",
          done_other: "تم العثور على {{count}} ملف",
          waiting: "بانتظار فتح ملفاتك",
          failed: "تعذّر فتح ملفاتك",
        },
        novaList: {
          running: "جارٍ التحقق من أتمتتك…",
          done_zero: "لا توجد عمليات أتمتة",
          done_one: "تم العثور على أتمتة واحدة",
          done_two: "تم العثور على أتمتتين",
          done_few: "تم العثور على {{count}} عمليات أتمتة",
          done_many: "تم العثور على {{count}} عملية أتمتة",
          done_other: "تم العثور على {{count}} عملية أتمتة",
          waiting: "بانتظار التحقق من الأتمتة",
          failed: "تعذّر تحميل الأتمتة",
        },
        cvList: {
          running: "جارٍ تصفح سيرك الذاتية…",
          done_zero: "لا توجد سير ذاتية",
          done_one: "تم العثور على سيرة ذاتية واحدة",
          done_two: "تم العثور على سيرتين ذاتيتين",
          done_few: "تم العثور على {{count}} سير ذاتية",
          done_many: "تم العثور على {{count}} سيرة ذاتية",
          done_other: "تم العثور على {{count}} سيرة ذاتية",
          waiting: "بانتظار فتح سيرك الذاتية",
          failed: "تعذّر تحميل سيرك الذاتية",
        },
        cvGet: {
          running: "جارٍ قراءة سيرتك الذاتية…",
          done: "تمت قراءة سيرتك الذاتية",
          waiting: "بانتظار فتح سيرتك الذاتية",
          failed: "تعذّر فتح سيرتك الذاتية",
        },
        cvTailor: {
          running: "جارٍ تخصيص سيرتك الذاتية…",
          done: "تم تخصيص سيرتك الذاتية",
          waiting: "بانتظار تخصيص سيرتك الذاتية",
          failed: "تعذّر تخصيص سيرتك الذاتية",
        },
        cvCreate: {
          running: "جارٍ بناء سيرتك الذاتية…",
          done: "تم بناء سيرتك الذاتية",
          waiting: "بانتظار بناء سيرتك الذاتية",
          failed: "تعذّر بناء سيرتك الذاتية",
        },
        cvExport: {
          running: "جارٍ تجهيز ملف التنزيل…",
          done: "ملف التنزيل جاهز",
          waiting: "بانتظار تجهيز ملف التنزيل",
          failed: "تعذّر تجهيز ملف التنزيل",
        },
        cvPublish: {
          running: "جارٍ نشر سيرتك الذاتية…",
          done: "تم نشر سيرتك الذاتية",
          waiting: "بانتظار تأكيدك للنشر",
          failed: "تعذّر نشر سيرتك الذاتية",
        },
        profileGet: {
          running: "جارٍ قراءة ملفك الشخصي…",
          done: "تمت قراءة ملفك الشخصي",
          waiting: "بانتظار فتح ملفك الشخصي",
          failed: "تعذّر فتح ملفك الشخصي",
        },
        applicationPrepare: {
          running: "جارٍ تجهيز طلبك…",
          done: "طلبك جاهز",
          waiting: "بانتظار تجهيز طلبك",
          failed: "تعذّر تجهيز طلبك",
        },
        catalogApplyPrepare: {
          running: "جارٍ تجهيز طلبك…",
          done: "طلبك جاهز",
          waiting: "بانتظار تجهيز طلبك",
          failed: "تعذّر تجهيز طلبك",
        },
        applicationSubmit: {
          running: "جارٍ إرسال طلبك…",
          done: "تم إرسال الطلب",
          waiting: "بانتظار تأكيدك للإرسال",
          failed: "تعذّر إرسال طلبك",
        },
        catalogApplySubmit: {
          running: "جارٍ إرسال طلبك…",
          done: "تم إرسال الطلب",
          waiting: "بانتظار تأكيدك للإرسال",
          failed: "تعذّر إرسال طلبك",
        },
        messageDraft: {
          running: "جارٍ صياغة رسالتك…",
          done: "المسودة جاهزة",
          waiting: "بانتظار صياغة رسالتك",
          failed: "تعذّرت صياغة رسالتك",
        },
        messageSend: {
          running: "جارٍ إرسال رسالتك…",
          done: "تم إرسال الرسالة",
          waiting: "بانتظار تأكيدك للإرسال",
          failed: "تعذّر إرسال رسالتك",
        },
        skillRun: {
          running: "جارٍ تشغيل المهارة…",
          done: "انتهت المهارة",
          waiting: "بانتظار تأكيدك للتشغيل",
          failed: "لم تكتمل المهارة",
        },
        skillInvoke: {
          running: "جارٍ تشغيل المهارة…",
          done: "انتهت المهارة",
          waiting: "بانتظار تأكيدك للتشغيل",
          failed: "لم تكتمل المهارة",
        },
        novaCompile: {
          running: "جارٍ تصميم الأتمتة…",
          done: "الأتمتة جاهزة",
          waiting: "بانتظار تصميم الأتمتة",
          failed: "تعذّر تصميم الأتمتة",
        },
        listConnectedServices: {
          running: "جارٍ التحقق من اتصالاتك…",
          done_zero: "لا توجد اتصالات",
          done_one: "تم العثور على اتصال واحد",
          done_two: "تم العثور على اتصالين",
          done_few: "تم العثور على {{count}} اتصالات",
          done_many: "تم العثور على {{count}} اتصالاً",
          done_other: "تم العثور على {{count}} اتصال",
          waiting: "بانتظار التحقق من اتصالاتك",
          failed: "تعذّر التحقق من اتصالاتك",
        },
        getRecentEmails: {
          running: "جارٍ قراءة بريدك…",
          done_zero: "لا توجد رسائل جديدة",
          done_one: "تمت قراءة رسالة واحدة",
          done_two: "تمت قراءة رسالتين",
          done_few: "تمت قراءة {{count}} رسائل",
          done_many: "تمت قراءة {{count}} رسالة",
          done_other: "تمت قراءة {{count}} رسالة",
          waiting: "بانتظار فتح بريدك",
          failed: "تعذّر فتح بريدك",
        },
        getRecentSlackMessages: {
          running: "جارٍ قراءة سلاك…",
          done_zero: "لا توجد رسائل جديدة",
          done_one: "تمت قراءة رسالة واحدة",
          done_two: "تمت قراءة رسالتين",
          done_few: "تمت قراءة {{count}} رسائل",
          done_many: "تمت قراءة {{count}} رسالة",
          done_other: "تمت قراءة {{count}} رسالة",
          waiting: "بانتظار فتح سلاك",
          failed: "تعذّر فتح سلاك",
        },
        sendEmail: {
          running: "جارٍ إرسال البريد…",
          done: "تم إرسال البريد",
          waiting: "بانتظار تأكيدك للإرسال",
          failed: "تعذّر إرسال البريد",
        },
        postSlackMessage: {
          running: "جارٍ النشر في سلاك…",
          done: "تم النشر في سلاك",
          waiting: "بانتظار تأكيدك للنشر",
          failed: "تعذّر النشر في سلاك",
        },
        triggerZapierWorkflow: {
          running: "جارٍ تشغيل Zap…",
          done: "بدأ تشغيل Zap",
          waiting: "بانتظار تأكيدك للتشغيل",
          failed: "تعذّر تشغيل Zap",
        },
        triggerMakeScenario: {
          running: "جارٍ تشغيل السيناريو…",
          done: "بدأ تشغيل السيناريو",
          waiting: "بانتظار تأكيدك للتشغيل",
          failed: "تعذّر تشغيل السيناريو",
        },
        addMemory: {
          running: "جارٍ حفظ ذلك…",
          done: "تم الحفظ",
          waiting: "بانتظار حفظ ذلك",
          failed: "تعذّر حفظ ذلك",
        },
        recallMemory: {
          running: "جارٍ استرجاع ما أعرفه…",
          done: "تم استرجاع سياقك",
          waiting: "بانتظار استرجاع سياقك",
          failed: "تعذّر استرجاع سياقك",
        },
        forgetMemory: {
          running: "جارٍ نسيان ذلك…",
          done: "تم النسيان",
          waiting: "بانتظار تأكيدك",
          failed: "تعذّر نسيان ذلك",
        },
        exportMemory: {
          running: "جارٍ تصدير ذاكرتك…",
          done: "تم تصدير الذاكرة",
          waiting: "بانتظار تصدير ذاكرتك",
          failed: "تعذّر تصدير ذاكرتك",
        },
        memoryGraphGet: {
          running: "جارٍ استرجاع ما أعرفه…",
          done: "تم استرجاع سياقك",
          waiting: "بانتظار استرجاع سياقك",
          failed: "تعذّر استرجاع سياقك",
        },
        webSearch: {
          running: "جارٍ البحث في الويب…",
          done: "تم البحث في الويب",
          waiting: "بانتظار البحث في الويب",
          failed: "تعذّر البحث في الويب",
        },
        readUrl: {
          running: "جارٍ قراءة الصفحة…",
          done: "تمت قراءة الصفحة",
          waiting: "بانتظار قراءة الصفحة",
          failed: "تعذّرت قراءة الصفحة",
        },
        readPdf: {
          running: "جارٍ قراءة ملف PDF…",
          done: "تمت قراءة ملف PDF",
          waiting: "بانتظار قراءة ملف PDF",
          failed: "تعذّرت قراءة ملف PDF",
        },
        readGithubRepo: {
          running: "جارٍ قراءة المستودع…",
          done: "تمت قراءة المستودع",
          waiting: "بانتظار قراءة المستودع",
          failed: "تعذّرت قراءة المستودع",
        },
        readSkill: {
          running: "جارٍ قراءة المهارة…",
          done: "تمت قراءة المهارة",
          waiting: "بانتظار قراءة المهارة",
          failed: "تعذّرت قراءة المهارة",
        },
        generateImage: {
          running: "جارٍ إنشاء الصورة…",
          done: "الصورة جاهزة",
          pending: "ما زال إنشاء الصورة جارياً",
          waiting: "بانتظار إنشاء الصورة",
          failed: "تعذّر إنشاء الصورة",
        },
        createDocument: {
          running: "جارٍ تجهيز المستند…",
          done: "المستند جاهز",
          pending: "ما زال تجهيز المستند جارياً",
          waiting: "بانتظار تجهيز المستند",
          failed: "تعذّر تجهيز المستند",
        },
        createSlides: {
          running: "جارٍ تجهيز الشرائح…",
          done: "الشرائح جاهزة",
          pending: "ما زال تجهيز الشرائح جارياً",
          waiting: "بانتظار تجهيز الشرائح",
          failed: "تعذّر تجهيز الشرائح",
        },
        createPage: {
          running: "جارٍ إنشاء الصفحة…",
          done: "الصفحة جاهزة",
          pending: "ما زال إنشاء الصفحة جارياً",
          waiting: "بانتظار إنشاء الصفحة",
          failed: "تعذّر إنشاء الصفحة",
        },
        artifactList: {
          running: "جارٍ عرض ملفاتك…",
          done_zero: "لم يتم العثور على ملفات",
          done_one: "تم العثور على ملف واحد",
          done_two: "تم العثور على ملفين",
          done_few: "تم العثور على {{count}} ملفات",
          done_many: "تم العثور على {{count}} ملفاً",
          done_other: "تم العثور على {{count}} ملف",
          waiting: "بانتظار عرض ملفاتك",
          failed: "تعذّر عرض ملفاتك",
        },
        artifactGet: {
          running: "جارٍ فتح الملف…",
          done: "تم فتح الملف",
          waiting: "بانتظار فتح الملف",
          failed: "تعذّر فتح الملف",
        },
        publishArtifact: {
          running: "جارٍ التحضير للنشر…",
          done: "جاهز للنشر",
          waiting: "بانتظار تجهيز الموقع",
          failed: "تعذّر التحضير للنشر",
        },
        unpublishArtifact: {
          running: "جارٍ إلغاء نشر الموقع…",
          done: "تم إلغاء نشر الموقع",
          waiting: "بانتظار إلغاء نشر الموقع",
          failed: "تعذّر إلغاء نشر الموقع",
        },
        updatePage: {
          running: "جارٍ تعديل الصفحة…",
          done: "تم تعديل الصفحة",
          waiting: "بانتظار تعديل الصفحة",
          failed: "تعذّر تعديل الصفحة",
        },
        updateDocument: {
          running: "جارٍ تعديل المستند…",
          done: "تم تعديل المستند",
          waiting: "بانتظار تعديل المستند",
          failed: "تعذّر تعديل المستند",
        },
        updateSlides: {
          running: "جارٍ تعديل الشرائح…",
          done: "تم تعديل الشرائح",
          waiting: "بانتظار تعديل الشرائح",
          failed: "تعذّر تعديل الشرائح",
        },
        suggestEdits: {
          running: "جارٍ البحث عن تحسينات…",
          done: "التعديلات المقترحة جاهزة",
          waiting: "بانتظار اقتراح التعديلات",
          failed: "تعذّر اقتراح التعديلات",
        },
        editImage: {
          running: "جارٍ تعديل الصورة…",
          done: "تم تعديل الصورة",
          pending: "لا يزال تعديل الصورة جاريًا",
          waiting: "بانتظار تعديل الصورة",
          failed: "تعذّر تعديل الصورة",
        },
        artifactRead: {
          running: "جارٍ قراءة الملف…",
          done: "تمت قراءة الملف",
          waiting: "بانتظار قراءة الملف",
          failed: "تعذّر قراءة الملف",
        },
      },
    },
    // Model names are product names, kept in Latin and wrapped in FSI…PDI
    // isolates so they render left-to-right inside the RTL menu.
    model: {
      label: "النموذج",
      locked: {
        plus: "بلس",
        pro: "برو",
      },
      newBadge: "جديد",
      auto: {
        title: "تلقائي",
        description: "النموذج الموصى به لخطتك",
      },
      providers: {
        google: "⁨Google⁩",
        anthropic: "⁨Anthropic⁩",
        openai: "⁨OpenAI⁩",
      },
      options: {
        // Every model does every job; the list is a care ladder, not a split
        // of tasks between models. Keep the Arabic parallel to the English.
        geminiFlashLite: {
          description: "الأسرع. تعديلات سريعة ومسودات أولى",
        },
        geminiFlash: {
          description: "استدلال أقوى لمسودات وتخصيص أكثر دقة",
        },
        geminiPro: {
          description: "يفكّر أطول في التخصيص وإعادة الصياغة",
        },
        claudeSonnet: {
          description: "صياغة أدق، وأقرب إلى بياناتك",
        },
        claudeOpus: {
          description: "الأكثر شمولاً للسير الكاملة وطلبات التوظيف",
        },
      },
    },
    // أدوات المحرر: البحث والصورة وشكل النتيجة. على الويب تظهر بجانب
    // اختيار النموذج، وعلى الهاتف داخل زر "+".
    capabilities: {
      states: {
        auto: "تلقائي",
        on: "تشغيل",
        off: "إيقاف",
      },
      addFiles: "إضافة صور وملفات",
      menuLabel: "إضافة ملفات وأدوات",
      research: {
        label: "البحث",
        sheetTitle: "البحث في الويب",
        options: {
          auto: {
            title: "تلقائي",
            description: "يبحث في الويب عندما تحتاج رسالتك إلى معلومات حديثة",
          },
          on: {
            title: "تشغيل",
            description: "يبحث في الويب قبل كل إجابة",
          },
          off: {
            title: "إيقاف",
            description: "يجيب دون البحث في الويب",
          },
        },
      },
      image: {
        label: "صورة",
        sheetTitle: "إنشاء صورة",
        lockedHint: "رقِّ اشتراكك إلى بلس لإنشاء الصور",
        options: {
          auto: {
            title: "تلقائي",
            description: "ينشئ صورة فقط عندما تطلبها",
          },
          on: {
            title: "تشغيل",
            description: "ينشئ صورة مع كل رسالة",
          },
          off: {
            title: "إيقاف",
            description: "لا ينشئ صورًا أبدًا",
          },
        },
      },
      result: {
        label: "النتيجة",
        sheetTitle: "شكل النتيجة",
        options: {
          auto: {
            title: "تلقائي",
            description: "يختار الشكل المناسب لرسالتك",
          },
          summary: {
            title: "ملخص",
            description: "يجيب داخل المحادثة",
          },
          document: {
            title: "مستند",
            description: "مستند يمكنك تنزيله بصيغة PDF",
          },
          slides: {
            title: "شرائح",
            description: "عرض شرائح يمكنك تنزيله لبرنامج PowerPoint",
          },
          page: {
            title: "صفحة",
            description: "صفحة ويب يمكنك معاينتها وتنزيلها",
          },
          image: {
            title: "صورة",
            description: "صورة يمكنك حفظها",
          },
        },
      },
    },
    // المحرر: قائمة "+" للمصادر، والإشارات "@" داخل الرسالة، وقائمة الأوامر
    // "/"، والإملاء. ورقة "+" وقائمة الاقتراحات على الهاتف تستخدمان الصفوف
    // والتسميات نفسها.
    composer: {
      sourcesFooter: "اكتب للبحث في المصادر والملفات",
      commandsFooter: "اكتب للبحث في الأوامر",
      placeholderJobs: "اعثر على وظائف تناسب سيرتي الذاتية...",
      placeholderCv: "ساعدني في تحسين سيرتي الذاتية...",
      noMatches: "لا توجد نتائج مطابقة لـ “{{query}}”",
      sources: {
        attach: {
          description: "ارفع من جهازك",
        },
        research: {
          title: "بحث الويب",
          description: "ابحث في الويب عن أحدث المعلومات",
        },
        image: {
          title: "إنشاء صورة",
          description: "دع تابيو ينشئ الصور لك",
        },
        result: {
          title: "شكل النتيجة",
          description: "محادثة أو مستند أو شرائح أو صورة",
        },
      },
      // التسمية تُكتب داخل الرسالة وتُقرأ منها، فاجعلها قصيرة.
      mentions: {
        research: "بحث الويب",
        image: "صورة",
        document: "مستند",
        slides: "شرائح",
        page: "صفحة",
      },
      mentionHints: {
        research: "يبحث في الويب لهذه الرسالة",
        image: "ينشئ صورة لهذه الرسالة",
        document: "يجيب عن هذه الرسالة بمستند",
        slides: "يجيب عن هذه الرسالة بعرض شرائح",
        page: "يجيب عن هذه الرسالة بصفحة ويب",
      },
      listening: "جارٍ الاستماع…",
      dictate: "بدء الإملاء",
      stopDictation: "إيقاف الإملاء",
      send: "إرسال",
      stop: "إيقاف الإنشاء",
      removeAttachment: "إزالة {{name}}",
      // ورقة "+" على الهاتف: مربعا الصور والكاميرا وأحدث الصور، ثم صف لكل
      // أداة. صف الأداة يضع شريحة فوق حقل الكتابة تنطبق على الرسالة التالية
      // فقط.
      sheet: {
        photos: "الصور",
        camera: "الكاميرا",
        recentPhoto: "إرفاق الصورة الحديثة {{number}}",
        rows: {
          research: {
            title: "بحث الويب",
            description: "ابحث في الويب لهذه الرسالة",
          },
          image: {
            title: "إنشاء صورة",
            description: "إنشاء وتعديل",
          },
          document: {
            title: "مستند",
            description: "اكتب مستندًا يمكنك تنزيله بصيغة PDF",
          },
          slides: {
            title: "شرائح",
            description: "عرض شرائح يمكنك تنزيله لبرنامج PowerPoint",
          },
          page: {
            title: "صفحة",
            description: "صفحة ويب يمكنك معاينتها وتنزيلها",
          },
          attach: {
            title: "رفع المزيد",
            description: "الملفات",
          },
        },
      },
      // الشرائح التي يضعها صف من ورقة "+" فوق حقل الكتابة، بتسميات الإشارات
      // أعلاه.
      chips: {
        label: "أدوات هذه الرسالة",
        remove: "إزالة {{name}}",
      },
    },
    // الملفات التي ينشئها الوكيل (مستندات وشرائح وصفحات وصور): بطاقات
    // المحادثة والعارض ولوحة التشغيل.
    artifacts: {
      kind: {
        document: "مستند",
        slides: "شرائح",
        page: "صفحة",
        image: "صورة",
        file: "ملف",
      },
      preparing: "جارٍ التجهيز…",
      failed: "تعذّر إنشاء هذا الملف. اطلبه مرة أخرى للمحاولة من جديد.",
      refused: "تعذّر إنشاء هذه الصورة من هذا الطلب.",
      unavailable: "هذا الملف لم يعد متاحًا.",
      runLabel: "الملفات",
      openImage: "فتح الصورة: {{title}}",
      createdAt: "{{kind}} · {{time}}",
      saved: "محفوظ",
      // An agent edit's card, and a saved version the checks still flag
      // (a success: the page is kept and cannot be published yet).
      card: {
        versionSaved: "تم حفظ الإصدار {{number}}",
        fixBefore_zero: "لا توجد مشكلات يجب إصلاحها قبل النشر",
        fixBefore_one: "أصلح مشكلة واحدة قبل النشر",
        fixBefore_two: "أصلح مشكلتين قبل النشر",
        fixBefore_few: "أصلح {{count}} مشكلات قبل النشر",
        fixBefore_many: "أصلح {{count}} مشكلة قبل النشر",
        fixBefore_other: "أصلح {{count}} من المشكلات قبل النشر",
      },
      // إخفاقات الكاتب المباشر (الخطة 7.7)؛ ما عداها يُعرض بنص `failed` أعلاه.
      failures: {
        CANCELLED: "توقف قبل الاكتمال",
        WRITER_TIMEOUT: "استغرقت كتابة هذا الملف وقتًا أطول من اللازم.",
        WRITER_FAILED: "تعذّرت كتابة هذا الملف.",
      },
      // بطاقة الإنشاء ولوحة العرض أثناء الكتابة المباشرة.
      building: {
        page: "جارٍ إنشاء الصفحة",
        document: "جارٍ كتابة المستند",
        slides: "جارٍ كتابة الشرائح",
        editing: "جارٍ التعديل",
        checking: "جارٍ فحص الصفحة",
        fixing_zero: "جارٍ إصلاح {{count}} من المشكلات",
        fixing_one: "جارٍ إصلاح مشكلة واحدة",
        fixing_two: "جارٍ إصلاح مشكلتين",
        fixing_few: "جارٍ إصلاح {{count}} مشكلات",
        fixing_many: "جارٍ إصلاح {{count}} مشكلة",
        fixing_other: "جارٍ إصلاح {{count}} من المشكلات",
        lines_zero: "{{count}} سطر",
        lines_one: "سطر واحد",
        lines_two: "سطران",
        lines_few: "{{count}} أسطر",
        lines_many: "{{count}} سطرًا",
        lines_other: "{{count}} سطر",
        section: "القسم {{current}} من {{total}}",
        sectionOnly: "القسم {{current}}",
        more: "+{{count}} أخرى",
        status: "قيد الإنشاء",
        jumpToLatest: "الانتقال إلى الأحدث",
        stopped: "توقف قبل الاكتمال",
        meta: "{{status}} · {{detail}}",
        elapsed: "{{count}} ث",
        finished: "اكتمل: {{title}}",
        codeLabel: "شيفرة {{title}}",
      },
      actions: {
        open: "فتح",
        copyLink: "نسخ الرابط",
        copyCode: "نسخ الشيفرة",
        codeCopied: "تم نسخ الشيفرة",
        linkCopied: "تم نسخ الرابط",
        copyFailed: "تعذّر نسخ الرابط",
        save: "حفظ",
        openPdf: "فتح ملف PDF",
        back: "رجوع",
        retry: "إعادة المحاولة",
        tryAgain: "حاول مرة أخرى",
        downloadFullSize: "تنزيل بالحجم الكامل",
        more: "المزيد",
        saveImage: "حفظ الصورة",
        share: "مشاركة",
        expand: "توسيع",
        collapse: "الخروج من العرض الكامل",
        download: "تنزيل",
        backToChat: "العودة إلى المحادثة",
        close: "إغلاق",
      },
      download: {
        pdf: "PDF",
        pptx: "PowerPoint",
        html: "HTML",
        image: "صورة",
        hint: "تنزيل {{format}}",
        failed: "تعذّر التنزيل. يُرجى المحاولة مرة أخرى.",
      },
      list: {
        title: "ملفاتك",
        empty: "لا توجد ملفات بعد.",
        more: "تُعرض أحدث ملفاتك.",
      },
      // المشاركة ولوحة النشر وحالة الموقع المنشور (الخطة 7.6 و7.7).
      publish: {
        share: "مشاركة",
        shareLabel: "مشاركة {{title}}",
        copyPrivateLink: "نسخ الرابط الخاص",
        toWeb: "النشر على الويب",
        title: "نشر",
        addressLabel: "عنوان الموقع",
        addressHint: "أحرف وأرقام وشرطات، من 3 إلى 40 حرفًا.",
        checking: "جارٍ التحقق…",
        available: "متاح",
        taken: "هذا الاسم مستخدم",
        reserved: "هذا الاسم محجوز",
        held: "هذا الاسم محجوز مؤقتًا. جرّب اسمًا آخر.",
        invalid: "استخدم من 3 إلى 40 حرفًا أو رقمًا أو شرطة",
        blocked: "اختر اسمًا آخر",
        usernameProtected: "هذا الاسم يخص أحد أعضاء Tabbio",
        checkFailed: "تعذّر التحقق من الاسم. حاول مرة أخرى.",
        try: "جرّب",
        suggestionsLabel: "أسماء متاحة",
        searchToggle: "الظهور في محركات البحث",
        searchHint: "قد تستغرق محركات البحث بضعة أسابيع لإدراج الموقع.",
        badgeToggle: "إظهار «صُنع باستخدام Tabbio»",
        badgeFree: "تعرض المواقع المجانية شارة صغيرة «صُنع باستخدام Tabbio».",
        limit: "لديك {{used}} من {{limit}} من المواقع المنشورة.",
        upgrade: "ترقية",
        unpublishOther: "إلغاء نشر موقع آخر",
        fixFirst: "أصلح المشكلات قبل النشر.",
        findings_zero: "لا توجد مشكلات يجب إصلاحها قبل النشر",
        findings_one: "مشكلة واحدة يجب إصلاحها قبل النشر",
        findings_two: "مشكلتان يجب إصلاحهما قبل النشر",
        findings_few: "{{count}} مشكلات يجب إصلاحها قبل النشر",
        findings_many: "{{count}} مشكلة يجب إصلاحها قبل النشر",
        findings_other: "{{count}} من المشكلات يجب إصلاحها قبل النشر",
        fixWithTabbio: "إصلاح باستخدام Tabbio",
        fixPrompt: "أصلح المشكلات التي وجدها الفحص في هذه الصفحة حتى أتمكن من نشرها.",
        cta: "نشر",
        publishing: "جارٍ النشر…",
        buildingHint: "موقعك على وشك أن يصبح جاهزًا. قد يستغرق ذلك بضع ثوانٍ أخرى.",
        failed: "تعذّر النشر. حاول مرة أخرى.",
        disabled: "النشر غير متاح لهذا الحساب بعد.",
        quota: "بلغت حد النشر لهذا اليوم. حاول مرة أخرى غدًا.",
        live: "موقعك منشور الآن",
        linkLabel: "رابط الموقع",
        open: "فتح الموقع",
        copySiteLink: "نسخ رابط الموقع",
        copyLink: "نسخ الرابط",
        shareLink: "مشاركة",
        manage: "إدارة الموقع",
        update: "تحديث الموقع",
        updating: "جارٍ تحديث الموقع…",
        updateHint: "الإصدار {{number}} أحدث من الموقع المنشور.",
        upToDate: "يعرض الموقع أحدث إصدار.",
        rename: "تغيير العنوان",
        renameHint: "سيوجّه العنوان القديم الزوار إلى الجديد لمدة 30 يومًا.",
        renameSave: "حفظ العنوان",
        renaming: "جارٍ تغيير العنوان…",
        renamed: "تم تغيير العنوان",
        redirecting: "يوجّه {{host}} الزوار إلى هنا حاليًا.",
        history: "سجل الموقع",
        historyEmpty: "لم يُنشر شيء بعد.",
        deployRow: "الإصدار {{version}} · {{time}}",
        deployCurrent: "منشور الآن",
        deployBuilding: "قيد الإنشاء",
        deployFailed: "تعذّر",
        rollback: "الرجوع إلى هذا الإصدار",
        rollbackLabel: "الرجوع إلى الإصدار {{version}}",
        rolledBack: "يعرض الموقع الإصدار الأقدم مرة أخرى",
        unpublish: "إلغاء النشر",
        unpublishTitle: "إلغاء نشر هذا الموقع؟",
        unpublishBody: "سيتوقف الرابط عن العمل فورًا. يمكنك النشر مرة أخرى لاحقًا.",
        unpublishing: "جارٍ إلغاء النشر…",
        unpublished: "تم إلغاء نشر الموقع",
        unpublishFailed: "تعذّر إلغاء نشر الموقع. حاول مرة أخرى.",
        views_zero: "لا مشاهدات في آخر 30 يومًا",
        views_one: "مشاهدة واحدة في آخر 30 يومًا",
        views_two: "مشاهدتان في آخر 30 يومًا",
        views_few: "{{count}} مشاهدات في آخر 30 يومًا",
        views_many: "{{count}} مشاهدة في آخر 30 يومًا",
        views_other: "{{count}} مشاهدة في آخر 30 يومًا",
        liveChip: "منشور",
        liveChipLabel: "منشور على {{host}}",
        publishedAt: "منشور على {{host}}",
        back: "رجوع",
        done: "تم",
        close: "إغلاق",
        suspended: "أُزيل هذا الموقع لمخالفته قواعد Tabbio.",
        loadFailed: "تعذّر تحميل الموقع. حاول مرة أخرى.",
        policy: "تلتزم المواقع المنشورة بسياسة مواقع Tabbio.",
        policyLink: "اقرأ السياسة",
      },
      // بطاقة publishArtifact وunpublishArtifact (نوع البطاقة site-publish).
      siteCard: {
        ready: "جاهز للنشر",
        noName: "اختر العنوان في لوحة النشر",
        published: "منشور",
        unpublished: "تم إلغاء نشر الموقع",
        publish: "نشر",
        publishAgain: "النشر مرة أخرى",
        manage: "إدارة",
      },
      // التعديل اليدوي (الخطة 7.3): تعديل وتم، وحالات الحفظ، وشريط المشكلات
      // وتبويب الشيفرة.
      edit: {
        edit: "تعديل",
        editLabel: "تعديل {{title}}",
        done: "تم",
        saving: "جارٍ الحفظ…",
        saved: "محفوظ",
        saveFailed: "تعذّر الحفظ. حاول مرة أخرى.",
        retry: "حاول مرة أخرى",
        conflict: "تغيّر هذا الملف في مكان آخر. أعد التحميل لرؤية أحدث إصدار.",
        reload: "إعادة التحميل",
        removedNote: "أُزيلت النصوص البرمجية والنماذج والملفات الخارجية.",
        findings_zero: "لا توجد مشكلات يجب إصلاحها قبل النشر",
        findings_one: "مشكلة واحدة يجب إصلاحها قبل النشر",
        findings_two: "مشكلتان يجب إصلاحهما قبل النشر",
        findings_few: "{{count}} مشكلات يجب إصلاحها قبل النشر",
        findings_many: "{{count}} مشكلة يجب إصلاحها قبل النشر",
        findings_other: "{{count}} من المشكلات يجب إصلاحها قبل النشر",
        advice_zero: "لا توجد تحسينات مقترحة",
        advice_one: "تحسين واحد مقترح",
        advice_two: "تحسينان مقترحان",
        advice_few: "{{count}} تحسينات مقترحة",
        advice_many: "{{count}} تحسينًا مقترحًا",
        advice_other: "{{count}} من التحسينات المقترحة",
        showFindings: "عرض المشكلات",
        hideFindings: "إخفاء المشكلات",
        fixWithTabbio: "إصلاح باستخدام Tabbio",
        fixPrompt: "أصلح المشكلات التي وجدها الفحص في هذا الملف.",
        frameTitle: "تعديل {{title}}",
        loading: "جارٍ فتح المحرر…",
        loadFailed: "تعذّر فتح المحرر. حاول مرة أخرى.",
        limit: "يتسع هذا الجزء لـ {{max}} حرف كحد أقصى.",
        editHint: "انقر على أي نص لتعديله. ينقلك مفتاح Tab إلى الجزء التالي.",
        editHintTouch: "اضغط على أي نص لتعديله.",
        codeSave: "حفظ",
        codeSaveLabel: "حفظ الشيفرة ({{shortcut}})",
        codeSaving: "جارٍ الحفظ…",
        codeSaved: "محفوظ",
        codeUnsaved: "تغييرات غير محفوظة",
        codeWebOnly: "يمكن تعديل الشيفرة في Tabbio على الويب.",
        codeEditLabel: "شيفرة {{title}}، قابلة للتعديل",
        notEditable: "لا يمكن تعديل هذا الملف هنا.",
      },
      // شريط العنصر وشريط التحديد (الخطة 7.3 و7.4).
      toolbar: {
        label: "إجراءات النص المحدد",
        elementLabel: "إجراءات هذا الجزء",
        ask: "اسأل Tabbio",
        shorter: "أقصر",
        longer: "أطول",
        tone: "النبرة",
        casual: "أكثر عفوية",
        formal: "أكثر رسمية",
        suggest: "اقتراح تعديلات",
        editLink: "تعديل الرابط",
        replaceImage: "استبدال الصورة",
        editImage: "تعديل باستخدام Tabbio",
        altText: "النص البديل",
        moveUp: "نقل لأعلى",
        moveDown: "نقل لأسفل",
        duplicate: "تكرار",
        remove: "إزالة",
        more: "إجراءات أخرى",
      },
      // ما يرسله الإجراء السريع مع التحديد بوصفه سياقًا.
      prompts: {
        shorter: "اجعل هذا الجزء أقصر",
        longer: "اجعل هذا الجزء أطول",
        casual: "اجعل أسلوب هذا الجزء أكثر عفوية",
        formal: "اجعل أسلوب هذا الجزء أكثر رسمية",
        suggest: "اقترح تعديلات على هذا الجزء",
        image: "عدّل هذه الصورة",
      },
      // شارة «اسأل Tabbio» في مربع الكتابة (الخطة 7.4).
      selection: {
        chip: "تعديل: {{text}}",
        clear: "إلغاء التحديد",
        image: "الصورة {{title}}",
      },
      // تعديل الرابط واستبدال الصورة والنص البديل في الصفحة (الخطة 7.3).
      link: {
        title: "تعديل الرابط",
        url: "عنوان الرابط",
        urlHint: "رابط https أو http أو mailto، أو #قسم في هذه الصفحة.",
        text: "نص الرابط",
        invalid: "استخدم رابطًا يبدأ بـ https:// أو http:// أو mailto: أو #.",
        save: "حفظ",
        cancel: "إلغاء",
      },
      image: {
        replaceTitle: "استبدال الصورة",
        yours: "صورك",
        loadingYours: "جارٍ تحميل صورك…",
        noImages: "لا توجد لديك صور بعد. اطلب من Tabbio إنشاء صورة، أو الصق رابطًا.",
        choose: "استخدام {{title}}",
        urlLabel: "أو الصق رابط صورة",
        urlHint: "يجب أن يبدأ الرابط بـ https://.",
        urlInvalid: "استخدم رابط صورة يبدأ بـ https://.",
        use: "استخدام الصورة",
        altTitle: "النص البديل",
        altLabel: "صف الصورة لمن لا يستطيع رؤيتها",
        save: "حفظ",
        cancel: "إلغاء",
        // زر التعديل في عارض الصورة (الخطة 7.3).
        edit: "تعديل",
        editLabel: "تعديل هذه الصورة",
        editPrompt: "التغيير المطلوب",
        editPlaceholder: "صف التغيير، مثلًا: اجعل الخلفية بيضاء",
        editSubmit: "تعديل الصورة",
        editing: "جارٍ تعديل الصورة…",
        editFailed: "تعذّر إجراء هذا التعديل.",
        editStartFailed: "تعذّر بدء التعديل. حاول مرة أخرى.",
        edited: "تم تعديل الصورة",
      },
      // اقتراح تعديلات (الخطة 7.4)، بطاقة artifact-suggestions.
      suggestions: {
        title: "تعديلات مقترحة",
        count_zero: "لا توجد اقتراحات لـ {{title}}",
        count_one: "اقتراح واحد لـ {{title}}",
        count_two: "اقتراحان لـ {{title}}",
        count_few: "{{count}} اقتراحات لـ {{title}}",
        count_many: "{{count}} اقتراحًا لـ {{title}}",
        count_other: "{{count}} من الاقتراحات لـ {{title}}",
        apply: "تطبيق",
        applyAll: "تطبيق الكل",
        dismiss: "تجاهل",
        applied: "تم التطبيق",
        dismissed: "تم التجاهل",
        applying: "جارٍ التطبيق…",
        before: "الآن",
        after: "المقترح",
        none: "لا توجد تعديلات مقترحة هذه المرة.",
        failed: "تعذّر تطبيق هذا الاقتراح. حاول مرة أخرى.",
        stale: "تغيّر هذا الملف بعد هذه الاقتراحات. اطلب اقتراحات جديدة.",
        notApplicable: "لا يمكن تطبيق هذا الاقتراح تلقائيًا.",
        open: "فتح للمراجعة",
        markLabel: "تعديل مقترح: {{reason}}",
        position: "الاقتراح {{current}} من {{total}}",
        previous: "الاقتراح السابق",
        next: "الاقتراح التالي",
      },
      // التحكم في الإصدارات (الخطة 7.5).
      versions: {
        label: "الإصدار {{number}} من {{total}}",
        previous: "الإصدار السابق",
        next: "الإصدار التالي",
        history: "سجل الإصدارات",
        byYou: "عدّلته أنت",
        byTabbio: "أنشأه Tabbio",
        restoredFrom: "مستعاد من الإصدار {{number}}",
        restoredFromUnknown: "مستعاد من إصدار أقدم",
        viewingOld: "أنت تعرض الإصدار {{number}}.",
        restore: "استعادة هذا الإصدار",
        restoring: "جارٍ الاستعادة…",
        backToLatest: "العودة إلى الأحدث",
        restored: "تمت استعادة الإصدار {{number}}",
        restoreFailed: "تعذّرت استعادة هذا الإصدار. حاول مرة أخرى.",
        cardMeta: "الإصدار {{number}}",
        row: "الإصدار {{number}}",
        latest: "الأحدث",
        live: "منشور على الموقع",
        pending: "قيد الإنشاء",
        failed: "تعذّر إنشاؤه",
        loading: "جارٍ تحميل الإصدارات…",
        loadFailed: "تعذّر تحميل الإصدارات. حاول مرة أخرى.",
        more: "عرض الإصدارات الأقدم",
      },
      // محررا المستندات والشرائح (الخطة 7.3).
      docEditor: {
        label: "تعديل {{title}}",
        title: "العنوان",
        subtitle: "العنوان الفرعي",
        heading: "عنوان القسم",
        section: "القسم {{number}}",
        addSection: "إضافة قسم",
        removeSection: "إزالة هذا القسم",
        addParagraph: "إضافة فقرة",
        blockType: "نوع الجزء",
        blockTypes: {
          paragraph: "فقرة",
          bullets: "قائمة نقطية",
          numbered: "قائمة مرقّمة",
          quote: "اقتباس",
          callout: "ملاحظة بارزة",
        },
        bold: "غامق",
        italic: "مائل",
        link: "رابط",
        linkPrompt: "عنوان الرابط",
        removeLink: "إزالة الرابط",
        moveUp: "نقل لأعلى",
        moveDown: "نقل لأسفل",
        delete: "حذف",
        item: "العنصر {{number}}",
        addItem: "إضافة عنصر",
        removeItem: "إزالة هذا العنصر",
        addRow: "إضافة صف",
        removeRow: "إزالة الصف الأخير",
        addColumn: "إضافة عمود",
        removeColumn: "إزالة العمود الأخير",
        cell: "الصف {{row}}، العمود {{column}}",
        header: "عنوان العمود {{column}}",
        caption: "التعليق",
        alt: "النص البديل",
        attribution: "المصدر",
        tone: "النوع",
        tones: {
          info: "ملاحظة",
          success: "خبر سار",
          warning: "تنبيه",
        },
        image: "صورة",
        table: "جدول",
        diagram: "مخطط",
        diagramLabels: "التسميات",
        diagramNode: "المربع {{number}}",
        diagramHint: "اطلب من Tabbio تغيير شكل المخطط أو روابطه.",
        editBlock: "تعديل",
        placeholder: "اكتب شيئًا",
        preparingPdf: "جارٍ تجهيز ملف PDF",
        limits: {
          sections: "يتسع المستند لـ {{max}} قسمًا كحد أقصى.",
          blocks: "يتسع المستند لـ {{max}} جزءًا كحد أقصى.",
          items: "تتسع القائمة لـ {{max}} عنصرًا كحد أقصى.",
          rows: "يتسع الجدول لـ {{max}} صفًا كحد أقصى.",
          columns: "يتسع الجدول لـ {{max}} أعمدة كحد أقصى.",
          characters: "يتسع هذا الجزء لـ {{max}} حرف كحد أقصى.",
        },
      },
      viewer: {
        title: "ملف",
        loading: "جارٍ تحميل الملف…",
        pending: "جارٍ تجهيز الملف. سيظهر هنا عندما يصبح جاهزًا.",
        unsupported: "لا يمكن معاينة هذا الملف هنا. نزّله بدلًا من ذلك.",
        offline: "أنت غير متصل. تحقّق من الاتصال ثم حاول مرة أخرى.",
        expired: "انتهت صلاحية رابط المعاينة.",
        notFoundTitle: "هذا الملف لم يعد متاحًا",
        notFoundHint: "ربما حُذف، أو أنه يخص حسابًا آخر.",
        error: "تعذّر تحميل الملف.",
        page: "معاينة",
        pdf: "PDF",
        code: "الشيفرة",
        frameTitle: "معاينة {{title}}",
      },
    },
    // بطاقة البحث: ما بحث عنه الوكيل وقرأه. مصادرها في صف المصادر أسفل
    // الإجابة ولا تتكرر هنا.
    research: {
      title: {
        search: "بحث في الويب",
        url: "صفحات تمت قراءتها",
        pdf: "ملف PDF تمت قراءته",
        github: "مستودع تمت قراءته",
        skill: "إرشادات المهارة",
      },
      searchedFor: "تم البحث عن {{queries}}",
      urlStatus: {
        success: "تمت القراءة",
        error: "تعذّر الفتح",
        paywall: "خلف اشتراك مدفوع",
        unsafe: "محظور",
      },
      commit: "الإيداع {{sha}}",
      filesRead: "الملفات المقروءة: {{files}}",
      treeTruncated: "مستودع كبير، قُرئ جزء منه فقط",
      skillVersion: "الإصدار {{version}}",
      showMore: "عرض المزيد",
      showLess: "عرض أقل",
      activity: {
        search: "تم البحث في الويب",
        read: "تمت قراءة {{name}}",
      },
    },
    dictationStart: "بدء الإملاء الصوتي",
    dictationStop: "إيقاف الإملاء الصوتي",
    dictationPermissionDeniedTitle: "يلزم الوصول للصوت",
    dictationPermissionDeniedMessage:
      "اسمح بالميكروفون والتعرّف على الكلام لإملاء الرسائل.",
    dictationPermissionSettingsMessage:
      "فعّل الميكروفون والتعرّف على الكلام من الإعدادات لاستخدام الإملاء الصوتي.",
    dictationUnavailableTitle: "الإملاء الصوتي غير متاح",
    dictationUnavailableMessage:
      "التعرّف على الكلام غير متاح على هذا الجهاز حالياً.",
    aiLimitReached: "استخدمت رصيدك المتاح",
    aiWorkspaceLimitReached: "وصلت مساحة العمل إلى حد استخدام الذكاء الاصطناعي",
    aiLimitReachedHint:
      "رقّ للحصول على رصيد أكبر، أو عد غداً عندما يتجدد رصيدك.",
    freeRepliesUsed: "استخدمت ردودك المجانية البالغ عددها {{limit}} اليوم",
    freeRepliesResetHint:
      "تتجدد الردود المجانية يوميًا. رقّ إلى Plus لاستخدام سخي للذكاء الاصطناعي.",
    subscriptionBlocked: {
      label: "الاشتراك",
      title: "استخدمت رصيدك المتاح",
      workspaceTitle: "تم بلوغ حد الذكاء الاصطناعي للمساحة",
      defaultMessage:
        "رقّ للحصول على رصيد أكبر، أو تابع غداً عندما يتجدد رصيدك اليومي.",
      upgradeCta: "عرض خيارات الترقية",
    },
    home: {
      greeting: {
        morning: "صباح الخير",
        afternoon: "مساء الخير",
        evening: "مساء الخير",
        night: "ما زلت مستيقظاً",
        fallback: "مرحباً بعودتك",
      },
      starterPrompts: {
        matchJobs: "ابحث عن وظائف تناسب ملفي الشخصي",
        matchSkills: "ابحث عن وظائف في دول الخليج تناسب مهاراتي",
        tailorCv: "خصّص سيرتي الذاتية لإعلان وظيفي محدد",
        interview: "ساعدني على التدرّب لمقابلة عمل",
        remoteRoles: "ابحث عن وظائف عن بُعد في دول الخليج تناسب ملفي الشخصي",
        bestFit: "ما الوظائف الأنسب لملفي الشخصي؟ وضّح لماذا تناسبني أفضل النتائج.",
        chooseCv: "ساعدني على اختيار أنسب سيرة ذاتية لدي لوظيفة محددة",
        exploreCvs: "اعرض سيري الذاتية ووضّح متى أستخدم كل واحدة منها",
        recommendSkill: "اقترح مهارة في تابيو تساعدني على تحقيق أهدافي المهنية",
        cvSkills: "اعرض مهارات تابيو المتاحة لتحسين سيرتي الذاتية",
        linkedinPost: "اكتب لي منشور لينكدإن أنشره هذا الأسبوع عن عملي ومجالي",
        industryBriefing: "أرسل لي ملخص اليوم عن آخر ما يحدث في مجالي",
      },
      moreSuggestions: "اقتراحات أخرى",
      rotatingSuggestions: {
        remoteRoles: "وظائف عن بُعد في الخليج",
        bestFit: "ما الأنسب لي؟",
        chooseCv: "اختر سيرة ذاتية لوظيفة",
        exploreCvs: "استعرض سيري الذاتية",
        recommendSkill: "اقترح مهارة",
        cvSkills: "اعرض مهارات السيرة الذاتية",
      },
      greetingMove: "مرحباً {{name}}، ما خطوتك التالية؟",
      greetingMoveNoName: "ما خطوتك التالية؟",
      placeholder: "اسأل أي شيء…",
      sendLabel: "إرسال الرسالة",
      voiceLabel: "وضع الصوت",
      dictateLabel: "إملاء صوتي",
      addLabel: "إضافة ملفات أو أدوات",
      menuLabel: "فتح القائمة",
      tryTitle: "جرّب Tabbio",
      tryClose: "إخفاء الاقتراحات",
      listening: "جارٍ الاستماع…",
      topnav: {
        profile: "الملف الشخصي",
        webcv: "السيرة الذاتية",
        jobs: "الوظائف",
        analytics: "المشاهدات",
        apps: "التطبيقات",
      },
      actions: {
        // ── باحث عن عمل (شخصي) ──
        webcv: {
          label: "أنشئ سيرتي الذاتية",
          prompts: [
            "ابنِ سيرتي الذاتية من خبراتي الأخيرة",
            "أعد صياغة قسم نبذة عني ليناسب مديري التوظيف في دبي",
            "أضف قسمًا عن خبرتي في سوق الخليج",
          ],
        },
        tailor: {
          label: "خصّص سيرتي الذاتية",
          prompts: [
            "خصّص سيرتي الأساسية لوظيفة مطوّر واجهات أمامية أول في أبوظبي",
            "أعد كتابة أحدث منصب مع إبراز العمل بالعربية والإنجليزية",
            "أرني أين يمكنني إضافة أرقام حقيقية لسيرة في مبيعات العقارات",
          ],
        },
        jobs: {
          label: "ابحث عن وظائف",
          prompts: [
            "ابحث عن وظائف React أولى في دبي أو أبوظبي",
            "اعرض الوظائف ذات الأولوية للمواطنين الإماراتيين المنشورة هذا الأسبوع",
            "ابحث عن وظائف رعاية صحية في الشارقة متاحة لمقيمي الخليج",
          ],
        },
        apply: {
          label: "تتبّع طلباتي",
          prompts: [
            "اعرض حالة طلباتي المفتوحة",
            "أرني الطلبات التي تنتظر رد المُوظِّف",
            "اكتب رسالة متابعة لطيفة للوظيفة التي قدّمت عليها الأسبوع الماضي",
          ],
        },
        autoapply: {
          label: "الأتمتة",
          prompts: [
            "اعرض أقوى مطابقات React Native في الإمارات",
            "اعرض المطابقات خارج دول الخليج قبل أن أقدم",
            "ابحث عن مطابقات تحتاج خطاب تغطية مخصصًا",
          ],
        },
        interview: {
          label: "التحضير للمقابلات",
          prompts: [
            "ساعدني على الاستعداد لمقابلة في أحد بنوك دبي الأسبوع المقبل",
            "حوّل أحدث منصب لي إلى أمثلة STAR لمقابلة سلوكية",
            "اختبرني في تصميم أنظمة React لوظيفة أولى",
          ],
        },
        linkedin: {
          label: "حسّن LinkedIn الخاص بي",
          prompts: [
            "راجع عنوان LinkedIn لسوق العمل في الإمارات",
            "اقترح ثلاث أفكار لمنشورات عن العمل في تقنية الخليج",
            "أعد كتابة قسم نبذة عني في LinkedIn ليتوافق مع سيرتي",
          ],
        },

        // ── الشركات ──
        findCandidates: {
          label: "ابحث عن مرشحين لوظائفنا المفتوحة",
          prompts: [
            "ابحث عن مرشحين لوظائفنا المفتوحة ورتّب الأنسب منهم",
            "ابحث عن مرشحين إماراتيين لوظيفة مهندس ميكانيكي",
            "اعرض أفضل المرشحين لوظيفة مطوّر React أول",
          ],
        },
        postjob: {
          label: "انشر وظيفة",
          prompts: [
            "اكتب مسودة وظيفة مطوّر React Native أول لمكتبنا في دبي",
            "اكتب مسودة وظيفة مهندس ميكانيكي للمواطنين الإماراتيين",
            "حوّل وصف وظيفتنا الأخير إلى مسودة جديدة",
          ],
        },
        shortlist: {
          label: "ابنِ قائمة مختصرة",
          prompts: [
            "ابحث عن مرشحين إماراتيين لوظيفة المهندس الميكانيكي",
            "ابحث عن مرشحي مبيعات يجيدون اللغتين في الرياض",
            "قارن آخر ثلاث قوائم مختصرة لهذه الوظيفة",
          ],
        },
        talent: {
          label: "ابحث عن مواهب",
          prompts: [
            "ابحث عن مهندسي React في الإمارات بخبرة خمس سنوات على الأقل",
            "أرني مسوّقين يجيدون العربية في دبي",
            "ابحث عن مستشاري عقارات في أبوظبي",
          ],
        },
        outreach: {
          label: "اكتب رسائل توظيف",
          prompts: [
            "اكتب رسالة لأفضل مرشح في قائمتي المختصرة",
            "اكتب متابعة لطيفة للمرشحين الذين أوقفناهم الأسبوع الماضي",
            "خصّص رسالة تعريف بناءً على أعمال المرشح",
          ],
        },
        schedule: {
          label: "حدّد المقابلات",
          prompts: [
            "اكتب مسودة دعوة لمقابلة مدتها 30 دقيقة غدًا الساعة 10 صباحًا بتوقيت الخليج",
            "اكتب مسودات دعوات مقابلة لأفضل ثلاثة مرشحين",
            "اكتب مسودة ملاحظات للجنة المقابلة",
          ],
        },
        careerpage: {
          label: "حسّن صفحتي المهنية",
          prompts: [
            "حدّث صفحتي المهنية بأحدث التعيينات",
            "حسّن صفحتي المهنية للوظائف ذات الأولوية للمواطنين الإماراتيين",
            "أضف قسم مزايا عن فوائد العمل في الخليج",
          ],
        },
        analytics: {
          label: "المشاهدات",
          prompts: [
            "اعرض مسار التوظيف لوظيفة Senior Frontend",
            "أي الوظائف المفتوحة تفقد أكبر عدد من المتقدمين؟",
            "قارن طلبات آخر 30 يومًا بالفترة السابقة",
          ],
        },
      },
    },
  },
  drawer: {
    tools: "الأدوات",
    inbox: "الوارد",
    notifications: "الإشعارات",
    apps: "التطبيقات",
    profile: "الملف الشخصي",
    webCv: "السيرة الذاتية",
    findJobs: "البحث عن وظائف",
    analytics: "المشاهدات",
    cvBuilder: "السيرة الذاتية",
    findJob: "البحث عن وظائف",
    upgrade: "ترقية",
    upgradeBlurb: "نماذج أكثر ورصيد أكبر",
    chatCta: "محادثة",
    premium: "Premium",
    categoryCareer: "الأدوات المهنية",
    categoryHiring: "أدوات التوظيف",
    categoryCustomize: "التخصيص",
  },

  // Messages / Inbox
  messages: {
    title: "الرسائل",
    noMessages: "لا توجد رسائل بعد",
    noMessagesSubtitle:
      "ستظهر المحادثات مع المسؤولين عن التوظيف وأصحاب العمل هنا",
    selectConversation: "اختر محادثة لبدء المراسلة",
    online: "متصل",
    sendMessage: "اكتب رسالة...",
    typing: "{{name}}يكتب...",
    typingMultiple: "عدة أشخاص يكتبون...",
    read: "مقروءة",
    delivered: "تم التسليم",
    sent: "تم الإرسال",
    sending: "جارٍ الإرسال...",
    sendFailed: "لم يتم الإرسال",
    sendFailedBody: "لم يتم إرسال رسالتك. تحقق من الاتصال وحاول مرة أخرى.",
    today: "اليوم",
    yesterday: "أمس",
    newConversation: "رسالة جديدة",
    systemMessage: "تابيو",
    systemReadOnly: "رسائل Tabbio للقراءة فقط.",
    loadingMessages: "جارٍ تحميل الرسائل...",
    noMoreMessages: "لا مزيد من الرسائل",
    messageDeleted: "تم حذف هذه الرسالة",
    deletedUser: "مستخدم محذوف",
    connectionLost: "جارٍ إعادة الاتصال...",
    searchUsers: "ابحث بالاسم أو اسم المستخدم أو البريد الإلكتروني...",
    noUsersFound: "لم يتم العثور على مستخدمين",
    startConversation: "بدء محادثة",
    conversationCreated: "تم بدء المحادثة",
    conversationFailed: "تعذّر بدء المحادثة",
    blockedError: "لا يمكنك مراسلة هذا الشخص الآن.",
    deleteTitle: "حذف المحادثة",
    deleteConfirm: "حذف محادثتك مع {{name}}؟ لا يمكن التراجع عن هذا.",
    deleteConfirmSimple: "حذف هذه المحادثة؟ لا يمكن التراجع عن هذا.",
    delete: "حذف",
    cancel: "إلغاء",
    deleteSuccess: "تم حذف المحادثة",
    deleteFailed: "تعذّر حذف المحادثة",
  },

  // Notifications
  notifications: {
    title: "الإشعارات",
    unread: "غير مقروء",
    moreActions: "خيارات الإشعار",
    time: {
      now: "الآن",
      minutes: "{{value}} د",
      hours: "{{value}} س",
      days: "{{value}} ي",
      weeks: "{{value}} أ",
      months: "{{value}} ش",
      years: "{{value}} سنة",
    },
    subtitle: "آخر التحديثات والنشاطات الخاصة بك",
    tabs: {
      jobAlerts: "تنبيهات الوظائف",
      activity: "النشاط",
      updated: "التحديثات",
    },
    noNotifications: "لا توجد إشعارات بعد",
    noNotificationsSubtitle:
      "ستظهر تحديثات الوظائف وحالة الطلبات والتنبيهات هنا",
    selectNotification: "اختر إشعاراً لعرض التفاصيل",
    markAllRead: "تعليم الكل كمقروء",
    groups: {
      today: "اليوم",
      week: "سابقًا هذا الأسبوع",
      earlier: "أقدم",
    },
    newCount_zero: "لا إشعارات جديدة",
    newCount_one: "إشعار جديد",
    newCount_two: "إشعاران جديدان",
    newCount_few: "{{count}} إشعارات جديدة",
    newCount_many: "{{count}} إشعارًا جديدًا",
    newCount_other: "{{count}} إشعار جديد",
    viaSource: "عبر {{source}}، {{when}}",
    matchChip: "تطابق {{score}}٪",
    matchesSummary_zero: "لا وظائف مطابقة عبر تنبيهاتك المحفوظة ({{alerts}})",
    matchesSummary_one: "وظيفة واحدة مطابقة عبر تنبيهاتك المحفوظة ({{alerts}})",
    matchesSummary_two: "وظيفتان مطابقتان عبر تنبيهاتك المحفوظة ({{alerts}})",
    matchesSummary_few: "{{count}} وظائف مطابقة عبر تنبيهاتك المحفوظة ({{alerts}})",
    matchesSummary_many: "{{count}} وظيفة مطابقة عبر تنبيهاتك المحفوظة ({{alerts}})",
    matchesSummary_other:
      "{{count}} وظيفة مطابقة عبر تنبيهاتك المحفوظة ({{alerts}})",
    manageFooter: "تحكّم بما يصلك هنا من",
    manageFooterLink: "تنبيهات الوظائف",
    searchPlaceholder: "بحث في الإشعارات…",
    markingAllRead: "جاري تعليم الكل كمقروء…",
    allMarkedRead: "تم تعليم جميع الإشعارات كمقروءة",
    deleted: "تم حذف الإشعار",
    deleteConfirm: "هل تريد حذف هذا الإشعار؟",
    permissionTitle: "تفعيل الإشعارات",
    permissionBody:
      "احصل على إشعارات حول تحديثات الوظائف ومواعيد المقابلات وحالة الطلبات.",
    permissionAllow: "السماح بالإشعارات",
    permissionLater: "لاحقاً",
    loadingMore: "جاري التحميل…",
    loadFailed: "تعذر تحميل الإشعارات",
    retry: "حاول مرة أخرى",
    types: {
      applicationUpdate: "تحديث الطلب",
      jobMatch: "وظيفة مطابقة",
      autoApply: "مطابقة تلقائية",
      profileView: "مشاهدة الملف الشخصي",
      interview: "مقابلة",
      system: "نظام",
    },
  },

  // Employer Job Posting
  jobPost: {
    defaults: {
      roleSlug: "role",
    },
    stepCounter: "{{current}} من {{total}}",
    generating: {
      title: "جاري إنشاء إعلان الوظيفة",
      subtitle: "نقرأ مدخلاتك ونقوم بتعبئة التفاصيل.",
    },
    success: {
      title: "تم النشر.",
      subtitle: "وظيفتك الآن نشطة داخل مساحة عمل الشركة.",
      postedTo: "تم النشر في {{company}}",
    },
    actions: {
      next: "التالي",
      post: "نشر",
      postRole: "نشر الوظيفة",
      posting: "جارٍ النشر...",
      done: "تم",
      copy: "نسخ",
      copied: "تم النسخ",
      buildJobPost: "إنشاء إعلان الوظيفة",
      postManually: "إدخال يدوي",
      writeWithAi: "اكتب بالذكاء الاصطناعي",
    },
    entry: {
      title: "إعلانات الوظائف",
      subtitle: "أنشئ إعلاناً جديداً عبر مسار موجه ثم انشره عند الجاهزية.",
      heroOverview:
        "{{roles}} وظائف نشطة و{{applicants}} متقدماً يتحركون داخل مسار التوظيف.",
      searchPlaceholder: "ابحث عن الأدوار أو الفرق أو المواقع",
      heroPill: "{{count}} متقدماً قيد المراجعة",
      openRolePill: "وظيفة مفتوحة بانتظار أول متقدم",
      applicantsShort: "متقد.",
      cardTitle: "نشر وظيفة جديدة",
      cardSubtitle:
        "ابدأ بالذكاء الاصطناعي أو أدخل التفاصيل يدوياً عبر 3 خطوات.",
      cta: "ابدأ النشر",
      loading: "جارٍ تحميل الوظائف...",
      loadFailed: "تعذر تحميل وظائف الشركة",
      loadFailedHint:
        "حاول مرة أخرى بعد قليل. ما زلت بحاجة إلى مساحة عمل شركة وصلاحية الوصول إليها.",
      emptyTitle: "لا توجد وظائف بعد",
      emptySubtitle:
        "انشر أول وظيفة وستظهر هنا وفي قسم الوظائف المفتوحة للشركة.",
      emptyFilteredTitle: "لا توجد وظائف مطابقة",
      emptyFilteredSubtitle:
        "جرّب عبارة بحث أخرى أو انتقل إلى تبويب مختلف للوظائف.",
      applications: "{{count}} متقدمون",
      postedOn: "نُشرت {{date}}",
      viewApplicants: "عرض المتقدمين",
      live: "نشطة",
      stats: {
        liveRoles: "الوظائف النشطة",
        totalApplicants: "إجمالي المتقدمين",
      },
      tabs: {
        all: "الكل",
        active: "نشطة",
        draft: "مسودة",
        closed: "مغلقة",
      },
    },
    step1: {
      title: "لننشر وظيفة.",
      subtitle: "الصق وصف الوظيفة وسنقوم بالإعداد، أو أدخل التفاصيل بنفسك.",
      textareaPlaceholder:
        'الصق وصف الوظيفة هنا، أو اكتب مثلاً:\n"مطور واجهات أمامية، دبي، هجين، React"',
      or: "أو",
      attach: "أرفق وصف الوظيفة (PDF أو Word أو صورة)",
      attaching: "جارٍ قراءة الملف...",
      attachClear: "إزالة المرفق",
    },
    step2: {
      title: "تفاصيل الوظيفة",
      subtitleAi: "قمنا بتعبئة هذه الحقول من الوصف. عدّل أي شيء يلزم.",
      subtitleManual: "أدخل الأساسيات الآن، ويمكنك التعديل لاحقاً.",
      fields: {
        title: "المسمى الوظيفي",
        description: "وصف الوظيفة",
        department: "القسم",
        country: "الدولة",
        city: "المدينة",
        workType: "نمط العمل",
        employment: "نوع التوظيف",
        experienceLevel: "مستوى الخبرة",
        applyMethod: "كيف يتقدم المرشحون؟",
      },
      placeholders: {
        title: "مثال: مصمم منتجات أول",
        description:
          "نبذة عن الدور\nما الذي سيقوم به المرشح، وما الذي تبحث عنه، ولماذا يجب أن يتقدم.",
        department: "اختر القسم",
        country: "اختر الدولة",
        city: "اختر المدينة",
        experienceLevel: "اختر المستوى",
        externalUrl: "https://careers.company.com/apply",
      },
      applyMethod: {
        tabbio: "عبر Tabbio",
        external: "رابط خارجي",
      },
      applyMethodHint: {
        tabbio:
          "يتقدم المرشحون عبر صفحة Tabbio الخاصة بك وتظهر الطلبات في مكتبة التوظيف.",
        external:
          "ينتقل المرشح إلى هذا الرابط عند الضغط على التقديم ولن تظهر الطلبات في مكتبة التوظيف.",
      },
    },
    step3: {
      title: "من يجب أن يتقدم؟",
      subtitleTabbio:
        "أضف فلاتر لتسهيل وصول المرشحين المناسبين قبل إرسال الطلب.",
      subtitleExternal: "فلاتر اختيارية تظهر على بطاقة الوظيفة.",
      fields: {
        nationality: "الجنسية",
        gender: "الجنس",
        genderReason: "السبب",
        yearsExperience: "الخبرة",
        qualification: "المؤهل",
        prescreens: "أسئلة ما قبل التقديم",
        customQuestion: "سؤال مخصص",
      },
      placeholders: {
        genderReason: "اختر السبب",
        yearsExperience: "أي",
        qualification: "أي",
        customQuestion: "أضف سؤالك الخاص",
      },
      prescreensHint: "يجيب المرشحون على هذه الأسئلة قبل إرسال الطلب.",
    },
    ai: {
      title: "قائد تسويق أول",
      badge: "مُنشأ بالذكاء الاصطناعي",
      generatedDescription:
        "نبذة عن الدور\nنبحث عن قائد تسويق أول لقيادة النمو الإقليمي عبر دول الخليج. ستتولى إدارة مسار التسويق بالكامل من الوعي بالعلامة التجارية حتى التحويل، بالتعاون المباشر مع فرق المنتج والمبيعات.\n\nالمسؤوليات\n• تنفيذ حملات نمو إقليمية عبر الإمارات والسعودية وقطر\n• إدارة ميزانيات الإعلانات الشهرية وتحسين الأداء\n• بناء وقيادة فريق تسويق من 3 إلى 5 أشخاص\n• مواءمة استراتيجية الإطلاق مع المنتج والمبيعات\n• تعزيز الاكتساب العضوي عبر المحتوى وSEO\n\nالمتطلبات\n• خبرة 5+ سنوات في تسويق B2B ويفضل داخل الخليج\n• خبرة في إدارة حملات Google وMeta وLinkedIn\n• معرفة بـ HubSpot أو أدوات مشابهة\n• مهارات تحليلية قوية باستخدام GA4 وتقارير الأداء\n• إجادة العربية والإنجليزية",
    },
    errors: {
      companyRequired: "انتقل إلى مساحة عمل شركة قبل نشر وظيفة.",
      titleRequired: "أضف مسمى وظيفياً قبل النشر.",
      descriptionRequired: "أضف وصف الوظيفة قبل النشر.",
      descriptionTooShort: "يجب أن يكون وصف الوظيفة {{count}} حرفًا على الأقل.",
      externalUrlRequired: "أضف رابط التقديم الخارجي قبل النشر.",
      submitFailed: "تعذر نشر هذه الوظيفة",
      submitFailedHint: "يرجى المحاولة مرة أخرى. لم يتم نشر الوظيفة.",
      promptRequired: "صف الدور الذي تريد نشره أولاً.",
      generateFailed: "تعذر توليد إعلان الوظيفة",
    },
    list: {
      generalDepartment: "عام",
      remoteFallback: "عن بُعد",
      status: {
        active: "نشطة",
        draft: "مسودة",
        closed: "مغلقة",
      },
    },
    options: {
      other: "أخرى",
      departments: {
        engineering: "الهندسة",
        marketing: "التسويق",
        sales: "المبيعات",
        product: "المنتج",
        design: "التصميم",
        finance: "المالية",
        operations: "العمليات",
        hr: "الموارد البشرية",
        legal: "القانونية",
        customerSuccess: "نجاح العملاء",
      },
      countries: {
        uae: "الإمارات العربية المتحدة",
        saudi: "المملكة العربية السعودية",
        qatar: "قطر",
        oman: "عُمان",
        bahrain: "البحرين",
        kuwait: "الكويت",
        egypt: "مصر",
        jordan: "الأردن",
        remote: "عن بُعد",
      },
      cities: {
        dubai: "دبي",
        abuDhabi: "أبوظبي",
        sharjah: "الشارقة",
        ajman: "عجمان",
        rasAlKhaimah: "رأس الخيمة",
        fujairah: "الفجيرة",
        alAin: "العين",
        riyadh: "الرياض",
        jeddah: "جدة",
        dammam: "الدمام",
        makkah: "مكة المكرمة",
        madinah: "المدينة المنورة",
        khobar: "الخبر",
        doha: "الدوحة",
        alWakrah: "الوكرة",
        alRayyan: "الريان",
        muscat: "مسقط",
        salalah: "صلالة",
        sohar: "صحار",
        manama: "المنامة",
        muharraq: "المحرق",
        riffa: "الرفاع",
        kuwaitCity: "مدينة الكويت",
        hawalli: "حولي",
        salmiya: "السالمية",
        cairo: "القاهرة",
        alexandria: "الإسكندرية",
        giza: "الجيزة",
        sharmElSheikh: "شرم الشيخ",
        amman: "عمّان",
        irbid: "إربد",
        zarqa: "الزرقاء",
      },
      workType: {
        onsite: "حضوري",
        hybrid: "هجين",
        remote: "عن بُعد",
      },
      employment: {
        fullTime: "دوام كامل",
        partTime: "دوام جزئي",
        contract: "عقد",
        internship: "تدريب",
      },
      experienceLevel: {
        entry0to2: "مبتدئ (0-2 سنوات)",
        mid2to5: "متوسط (2-5 سنوات)",
        senior5to8: "أول (5-8 سنوات)",
        lead8to12: "قيادي (8-12 سنة)",
        executive12plus: "تنفيذي (12+ سنة)",
      },
      nationality: {
        open: "متاح للجميع",
        emiratiOnly: "إماراتي فقط",
        saudiOnly: "سعودي فقط",
        gcc: "مواطنو الخليج",
      },
      gender: {
        any: "أي",
        male: "ذكر",
        female: "أنثى",
      },
      genderReason: {
        legalRequirement: "متطلب قانوني",
        roleSpecific: "خاص بطبيعة الدور",
      },
      yearsExperience: {
        any: "أي",
        zeroToOne: "0-1 سنة",
        oneToThree: "1-3 سنوات",
        threeToFive: "3-5 سنوات",
        fiveToEight: "5-8 سنوات",
        eightToTwelve: "8-12 سنة",
        twelvePlus: "12+ سنة",
      },
      qualification: {
        any: "أي",
        highSchool: "ثانوية عامة",
        diploma: "دبلوم",
        bachelors: "بكالوريوس",
        masters: "ماجستير",
        phd: "دكتوراه",
      },
    },
    prescreens: {
      exp: {
        label: "هل لديك الخبرة المطلوبة؟",
        tag: "الخبرة",
      },
      visa: {
        label: "هل لديك تأشيرة عمل سارية؟",
        tag: "الأهلية",
      },
      relocate: {
        label: "هل أنت مستعد للانتقال؟",
        tag: "الأهلية",
      },
      start: {
        label: "هل يمكنك البدء خلال 30 يوماً؟",
        tag: "التوفر",
      },
      team: {
        label: "هل سبق أن أدرت فريقاً؟",
        tag: "الخبرة",
      },
      arabic: {
        label: "هل تجيد اللغة العربية بطلاقة؟",
        tag: "اللغة",
      },
      english: {
        label: "هل تجيد اللغة الإنجليزية بطلاقة؟",
        tag: "اللغة",
      },
      degree: {
        label: "هل لديك شهادة مناسبة للدور؟",
        tag: "المؤهل",
      },
    },
  },

  jobDetail: {
    title: "مساحة عمل الدور",
    tabs: {
      overview: "نظرة عامة",
      applicants: "المتقدمون",
      matched: "المرشحون المطابقون",
    },
    close: {
      title: "إغلاق هذه الوظيفة",
      body: "تنتقل الوظائف المغلقة من التوظيف النشط مع بقاء المتقدمين والتقارير متاحة.",
      action: "إغلاق الوظيفة",
      confirmTitle: "إغلاق هذه الوظيفة؟",
      confirmBody:
        "لن تظهر هذه الوظيفة للمرشحين كوظيفة نشطة. سيبقى المتقدمون الحاليون في مسار التوظيف.",
      confirmAction: "تأكيد الإغلاق",
      closedLabel: "هذه الوظيفة مغلقة. لا يزال المتقدمون والتقارير متاحين.",
      successTitle: "تم إغلاق الوظيفة",
      successBody: "انتقلت هذه الوظيفة إلى الوظائف المغلقة.",
      errorTitle: "تعذر إغلاق الوظيفة",
    },
    matched: {
      matchLabel: "مطابقة",
      upgradeBadge: "ترقية للمراسلة",
      empty: {
        title: "لا توجد مطابقات بعد",
        subtitle:
          "سنعرض هنا مرشحي Tabbio عند مطابقتهم لهذه الوظيفة. عاود الزيارة قريباً.",
      },
    },
  },
  jobApplicants: {
    title: "المتقدمون",
    subtitle: "راجع كل مرشح لهذه الوظيفة وحرّكه عبر مسار التوظيف الخاص بك.",
    heroOverview:
      "{{total}} متقدماً إجمالاً، {{reviewed}} تمت مراجعته، {{shortlisted}} ضمن القائمة المختصرة، و{{interview}} في المقابلة.",
    detailTitle: "المرشح",
    detailSubtitle: "حزمة الطلب الكاملة",
    searchPlaceholder: "ابحث بالاسم أو البريد أو المسمى أو السيرة",
    clearFilters: "مسح الفلاتر",
    loadingTitle: "جارٍ تحميل المتقدمين...",
    loadingSubtitle: "نقوم بجلب كل من تقدم لهذه الوظيفة.",
    loadingDetailTitle: "جارٍ تحميل المرشح...",
    loadingDetailSubtitle: "نقوم بجلب الطلب الكامل وكل نسخ السيرة الذاتية.",
    loadErrorTitle: "تعذر تحميل المتقدمين",
    loadErrorSubtitle:
      "حاول مرة أخرى بعد قليل. ما زلت بحاجة إلى صلاحية الوصول من مساحة عمل الشركة.",
    emptyTitle: "لا يوجد متقدمون بعد",
    emptySubtitle: "سيظهر المتقدمون هنا بمجرد أن يتقدم المرشحون عبر Tabbio.",
    emptyFilteredTitle: "لا توجد نتائج مطابقة",
    emptyFilteredSubtitle: "جرّب بحثاً آخر أو أزل بعض فلاتر المراحل.",
    notFoundTitle: "تعذر العثور على المرشح",
    notFoundSubtitle: "لم يعد هذا الطلب متاحاً في مساحة العمل النشطة.",
    noTitle: "لا يوجد مسمى مضاف",
    noSubmittedCv: "لا توجد سيرة ذاتية مرسلة",
    noFurtherActions: "لا توجد إجراءات إضافية متاحة من جهة الشركة لهذا الطلب.",
    noDataValue: "غير متوفر",
    appliedAgo: "تم التقديم {{time}}",
    messageHint:
      "يستلم المرشح إشعاراً داخل التطبيق، وأول رسالة غير مقروءة من المجند ترسل أيضاً عبر البريد.",
    messagePlaceholder: "اكتب رسالة لهذا المرشح",
    statusUpdatedTitle: "تم تحديث الحالة",
    statusUpdatedBody: "تم نقل الطلب إلى {{status}}.",
    statusUpdateFailedTitle: "تعذر تحديث حالة الطلب",
    messageSentTitle: "تم إرسال الرسالة",
    messageSentBody: "يمكن للمرشح الآن الرد من صندوق رسائله في Tabbio.",
    messageFailedTitle: "تعذر إرسال الرسالة",
    currentLabel: "حالي",
    filters: {
      all: "الكل",
      clear: "مسح",
    },
    counts: {
      total: "الإجمالي",
      reviewed: "تمت المراجعة",
      shortlisted: "القائمة المختصرة",
      interview: "المقابلة",
      offered: "العرض",
      rejected: "مرفوض",
    },
    status: {
      applied: "تم التقديم",
      reviewed: "تمت المراجعة",
      shortlisted: "ضمن القائمة المختصرة",
      interview: "مقابلة",
      offered: "عرض",
      rejected: "مرفوض",
      withdrawn: "منسحب",
    },
    stage: {
      inbox: "الوارد",
      screening: "الفرز",
      interview: "المقابلة",
      offer: "العرض",
    },
    actions: {
      sendMessage: "إرسال رسالة",
      sendingMessage: "جارٍ الإرسال...",
      openThread: "فتح المحادثة",
      openApplication: "فتح الطلب",
      reviewed: "تحديد كمراجع",
      shortlisted: "إضافة للقائمة المختصرة",
      interview: "نقل إلى المقابلة",
      offered: "نقل إلى العرض",
      rejected: "رفض المرشح",
    },
    sections: {
      actions: "إجراءات التوظيف",
      message: "رسالة المجند",
      contact: "البيانات الخاصة",
      screeningAnswers: "إجابات الأسئلة",
      statusHistory: "سجل الحالة",
      smartCv: "السيرة الذاتية",
      submittedCv: "السيرة الذاتية المرسلة",
      additionalCv: "سيرة ذاتية إضافية",
      profile: "ملخص الملف",
      skills: "المهارات",
      experience: "الخبرة",
      education: "التعليم",
      certifications: "الشهادات",
      highlights: "الإنجازات",
      projects: "المشاريع",
    },
    fields: {
      job: "الوظيفة",
      company: "الشركة",
      appliedAt: "تاريخ التقديم",
      updatedAt: "آخر تحديث",
      location: "الموقع",
      email: "البريد الإلكتروني",
      phone: "الهاتف",
      nationality: "الجنسية",
      byUserId: "تم التحديث بواسطة {{id}}",
      coverLetter: "خطاب التقديم",
    },
    cv: {
      updatedOn: "آخر تحديث {{date}}",
      submitted: "المستخدمة لهذه الوظيفة",
      additional: "نسخة إضافية",
      empty: "لا توجد سيرة ذاتية مرفقة بهذا الطلب.",
      sectionFallback: "قسم بدون عنوان",
    },
    pagination: {
      previous: "الصفحة السابقة",
      next: "الصفحة التالية",
      pageOf: "صفحة {{page}} من {{total}}",
    },
    noData: {
      cv: "لا توجد سيرة ذاتية مرفقة بهذا الطلب.",
      screeningAnswers: "لم يتم إرسال إجابات أسئلة التقديم.",
      statusHistory: "لا توجد تحديثات حالة بعد.",
      profile: "لا يوجد ملخص ملف مضاف بعد.",
      skills: "لا توجد مهارات مضافة بعد.",
      experience: "لا توجد خبرات مضافة بعد.",
      education: "لا يوجد تعليم مضاف بعد.",
      certifications: "لا توجد شهادات مضافة بعد.",
      highlights: "لا توجد إنجازات مضافة بعد.",
      projects: "لا توجد مشاريع مضافة بعد.",
    },
  },

  employerCandidates: {
    title: "المرشحون",
    detailHeaderFallback: "مرشّح",
    subtitle:
      "ابحث في مواهب Tabbio العامة القابلة للاكتشاف، ثم احفظ الملفات القوية داخل مكتبتك الخاصة وأضفها إلى القوائم المختصرة للمتابعة.",
    searchTitle: "ابحث في دليل المرشحين",
    searchSubtitle:
      "استخدم بحثاً منطقياً يدعم AND وOR وNOT والعبارات بين علامتي اقتباس والحقول مثل skills: وlocation: وcompany:.",
    searchPlaceholder:
      'مثال: skills:"product design" AND location:dubai NOT company:"Acme"',
    clearFilters: "مسح الفلاتر",
    moreFilters: "الفلاتر",
    moreFiltersTitle: "مزيد من الفلاتر",
    searchByJD: "البحث بوصف الوظيفة",
    searchByJDTitle: "لصق وصف وظيفة",
    searchByJDPlaceholder: "الصق وصف الوظيفة الكامل هنا…",
    searchByJDAction: "بحث",
    resultsCount: "{{count}} مرشحين",
    smartParse: {
      buttonLabel: "تحليل ذكي",
      successTitle: "تم تحويل البحث",
      successMessage_one: "تم استخراج فلتر واحد من بحثك",
      successMessage_other: "تم استخراج {{count}} فلاتر من بحثك",
      fallbackTitle: "تم البحث ككلمة مفتاحية",
      fallbackMessage:
        "تعذر استخراج فلاتر محددة: يبقى النص الأصلي كاستعلام كلمة مفتاحية.",
      errorTitle: "تعذر تحليل البحث",
    },
    resultsHint:
      "الفلاتر المنظمة تعمل مع البحث المنطقي، ولن يظهر هنا إلا المرشحون العامون والقابلون للاكتشاف.",
    loadingTitle: "جارٍ تحميل المرشحين...",
    loadingSubtitle:
      "نقوم بجلب المرشحين العامين القابلين للاكتشاف لمساحة عمل الشركة.",
    loadingDetailTitle: "جارٍ تحميل المرشح...",
    loadingDetailSubtitle:
      "نقوم بجلب الملف الشخصي وقنوات الاتصال المتاحة وحالة القوائم المختصرة.",
    errorTitle: "تعذر تحميل المرشحين",
    errorSubtitle:
      "حاول مرة أخرى بعد قليل. ما زالت مساحة العمل النشطة بحاجة إلى صلاحية شركة.",
    emptyTitle: "لا يوجد مرشحون مطابقون",
    emptySubtitle:
      "جرّب بحثاً منطقياً أوسع أو أزل بعض فلاتر الموقع أو المهارات أو الشركات.",
    notFoundTitle: "تعذر العثور على المرشح",
    notFoundSubtitle:
      "لم يعد هذا المرشح متاحاً في الدليل العام لمساحة العمل النشطة.",
    retry: "أعد المحاولة",
    back: "رجوع",
    contactEmpty: "لا توجد خيارات تواصل متاحة لهذا المرشح حالياً.",
    outreachTemplates: {
      openButton: "القوالب",
      sheetTitle: "قوالب التواصل",
      sheetSubtitle:
        "اختر قالباً محفوظاً لملء الرسالة، أو احفظ مسودتك الحالية لاستخدامها لاحقاً.",
      loading: "جارٍ تحميل القوالب...",
      empty:
        "لا توجد قوالب بعد: ابدأ الكتابة في المربع أدناه لإنشاء قالبك الأول.",
      privateBadge: "خاص",
      companyBadge: "فريق",
      byCreator: "فريق · بواسطة {{name}}",
      deleteAction: "حذف القالب",
      saveCurrentTitle: "احفظ الرسالة الحالية كقالب",
      namePlaceholder: "اسم القالب (مثل: تواصل أولي)",
      saveButton: "حفظ القالب",
      savingButton: "جارٍ الحفظ…",
      visibility: {
        private: "خاص",
        company: "فريق",
      },
      appliedTitle: "تم تطبيق القالب",
      appliedMessage: 'تم تحميل "{{name}}" في الرسالة.',
      savedTitle: "تم حفظ القالب",
      deletedTitle: "تم حذف القالب",
      errorTitle: "تعذر حفظ القالب",
    },
    outreachHint:
      "إرسال التواصل ينشئ أو يعيد استخدام محادثة Tabbio، ويرسل أيضاً بريداً إلكترونياً للمرشح عند توفره.",
    outreachDrafting: "جارٍ صياغة الرسالة بالذكاء الاصطناعي…",
    composeTitle: "مراسلة {{name}}",
    composeSubtitle: "أرسل رسالة من المجند من داخل الدليل مباشرة.",
    outreachPlaceholder: "اكتب رسالة من المجند إلى هذا المرشح",
    outreachLockedBody:
      "التواصل المباشر مقفل في خطة الشركة المجانية. قم بترقية مساحة العمل لفتح رسائل المجند ورؤية بيانات الاتصال الخاصة.",
    outreachCharCounter: "{{count}} / {{max}}",
    outreachValidation: {
      tooShort: "يجب ألا تقل الرسالة عن {{min}} حرفًا",
      tooLong: "يجب ألا تتجاوز الرسالة {{max}} حرفًا",
      placeholders: "استبدل القوالب مثل {{'{{name}}'}} قبل الإرسال",
    },
    preSendChecklist: {
      title: "قبل الإرسال",
      emailOnFile: "للمرشّح بريد إلكتروني مسجّل",
      messageLength: "الرسالة 30 حرفًا على الأقل",
      noPlaceholders: "لا توجد قوالب {متغيّرة} متبقية في الرسالة",
    },
    experienceEmpty: "لا توجد خبرات عامة متاحة لهذا المرشح بعد.",
    educationEmpty: "لا توجد بيانات تعليم عامة متاحة لهذا المرشح بعد.",
    educationFallback: "التعليم",
    matchEvidence: {
      skills_one: "مهارة واحدة مطابقة",
      skills_other: "{{count}} مهارات مطابقة",
      company: "نفس الشركة",
      location: "نفس الموقع",
      experience: "مطابقة الدور",
      source: "مستعد للعمل",
    },
    spotlight: {
      openToWork: "مستعد للعمل",
      recentlyActive: "نشط حديثاً",
      highMatch: "تطابق عالٍ",
      notContacted: "لم يتم التواصل",
      saved: "محفوظ",
      shortlisted: "مختصر",
      pastApplicant: "متقدم سابق",
    },
    badges: {
      saved: "محفوظ في المكتبة",
      shortlistedCount: "{{count}} قوائم مختصرة",
      outreachLocked: "التواصل مقفل",
    },
    filters: {
      location: "المواقع",
      skills: "المهارات",
      companies: "الشركات",
      locationPlaceholder: "دبي، أبوظبي",
      skillsPlaceholder: "React، Figma، Recruiting",
      companiesPlaceholder: "Google، Careem، Tabbio",
    },
    actions: {
      save: "حفظ",
      saved: "محفوظ",
      createShortlist: "قائمة مختصرة",
      shortlisted: "تمت الإضافة",
      message: "مراسلة",
      chat: "دردشة",
      email: "بريد",
      sendOutreach: "إرسال",
      cancel: "إلغاء",
      suggestDraft: "اقتراح بالذكاء الاصطناعي",
      regenerateDraft: "إعادة الاقتراح بالذكاء الاصطناعي",
    },
    confirm: {
      saveTitle: "حفظ إلى المكتبة؟",
      saveMessage: "أضِف {{name}} إلى مكتبة المرشحين الخاصة بك للمتابعة.",
      shortlistTitle: "إضافة إلى القائمة المختصرة؟",
      shortlistMessage: "أضِف {{name}} إلى قائمة مختصرة لهذا الدور.",
      chatTitle: "بدء دردشة؟",
      chatMessage: "افتح محادثة Tabbio مع {{name}}.",
    },
    sections: {
      contact: "قنوات الاتصال المرئية",
      shortlists: "القوائم المختصرة",
      outreach: "التواصل",
      skills: "المهارات",
      about: "نبذة",
      experience: "الخبرة",
      education: "التعليم",
    },
    contacts: {
      tabbioMessage: "صندوق Tabbio",
      whatsapp: "واتساب",
      telegram: "تيليجرام",
      slack: "سلاك",
      email: "البريد الإلكتروني",
      phone: "الهاتف",
      landline: "الهاتف الأرضي",
    },
    contactValues: {
      tabbioMessage: "افتح المحادثة في صندوق Tabbio",
    },
    shortlists: {
      empty:
        "لم تنشئ قائمة مختصرة بعد. أنشئ واحدة هنا وسيتم إضافة المرشح إليها مباشرة.",
      defaultName: "قائمة {{name}}",
    },
    toasts: {
      savedTitle: "تم حفظ المرشح",
      savedMessage: "أصبح المرشح الآن متاحاً داخل مكتبتك.",
      saveFailedTitle: "تعذر حفظ المرشح",
      shortlistCreatedTitle: "تم إنشاء القائمة المختصرة",
      shortlistCreatedMessage: "تمت إضافة المرشح إلى القائمة الجديدة.",
      shortlistAddedTitle: "تم تحديث القائمة المختصرة",
      shortlistAddedMessage: "تمت إضافة المرشح إلى القائمة المختصرة.",
      shortlistAlreadyAddedMessage: "هذا المرشح موجود بالفعل في تلك القائمة.",
      shortlistFailedTitle: "تعذر تحديث القائمة المختصرة",
      emailFailedTitle: "تعذر فتح البريد الإلكتروني",
      outreachSentTitle: "تم إرسال التواصل",
      outreachSentMessage: "يمكن للمرشح الآن الرد من صندوق رسائله في Tabbio.",
      outreachFailedTitle: "تعذر إرسال التواصل",
      draftReadyTitle: "تم تجهيز الاقتراح",
      draftReadyMessage: "راجع المسودة وعدّلها قبل الإرسال.",
      draftFailedTitle: "تعذر إنشاء المسودة",
    },
  },

  // Services / Apps
  services: {
    title: "التطبيقات",
    subtitle: "اربط Tabbio مع Gmail وZapier وMake والتقويم ومصادر MCP.",
    searchPlaceholder: "بحث في الاتصالات…",
    // Categories
    categories: {
      topPicks: "الأفضل",
      career: "المسار المهني",
      writing: "الكتابة",
      interview: "المقابلات",
      analytics: "المشاهدات",
    },
    // Sections
    featured: "المميزة",
    featuredSubtitle: "أدوات مهنية مختارة من Tabbio",
    trending: "الرائجة",
    trendingSubtitle: "الخدمات الأكثر استخداماً",
    // Service names
    cvScorePro: "تقييم السيرة Pro",
    tailoredCvs: "سير ذاتية مخصصة",
    coverLetters: "خطابات التغطية",
    applicationPack: "حزمة التقديم",
    interviewPrep: "التحضير للمقابلة",
    salaryInsights: "رؤى الرواتب",
    recruiterPreview: "معاينة مسؤول التوظيف",
    autoApply: "الأتمتة",
    analytics: "المشاهدات",
    myServices: "خدماتي",
    library: "المكتبة",
    shortlists: "القوائم المختصرة",
    gmail: "Gmail",
    zapier: "Zapier",
    make: "Make",
    calendar: "التقويم",
    memoryMcp: "الذاكرة + MCP",
    // Service descriptions
    cvScoreProDesc:
      "قيّم سيرتك مقابل دور خليجي، وفحوصات ATS، والمهارات الناقصة، ومخاطر القراءة من مسؤول التوظيف…",
    tailoredCvsDesc:
      "أنشئ سير ذاتية مخصصة لكل وصف وظيفي باستخدام تحليل الذكاء الاصطناعي…",
    coverLettersDesc:
      "أنشئ خطابات تغطية مخصصة تبرز نقاط قوتك وتتوافق مع متطلبات الوظيفة…",
    applicationPackDesc:
      "أنشئ حزمة كاملة للدور تشمل ملاحظات السيرة والخطاب والإجابات والتحضير والراتب والقائمة…",
    interviewPrepDesc:
      "تدرب على المقابلات مع الذكاء الاصطناعي واحصل على ملاحظات فورية…",
    salaryInsightsDesc:
      "قدّر نطاق راتب خليجي ومستوى الثقة ونص تفاوض للدور المستهدف…",
    recruiterPreviewDesc:
      "اعرف كيف قد يقرأ أصحاب العمل ملفك، الأدلة، التحقق، ومخاطر المطابقة…",
    autoApplyDesc:
      "جدول أتمتة البحث عن الوظائف من ملفك وراجع كل مطابقة قبل التقديم…",
    analyticsDesc:
      "تتبع تقدم بحثك عن وظيفة وإحصاءات الطلبات ومشاهدات الملف الشخصي…",
    myServicesDesc: "إدارة خدماتك النشطة واشتراكاتك وسجل الاستخدام…",
    libraryDesc:
      "إدارة مكتبة المرشحين ومسارات الأدوار وإجراءات الملف من شاشة واحدة…",
    shortlistsDesc:
      "أنشئ روابط القوائم المختصرة، اجمع قرارات المراجعين، واحسم اختيارات التوظيف…",
    gmailDesc:
      "زامن رسائل المسار المهني وردود مسؤولي التوظيف وتحديثات التقديم داخل خريطة ذاكرة Tabbio.",
    zapierDesc:
      "أرسل أحداث Tabbio إلى تدفقات Zapier للمتابعة والتنبيهات والتسليم.",
    makeDesc: "اربط إشارات Tabbio بسيناريوهات Make لأتمتة العمل المجدولة.",
    calendarDesc: "نسق المقابلات والتذكيرات ومتابعات التقديم مع التقويم.",
    memoryMcpDesc:
      "أدر الذاكرة المتصلة وسياق السيرة ووصول MCP الذي يستخدمه الوكيل.",
    byTabbio: "من Tabbio",
    manageConnection: "إدارة",
    comingSoon: "قريباً",
    noServices: "لا توجد اتصالات",
    noServicesSubtitle: "ستظهر هنا التطبيقات المتصلة ومزودات الأتمتة",
  },

  library: {
    title: "المكتبة",
    candidateProfileTitle: "ملف المرشح",
    sections: {
      database: "قاعدة البيانات",
      roles: "الأدوار",
      activeJobs: "الوظائف النشطة المنشورة",
      collections: "المجموعات",
      savedSearches: "عمليات البحث المحفوظة",
    },
    database: {
      allCandidates: "كل المرشحين",
      talentPool: "مجمع المواهب",
      offlineCvs: "السير غير المتصلة",
    },
    actions: {
      newRole: "دور جديد",
      newCollection: "مجموعة جديدة",
      saveSearch: "حفظ البحث",
      viewFullCv: "عرض السيرة كاملة",
      addToShortlist: "إضافة للقائمة المختصرة",
      selectShortlist: "اختيار قائمة مختصرة",
      createShortlist: "إنشاء قائمة مختصرة",
      manageCollections: "إدارة المجموعات",
      star: "تمييز المرشح",
      unstar: "إزالة التمييز",
      reject: "رفض",
    },
    roleCandidates: "{{count}} مرشحين",
    searchPlaceholder: "ابحث عن المرشحين...",
    loading: "جارٍ تحميل المكتبة...",
    errorTitle: "تعذر تحميل بيانات المكتبة",
    setup: {
      title: "إعداد المكتبة قيد التنفيذ",
      subtitle:
        "جداول المكتبة الجديدة غير متاحة بعد. طبّق آخر ترحيل للمكتبة ثم حدّث هذه الشاشة.",
      blockedTitle: "يلزم إكمال إعداد المكتبة",
      blockedMessage: "هذا الإجراء غير متاح حتى يكتمل إعداد المكتبة الأخير.",
    },
    match: "التطابق",
    matchScore: "نسبة التطابق",
    addedOn: "أُضيف",
    stage: {
      inbox: "الوارد",
      screening: "الفرز",
      interview: "المقابلة",
      offer: "العرض",
      talent_pool: "مجمع المواهب",
    },
    source: {
      page: "الصفحة",
      email: "البريد",
      upload: "رفع",
      scan: "مسح",
    },
    kind: {
      applicant: "متقدم",
      external: "رفع خارجي",
    },
    origin: {
      applied: "تقدم",
      saved: "محفوظ",
      uploaded: "مرفوع",
      email: "بريد",
    },
    sort: {
      title: "الترتيب حسب",
      options: {
        newest: "الأحدث أولاً",
        match_desc: "نسبة التطابق (من الأعلى)",
        name_asc: "الاسم (أ-ي)",
      },
    },
    filters: {
      title: "الفلاتر",
      location: "الموقع",
      stage: "المرحلة",
      source: "المصدر",
      decision: "القرار",
      candidateType: "نوع المرشح",
      collection: "المجموعة",
      locationPlaceholder: "أضف مدينة أو دولة",
      starredOnly: "المميزة بنجمة فقط",
      apply: "تطبيق الفلاتر",
      allFilters: "جميع الفلاتر",
    },
    addSheet: {
      title: "إضافة إلى المكتبة",
      featuredTitle: "قاعدة بيانات Tabbio",
      featured: "مميز",
      featuredSubtitle: "ابحث في ملفات المرشحين على Tabbio",
      uploadCv: "رفع سيرة ذاتية",
      uploadCvSubtitle: "أضف ملف PDF أو DOCX من جهازك",
      emailForward: "إعادة توجيه البريد",
      emailUnavailable: "عنوان إعادة التوجيه غير متاح",
      emailUnavailableTitle: "عنوان إعادة التوجيه غير متاح",
      emailNotConfigured: "إعداد إعادة التوجيه مطلوب",
      emailNotConfiguredTitle: "إعادة توجيه البريد تحتاج إلى إعداد",
      emailNotConfiguredMessage:
        "قم بإعداد نطاق السير الذاتية الوارد وWebhook الخاص بـ SendGrid Parse قبل مشاركة هذا العنوان.",
      emailCopiedTitle: "تم نسخ العنوان",
      emailCopiedMessage:
        "شارك هذا العنوان لاستقبال السير الذاتية داخل المكتبة.",
      emailSharedTitle: "تمت مشاركة العنوان",
      emailSharedMessage: "أصبح عنوان إعادة التوجيه جاهزاً للإرسال.",
    },
    jobs: {
      emptyTitle: "لا توجد وظائف نشطة بعد",
      emptySubtitle: "انشر أول وظيفة مباشرة وستظهر طلباتها هنا.",
    },
    roleActions: {
      title: "إجراءات الدور",
      editRole: "تعديل تفاصيل الدور",
      pauseRole: "تبديل الحالة (إيقاف)",
      activateRole: "تبديل الحالة (تفعيل)",
      deleteRole: "حذف الدور",
      updatedTitle: "تم تحديث الدور",
      errorTitle: "تعذر تحديث الدور",
      nameLabel: "اسم الدور",
      namePlaceholder: "حدّث اسم الدور",
    },
    upload: {
      successTitle: "تم رفع السيرة الذاتية",
      successMessage: "أصبح المرشح متاحاً الآن في مكتبتك.",
      errorTitle: "تعذر رفع السيرة الذاتية",
      uploading: "جارٍ الرفع...",
      processingTitle: "جارٍ رفع السيرة الذاتية إلى المكتبة",
      processingMessage:
        "يرجى الانتظار بينما نقوم بتحليل السيرة وإنشاء ملف المرشح.",
      parsingPill: "جارٍ معالجة السيرة الذاتية…",
      parsingFailedPill: "تعذرت معالجة السيرة الذاتية",
    },
    collections: {
      createTitle: "إنشاء مجموعة",
      createAction: "إنشاء المجموعة",
      nameLabel: "اسم المجموعة",
      namePlaceholder: "مثال: مرحلة المقابلة النهائية",
      descriptionLabel: "الوصف",
      descriptionPlaceholder: "ملاحظات اختيارية لفريقك...",
      candidateCount: "{{count}} مرشحين",
      emptyTitle: "لا توجد مجموعات بعد",
      emptySubtitle: "أنشئ مجموعة لتنظيم المرشحين بشكل داخلي.",
      emptyCandidatesTitle: "لا يوجد مرشحون في هذه المجموعة",
      emptyCandidatesSubtitle:
        "أضف مرشحين إلى هذه المجموعة للحفاظ على تنظيم القائمة.",
      requiredTitle: "اسم المجموعة مطلوب.",
      createdTitle: "تم إنشاء المجموعة",
      createdMessage: "يمكنك الآن البدء بإضافة المرشحين إليها.",
      errorTitle: "تعذر تحديث المجموعات",
      manageTitle: "إدارة المجموعات",
      manageDescription:
        "اختر المجموعات الخاصة التي يجب أن يظهر فيها هذا المرشح.",
      manageCandidatesTitle: "إدارة المرشحين",
      manageCandidatesDescription:
        "اختر مرشحي المكتبة الذين يجب أن ينتموا إلى {{name}}.",
      manageCandidatesAction: "إدارة المرشحين",
      savedTitle: "تم تحديث المجموعات",
    },
    roleOverview: {
      sectionTitle: "نظرة عامة على الدور",
      lastApplicantAt: "آخر متقدم",
      lastApplicantNone: "لا يوجد متقدمون بعد",
      tiles: {
        applicants: "المتقدمون",
        savedCandidates: "مرشحون محفوظون",
        shortlisted: "في القائمة المختصرة",
        contacted: "تم التواصل معهم",
        highMatchNotContacted: "تطابق عالٍ ولم يتم التواصل",
        recentActivity: "النشاط الأخير",
        savedSearches: "عمليات البحث المحفوظة",
      },
    },
    savedSearches: {
      sectionTitle: "عمليات البحث المحفوظة",
      emptyTitle: "لا توجد عمليات بحث محفوظة بعد",
      emptySubtitle: "احفظ تركيبة فلاتر من صفحة المرشحين لاستدعائها لاحقاً.",
      savingState: "جارٍ الحفظ…",
      savedTitle: "تم حفظ البحث",
      savedAsMessage: 'تم الحفظ باسم "{{name}}". افتحه من شاشة المكتبة.',
      saveErrorTitle: "تعذر حفظ البحث",
      deleteAction: "حذف",
      deletedTitle: "تم حذف البحث المحفوظ",
      filtersSummary: {
        empty: "لا توجد فلاتر",
        location: "{{count}} مواقع",
        location_one: "موقع واحد",
        skill: "{{count}} مهارات",
        skill_one: "مهارة واحدة",
        company: "{{count}} شركات",
        company_one: "شركة واحدة",
      },
    },
    status: {
      shortlisted: "مختصر",
      rejected: "مرفوض",
    },
    star: {
      savedTitle: "تم تمييز المرشح",
      removedTitle: "تمت إزالة التمييز",
    },
    reject: {
      confirmTitle: "رفض المرشح؟",
      confirmMessage: "سيتم تعليم هذا المرشح كمرفوض داخل مكتبتك.",
      successTitle: "تم رفض المرشح",
    },
    shortlists: {
      savedTitle: "تمت إضافة المرشح إلى القائمة المختصرة",
      errorTitle: "تعذر تحديث القائمة المختصرة",
      addedState: "تمت الإضافة",
    },
    profile: {
      summary: "الملخص",
      roles: "الأدوار",
      collections: "المجموعات",
      experience: "الخبرة",
      education: "التعليم",
      documents: "المستندات",
      noSummary: "لا يوجد ملخص متاح بعد.",
      noRoles: "هذا المرشح غير مرتبط بدور بعد.",
      noCollections: "هذا المرشح ليس ضمن أي مجموعة بعد.",
      noExperience: "لم يتم تحليل الخبرات بعد.",
      noEducation: "لم يتم تحليل التعليم بعد.",
      noDocuments: "لا توجد مستندات مرفوعة بعد.",
      roleActive: "دور نشط",
      rolePaused: "دور متوقف",
      locationUnknown: "الموقع غير متوفر",
    },
    cvSnippet: {
      title: "مقتطف معاينة السيرة",
      mostRecent: "الأحدث",
    },
    cvSheet: {
      title: "معاينة السيرة الكاملة",
      placeholder:
        "هذه معاينة ثابتة حالياً. سيتم ربط عرض السيرة الكاملة والتنزيل في المرحلة القادمة.",
      noDocumentPreview: "لا توجد معاينة مستخرجة لهذا الملف بعد.",
    },
    empty: {
      title: "لا يوجد مرشحون",
      subtitle: "جرّب تعديل البحث أو الفلاتر أو الدور المحدد.",
    },
    projects: {
      title: "المشاريع",
      subtitle: "مساحات عمل للأدوار التي توظّف لها حالياً.",
      sectionLabel: "المشاريع",
      newProject: "مشروع جديد",
      empty: {
        title: "لا توجد مشاريع بعد",
        subtitle: "أنشئ مشروعاً لإدارة المرشحين عبر مسار التوظيف.",
      },
      detailEmpty: {
        title: "لا يوجد مرشحون في هذا المشروع بعد",
        subtitle: "أضف مرشحين من المكتبة لبدء مسار التوظيف.",
      },
      error: {
        title: "تعذّر تحميل المشاريع",
        subtitle: "حدث خطأ ما. أعد المحاولة.",
        retry: "إعادة المحاولة",
      },
      candidateCount: "{{count}} مرشح",
      stageCount: "{{stage}}: {{count}}",
      tabs: {
        overview: "نظرة عامة",
        talentPool: "حوض المواهب",
        pipeline: "مسار التوظيف",
        jobPost: "إعلان الوظيفة",
        settings: "الإعدادات",
      },
      overview: {
        totalCandidates: "المرشحون",
        stageBreakdown: "تفصيل المسار",
        linkedJob: "الوظيفة المرتبطة",
        noLinkedJob: "لا توجد وظيفة مرتبطة",
      },
      jobPost: {
        empty: {
          title: "لا توجد وظيفة مرتبطة بهذا المشروع",
          subtitle: "اربط إعلان وظيفة لعرض المتقدمين هنا.",
        },
        viewJob: "عرض الوظيفة",
      },
      settings: {
        nameLabel: "اسم المشروع",
        namePlaceholder: "مثال: توظيف مهندس واجهة أمامية للربع الثالث",
        descriptionLabel: "الوصف",
        descriptionPlaceholder:
          "سبب التوظيف ومعايير النجاح والمتطلبات الأساسية...",
        statusLabel: "الحالة",
        statusActive: "نشط",
        statusArchived: "مؤرشف",
        save: "حفظ التغييرات",
        deleteProject: "حذف المشروع",
        deleteConfirm: "هل تريد حذف هذا المشروع؟ سيبقى المرشحون في مكتبتك.",
      },
      create: {
        title: "إنشاء مشروع",
        submit: "إنشاء المشروع",
        nameLabel: "اسم المشروع",
        namePlaceholder: "مثال: توظيف مهندس أول",
        descriptionLabel: "الوصف (اختياري)",
        descriptionPlaceholder: "سياق هذا التوظيف...",
        requiredName: "اسم المشروع مطلوب.",
      },
      pipeline: {
        moveTo: "نقل إلى",
        stages: {
          inbox: "الواردة",
          screening: "الفرز",
          interview: "المقابلة",
          offer: "العرض",
          hired: "تم التعيين",
          rejected: "مرفوض",
        },
      },
    },
    onboarding: {
      title: "ابدأ هنا",
      subtitle: "جهّز مساحة عمل التوظيف خلال أربع خطوات سريعة.",
      steps: {
        importCvs: {
          title: "استيراد السير الذاتية",
          subtitle: "ارفع سير المرشحين إلى مكتبتك.",
        },
        setForwarding: {
          title: "إعداد إعادة توجيه البريد",
          subtitle: "استيراد تلقائي للمرشحين من بريدك.",
        },
        createProject: {
          title: "إنشاء مشروع",
          subtitle: "نظّم المرشحين حسب الدور.",
        },
        shortlist: {
          title: "إنشاء قائمة مختصرة",
          subtitle: "شارك المرشحين مع أصحاب القرار لجمع الملاحظات.",
        },
      },
      progressLabel: "{{done}} من {{total}} مكتمل",
    },
    forwarding: {
      readiness: {
        not_set: {
          title: "إعداد إعادة توجيه البريد",
          subtitle: "استيراد تلقائي لسير المرشحين من بريدك.",
        },
        partial: {
          title: "تم إعداد إعادة التوجيه",
          subtitle: "بانتظار أول بريد مُعاد توجيهه.",
        },
        active: {
          title: "إعادة التوجيه نشطة",
          subtitle: "تتم إضافة المرشحين من الرسائل المُعاد توجيهها إلى مكتبتك.",
        },
      },
    },
    spotlights: {
      open_to_work: "متاح للعمل",
      past_applicant: "متقدم سابق",
      strong_skills: "مهارات قوية",
      recently_active: "نشط مؤخراً",
      needs_review: "بحاجة للمراجعة",
    },
    boolFilters: {
      skill: "المهارة",
      jobTitle: "المسمى الوظيفي",
      company: "الشركة",
      location: "الموقع",
      experience: "الخبرة",
      education: "التعليم",
      language: "اللغة",
      openToWork: "متاح للعمل",
      pastApplicant: "متقدم سابق",
    },
  },

  shortlists: {
    title: "القوائم المختصرة",
    searchPlaceholder: "ابحث في القوائم المختصرة...",
    meta: {
      candidates: "{{count}} مرشحين",
    },
    empty: {
      title: "لا توجد قوائم مختصرة بعد",
      subtitle: "أنشئ أول قائمة مختصرة لبدء جمع ملاحظات المراجعين.",
    },
    actions: {
      add: "إضافة",
      addCandidates: "إضافة مرشحين",
      save: "حفظ",
      deleteShortlist: "حذف القائمة المختصرة",
      startReviewing: "ابدأ المراجعة",
      loginWithTabbio: "تسجيل الدخول عبر Tabbio",
      pass: "رفض",
      shortlist: "اختيار",
      submitReview: "إرسال المراجعة",
    },
    create: {
      title: "إنشاء قائمة مختصرة",
      nameLabel: "اسم القائمة المختصرة",
      namePlaceholder: "مثال: مرشحو الواجهة الأمامية Q3",
      descriptionLabel: "الوصف (اختياري)",
      descriptionPlaceholder: "سياق يهم مدير التوظيف...",
      submit: "إنشاء القائمة المختصرة",
      requiredName: "اسم القائمة المختصرة مطلوب.",
    },
    edit: {
      title: "تعديل القائمة المختصرة",
      nameLabel: "الاسم",
      descriptionLabel: "الوصف",
      jobDescriptionLabel: "الوصف الوظيفي",
      jobDescriptionHint: "اختياري · يفعّل نسبة التطابق",
      pickRolePlaceholder: "اختر من الأدوار النشطة...",
      pastePlaceholder: "أو الصق يدوياً...",
      deleteTitle: "حذف القائمة المختصرة؟",
      deleteMessage: "لا يمكن التراجع عن هذا الإجراء.",
    },
    addCandidates: {
      title: "إضافة مرشحين",
      searchPlaceholder: "ابحث عن المرشحين...",
      apply: "تطبيق ({{count}})",
      empty: "لا يوجد مرشحون مطابقون",
    },
    detail: {
      linkCopied: "تم نسخ الرابط",
      linkCopyFailed: "تعذر نسخ الرابط",
      feedback: "الملاحظات",
      feedbackSummary: "{{reviewers}} مراجعين · {{reviews}} مراجعات",
      yesCount: "{{count}} نعم",
      noCount: "{{count}} لا",
      yes: "نعم",
      no: "لا",
      candidatesCount: "المرشحون ({{count}})",
      noCandidates: "لا يوجد مرشحون بعد",
      noCandidatesSubtitle: "أضف مرشحين من مكتبتك للبدء",
    },
    public: {
      by: "بواسطة",
      namePlaceholder: "أدخل اسمك للانضمام...",
      or: "أو",
      poweredBy: "مدعوم بواسطة",
      enterNameRequired: "يرجى إدخال الاسم للمتابعة.",
      reviewUnavailable: "هذه القائمة غير متاحة للمراجعة حالياً.",
      loginPlaceholder: "سيتم ربط تسجيل الدخول في المرحلة القادمة.",
    },
    review: {
      notePlaceholder: "أضف ملاحظة...",
      sections: {
        experience: "الخبرة",
        education: "التعليم",
        skills: "المهارات",
      },
    },
    confirm: {
      title: "تأكيد المراجعة",
      shortlisted: "مختار",
      passed: "مرفوض",
      sectionShortlisted: "المختارون",
      noNote: "بدون ملاحظة",
      noShortlisted: "لا يوجد مرشحون مختارون بعد",
      reviewingAs: "تتم المراجعة باسم {{name}}",
    },
    time: {
      justNow: "الآن",
      minutesAgo: "قبل {{count}} د",
      hoursAgo: "قبل {{count}} س",
      daysAgo: "قبل {{count}} ي",
      weeksAgo: "قبل {{count}} أ",
    },
  },

  // Automation
  autoApply: {
    title: "الأتمتة",
    subtitle:
      "راجع أتمتة البحث عن الوظائف والفحوصات المجدولة وإشارات الوكيل. التقديم يبقى بيدك.",
    lastRun: "آخر فحص:",
    never: "أبداً",
    loading: "جارٍ تحميل الأتمتة...",
    loadFailed: "تعذر تحميل الأتمتة",
    summaryTitle: "نظرة عامة على الأتمتة",
    summaryBody:
      "{{enabledCount}} من أصل {{totalCount}} إشارات مطابقة تراقب الفرص. آخر فحص {{latestRun}}. كل فرصة تبقى للمراجعة أولاً.",
    rulesTitle: "إشارات المطابقة",
    rulesBody:
      "هذه التفضيلات توجه ما يعرضه Tabbio. لا يتم إرسال طلبات تلقائياً.",
    metrics: {
      enabled: "الإشارات المفعّلة",
      queue: "للمراجعة",
      recent: "مطابقات حديثة",
    },
    queueTitle: "قائمة المراجعة",
    queueBody: "يوجد {{count}} وظائف مطابقة بانتظار مراجعتك",
    queueCount: "الطابور: {{count}}",
    enabledCount: "المفعّل: {{count}}",
    enabled: "الإشارة تراقب",
    disabled: "الإشارة متوقفة",
    runNow: "تحديث المطابقات",
    runStarted: "بدأ تحديث المطابقات",
    updateFailed: "تعذر تحديث هذه الإشارة",
    runFailed: "تعذر تحديث المطابقات",
    matchWatching: "تراقب",
    matchPaused: "متوقفة",
    reviewFirst: "مراجعة أولاً",
    activityTitle: "النشاط الأخير",
    activityBody: "آخر المطابقات وتغييرات حالة المراجعة والتنبيهات",
    activityEmptyTitle: "لا يوجد نشاط حديث",
    activityEmptyBody:
      "ستظهر هنا الوظائف المطابقة الجديدة عندما تجد الأتمتة فرصة قوية.",
    activityCount: "آخر {{count}}",
    activityMatchScore: "مطابقة {{score}}",
    activityLastUpdated: "تم التحديث {{time}}",
    activityReasons: "سبب التطابق: {{reasons}}",
    activityChannels: "تم التنبيه عبر {{channels}}",
    activityDismissed: "تم الإخفاء",
    activityDismissFailed: "تعذر إخفاء هذا النشاط",
    openJob: "فتح الوظيفة",
    dismiss: "إخفاء",
    daily: "يومي",
    weekly: "أسبوعي",
    instant: "فوري",
    monthly: "شهري",
    counts: {
      matched: "مطابق",
      eligibleAutoApply: "جاهز",
      needsReview: "يحتاج مراجعة",
      autoApplied: "تمت المراجعة",
      skipped: "تم التخطي",
      failed: "فشل",
      dismissed: "مخفي",
    },
    activityStatuses: {
      matched: "مطابق",
      eligibleAutoApply: "جاهز للمراجعة",
      needsReview: "يحتاج مراجعة",
      autoApplied: "تمت المراجعة",
      skipped: "تم التخطي",
      failed: "فشل",
      dismissed: "مخفي",
    },
    settings: {
      minMatchScore: "درجة مطابقة {{count}}%",
      sources: "{{count}} من المصادر",
      locations: "{{count}} من المواقع",
      workModes: "{{count}} من أنماط العمل",
      employmentTypes: "{{count}} من أنواع التوظيف",
      pushEnabled: "تنبيهات فورية",
      emailDigestEnabled: "ملخص عبر البريد",
      digestHourLocal: "الملخص عند {{time}}",
    },
    jobAlerts: "تنبيهات الوظائف الجديدة",
    jobAlertsDesc: "احصل على إشعار عند تطابق وظائف جديدة مع ملفك الشخصي",
    jobAlertsResult: "٣ وظائف جديدة",
    autoApplyMatches: "الأتمتة",
    autoApplyMatchesDesc:
      "يعثر على الوظائف عالية الملاءمة ويُبقي كل مطابقة جاهزة للمراجعة قبل أن تقدم",
    autoApplyMatchesResult: "مطابقتان جاهزتان",
    marketReport: "تقرير السوق الأسبوعي",
    marketReportDesc: "ملخص اتجاهات سوق العمل في مجالك",
    marketReportResult: "تم تسليم التقرير",
    profileViewAlerts: "تنبيهات مشاهدة الملف",
    profileViewAlertsDesc:
      "احصل على إشعار عند مشاهدة أصحاب العمل لسيرتك الذاتية",
    profileViewAlertsResult: "ADNOC شاهد ملفك الشخصي",
    salaryInsights: "رؤى الرواتب",
    salaryInsightsDesc: "مقارنة رواتب شهرية لأدوارك المستهدفة",
  },

  // Analytics
  analytics: {
    title: "المشاهدات",
    personalSubtitle: "تابع أداء ملفك العام وأين تكتشفك الشركات.",
    employerTitle: "مشاهدات الشركة",
    employerSubtitle:
      "قِس اهتمام الزوار بصفحة الشركة وصحة مسار التوظيف وأداء اكتشاف المواهب.",
    period7d: "٧ أيام",
    period30d: "٣٠ يوم",
    periodAll: "كل الوقت",
    heroSummary7d: "آخر ٧ أيام",
    heroSummary30d: "آخر ٣٠ يوم",
    heroSummaryAll: "كل الوقت",
    retry: "إعادة المحاولة",
    errorTitle: "تعذر تحميل المشاهدات",
    errorSubtitle: "حدّث الصفحة لجلب أحدث البيانات من الخادم.",
    overviewTab: "نظرة عامة",
    talentTab: "المواهب",
    jobsTab: "الوظائف",
    publicProfileSection: "الملف العام",
    publicProfileSectionSubtitle:
      "هذه الأرقام تأتي من مشاهدات وأنشطة نقر يتم تتبعها من الخادم على صفحتك العامة.",
    publicProfile: "الملف العام",
    publicCv: "السيرة العامة",
    privateShareLink: "رابط مشاركة خاص",
    publicEngagementSection: "التفاعل",
    recentPublicActivity: "النشاط العام الأخير",
    discoverabilitySection: "الظهور والاكتشاف",
    discoverabilitySectionSubtitle:
      "اعرف كم مرة ظهرت في بحث أصحاب العمل وكم مرة فتحوا ملفك بعد البحث.",
    discoverability: "الظهور",
    companyPageSection: "صفحة الشركة",
    companyPageSectionSubtitle:
      "تابع كيف تتحول زيارات صفحة الشركة العامة إلى نقرات على الوظائف واهتمام بالمواهب.",
    companyPage: "صفحة الشركة",
    talentSection: "اكتشاف المواهب",
    talentSectionSubtitle:
      "افهم ما الذي بحث عنه أصحاب العمل ومن قاموا بفتحه وأي المرشحين تقدّموا في المسار.",
    jobsSection: "أداء الوظائف",
    jobsSectionSubtitle:
      "رتّب الوظائف التي تجذب الانتباه وتتحول إلى طلبات تقديم.",
    jobPerformanceSection: "أداء الوظيفة",
    jobPerformanceSectionSubtitle:
      "يتم حساب هذا المسار من أحداث نقاط النهاية وعمليات التقديم على الخادم.",
    views: "المشاهدات",
    clicks: "النقرات",
    ctr: "نسبة النقر",
    pageViews: "مشاهدات الصفحة",
    cvViews: "مشاهدات السيرة",
    shareLinkViews: "مشاهدات روابط المشاركة",
    uniqueVisitors: "زوار فريدون",
    uniqueViewers: "مشاهدون فريدون",
    ctaClicks: "نقرات الدعوة للإجراء",
    contactClicks: "نقرات التواصل",
    downloads: "التنزيلات",
    shares: "المشاركات",
    publicCtaClicks: "نقرات الدعوات العامة",
    publicJobClicks: "نقرات الوظائف العامة",
    jobViews: "مشاهدات الوظيفة",
    applyIntents: "نوايا التقديم",
    applications: "طلبات التقديم",
    searches: "عمليات البحث",
    searchMatches: "مرات الظهور في البحث",
    profileViews: "مشاهدات الملف",
    uniqueCompanies: "شركات فريدة",
    conversionRate: "معدل التحويل",
    shortlisted: "تم إدراجهم",
    starred: "مميز",
    rejected: "مرفوض",
    pageViewsHelper: "كل مشاهدة تم تتبعها من الخادم على ملفك.",
    uniqueVisitorsHelper: "زوار بدون تكرار ضمن الفترة المحددة.",
    uniqueViewersHelper: "مشاهدون بدون تكرار لهذه الوظيفة ضمن الفترة المحددة.",
    ctaClicksHelper: "نقرات على الدعوات القابلة للتتبع من ملفك.",
    publicCtaClicksHelper: "نقرات على روابط الدعوة في صفحة الشركة.",
    publicJobClicksHelper: "نقرات من صفحة الشركة إلى الوظائف المفتوحة.",
    companyPageViewsHelper: "مشاهدات تم التقاطها عبر بكسل العرض في الخادم.",
    jobViewsHelper: "فتح صفحة تفاصيل الوظيفة المسجل في الخادم.",
    applyIntentsHelper: "أحداث التحضير أو فتح التقديم قبل الإرسال.",
    applicationsHelper: "طلبات التقديم الأصلية المكتملة.",
    searchesHelper: "عمليات بحث أصحاب العمل المسجلة في مسارات المواهب.",
    searchMatchesHelper: "عدد مرات ظهور ملفك في نتائج بحث أصحاب العمل.",
    profileViewsHelper: "مرات فتح الملف المنسوبة إلى الاكتشاف.",
    uniqueCompaniesHelper: "أصحاب عمل مختلفون بحثوا عنك أو فتحوا ملفك.",
    shortlistedHelper: "مرشحون تم نقلهم إلى القوائم المختصرة خلال هذه الفترة.",
    starredHelper: "مرشحون تم تمييزهم للمتابعة خلال هذه الفترة.",
    rejectedHelper: "مرشحون تم استبعادهم من الاعتبار خلال هذه الفترة.",
    conversionRateHelper:
      "طلبات التقديم مقسومة على نوايا التقديم، أو على المشاهدات إذا لم توجد نوايا.",
    viewsOverTime: "المشاهدات عبر الزمن",
    profileViewsChart: "مشاهدات الملف عبر الزمن",
    profileViewsChartSubtitle:
      "المشاهدات العامة لملفك التي تم تتبعها من الخادم ضمن الفترة المحددة.",
    companyPageViewsChart: "مشاهدات صفحة الشركة عبر الزمن",
    companyPageViewsChartSubtitle:
      "مشاهدات صفحة الشركة العامة التي تم تتبعها من الخادم.",
    searchMatchesChart: "الظهور في البحث عبر الزمن",
    searchMatchesChartSubtitle: "متى ظهر ملفك في عمليات بحث أصحاب العمل.",
    candidateViewsChart: "مشاهدات المرشح عبر الزمن",
    candidateViewsChartSubtitle: "فتح الملف بعد اكتشاف المرشح أو البحث عنه.",
    jobViewsChart: "مشاهدات الوظيفة عبر الزمن",
    jobViewsChartSubtitle: "مشاهدات تفاصيل الوظيفة خلال الفترة المحددة.",
    applyIntentsChart: "نوايا التقديم عبر الزمن",
    applyIntentsChartSubtitle: "خطوات التحضير أو الفتح قبل الإرسال.",
    applicationsChart: "طلبات التقديم عبر الزمن",
    applicationsChartSubtitle: "طلبات التقديم الأصلية المرسلة لهذه الوظيفة.",
    topLinks: "أهم الروابط",
    trafficSources: "مصادر الزيارات",
    devices: "الأجهزة",
    topCountries: "أهم الدول",
    topSources: "أهم المصادر",
    topLocations: "أهم المواقع",
    topCvTargets: "أهم السير",
    topKeywords: "أهم الكلمات المفتاحية",
    topKeywordsSubtitle:
      "مصطلحات البحث الأكثر ارتباطًا بالاكتشاف وفتح الملفات.",
    recentActivity: "أحدث نشاط للشركات",
    recentActivitySubtitle:
      "آخر الشركات التي طابقت ملفك في البحث ثم فتحت ملفك.",
    topApplicants: "أفضل المتقدمين",
    topApplicantsSubtitle:
      "يتم ترتيبهم بحسب مرحلة الطلب والقائمة المختصرة ودرجة المطابقة والحداثة.",
    topCandidates: "أهم المرشحين",
    topCandidatesSubtitle:
      "المرشحون الذين تم التفاعل معهم أكثر خلال هذه الفترة.",
    topJobs: "أفضل الوظائف",
    topJobsSubtitle:
      "الوظائف التي حققت أفضل مزيج من المشاهدات ونية التقديم وطلبات التقديم المكتملة.",
    jobsPerformanceTitle: "مسار التوظيف",
    jobsPerformanceSubtitle: "مؤشرات عامة لمسار الوظائف خلال الفترة الحالية.",
    jobFunnelTitle: "مسار الوظيفة",
    jobFunnelSubtitle: "كيف تقدم الزوار من المشاهدة حتى التقديم.",
    talentFunnelTitle: "مسار المواهب",
    talentFunnelSubtitle: "كيف تحرك اكتشاف أصحاب العمل المرشحين داخل المسار.",
    candidateFeedTitle: "تغذية ظهور المرشحين",
    candidateFeedSubtitle:
      "مساحة مخصصة لملخصات ظهور المرشح من جهة المرشح حين يتم إتاحتها في تحليلات الشركة.",
    jobApplicantsSubtitle:
      "المتقدمون المرتبون لهذه الوظيفة وفق قواعد الترتيب في تحليلات الخادم.",
    emptyKeywordsTitle: "لا توجد بيانات كلمات مفتاحية بعد",
    emptyKeywordsSubtitle:
      "ستظهر تحليلات الكلمات عندما يبحث أصحاب العمل عنك أو عن مرشحيك.",
    emptyPublicSourcesTitle: "لا توجد بيانات مصادر بعد",
    emptyPublicSourcesSubtitle:
      "ستظهر المصادر بعد تتبع زيارات الملف أو السيرة أو روابط المشاركة.",
    emptyPublicLocationsTitle: "لا توجد بيانات مواقع بعد",
    emptyPublicLocationsSubtitle:
      "تظهر المواقع عندما يرسل مزود الاستضافة بيانات جغرافية الزائر.",
    emptyPublicCvTargetsTitle: "لا توجد بيانات للسير بعد",
    emptyPublicCvTargetsSubtitle:
      "سيظهر وصول كل سيرة بعد فتح الزوار للسيرة العامة أو روابط المشاركة الخاصة.",
    emptyPublicActivityTitle: "لا يوجد نشاط عام بعد",
    emptyPublicActivitySubtitle:
      "ستظهر هنا المشاهدات ونقرات التواصل والتنزيلات والمشاركات عند تفاعل الزوار.",
    anonymousVisitor: "زائر مجهول",
    publicEventView: "تمت المشاهدة",
    publicEventShare: "تمت المشاركة",
    publicEventCta: "نقرة دعوة",
    publicEventBlock: "نقرة قسم",
    publicEventJobApply: "نقرة وظيفة",
    publicEventContact: "نقرة تواصل",
    publicEventDownload: "تم التنزيل",
    emptyActivityTitle: "لا يوجد نشاط شركات بعد",
    emptyActivitySubtitle:
      "سيظهر هنا نشاط البحث وفتح الملفات من الشركات عند حدوثه.",
    emptyApplicantsTitle: "لا يوجد متقدمون بعد",
    emptyApplicantsSubtitle:
      "سيظهر المتقدمون هنا عندما تبدأ هذه الوظيفة باستقبال الطلبات.",
    emptyCandidatesTitle: "لا يوجد تفاعل مع المرشحين بعد",
    emptyCandidatesSubtitle:
      "ستمتلئ هذه القائمة عند مشاهدة المرشحين أو تمييزهم أو رفضهم أو إضافتهم للقوائم المختصرة.",
    emptyCandidateFeedTitle: "لا توجد تغذية ظهور للمرشحين بعد",
    emptyCandidateFeedSubtitle:
      "ستمتلئ هذه المساحة عندما تصبح ملخصات ظهور المرشح متاحة في تحليلات الشركة.",
    emptyJobsTitle: "لا توجد وظائف متتبعة بعد",
    emptyJobsSubtitle:
      "ستظهر تحليلات الوظائف عندما تستقبل وظائفك المنشورة مشاهدات أو طلبات تقديم.",
    emptyJobFunnelTitle: "لا توجد بيانات لمسار الوظائف بعد",
    emptyJobFunnelSubtitle:
      "انشر وظائف ووجّه الزيارات لبدء تعبئة مسار الوظائف.",
    emptyTalentFunnelTitle: "لا توجد بيانات لمسار المواهب بعد",
    emptyTalentFunnelSubtitle:
      "ابحث عن المرشحين أو افتحهم أو أضفهم للقوائم المختصرة لملء مسار المواهب.",
    candidateVisibilityTitle: "يتم تتبع الظهور من الخادم",
    candidateVisibilitySubtitle:
      "مرات الظهور في البحث وفتح الشركات للملف ونقرات الدعوات تظل مرتبطة بتحليلات على مستوى نقاط النهاية.",
    noRecentActivity: "لا يوجد نشاط حديث",
    unknownCompany: "شركة غير معروفة",
    viewedProfile: "تم فتح الملف",
    matchedOnly: "مطابقة فقط",
    noApplicantTitle: "لا يوجد مسمى",
    noKeywordsYet: "لا توجد كلمات بعد",
    latestCompanyFallback: "آخر شركة غير متاحة",
    rejectedLabel: "مرفوض",
    starredLabel: "مميز",
    shortlistedLabel: "ضمن المختصر",
    viewedLabel: "تمت المشاهدة",
    jobDetailTitle: "تحليلات الوظيفة",
    jobDetailSubtitle:
      "افحص مسار هذه الوظيفة من المشاهدة حتى نية التقديم والطلبات المرسلة.",
    totalPoints: "{{count}} نقطة إجمالية",
    totalViewsLabel: "{{count}} مشاهدة",
    totalMatchesLabel: "{{count}} مطابقة",
    totalSearchesLabel: "{{count}} بحث",
    totalApplicationsLabel: "{{count}} طلب تقديم",
    totalApplyIntentsLabel: "{{count}} نية تقديم",
    keywordRow: "{{searches}} عمليات بحث · {{views}} مشاهدات ملف",
    activityRow: "ظهر مع “{{keyword}}” في {{matchedAt}}",
    funnelCountLabel: "{{count}} حدث",
    conversionValue: "{{value}} تحويل",
    topApplicantMeta: "{{job}} · {{updatedAt}}",
    topCandidateMeta: "{{views}} مشاهدات · {{shortlists}} إجراءات قائمة مختصرة",
    topJobMeta:
      "{{views}} مشاهدات · {{applyIntents}} نوايا · {{applications}} طلبات",
    candidateFeedMeta:
      "{{matches}} مرات ظهور · {{views}} مشاهدات · {{companies}} شركات",
    matchScoreValue: "{{value}} مطابقة",
    jobDetailMeta: "الحالة الحالية: {{status}}",
    mobile: "الجوال",
    desktop: "الحاسوب",
    direct: "مباشر",
    linkedin: "LinkedIn",
    instagram: "Instagram",
    whatsapp: "WhatsApp",
    other: "أخرى",
  },

  entitlementGate: {
    eyebrowPlus: "تتطلب خطة Plus",
    eyebrowPro: "تتطلب خطة Pro",
    titlePlus: "ميزة Plus",
    titlePro: "ميزة Pro",
    descriptionPlus: "متاح على Plus وما فوق. قم بالترقية لفتح هذه الميزة.",
    descriptionPro: "متاح على Pro وما فوق. قم بالترقية لفتح هذه الميزة.",
    ctaUpgradeIndividualPlus: "الترقية إلى Plus",
    ctaUpgradeIndividualPro: "الترقية إلى Pro",
    ctaUpgradeEmployerPlus: "ترقية مساحة العمل إلى Plus",
    ctaUpgradeEmployerPro: "ترقية مساحة العمل إلى Pro",
    loading: "جارٍ فحص الاشتراك…",
    resourcesTitle: "ما الذي ستحصل عليه",
    resourcesSubtitle:
      "كل إجراء مدفوع يعيد مخرجاً محفوظاً، وليس مجرد رد دردشة.",
    benefits: {
      careerArtifacts: {
        title: "تقارير مهنية منظمة",
        body: "درجات ملاءمة السيرة، المهارات الناقصة، مخاطر مسؤول التوظيف، والخطوات التالية محفوظة في التطبيق.",
      },
      applicationPack: {
        title: "مواد جاهزة للتقديم",
        body: "خطابات تغطية، إجابات فرز، تحضير مقابلات، إرشاد رواتب، وقوائم مراجعة للتقديم.",
      },
      marketPrep: {
        title: "سياق مخصص للخليج",
        body: "الدور، الدولة، المستوى، وإشارات السوق تؤثر في النتيجة قبل التوليد.",
      },
      employerReach: {
        title: "أدوات توظيف خاصة",
        body: "افتح سير عمل مسؤولي التوظيف، أدلة المرشحين، وإجراءات التوظيف داخل مساحة العمل.",
      },
      employerRanking: {
        title: "قرارات مرشحين أفضل",
        body: "استخدم ترتيب الذكاء الاصطناعي، إشارات الملف الأعمق، وسياق القوائم المختصرة للتحرك أسرع.",
      },
      employerWorkflow: {
        title: "سير عمل محفوظ للفريق",
        body: "نظّم أعمال التوظيف عبر المكتبة، القوائم المختصرة، التواصل، والمراجعات.",
      },
    },
  },

  // Upgrade / Paywall
  upgrade: {
    screenTitle: "\u0627\u0644\u062a\u0631\u0642\u064a\u0629",
    tabPlus: "Plus",
    tabPro: "Pro",
    // Plan names stay Latin in the Arabic UI, as the tabs above do.
    lockBadge: {
      plus: "PLUS",
      pro: "PRO",
    },
    iconNote: "",
    featuresHeader: "\u0627\u0644\u0645\u0632\u0627\u064a\u0627",
    columnFree: "\u0645\u062c\u0627\u0646\u064a",
    columnPlus: "Plus",
    columnPro: "Pro",
    billingMonthly: "\u0634\u0647\u0631\u064a",
    billingYearly: "\u0633\u0646\u0648\u064a",
    billingYearlyBonus:
      "\u0634\u0647\u0631\u0627\u0646 \u0645\u062c\u0627\u0646\u064b\u0627",
    disclaimer:
      "\u064a\u062a\u062c\u062f\u062f \u062a\u0644\u0642\u0627\u0626\u064a\u0627\u064b. \u064a\u0645\u0643\u0646\u0643 \u0627\u0644\u0625\u0644\u063a\u0627\u0621 \u0641\u064a \u0623\u064a \u0648\u0642\u062a.",
    legalPrefix:
      "\u0628\u0627\u0644\u0627\u0634\u062a\u0631\u0627\u0643\u060c \u0623\u0646\u062a \u062a\u0648\u0627\u0641\u0642 \u0639\u0644\u0649",
    legalAnd: "\u0648",
    privacyPolicy:
      "\u0633\u064a\u0627\u0633\u0629 \u0627\u0644\u062e\u0635\u0648\u0635\u064a\u0629",
    termsOfUse:
      "\u0634\u0631\u0648\u0637 \u0627\u0644\u0627\u0633\u062a\u062e\u062f\u0627\u0645 (EULA)",
    legalSuffix: ".",
    ctaWord: "ترقية",
    continueFree: "المتابعة بالخطة المجانية",
    purchaseSuccess: "تم تحديث الاشتراك",
    purchaseFailed: "تعذر بدء الدفع",
    checkoutCanceled: "تم إلغاء الدفع",
    companyRequired: "يجب أن تكون داخل مساحة شركة للفوترة الخاصة بأصحاب العمل.",
    individual: {
      titlePlus: "مُخصّص لكل وظيفة",
      titlePro: "سلّم البحث إلى وكيلك",
      subtitlePlus: "",
      subtitlePro: "",
      ctaPlusMonthly:
        "\u062a\u0631\u0642\u064a\u0629 \u0628\u0640 $14.99/\u0634\u0647\u0631",
      ctaPlusYearly:
        "\u062a\u0631\u0642\u064a\u0629 \u0628\u0640 $9.99/\u0634\u0647\u0631",
      ctaProMonthly:
        "\u062a\u0631\u0642\u064a\u0629 \u0628\u0640 $29.99/\u0634\u0647\u0631",
      ctaProYearly:
        "\u062a\u0631\u0642\u064a\u0629 \u0628\u0640 $24.99/\u0634\u0647\u0631",
    },
    employer: {
      titlePlus: "\u0627\u062d\u0635\u0644 \u0639\u0644\u0649 Tabbio Plus",
      titlePro: "\u0627\u062d\u0635\u0644 \u0639\u0644\u0649 Tabbio Pro",
      subtitlePlus:
        "\u0648\u0638\u0651\u0641 \u0628\u0630\u0643\u0627\u0621 \u0644\u0627 \u0628\u062c\u0647\u062f",
      subtitlePro:
        "\u0623\u062a\u0645\u062a\u0629 \u0639\u0645\u0644\u064a\u0629 \u0627\u0644\u062a\u0648\u0638\u064a\u0641",
      ctaPlusMonthly:
        "\u062a\u0631\u0642\u064a\u0629 \u0628\u0640 $49.99/\u0645\u0642\u0639\u062f/\u0634\u0647\u0631",
      ctaPlusYearly:
        "\u062a\u0631\u0642\u064a\u0629 \u0628\u0640 $39.99/\u0645\u0642\u0639\u062f/\u0634\u0647\u0631",
      ctaProMonthly:
        "\u062a\u0631\u0642\u064a\u0629 \u0628\u0640 $99.99/\u0645\u0642\u0639\u062f/\u0634\u0647\u0631",
      ctaProYearly:
        "\u062a\u0631\u0642\u064a\u0629 \u0628\u0640 $79.99/\u0645\u0642\u0639\u062f/\u0634\u0647\u0631",
    },
    features: {
      moreAiUsage:
        "\u0627\u0633\u062a\u062e\u062f\u0627\u0645 \u0623\u0643\u062b\u0631 \u0644\u0644\u0630\u0643\u0627\u0621 \u0627\u0644\u0627\u0635\u0637\u0646\u0627\u0639\u064a",
      smarterAiModel: "نموذج ذكاء اصطناعي أذكى",
      downloadAnyFormat:
        "\u062a\u062d\u0645\u064a\u0644 \u0628\u0623\u064a \u0635\u064a\u063a\u0629",
      customBranding:
        "\u0639\u0644\u0627\u0645\u0629 \u062a\u062c\u0627\u0631\u064a\u0629 \u0645\u062e\u0635\u0635\u0629",
      fullAnalytics:
        "\u062a\u062d\u0644\u064a\u0644\u0627\u062a \u0643\u0627\u0645\u0644\u0629",
      higherVisibility:
        "\u0638\u0647\u0648\u0631 \u0623\u0639\u0644\u0649 \u0644\u0623\u0635\u062d\u0627\u0628 \u0627\u0644\u0639\u0645\u0644",
      everythingInPlus: "\u0643\u0644 \u0645\u0632\u0627\u064a\u0627 Plus",
      mostPowerfulAi: "نموذج الذكاء الاصطناعي الأكثر قدرة",
      extendedAgentMemory:
        "\u0630\u0627\u0643\u0631\u0629 \u0648\u0643\u064a\u0644 \u0645\u0645\u062a\u062f\u0629",
      doubleVisibility:
        "\u0636\u0639\u0641 \u0627\u0644\u0638\u0647\u0648\u0631 \u0644\u0623\u0635\u062d\u0627\u0628 \u0627\u0644\u0639\u0645\u0644",
      autopilotJobMatching:
        "\u0645\u0637\u0627\u0628\u0642\u0629 \u0648\u0638\u0627\u0626\u0641 \u062a\u0644\u0642\u0627\u0626\u064a\u0629",
      prioritySearchResults:
        "\u0623\u0648\u0644\u0648\u064a\u0629 \u0641\u064a \u0646\u062a\u0627\u0626\u062c \u0627\u0644\u0628\u062d\u062b",
      moreHiringPages:
        "\u0635\u0641\u062d\u0627\u062a \u062a\u0648\u0638\u064a\u0641 \u0648\u0625\u0639\u0644\u0627\u0646\u0627\u062a \u0623\u0643\u062b\u0631",
      aiCandidateRanking:
        "\u062a\u0631\u062a\u064a\u0628 \u0627\u0644\u0645\u0631\u0634\u062d\u064a\u0646 \u0628\u0627\u0644\u0630\u0643\u0627\u0621 \u0627\u0644\u0627\u0635\u0637\u0646\u0627\u0639\u064a",
      teamAnalytics:
        "\u062a\u062d\u0644\u064a\u0644\u0627\u062a \u0627\u0644\u0641\u0631\u064a\u0642",
      autopilotHiring:
        "\u062a\u0648\u0638\u064a\u0641 \u062a\u0644\u0642\u0627\u0626\u064a",
      doubleJobVisibility:
        "\u0636\u0639\u0641 \u0638\u0647\u0648\u0631 \u0627\u0644\u0625\u0639\u0644\u0627\u0646\u0627\u062a",
      prioritySupport: "\u062f\u0639\u0645 \u0623\u0648\u0644\u0648\u064a",
      // Paywall feature-table rows (UpgradeContent via upgrade-data.ts).
      // Brand names (Gmail, Slack, Zapier, QR) stay Latin and
      // are wrapped in LRI\u2026PDI (U+2066/U+2069) isolates for correct RTL flow.
      unlimitedCvs:
        "\u0633\u064a\u0631 \u0630\u0627\u062a\u064a\u0629 \u063a\u064a\u0631 \u0645\u062d\u062f\u0648\u062f\u0629",
      smarterAiWriting: "كتابة وتخصيص موجهان بالذكاء الاصطناعي",
      coverLetters: "رسائل تعريف مخصصة لكل وظيفة",
      applicationPackets: "حزم تقديم متكاملة",
      unlimitedAutofill: "تعبئة SmartApply غير محدودة",
      premiumSkills: "مهارات مميزة ومخصصة",
      connectedApps:
        "\u0627\u0631\u0628\u0637 \u062a\u0637\u0628\u064a\u0642\u0627\u062a\u0643 (\u2066Gmail\u2069 \u0648\u2066Slack\u2069 \u0648\u2066Zapier\u2069)",
      betterJobMatching:
        "\u0645\u0637\u0627\u0628\u0642\u0629 \u0648\u0638\u0627\u0626\u0641 \u0623\u0641\u0636\u0644",
      careerAgent:
        "\u0648\u0643\u064a\u0644\u0643 \u0627\u0644\u0645\u0647\u0646\u064a \u0627\u0644\u0630\u0643\u064a",
      novaAutomations: "\u0627\u0644\u0623\u062a\u0645\u062a\u0629",
      interviewPrep: "التحضير للمقابلات",
      salaryInsights: "ذكاء الرواتب",
      recruiterPreview: "معاينة مسؤول التوظيف",
      sourcesAnalytics:
        "\u062a\u062d\u0644\u064a\u0644\u0627\u062a \u0627\u0644\u0645\u0634\u0627\u0647\u062f\u0627\u062a \u0648\u0627\u0644\u0645\u0635\u0627\u062f\u0631",
      hiringPages:
        "\u0635\u0641\u062d\u0627\u062a \u0627\u0644\u062a\u0648\u0638\u064a\u0641",
      jobPosts:
        "\u0625\u0639\u0644\u0627\u0646\u0627\u062a \u0627\u0644\u0648\u0638\u0627\u0626\u0641",
      privateContactVisibility:
        "\u0639\u0631\u0636 \u0628\u064a\u0627\u0646\u0627\u062a \u0627\u0644\u062a\u0648\u0627\u0635\u0644 \u0627\u0644\u062e\u0627\u0635\u0629",
      recruiterOutreach:
        "\u0627\u0644\u062a\u0648\u0627\u0635\u0644 \u0645\u0639 \u0627\u0644\u0645\u0631\u0634\u062d\u064a\u0646",
      jdGenerator:
        "\u0645\u0648\u0644\u0651\u062f \u0627\u0644\u0648\u0635\u0641 \u0627\u0644\u0648\u0638\u064a\u0641\u064a",
      bulkScreening:
        "\u0641\u0631\u0632 \u0627\u0644\u0645\u0631\u0634\u062d\u064a\u0646 \u062f\u0641\u0639\u0629 \u0648\u0627\u062d\u062f\u0629",
      talentInsights:
        "\u0631\u0624\u0649 \u0627\u0644\u0645\u0648\u0627\u0647\u0628",
      careerFairQrAnalytics:
        "\u062a\u062d\u0644\u064a\u0644\u0627\u062a \u2066QR\u2069 \u0644\u0645\u0639\u0627\u0631\u0636 \u0627\u0644\u062a\u0648\u0638\u064a\u0641",
    },
    // Individual paywall rows, authored to the pricing spec.
    rows: {
      everythingInFree: "كل مزايا Free",
      smarterAi: "ذكاء اصطناعي أذكى (⁨{{model}}⁩)",
      tailoredCvs: "سير ذاتية مخصّصة لكل وظيفة",
      unlimitedAutofill: "تعبئة SmartApply",
      autofill_free: "10/شهر",
      autofill_plus: "غير محدودة",
      coverLetters: "رسائل تعريف ورسائل تواصل",
      skillsHub: "تثبيت مهارات الوكيل وتشغيلها",
      seeWhoViewed: "اعرف من اطّلع على ملفك",
      anyDownloadFormat: "التحميل بأي صيغة",
      customBranding: "علامة تجارية مخصّصة",
      connectApps: "اربط تطبيقاتك (\u2068Gmail, Zapier\u2069)",
      everythingInPlus: "كل مزايا Plus",
      findsJobs: "يجد الوظائف ويجهّزك للمقابلات",
      automations: "أتمتة (مهام مجدولة)",
      extendedAgentMemory: "ذاكرة وكيل ممتدة",
      credits: "الرصيد",
      credits_free: "70/يوم",
      credits_plus: "10,000/شهر",
      credits_pro: "100,000/شهر",
      creditsDaily_free: "يتجدد يومياً",
      creditsDaily_plus: "+ 300/يوم",
      creditsDaily_pro: "+ 3,000/يوم",
    },
    // Pro-tier Plus-vs-Pro comparison rows (text cells, not checkmarks)
    comparison: {
      topAi:
        "\u0627\u0644\u0630\u0643\u0627\u0621 \u0627\u0644\u0627\u0635\u0637\u0646\u0627\u0639\u064a",
      // Plus highlights Gemini; Pro highlights Claude at the highest capacity.
      topAiFreeSubtitle: "النموذج المميز",
      topAiPaidSubtitle: "أعلى سعة",
      usage: "\u0627\u0644\u0627\u0633\u062a\u062e\u062f\u0627\u0645",
      usageFree: "\u0642\u064a\u0627\u0633\u064a",
      usagePaid: "\u062d\u062f\u0648\u062f \u0623\u0639\u0644\u0649",
      visibility: "\u0627\u0644\u0638\u0647\u0648\u0631",
      visibilityFree: "\u0623\u0639\u0644\u0649",
      visibilityPaid: "\u0627\u0644\u0623\u0642\u0635\u0649",
    },
    context: {
      allowanceRemaining:
        "متبقي {{remaining}} من {{limit}} من {{unit}} المشمولة",
      allowanceUsed: "تم استخدام كل {{limit}} من {{unit}} المشمولة",
      resetsOn: "يتجدد في {{date}}",
      reason: {
        credits:
          "لقد استخدمت رصيدك المجاني لهذا اليوم. يتجدد غدًا، أو رقِّ خطتك لتتابع الآن. محادثتك ومسوداتك محفوظة.",
        image:
          "لقد استخدمت صورتك المجانية لهذا اليوم. تحصل على صورة أخرى غدًا، أو احصل على المزيد مع \u2066{{plan}}\u2069.",
        research:
          "لقد استخدمت عمليات البحث المجانية على الويب لهذا اليوم. تحصل على المزيد غدًا، أو مع \u2066{{plan}}\u2069.",
        document:
          "لقد استخدمت ملفاتك المجانية لهذا اليوم (المستندات والشرائح والصفحات). تحصل على المزيد غدًا، أو مع \u2066{{plan}}\u2069.",
        edit:
          "لقد استخدمت تعديلات الملفات المجانية لهذا اليوم. تحصل على المزيد غدًا، أو مع \u2066{{plan}}\u2069.",
        automations:
          "تعمل المهام المؤتمتة وفق جدول مع خطة \u2066Pro\u2069. مسودتك محفوظة.",
      },
      units: {
        reply: "الردود",
        run: "مرات التشغيل",
        preview: "المعاينات",
        report: "التقارير",
        generation: "مرات الإنشاء",
        autofill: "مرات التعبئة",
        action: "الإجراءات",
      },
      generic: {
        title: "افتح هذه الخطوة التالية",
        subtitle:
          "تم حفظ عملك. اختر الخطة التي تشمل هذا الإجراء وتابع من حيث توقفت.",
      },
      chatLimit: {
        title: "واصل المحادثة",
        subtitle:
          "استخدمت رصيدك المجاني لليوم. تضيف Plus رصيداً شهرياً قدره 10,000 للمحادثة والسير الذاتية والمزيد.",
      },
      skillRun: {
        title: "واصل تشغيل المهارات",
        subtitle:
          "تم حفظ اختيارك. استخدمت رصيدك المجاني لليوم. تضيف Plus رصيداً شهرياً قدره 10,000 لتواصل تشغيل المهارات.",
      },
      studioGenerate: {
        title: "أنشئ هذه المادة المهنية",
        subtitle:
          "تم حفظ مشروعك. رقّ خطتك لإنشاء التقرير أو الرسالة أو مادة التقديم التي اخترتها.",
      },
      applicationAutofill: {
        title: "واصل تعبئة طلبات التقديم",
        subtitle:
          "تشمل خطتا Plus وPro تعبئة SmartApply غير محدودة. سيبقى طلبك مفتوحاً لتتابع بعد الترقية.",
      },
      novaPreview: {
        title: "أنشئ خطة وكيل مهني أخرى",
        subtitle:
          "تم حفظ تعليماتك. رقّ لمزيد من معاينات الوكيل المهني وتابع بالمسودة نفسها.",
      },
      novaActivate: {
        title: "فعّل أتمتة الوكيل المهني",
        subtitle:
          "تم حفظ مسودة الأتمتة. تفعّل Pro التشغيل المجدول مع إبقاء الموافقات وضوابط الأمان.",
      },
      export: {
        title: "صدّر بكل الصيغ",
        subtitle:
          "تضيف Plus تصدير DOCX والنص وMarkdown القابل للتحرير، بينما يبقى PDF متاحًا مجانًا.",
      },
      analytics: {
        title: "اعرف ما الذي ينجح",
        subtitle: "تفتح Plus تحليلات الظهور والمصادر والتفاعل كاملة.",
      },
      branding: {
        title: "اجعل ملفك يعكس هويتك بوضوح",
        subtitle:
          "تفتح Plus العلامة التجارية المخصصة مع الحفاظ على ملفك ومحتواك الحاليين.",
      },
      connectors: {
        title: "اربط المزيد من سير عملك",
        subtitle:
          "رقّ عندما تحتاج إلى مزيد من الأدوات المتصلة. يمكنك دائمًا مراجعة الاتصالات الحالية وفصلها.",
      },
      voice: {
        title: "واصل استخدام الصوت",
        subtitle:
          "وصلت إلى وقت الصوت المشمول لهذا الشهر. رقّ لمزيد من المحادثات الصوتية، بينما تبقى المحادثة النصية متاحة.",
      },
      onboardingChoice: {
        title: "اختر كيف يساعدك Tabbio",
        subtitle:
          "ابدأ مجانًا، وأنشئ طلبات أقوى مع Plus، أو أتمت العمل المتكرر مع Pro.",
      },
      onboardingEnd: {
        title: "مساحتك المهنية جاهزة",
        subtitle:
          "تابع مجانًا أو افتح الأدوات المطابقة للأهداف والسيرة التي أعددتها للتو.",
      },
    },
  },

  voice: {
    permission: {
      rationale:
        "\u064a\u0633\u062a\u062e\u062f\u0645 Tabbio \u0627\u0644\u0645\u064a\u0643\u0631\u0648\u0641\u0648\u0646 \u0644\u0644\u0648\u0636\u0639 \u0627\u0644\u0635\u0648\u062a\u064a : \u0627\u0644\u0643\u062a\u0627\u0628\u0629 \u0645\u062a\u0627\u062d\u0629 \u062f\u0627\u0626\u0645\u064b\u0627.",
      deniedToast:
        "\u062a\u0645 \u0631\u0641\u0636 \u0627\u0644\u0648\u0635\u0648\u0644 \u0625\u0644\u0649 \u0627\u0644\u0645\u064a\u0643\u0631\u0648\u0641\u0648\u0646. \u0644\u0627 \u064a\u0632\u0627\u0644 \u0628\u0625\u0645\u0643\u0627\u0646\u0643 \u0627\u0644\u0643\u062a\u0627\u0628\u0629 \u0644\u0644\u0645\u062d\u0627\u062f\u062b\u0629.",
      deniedTitle:
        "\u064a\u0644\u0632\u0645 \u0627\u0644\u0648\u0635\u0648\u0644 \u0625\u0644\u0649 \u0627\u0644\u0645\u064a\u0643\u0631\u0648\u0641\u0648\u0646",
      deniedSettings:
        "\u0641\u0639\u0651\u0644 \u0627\u0644\u0645\u064a\u0643\u0631\u0648\u0641\u0648\u0646 \u0645\u0646 \u0627\u0644\u0625\u0639\u062f\u0627\u062f\u0627\u062a \u0644\u0627\u0633\u062a\u062e\u062f\u0627\u0645 \u0627\u0644\u0635\u0648\u062a.",
      openSettings:
        "\u0641\u062a\u062d \u0627\u0644\u0625\u0639\u062f\u0627\u062f\u0627\u062a",
    },
    session: {
      startError:
        "\u062a\u0639\u0630\u0651\u0631 \u0628\u062f\u0621 \u0627\u0644\u0648\u0636\u0639 \u0627\u0644\u0635\u0648\u062a\u064a. \u062d\u0627\u0648\u0644 \u0645\u062c\u062f\u062f\u064b\u0627 \u0623\u0648 \u0627\u0643\u062a\u0628 \u0631\u0633\u0627\u0644\u062a\u0643.",
    },
    ptt: {
      hint: "\u0627\u0636\u063a\u0637 \u0644\u0644\u062a\u062d\u062f\u062b\u060c \u0648\u0627\u0636\u063a\u0637 \u0645\u0631\u0629 \u0623\u062e\u0631\u0649 \u0644\u0644\u0625\u0646\u0647\u0627\u0621",
      recording: "\u0623\u0633\u062a\u0645\u0639\u2026",
      transcribing:
        "\u062c\u0627\u0631\u064a \u0627\u0644\u0646\u0633\u062e\u2026",
      cancel:
        "\u062d\u0631\u0651\u0631 \u0644\u0644\u0625\u0631\u0633\u0627\u0644",
    },
    transcribe: {
      offlineTitle:
        "\u0627\u0644\u0635\u0648\u062a \u063a\u064a\u0631 \u0645\u062a\u0627\u062d \u0628\u062f\u0648\u0646 \u0627\u062a\u0635\u0627\u0644",
      offlineMessage:
        "\u0627\u0643\u062a\u0628 \u0644\u0644\u0645\u062d\u0627\u062f\u062b\u0629 : \u0627\u0644\u0635\u0648\u062a \u0633\u064a\u0639\u0648\u062f \u0639\u0646\u062f \u0627\u0644\u0627\u062a\u0635\u0627\u0644.",
      errorTitle:
        "\u062a\u0639\u0630\u0651\u0631 \u0627\u0644\u0646\u0633\u062e",
      errorMessage:
        "\u0641\u0634\u0644 \u0627\u0644\u0635\u0648\u062a. \u062d\u0627\u0648\u0644 \u0645\u062c\u062f\u062f\u0627\u064b \u0623\u0648 \u0627\u0643\u062a\u0628 \u0631\u0633\u0627\u0644\u062a\u0643.",
    },
    cap: {
      title:
        "\u062f\u0642\u0627\u0626\u0642 \u0627\u0644\u0635\u0648\u062a \u0627\u0644\u0645\u0633\u062a\u062e\u062f\u0645\u0629",
      message:
        "\u0644\u0642\u062f \u0627\u0633\u062a\u062e\u062f\u0645\u062a \u0643\u0627\u0645\u0644 \u062f\u0642\u0627\u0626\u0642 \u0627\u0644\u0635\u0648\u062a \u0644\u0647\u0630\u0627 \u0627\u0644\u0634\u0647\u0631. \u0631\u0642\u0651 \u0644\u0644\u0645\u0632\u064a\u062f.",
      remainingMinutes:
        "\u062a\u0628\u0642\u0649 {{count}} \u062f\u0642\u064a\u0642\u0629 \u0647\u0630\u0627 \u0627\u0644\u0634\u0647\u0631",
      capLabel: "{{used}} \u0645\u0646 {{cap}} \u062f\u0642\u064a\u0642\u0629",
      upgradeCta:
        "\u0627\u0644\u062a\u0631\u0642\u064a\u0629 \u0625\u0644\u0649 Premium",
    },
    handsfree: {
      title:
        "\u0627\u0644\u0648\u0636\u0639 \u0627\u0644\u0635\u0648\u062a\u064a",
      tapToStart: "\u0627\u0636\u063a\u0637 \u0644\u0644\u0628\u062f\u0621",
      tapToInterrupt:
        "\u0627\u0636\u063a\u0637 \u0644\u0644\u0645\u0642\u0627\u0637\u0639\u0629",
      idle:
        "\u0627\u0636\u063a\u0637 \u0645\u0637\u0648\u0644\u0627\u064b \u0644\u0644\u062a\u062d\u062f\u062b",
      thinking: "\u0623\u0641\u0643\u0651\u0631\u2026",
      speaking: "\u0623\u062a\u062d\u062f\u0651\u062b\u2026",
      ready:
        "\u0645\u0631\u062d\u0628\u0627\u064b\u060c \u0623\u0646\u0627 \u0646\u0648\u0641\u0627. \u0628\u0645\u0627\u0630\u0627 \u062a\u0641\u0643\u0631\u061f",
      lookingUp:
        "\u0623\u0628\u062d\u062b \u0639\u0646 \u0630\u0644\u0643\u2026",
      planLimit:
        "\u0648\u0635\u0644\u062a \u0625\u0644\u0649 \u062d\u062f \u0627\u0644\u0645\u062d\u0627\u062f\u062b\u0627\u062a \u0641\u064a \u062e\u0637\u062a\u0643. \u0642\u0645 \u0628\u0627\u0644\u062a\u0631\u0642\u064a\u0629 \u0644\u0645\u062a\u0627\u0628\u0639\u0629 \u0627\u0644\u062d\u062f\u064a\u062b.",
      // Web voice mode (components/voice/live). Nova is feminine; her status
      // lines stay in her first person, like the strings above.
      live: {
        ready: "\u062c\u0627\u0647\u0632\u0629",
        starting: "\u062c\u0627\u0631\u064d \u0627\u0644\u0628\u062f\u0621\u2026",
        listening: "\u0623\u0633\u062a\u0645\u0639\u2026",
        micOff: "\u0627\u0644\u0645\u064a\u0643\u0631\u0648\u0641\u0648\u0646 \u0645\u062a\u0648\u0642\u0641",
        paused: "\u0645\u062a\u0648\u0642\u0641 \u0645\u0624\u0642\u062a\u0627\u064b",
        send: "\u0627\u0636\u063a\u0637 \u0644\u0644\u0625\u0631\u0633\u0627\u0644",
        unmute: "\u0627\u0636\u063a\u0637 \u0644\u062a\u0634\u063a\u064a\u0644 \u0627\u0644\u0645\u064a\u0643\u0631\u0648\u0641\u0648\u0646",
        resume: "\u0627\u0636\u063a\u0637 \u0644\u0644\u0645\u062a\u0627\u0628\u0639\u0629",
        retry: "\u0627\u0636\u063a\u0637 \u0644\u0625\u0639\u0627\u062f\u0629 \u0627\u0644\u0645\u062d\u0627\u0648\u0644\u0629",
        continue: "\u0627\u0636\u063a\u0637 \u0644\u0645\u062a\u0627\u0628\u0639\u0629 \u0627\u0644\u062d\u062f\u064a\u062b",
        stuck: "\u0644\u0627 \u064a\u0648\u062c\u062f \u0635\u0648\u062a",
        stuckDetail: "\u0644\u0645 \u064a\u062a\u0645\u0643\u0646 \u0627\u0644\u0645\u062a\u0635\u0641\u062d \u0645\u0646 \u062a\u0634\u063a\u064a\u0644 \u0635\u0648\u062a \u0646\u0648\u0641\u0627.",
        saving: "\u062c\u0627\u0631\u064d \u0627\u0644\u062d\u0641\u0638\u2026",
        noMic: "\u0627\u0644\u0645\u064a\u0643\u0631\u0648\u0641\u0648\u0646 \u063a\u064a\u0631 \u0645\u062a\u0627\u062d",
        offline: "\u0644\u0627 \u064a\u0648\u062c\u062f \u0627\u062a\u0635\u0627\u0644",
        planReached: "\u0628\u0644\u063a\u062a \u062d\u062f \u0627\u0644\u0645\u062d\u0627\u062f\u062b\u0627\u062a",
        error: "\u062d\u062f\u062b \u062e\u0637\u0623 \u0645\u0627",
        microphone: "\u0627\u0644\u0645\u064a\u0643\u0631\u0648\u0641\u0648\u0646",
        end: "\u0625\u0646\u0647\u0627\u0621",
        captions: "\u0627\u0644\u0646\u0635 \u0627\u0644\u0645\u0643\u062a\u0648\u0628",
        notCaught: "\u0644\u0645 \u0623\u0633\u0645\u0639\u0643 \u062c\u064a\u062f\u0627\u064b",
        noMetering: "\u0644\u0627 \u064a\u0645\u0643\u0646\u0646\u064a \u062a\u062d\u062f\u064a\u062f \u0645\u062a\u0649 \u062a\u062a\u0648\u0642\u0641 \u0639\u0646 \u0627\u0644\u0643\u0644\u0627\u0645. \u0627\u0636\u063a\u0637 \u0644\u0644\u0625\u0631\u0633\u0627\u0644 \u0639\u0646\u062f\u0645\u0627 \u062a\u0646\u062a\u0647\u064a.",
        micBlocked: "\u0627\u0633\u0645\u062d \u0644\u0644\u0645\u062a\u0635\u0641\u062d \u0628\u0627\u0633\u062a\u062e\u062f\u0627\u0645 \u0627\u0644\u0645\u064a\u0643\u0631\u0648\u0641\u0648\u0646 \u0644\u062a\u062a\u062d\u062f\u062b \u0645\u0639 \u0646\u0648\u0641\u0627.",
        slow: "\u064a\u0633\u062a\u063a\u0631\u0642 \u0627\u0644\u0623\u0645\u0631 \u0648\u0642\u062a\u0627\u064b \u0623\u0637\u0648\u0644 \u0645\u0646 \u0627\u0644\u0645\u0639\u062a\u0627\u062f.",
        approval: "\u062a\u062d\u062a\u0627\u062c \u0646\u0648\u0641\u0627 \u0625\u0644\u0649 \u0645\u0648\u0627\u0641\u0642\u062a\u0643 \u0641\u064a \u0627\u0644\u0645\u062d\u0627\u062f\u062b\u0629 \u0644\u0644\u0645\u062a\u0627\u0628\u0639\u0629.",
        continueInChat: "\u062a\u0627\u0628\u0639 \u0641\u064a \u0627\u0644\u0645\u062d\u0627\u062f\u062b\u0629",
        interrupted: "\u062a\u0645\u062a \u0627\u0644\u0645\u0642\u0627\u0637\u0639\u0629",
        failed: "\u062a\u0639\u0630\u0651\u0631 \u0639\u0644\u0649 \u0646\u0648\u0641\u0627 \u0627\u0644\u0631\u062f",
        jumpToLatest: "\u0627\u0644\u0627\u0646\u062a\u0642\u0627\u0644 \u0625\u0644\u0649 \u0627\u0644\u0623\u062d\u062f\u062b",
        spaceKey: "\u0645\u0633\u0627\u0641\u0629",
        escKey: "Esc",
      },
    },
  },

  chatInputDisclaimer: "قد يخطئ الذكاء الاصطناعي. تحقّق من التفاصيل المهمة.",
  assistantName: "الوكيل المهني",
  disclaimer:
    "وكيلك المهني مساعد يعمل بالذكاء الاصطناعي. قد يخطئ، لذا تحقّق من المعلومات المهمة.",
  messagePlaceholder: "أرسل رسالة إلى Tabbio",
  userAccount: "حساب المستخدم",
  workspaceTypePersonal: "حساب فردي",
  workspaceTypeCompany: "شركة",
  closeSidebar: "إغلاق القائمة",
  openSidebar: "فتح القائمة",
  tabbioForWeb: "Tabbio للويب",
  memoryFields: "حقول",
  memoryEditHelp: "JSON منظم فقط. الحفظ يدمج الحقول المعدلة في ذاكرة العمل.",

  taxonomy: {
    sectionTitle: "المهارات",
    otherSkillsMentioned: "مهارات أخرى مذكورة",
    confidence: {
      high: "تطابق بثقة عالية",
      medium: "تطابق محتمل",
      low: "ثقة منخفضة",
    },
    source: {
      alias: "تطابق اسم بديل",
      key: "تطابق قياسي",
      family: "تطابق ضمن العائلة",
      fuzzy: "تطابق تقريبي",
      none: "لا يوجد تطابق قياسي",
    },
  },

  msgPrefs: {
    title: "المراسلة",
    modes: {
      seeker: "وضع الباحث عن عمل",
      employer: "صاحب العمل · {{workspace}}",
    },
    seeker: {
      sectionTitle: "من يمكنه مراسلتي",
      sectionHelp:
        "أنت في وضع الباحث عن عمل. أي شخص ترسل إليه أولاً يمكنه الرد دائماً، بغض النظر عن هذه الإعدادات.",
      candidate: {
        label: "الباحثون عن عمل",
        desc: "أي شخص آخر يبحث عن عمل على تابيو",
      },
      company: {
        label: "الشركات",
        desc: "مسؤولو التوظيف الداخليون ومديرو التوظيف",
      },
      recruiter: {
        label: "مسؤولو التوظيف",
        desc: "مسؤولو التوظيف المستقلون وشركاء المواهب",
      },
      founder: {
        label: "المؤسسون",
        desc: "المؤسسون والرؤساء التنفيذيون للفرق الصغيرة",
      },
      agency: { label: "الوكالات", desc: "وكالات التوظيف وإلحاق العمالة" },
      freelancer: { label: "المستقلون", desc: "متعاقدون يعملون لحسابهم الخاص" },
    },
    employer: {
      sectionTitle: "من يمكنه مراسلة مساحة العمل",
      sectionHelp:
        "أنت في وضع صاحب العمل. تنطبق الإعدادات عندما يراسل الأشخاص صندوق الوارد لمساحة العمل.",
      master: {
        label: "السماح لجميع مستخدمي المنصة",
        desc: "صندوق وارد مفتوح: يمكن لأي شخص مراسلة مساحة العمل",
      },
      applied: {
        label: "المرشحون الذين تقدموا للوظائف",
        desc: "افتراضي؛ يُبقي الصندوق مرتبطاً بمسار التوظيف",
      },
      cold: {
        label: "جميع المرشحين (رسائل مباشرة باردة)",
        desc: "فتح المصادر الواردة من أي مرشح",
      },
      freelancers: {
        label: "المستقلون فقط",
        desc: "توظيف قائم على المشاريع: متعاقدون مستقلون",
      },
      agency: {
        label: "الوكالات",
        desc: "شركاء التوظيف الذين يقدمون المرشحين",
      },
      blockSpam: {
        sectionTitle: "حظر الرسائل الترويجية",
        sectionHelp:
          "تصفية الرسائل العامة عندما يكون من الواضح أن المرسل لم يطّلع على إعلان الوظيفة.",
        label: "الحظر التلقائي للرسائل التي يُحتمل أن تكون مزعجة",
        desc: 'تُصفّى عروض "لدينا مرشحون لك"',
      },
    },
  },

  msgGated: {
    headline: "يقبل {{firstName}} الرسائل من هذه الأدوار فقط",
    applyViaJob: "التقدّم لوظيفة {{jobTitle}}",
    notifyWhenOpen: "أعلمني عندما يفتح {{firstName}} استقبال الرسائل",
    explainer:
      "أنت مسجَّل الدخول كمرشح، لذا الرسائل المباشرة غير متاحة الآن: لكن لا يزال بإمكانك لفت انتباه {{firstName}}.",
  },

  msgSheet: {
    editProfile: "تعديل ملفك الشخصي",
    muteNotifications: "كتم الإشعارات",
    unmuteNotifications: "إلغاء كتم الإشعارات",
    blockPerson: "حظر {{name}}",
    report: "الإبلاغ",
    menuLabel: "خيارات المحادثة",
    blockedTitle: "تم الحظر",
    blockedBody: "لن يتمكّن {{name}} من مراسلتك بعد الآن.",
    blockFailedTitle: "تعذّر الحظر",
    mutedTitle: "تم الكتم",
    mutedBody: "إشعارات هذه المحادثة متوقفة.",
    muteFailedTitle: "تعذّر الكتم",
    unmutedTitle: "تم إلغاء الكتم",
    unmutedBody: "إشعارات هذه المحادثة مفعّلة.",
    unmuteFailedTitle: "تعذّر إلغاء الكتم",
    reportedTitle: "تم استلام البلاغ",
    reportedBody:
      "شكراً: تم استلام بلاغك. يمكنك متابعته من الإعدادات ضمن بلاغاتي.",
    reportFailedTitle: "تعذّر إرسال البلاغ",
  },

  userReports: {
    title: "بلاغاتي",
    subtitle:
      "تابع البلاغات التي أرسلتها. سنرسل لك إشعاراً أيضاً عند توفر النتيجة.",
    viewStatus: "عرض حالة البلاغ",
    loading: "جارٍ تحميل بلاغاتك...",
    loadFailed: "تعذّر تحميل بلاغاتك.",
    retry: "حاول مجدداً",
    emptyTitle: "لا توجد بلاغات مرسلة",
    emptyBody: "ستظهر هنا البلاغات التي ترسلها بشأن مستخدم آخر.",
    reference: "المرجع {{id}}",
    status: {
      pending: {
        label: "تم الاستلام",
        description: "تم إرسال بلاغك بنجاح وهو بانتظار المراجعة.",
      },
      reviewing: {
        label: "قيد المراجعة",
        description: "يقوم فريق السلامة لدينا بمراجعة البلاغ.",
      },
      actioned: {
        label: "تم اتخاذ إجراء",
        description:
          "راجعنا البلاغ واتخذنا إجراءً وفق سياساتنا. لا تتم مشاركة تفاصيل الإجراء الخاصة.",
      },
      dismissed: {
        label: "لم يتم العثور على مخالفة",
        description:
          "راجعنا البلاغ ولم نجد مخالفة للسياسات بناءً على المعلومات المتاحة.",
      },
    },
  },

  // شاشات الوصول من قائمة الخيارات في السيرة العامة ("افتح في تبيو" / "إبلاغ").
  profileHandoff: {
    back: "رجوع",
    message: "مراسلة",
    report: "إبلاغ",
    loading: "جارٍ تحميل الملف...",
    notFoundTitle: "هذا الملف غير متاح",
    notFoundBody: "ربما تم جعله خاصاً أو إزالته.",
  },

  reportProfile: {
    title: "الإبلاغ عن {{name}}",
    subtitle: "أخبرنا بالمشكلة. يراجع فريقنا كل بلاغ.",
    signInRequired: "سجّل الدخول لإرسال بلاغ...",
    loading: "جارٍ التحميل...",
    notFoundTitle: "هذا الملف غير متاح",
    notFoundBody: "لم نتمكّن من العثور على الشخص المُبلغ عنه.",
    detailsPlaceholder: "أضف أي تفاصيل تساعدنا في المراجعة (اختياري)",
    submit: "إرسال البلاغ",
    done: "تم",
    categories: {
      spam: "رسائل مزعجة أو احتيال",
      harassment: "تحرّش أو كراهية",
      impersonation: "انتحال شخصية",
      inappropriate_content: "محتوى غير لائق",
      other: "شيء آخر",
    },
  },

  roles: {
    candidate: "باحث عن عمل",
    company: "شركة",
    recruiter: "مسؤول توظيف",
    founder: "مؤسس",
    agency: "وكالة توظيف",
    freelancer: "مستقل",
    master: "أي شخص",
    candidate_who_applied: "المرشحون الذين تقدموا",
    all_candidates: "جميع المرشحين",
    freelancers: "المستقلون",
  },

  profile: {
    editTitle: "تعديل الملف الشخصي",
    savingLabel: "جارٍ الحفظ…",
    savedTitle: "تم الحفظ",
    savedBody: "تم تحديث ملفك الشخصي.",
    saveFailedTitle: "تعذّر الحفظ",
    photoPermissionTitle: "صلاحية الوصول إلى الصور مطلوبة",
    photoPermissionBody:
      "اسمح لـ Tabbio بقراءة مكتبة الصور لاختيار صورة شخصية.",
    photoUpdatedTitle: "تم تحديث الصورة",
    photoUpdatedBody: "صورتك الشخصية الجديدة نشطة الآن.",
    photoFailedTitle: "تعذّر تحديث الصورة",
    fields: {
      name: "الاسم",
      headline: "العنوان المهني",
      summary: "نبذة",
      location: "الموقع",
    },
  },
  // Subscription journeys (A-J, L). Copy lifted from the design reference;
  // see lib/subscription-journey/COPY.md for the screen -> key map.
  subscription: {
    tierFree: 'مجاني',
    providers: {
      appStore: '\u2066App Store\u2069',
      googlePlay: '\u2066Google Play\u2069',
      web: 'الفوترة عبر الويب',
    },
    cycles: {
      label: 'فترة الاشتراك',
      monthly: 'شهري',
      yearly: 'سنوي',
    },
    perMonth: '/ شهر',
    actions: {
      back: 'رجوع',
      close: 'إغلاق',
      continue: 'متابعة',
      done: 'تم',
      notNow: 'مو الحين',
      keepMyPlan: 'الاحتفاظ بباقتي',
      backToMyPlan: 'العودة لباقتي',
      continueCancellation: 'متابعة الإلغاء',
    },
    legal: {
      restore: 'استعادة',
      terms: 'الشروط',
      privacy: 'الخصوصية',
    },
    paywall: {
      screenTitle: 'ترقية',
      heading: 'اشترك في \u2066Tabbio {{tier}}\u2069',
      subtitle: {
        plus: 'جهّز أكثر مع كتابة محسّنة لسيرتك.',
        pro: 'خطوتك الجاية أسهل مع مساعدك للوظائف.',
      },
      tierGroupLabel: 'نوع الباقة',
      compareCaption: 'قارن المجاني مع \u2066Tabbio {{tier}}\u2069',
      columns: {
        features: 'المزايا',
        free: 'مجاني',
      },
      rows: {
        cvWriting: 'كتابة السيرة',
        moreAi: 'استخدام أكثر للذكاء الاصطناعي',
        higherLimits: 'حدود أعلى للذكاء الاصطناعي',
        nova: 'نوفا، مساعدك للوظائف',
        scheduled: 'بحث مجدول عن الوظائف',
        tools: 'اربط أدواتك',
        insights: 'الإحصاءات',
        customization: 'خيارات تخصيص أكثر',
      },
      details: {
        tools: {
          everyday: 'أدواتك اليومية',
          ai: 'اتصالات الذكاء الاصطناعي',
          developer: 'أدوات المطوّرين',
          note: 'الوصول للنماذج يعتمد على حسابك المتصل.',
        },
        insights: 'شوف المشاهدات والتنزيلات ومصادر الزيارات.',
        customization: 'أزل علامة تابيو، وخصّص معاينة رابطك، واختر صيغ تنزيل أكثر.',
      },
      included: 'متوفر',
      notIncluded: 'غير متوفر',
      upgradeFor: 'اشترك مقابل \u2068{{price}}\u2069',
      disclosureMonthly: 'يتجدد شهرياً. تقدر تلغي بأي وقت.',
      disclosureYearly: '\u2068{{price}}\u2069 سنوياً. يتجدد حتى الإلغاء.',
    },
    compare: {
      title: 'قارن الباقات',
      pricePerMonth: '\u2068{{price}}\u2069 / شهر',
      backToChoice: 'العودة لاختياري',
      features: {
        free: {
          basicWriting: 'كتابة أساسية للسيرة',
          oneCv: 'سيرة واحدة ورابطك الخاص',
        },
        plus: {
          enhancedWriting: 'كتابة محسّنة مع \u2068{{model}}\u2069',
          moreAi: 'استخدام أكثر للذكاء الاصطناعي',
          connectTools: 'اربط أدواتك',
          insights: 'الإحصاءات',
          customization: 'خيارات تخصيص أكثر',
        },
        pro: {
          everythingInPlus: 'كل مزايا \u2066Plus\u2069',
          advancedWriting: 'كتابة متقدمة مع \u2068{{model}}\u2069',
          nova: 'نوفا، مساعدك للوظائف',
          scheduled: 'بحث مجدول عن الوظائف',
          higherLimits: 'حدود أعلى للذكاء الاصطناعي',
        },
      },
    },
    checkout: {
      title: 'راجع باقتك',
      heading: 'نظرة أخيرة.',
      subtitle: 'بتأكد اشتراكك بأمان عند مزوّد الفوترة.',
      planRow: '\u2066Tabbio\u2069 \u2068{{tier}}\u2069',
      monthlySubscription: 'اشتراك شهري',
      yearlySubscription: 'اشتراك سنوي',
      totalToday: 'الإجمالي اليوم',
      renewsAutomatically: 'يتجدد تلقائياً',
      everyMonth: 'كل شهر ما لم يتم الإلغاء',
      everyYear: 'كل سنة ما لم يتم الإلغاء',
      billedThrough: 'الفوترة عبر',
      accessNote: 'تبدأ مزاياك المدفوعة بعد تأكيد الشراء.',
      fine: 'تقدر تدير التجديد أو تلغيه من إعدادات الاشتراك عند مزوّد الفوترة.',
      continueTo: 'المتابعة إلى \u2068{{provider}}\u2069',
      restoreExisting: 'استعادة اشتراك سابق',
      checking: 'نتحقّق من اشتراكك.',
      delayed: 'يمكن تمّ الدفع. خلّنا نتحقّق من تفعيل المزايا.',
      checkAgain: 'تحقّق مرة ثانية',
      backToTabbio: 'العودة إلى تابيو',
      cancelled: 'ما تمّت عملية الشراء.',
      unchanged: 'باقتك ما تغيّرت.',
      errors: {
        unavailable: {
          title: 'هذه الباقة غير متاحة حاليًا.',
          body: 'لم يتمكن المتجر من عرضها الآن. لم تتغير باقتك؛ حاول مرة أخرى بعد قليل.',
        },
        network: {
          title: 'يبدو أنك غير متصل بالإنترنت.',
          body: 'تحقق من اتصالك ثم حاول مرة أخرى. لم تتغير باقتك.',
        },
        store: {
          title: 'تعذر على ⁨{{provider}}⁩ إتمام عملية الشراء.',
          body: 'لم تتغير باقتك. حاول مرة أخرى، أو تحقق من طريقة الدفع في ⁨{{provider}}⁩.',
        },
        notAllowed: {
          title: 'عمليات الشراء غير مسموح بها على هذا الجهاز.',
          body: 'تحقق من قيود الشراء أو إعدادات مدة استخدام الجهاز، ثم حاول مرة أخرى.',
        },
        signIn: {
          title: 'سجّل الدخول للمتابعة.',
          body: 'انتهت جلستك قبل بدء عملية الشراء. سجّل الدخول مرة أخرى ثم حاول من جديد.',
        },
      },
    },
    welcome: {
      title: 'كل شي جاهز',
      heading: 'أهلاً بك في \u2068{{tier}}\u2069.',
      subtitle: 'خلّنا نجهّزك لخطوتك الياية.',
      cardTitle: 'ابدأ بسيرة أقوى',
      cardBody: 'نوفا تقترح لك نبذة أوضح. وأنت تختار التغييرات اللي تناسبك.',
      improveCv: 'طوّر سيرتي الذاتية',
      improvePrompt: 'حسّن نبذتي في سيرتي الذاتية',
    },
    billing: {
      title: 'الباقة والفوترة',
      tagline: {
        pro: 'كتابة متقدمة + نوفا',
        plus: 'كتابة محسّنة للسيرة',
        free: 'كتابة أساسية للسيرة',
      },
      pricePerMonth: '\u2068{{price}}\u2069 / شهرياً',
      pricePerYear: '\u2068{{price}}\u2069 / سنوياً',
      renews: 'يتجدد \u2068{{date}}\u2069',
      accessUntil: 'الوصول متاح إلى \u2068{{date}}\u2069',
      pauseStarts: 'يبدأ الإيقاف \u2068{{date}}\u2069',
      accessUnknown: 'تحقق من موعد انتهاء وصولك',
      metrics: {
        label: 'نشاطك',
        applicationsSent: 'طلبات التوظيف',
        cvsTailored: 'سير مخصصة',
        profileViews: 'زيارات الملف',
      },
      improveCv: 'طوّر سيرتي',
      improveCvSub: 'خل طلبك الجاي أقوى',
      viewProfile: 'شوف ملفي',
      viewProfileSub: 'شوف اللي يشوفه أصحاب العمل',
      planDetails: 'تفاصيل الباقة',
      planPricePerMonth: '\u2068{{price}}\u2069 شهرياً',
      planPricePerYear: '\u2068{{price}}\u2069 سنوياً',
      change: 'تغيير',
      nextPayment: 'الدفعة القادمة',
      accessUntilLabel: 'الوصول متاح إلى',
      pauseStartsLabel: 'يبدأ الإيقاف',
      dateAndPrice: '\u2068{{date}}\u2069 · \u2068{{price}}\u2069',
      manageSubscription: 'إدارة الاشتراك',
      cancelSubscription: 'إلغاء الاشتراك',
      turnRenewalOn: 'إعادة تشغيل التجديد',
      renewalOff: 'التجديد متوقف',
      viewScheduledPause: 'عرض الإيقاف المجدول',
      billingHelp: 'مساعدة الفوترة',
      receipts: 'سجل الفوترة والإيصالات',
      restorePurchases: 'استعادة المشتريات',
      refreshSubscription: 'تحديث حالة الاشتراك',
      requestRefund: 'طلب استرداد المبلغ',
    },
    info: {
      receipts: {
        title: 'سجل الفوترة والإيصالات',
        body: 'إيصالاتك موجودة عند \u2068{{provider}}\u2069، مزوّد اشتراكك.',
      },
      refund: {
        title: 'طلب استرداد المبلغ',
        body: 'يراجع \u2068{{provider}}\u2069 طلبات الاسترداد. الأهلية والمدة حسب شروط المزوّد.',
        note: 'طلب الاسترداد منفصل عن إيقاف التجديد.',
      },
      nextPayment: {
        title: 'دفعتك القادمة',
        body: 'المزوّد هو المرجع للمبلغ والضريبة والعملة والتاريخ.',
      },
      provider: {
        body: 'مزوّد الفوترة يتبع عملية الشراء الأصلية حتى لو غيّرت جهازك.',
      },
      terms: {
        title: 'شروط الاشتراك',
        body: 'الباقات المدفوعة تتجدد تلقائياً ما لم يتم إلغاؤها عند المزوّد. المبلغ والتاريخ النهائيان يؤخذان من شاشة تأكيد المزوّد.',
      },
      profile: {
        title: 'ملفك العام',
        body: 'رابطك العام واحد، ويبقى نفسه مع كل الباقات.',
        copy: 'نسخ الرابط',
        copied: 'تم النسخ',
      },
      cv: {
        title: 'سيرتك المحفوظة',
        body: 'محفوظة في حسابك. إيقاف التجديد ما يحذفها.',
      },
      free: {
        title: 'المتابعة على المجاني',
        body: 'سيرتك ورابطك العام متاحين.',
      },
    },
    cancel: {
      reasons: {
        title: 'إلغاء الاشتراك',
        heading: 'ليش قررت تلغي؟',
        groupLabel: 'سبب الإلغاء',
        options: {
          found_job: 'حصلت وظيفة',
          later: 'باخذ راحة',
          price: 'السعر غالي علي',
          value: 'ما كان قد توقعاتي',
          confusing: 'مو واضح لي كيف أستخدمه',
          broken: 'أواجه مشاكل تقنية',
          other: 'أحتاج شي ثاني',
        },
      },
      details: {
        value: {
          cv: 'كتابة السيرة',
          matches: 'الوظائف المقترحة',
          results: 'نتائج التقديم',
          other: 'شي ثاني',
        },
        confusing: {
          cv: 'تطوير سيرتي',
          matches: 'البحث عن وظيفة',
          nova: 'استخدام نوفا',
        },
        broken: {
          crash: 'التطبيق علّق أو تقفل',
          loading: 'شي ما تحمّل',
          failed: 'خطوة ما اكتملت',
          other: 'شي ثاني',
        },
        other: {
          missing: 'ميزة ناقصة',
          switching: 'أداة ثانية',
          other: 'سبب ثاني',
        },
      },
      help: {
        title: 'قبل ما تروح',
        titles: {
          foundJob: 'مبروك على الوظيفة اليديدة!',
          value: 'شو ما كان قد توقعاتك؟',
          confusing: 'شو كنت تحاول تسوي؟',
          broken: 'شو المشكلة اللي واجهتك؟',
          price: 'اختار الباقة اللي تناسبك.',
          other: 'شو اللي ناقص؟',
        },
        career: {
          heading: 'كيف ساعدك تابيو؟',
          groupLabel: 'شو اللي ساعد',
          tellMore: 'خبرنا أكثر شوي',
          placeholder: 'جملة وحدة تكفي',
          note: 'ملاحظتك تساعدنا نطوّر تابيو.',
        },
        priceInfo: 'فوترتك السنوية ما تتغير. تقدر تقارن الباقات قبل ما تقرر.',
        comparePlans: 'قارن الباقات',
        prompts: {
          missing: 'شو تبي تابيو يسوي لك؟',
          switching: 'شو تسوي الأداة الثانية بشكل أفضل؟',
          broken: 'شو صار، وشو كنت تحاول تسوي؟',
          confusing: 'وين وقفت وما عرفت تكمل؟',
          value: 'شو كنت تتوقع من تابيو؟',
          default: 'شو تحب تخبرنا؟',
        },
        placeholder: 'كم كلمة تكفي…',
        note: 'ملاحظتك تساعدنا نحدد شو نحسّن في الخطوة الياية.',
        feedbackReceived: 'شكراً، وصلت ملاحظتك.',
        feedbackFailed: 'ما انرسلت الملاحظة. كلامك محفوظ وتقدر تكمل.',
      },
      career: {
        title: 'خل تابيو معك',
        heading: 'وظيفتك اليديدة هي البداية.',
        subtitle: 'خل تابيو جاهز لخطوتك الياية.',
        features: {
          current: 'خل سيرتك وملفك على \u2066LinkedIn\u2069 محدثين',
          identity: 'طوّر هويتك المهنية',
          opportunities: 'حصل فرص أفضل متى ما كنت جاهز',
        },
        fine: 'نوفا يقدر يواصل مساعدتك حتى بعد ما تبدأ وظيفتك اليديدة.',
        attribution: {
          cv: 'السيرة',
          jobboard: 'لوحة الوظائف',
          recruiter: 'جهة عمل',
          agent: 'المساعد',
          elsewhere: 'مو من تابيو',
          other: 'شي ثاني',
        },
      },
      pause: {
        title: 'خذ لك راحة',
        unavailable: {
          heading: 'تقدر توقف التجديد.',
          body: 'الإيقاف المؤقت غير متاح لهذا الاشتراك عبر \u2068{{provider}}\u2069. تقدر توقف التجديد وتستخدم مزاياك إلى \u2068{{date}}\u2069.',
          bodyNoDate: 'الإيقاف المؤقت غير متاح لهذا الاشتراك عبر \u2068{{provider}}\u2069. تقدر توقف التجديد وتستخدم مزاياك لين تنتهي باقتك.',
          info: 'سيرتك ورابطك العام يبقون متاحين على المجاني.',
        },
        noThanks: 'لا شكراً، متابعة',
        heading: 'راحة، مو وداع.',
        subtitle: 'وقف باقتك مؤقتاً وارجع متى ما كنت جاهز.',
        lengthLabel: 'مدة الإيقاف',
        months: {
          one: 'شهر',
          two: 'شهرين',
          three: '٣ أشهر',
        },
        timelineRow: '\u2068{{date}}\u2069 · \u2068{{title}}\u2069',
        starts: 'يبدأ الإيقاف',
        startsBody: 'تتوقف الأدوات المدفوعة. سيرتك ورابطك يبقون.',
        reminder: 'بنذكّرك',
        reminderBody: 'قبل رجوع اشتراكك بثلاثة أيام.',
        resumes: 'يرجع اشتراكك',
        resumesBody: '\u2068{{price}}\u2069 شهرياً. تقدر تلغي من \u2066Google Play\u2069.',
        review: 'مراجعة الإيقاف في \u2066Google Play\u2069',
        scheduled: {
          title: 'إيقافك المؤقت',
          heading: 'تم تحديد موعد راحتك.',
          body: 'أكد \u2066Google Play\u2069 الإيقاف. مزاياك الحالية تبقى إلى موعد بدايته.',
          startsLabel: 'يبدأ الإيقاف',
          resumesOn: 'يرجع في \u2068{{date}}\u2069',
          thenPrice: 'وبعدها \u2068{{price}}\u2069 شهرياً. تقدر تدير أو تلغي من \u2066Google Play\u2069.',
          info: 'سيرتك المحفوظة ورابطك العام يبقون متاحين خلال الراحة.',
        },
      },
      confirm: {
        title: 'إلغاء الاشتراك',
        heading: 'هذا اللي بيصير.',
        subtitle: 'وقف التجديد. واحتفظ بشغلك.',
        successHeading: 'مبروك الوظيفة اليديدة.',
        successSubtitle: 'بنخلي سيرتك ورابطك جاهزين متى ما احتجتهم مرة ثانية.',
        benefitsStayUntil: 'مزايا \u2068{{tier}}\u2069 تبقى إلى',
        accessUnknown: 'تحقق من موعد انتهاء وصولك',
        staysTitle: 'يبقى معك على المجاني',
        stays: {
          savedCv: 'سيرتك الذاتية المحفوظة',
          publicProfile: 'ملفك العام ورابطه',
        },
        stopsAfter: 'يتوقف بعد \u2068{{date}}\u2069',
        stopsLater: 'يتوقف لما تنتهي باقتك',
        stops: {
          paidAi: 'أدوات الذكاء الاصطناعي المدفوعة والحدود الأعلى',
          premium: 'مزايا الباقة المدفوعة',
        },
        fine: 'بتكمل في \u2068{{provider}}\u2069. ما يتغيّر شي إلا بعد تأكيدك هناك.',
        continueToCancel: 'متابعة الإلغاء',
      },
      provider: {
        title: 'إدارة الاشتراك',
        heading: 'الإدارة عبر \u2068{{provider}}\u2069',
        subtitle: 'اشتراكك مرتبط بالمزوّد اللي دفعت من خلاله.',
        pendingHeading: 'خلّنا نتحقق من باقتك.',
        pendingSubtitle: 'ما وصلنا تغيير مؤكد للحين. وصولك الحالي يبقى مثل ما هو.',
        steps: {
          open: 'افتح \u2068{{provider}}\u2069',
          find: 'اختار تابيو من الاشتراكات',
        },
        intents: {
          pause: 'إيقاف الاشتراك مؤقتاً',
          renew: 'إعادة تشغيل التجديد',
          manage: 'راجع اشتراكك',
          cancel: 'إيقاف التجديد',
        },
        pendingInfo: 'بانتظار التأكيد. التغيير مو مؤكد للحين.',
        returnInfo: 'الرجوع لهنا مو تأكيد للتغيير. نتحقق من حالة الاشتراك أول.',
        checkAgain: 'تحقق مرة ثانية',
      },
    },
    renewalOff: {
      title: 'اشتراكك',
      heading: 'التجديد متوقف.',
      subtitle: 'ما في دفعات تلقائية بعد اليوم. استفد من المدة المتبقية لك.',
      benefitsEnd: 'تنتهي مزايا \u2068{{tier}}\u2069 في',
      info: 'بعدها تبقى سيرتك المحفوظة ورابطك العام على الباقة المجانية.',
      keepUsing: 'استخدام مزاياي المتبقية',
      turnRenewalOn: 'إعادة تشغيل التجديد',
    },
    lapsed: {
      title: 'باقتك',
      heading: 'أنت على المجاني الحين.',
      subtitle: 'سيرتك ورابطك العام موجودين مثل ما تركتهم.',
      ended: 'انتهت \u2068{{tier}}\u2069 في \u2068{{date}}\u2069',
      novaNote: 'نوفا هنا متى ما احتجت مساعدة.',
      savedCv: 'سيرتي المحفوظة',
      stillYours: 'ما زالت لك',
      publicProfile: 'ملفي العام',
      readyToShare: 'جاهز للمشاركة',
      explorePlans: 'استكشف الباقات',
      continueFree: 'المتابعة مجاناً',
    },
    states: {
      screenTitle: 'اشتراكك',
      loading: 'جاري التحميل',
      loadingLabel: 'جاري تحميل الشاشة',
      error: {
        title: 'صار خطأ في التحميل.',
        body: 'باقتك ما تغيّرت. جرّب مرة ثانية متى ما كنت جاهز.',
      },
      offline: {
        title: 'أنت غير متصل.',
        body: 'اتصل بالإنترنت للتحقق من باقتك. ما يتغيّر شي وأنت غير متصل.',
      },
      unavailable: {
        title: 'هذا الخيار غير متاح.',
        body: 'المزوّد ما قدر يوفّر هالباقة الحين. باقتك الحالية ما تغيّرت.',
      },
      pending: {
        title: 'بانتظار التأكيد.',
        body: 'المزوّد ما أكّد التغيير للحين. باقتك الحالية تبقى مفعّلة.',
      },
      checkStatus: 'تحقق من الحالة',
      tryAgain: 'حاول مرة ثانية',
    },
  },
  // Audit E03: what a submission sent, and what a share link shares.
  submissionReceipts: {
    candidateTitle: 'ما أرسلته',
    employerTitle: 'إيصالات التقديم',
    sentCount_zero: 'لم يُرسَل بعد',
    sentCount_one: 'أُرسِل مرة واحدة',
    sentCount_two: 'أُرسِل مرتين',
    sentCount_few: 'أُرسِل {{count}} مرات',
    sentCount_many: 'أُرسِل {{count}} مرة',
    sentCount_other: 'أُرسِل {{count}} مرة',
    recipient: 'أُرسِل إلى',
    fields: {
      cv: 'السيرة الذاتية',
      language: 'اللغة',
      sentAt: 'وقت الإرسال',
      source: 'أُرسِل من',
      file: 'الملف',
    },
    heading: {
      original: 'التقديم الأصلي',
      updated: 'تقديم محدَّث',
    },
    current: 'الحالي',
    cv: {
      none: 'لم تُرفَق سيرة ذاتية',
      notRecorded: 'غير مسجَّل',
    },
    language: {
      en: 'الإنجليزية',
      ar: 'العربية',
      notRecorded: 'غير مسجَّلة',
    },
    source: {
      app: 'تطبيق Tabbio',
      companyPage: 'صفحة الشركة على Tabbio',
      publicApply: 'نموذج التقديم العام',
      other: 'أخرى',
    },
    historical: {
      title: 'أُرسِل قبل تسجيل الإيصالات',
      body: 'أُرسِل هذا قبل أن يحتفظ Tabbio بإيصالات التقديم، لذلك لم تُسجَّل تفاصيله الدقيقة.',
    },
    employerSummaryNote:
      'تظهر التقديمات السابقة كملخصات فقط. السيرة الذاتية الحالية وحدها مشارَكة معك.',
  },
  shareLinkDetails: {
    title: 'تفاصيل الرابط',
    fields: {
      cv: 'السيرة الذاتية',
      access: 'من يمكنه فتحه',
      contact: 'الهاتف والبريد',
      download: 'التنزيل',
      expiry: 'الانتهاء',
      created: 'تاريخ الإنشاء',
      opened: 'مرات الفتح',
    },
    mainCv: 'السيرة الرئيسية',
    access: {
      anyone: 'أي شخص لديه الرابط',
    },
    contact: {
      included: 'مضمَّنان',
      partial: 'مضمَّنان جزئيًا',
      hidden: 'مخفيّان',
    },
    download: {
      allowed: 'مسموح',
      off: 'غير مسموح',
    },
    expiry: {
      never: 'لا ينتهي',
      expired: 'انتهى في {{date}}',
    },
    opened: {
      never: 'لم يُفتَح بعد',
      count_zero: 'لم يُفتَح بعد',
      count_one: 'مرة واحدة',
      count_two: 'مرتان',
      count_few: '{{count}} مرات',
      count_many: '{{count}} مرة',
      count_other: '{{count}} مرة',
    },
  },
} as const;
